import * as React from "react";

import { IconSvgProps } from "@/types";

export const Logo: React.FC<IconSvgProps> = ({ ...props }) => (
  <svg
    fill="none"
    height="64"
    viewBox="0 0 302 64"
    width="302"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_2057_43870)">
      <mask
        height="3"
        id="mask0_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="295"
        y="8"
      >
        <path d="M297.432 8.2439H295.167V10.5027H297.432V8.2439Z" fill="white" />
      </mask>
      <g mask="url(#mask0_2057_43870)">
        <mask
          height="3"
          id="mask1_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="295"
          y="8"
        >
          <path d="M297.432 8.2439H295.167V10.5027H297.432V8.2439Z" fill="white" />
        </mask>
        <g mask="url(#mask1_2057_43870)">
          <path
            d="M295.167 8.2439L296.299 9.37331M296.299 9.37331L297.432 8.2439M296.299 9.37331L297.432 10.5027M296.299 9.37331L295.167 10.5027"
            stroke="#C4C4C4"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask2_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="298"
        y="8"
      >
        <path d="M301.207 8.2439H298.942V10.5027H301.207V8.2439Z" fill="white" />
      </mask>
      <g mask="url(#mask2_2057_43870)">
        <mask
          height="3"
          id="mask3_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="298"
          y="8"
        >
          <path d="M301.207 8.2439H298.942V10.5027H301.207V8.2439Z" fill="white" />
        </mask>
        <g mask="url(#mask3_2057_43870)">
          <path
            d="M298.942 8.2439L300.074 9.37331M300.074 9.37331L301.207 8.2439M300.074 9.37331L301.207 10.5027M300.074 9.37331L298.942 10.5027"
            stroke="#C4C4C4"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask4_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="295"
        y="12"
      >
        <path d="M297.432 12.0086H295.167V14.2674H297.432V12.0086Z" fill="white" />
      </mask>
      <g mask="url(#mask4_2057_43870)">
        <mask
          height="3"
          id="mask5_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="295"
          y="12"
        >
          <path d="M297.432 12.0086H295.167V14.2674H297.432V12.0086Z" fill="white" />
        </mask>
        <g mask="url(#mask5_2057_43870)">
          <path
            d="M295.167 12.0086L296.299 13.138M296.299 13.138L297.432 12.0086M296.299 13.138L297.432 14.2674M296.299 13.138L295.167 14.2674"
            stroke="#C4C4C4"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask6_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="298"
        y="12"
      >
        <path d="M301.207 12.0086H298.942V14.2674H301.207V12.0086Z" fill="white" />
      </mask>
      <g mask="url(#mask6_2057_43870)">
        <mask
          height="3"
          id="mask7_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="298"
          y="12"
        >
          <path d="M301.207 12.0086H298.942V14.2674H301.207V12.0086Z" fill="white" />
        </mask>
        <g mask="url(#mask7_2057_43870)">
          <path
            d="M298.942 12.0086L300.074 13.138M300.074 13.138L301.207 12.0086M300.074 13.138L301.207 14.2674M300.074 13.138L298.942 14.2674"
            stroke="#C4C4C4"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="4"
        id="mask8_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="295"
        y="15"
      >
        <path d="M297.432 15.7733H295.167V18.0321H297.432V15.7733Z" fill="white" />
      </mask>
      <g mask="url(#mask8_2057_43870)">
        <mask
          height="4"
          id="mask9_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="295"
          y="15"
        >
          <path d="M297.432 15.7733H295.167V18.0321H297.432V15.7733Z" fill="white" />
        </mask>
        <g mask="url(#mask9_2057_43870)">
          <path
            d="M295.167 15.7733L296.299 16.9027M296.299 16.9027L297.432 15.7733M296.299 16.9027L297.432 18.0321M296.299 16.9027L295.167 18.0321"
            stroke="#C4C4C4"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="4"
        id="mask10_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="298"
        y="15"
      >
        <path d="M301.207 15.7733H298.942V18.0321H301.207V15.7733Z" fill="white" />
      </mask>
      <g mask="url(#mask10_2057_43870)">
        <mask
          height="4"
          id="mask11_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="298"
          y="15"
        >
          <path d="M301.207 15.7733H298.942V18.0321H301.207V15.7733Z" fill="white" />
        </mask>
        <g mask="url(#mask11_2057_43870)">
          <path
            d="M298.942 15.7733L300.074 16.9027M300.074 16.9027L301.207 15.7733M300.074 16.9027L301.207 18.0321M300.074 16.9027L298.942 18.0321"
            stroke="#C4C4C4"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask12_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="12"
        y="19"
      >
        <path d="M14.3065 19.538H12.0415V21.7968H14.3065V19.538Z" fill="white" />
      </mask>
      <g mask="url(#mask12_2057_43870)">
        <mask
          height="3"
          id="mask13_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="12"
          y="19"
        >
          <path d="M14.3065 19.538H12.0415V21.7968H14.3065V19.538Z" fill="white" />
        </mask>
        <g mask="url(#mask13_2057_43870)">
          <path
            d="M12.0415 19.538L13.174 20.6674M13.174 20.6674L14.3065 19.538M13.174 20.6674L14.3065 21.7968M13.174 20.6674L12.0415 21.7968"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask14_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="15"
        y="19"
      >
        <path d="M18.0814 19.538H15.8164V21.7968H18.0814V19.538Z" fill="white" />
      </mask>
      <g mask="url(#mask14_2057_43870)">
        <mask
          height="3"
          id="mask15_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="15"
          y="19"
        >
          <path d="M18.0814 19.538H15.8164V21.7968H18.0814V19.538Z" fill="white" />
        </mask>
        <g mask="url(#mask15_2057_43870)">
          <path
            d="M15.8164 19.538L16.9489 20.6674M16.9489 20.6674L18.0814 19.538M16.9489 20.6674L18.0814 21.7968M16.9489 20.6674L15.8164 21.7968"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask16_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="19"
        y="19"
      >
        <path d="M21.8564 19.538H19.5914V21.7968H21.8564V19.538Z" fill="white" />
      </mask>
      <g mask="url(#mask16_2057_43870)">
        <mask
          height="3"
          id="mask17_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="19"
          y="19"
        >
          <path d="M21.8564 19.538H19.5914V21.7968H21.8564V19.538Z" fill="white" />
        </mask>
        <g mask="url(#mask17_2057_43870)">
          <path
            d="M19.5914 19.538L20.7239 20.6674M20.7239 20.6674L21.8564 19.538M20.7239 20.6674L21.8564 21.7968M20.7239 20.6674L19.5914 21.7968"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask18_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="23"
        y="19"
      >
        <path d="M25.6315 19.538H23.3665V21.7968H25.6315V19.538Z" fill="white" />
      </mask>
      <g mask="url(#mask18_2057_43870)">
        <mask
          height="3"
          id="mask19_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="23"
          y="19"
        >
          <path d="M25.6315 19.538H23.3665V21.7968H25.6315V19.538Z" fill="white" />
        </mask>
        <g mask="url(#mask19_2057_43870)">
          <path
            d="M23.3665 19.538L24.499 20.6674M24.499 20.6674L25.6315 19.538M24.499 20.6674L25.6315 21.7968M24.499 20.6674L23.3665 21.7968"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask20_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="27"
        y="19"
      >
        <path d="M29.4065 19.538H27.1415V21.7968H29.4065V19.538Z" fill="white" />
      </mask>
      <g mask="url(#mask20_2057_43870)">
        <mask
          height="3"
          id="mask21_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="27"
          y="19"
        >
          <path d="M29.4065 19.538H27.1415V21.7968H29.4065V19.538Z" fill="white" />
        </mask>
        <g mask="url(#mask21_2057_43870)">
          <path
            d="M27.1415 19.538L28.274 20.6674M28.274 20.6674L29.4065 19.538M28.274 20.6674L29.4065 21.7968M28.274 20.6674L27.1415 21.7968"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask22_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="30"
        y="19"
      >
        <path d="M33.1815 19.538H30.9165V21.7968H33.1815V19.538Z" fill="white" />
      </mask>
      <g mask="url(#mask22_2057_43870)">
        <mask
          height="3"
          id="mask23_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="30"
          y="19"
        >
          <path d="M33.1815 19.538H30.9165V21.7968H33.1815V19.538Z" fill="white" />
        </mask>
        <g mask="url(#mask23_2057_43870)">
          <path
            d="M30.9165 19.538L32.049 20.6674M32.049 20.6674L33.1815 19.538M32.049 20.6674L33.1815 21.7968M32.049 20.6674L30.9165 21.7968"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask24_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="34"
        y="19"
      >
        <path d="M36.9564 19.538H34.6914V21.7968H36.9564V19.538Z" fill="white" />
      </mask>
      <g mask="url(#mask24_2057_43870)">
        <mask
          height="3"
          id="mask25_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="34"
          y="19"
        >
          <path d="M36.9564 19.538H34.6914V21.7968H36.9564V19.538Z" fill="white" />
        </mask>
        <g mask="url(#mask25_2057_43870)">
          <path
            d="M34.6914 19.538L35.8239 20.6674M35.8239 20.6674L36.9564 19.538M35.8239 20.6674L36.9564 21.7968M35.8239 20.6674L34.6914 21.7968"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask26_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="38"
        y="19"
      >
        <path d="M40.7316 19.538H38.4666V21.7968H40.7316V19.538Z" fill="white" />
      </mask>
      <g mask="url(#mask26_2057_43870)">
        <mask
          height="3"
          id="mask27_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="38"
          y="19"
        >
          <path d="M40.7316 19.538H38.4666V21.7968H40.7316V19.538Z" fill="white" />
        </mask>
        <g mask="url(#mask27_2057_43870)">
          <path
            d="M38.4666 19.538L39.5991 20.6674M39.5991 20.6674L40.7316 19.538M39.5991 20.6674L40.7316 21.7968M39.5991 20.6674L38.4666 21.7968"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask28_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="42"
        y="19"
      >
        <path d="M44.5065 19.538H42.2415V21.7968H44.5065V19.538Z" fill="white" />
      </mask>
      <g mask="url(#mask28_2057_43870)">
        <mask
          height="3"
          id="mask29_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="42"
          y="19"
        >
          <path d="M44.5065 19.538H42.2415V21.7968H44.5065V19.538Z" fill="white" />
        </mask>
        <g mask="url(#mask29_2057_43870)">
          <path
            d="M42.2415 19.538L43.374 20.6674M43.374 20.6674L44.5065 19.538M43.374 20.6674L44.5065 21.7968M43.374 20.6674L42.2415 21.7968"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask30_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="46"
        y="19"
      >
        <path d="M48.2815 19.538H46.0165V21.7968H48.2815V19.538Z" fill="white" />
      </mask>
      <g mask="url(#mask30_2057_43870)">
        <mask
          height="3"
          id="mask31_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="46"
          y="19"
        >
          <path d="M48.2815 19.538H46.0165V21.7968H48.2815V19.538Z" fill="white" />
        </mask>
        <g mask="url(#mask31_2057_43870)">
          <path
            d="M46.0165 19.538L47.149 20.6674M47.149 20.6674L48.2815 19.538M47.149 20.6674L48.2815 21.7968M47.149 20.6674L46.0165 21.7968"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask32_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="49"
        y="19"
      >
        <path d="M52.0565 19.538H49.7915V21.7968H52.0565V19.538Z" fill="white" />
      </mask>
      <g mask="url(#mask32_2057_43870)">
        <mask
          height="3"
          id="mask33_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="49"
          y="19"
        >
          <path d="M52.0565 19.538H49.7915V21.7968H52.0565V19.538Z" fill="white" />
        </mask>
        <g mask="url(#mask33_2057_43870)">
          <path
            d="M49.7915 19.538L50.924 20.6674M50.924 20.6674L52.0565 19.538M50.924 20.6674L52.0565 21.7968M50.924 20.6674L49.7915 21.7968"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask34_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="53"
        y="19"
      >
        <path d="M55.8315 19.538H53.5665V21.7968H55.8315V19.538Z" fill="white" />
      </mask>
      <g mask="url(#mask34_2057_43870)">
        <mask
          height="3"
          id="mask35_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="53"
          y="19"
        >
          <path d="M55.8315 19.538H53.5665V21.7968H55.8315V19.538Z" fill="white" />
        </mask>
        <g mask="url(#mask35_2057_43870)">
          <path
            d="M53.5665 19.538L54.699 20.6674M54.699 20.6674L55.8315 19.538M54.699 20.6674L55.8315 21.7968M54.699 20.6674L53.5665 21.7968"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="5"
        id="mask36_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="67"
        y="18"
      >
        <path d="M71.725 18.8235H67.95V22.5883H71.725V18.8235Z" fill="white" />
      </mask>
      <g mask="url(#mask36_2057_43870)">
        <mask
          height="5"
          id="mask37_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="67"
          y="18"
        >
          <path d="M71.725 18.8235H67.95V22.5883H71.725V18.8235Z" fill="white" />
        </mask>
        <g mask="url(#mask37_2057_43870)">
          <mask
            height="5"
            id="mask38_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="67"
            y="18"
          >
            <path d="M71.725 18.8235H67.95V22.5883H71.725V18.8235Z" fill="white" />
          </mask>
          <g mask="url(#mask38_2057_43870)">
            <path
              d="M67.95 18.8235L68.8937 19.7647M68.8937 19.7647L69.8375 18.8235L70.7812 19.7647M68.8937 19.7647L69.8375 20.7059M68.8937 19.7647L67.95 20.7059L68.8937 21.6471M70.7812 19.7647L69.8375 20.7059M70.7812 19.7647L71.725 18.8235M70.7812 19.7647L71.725 20.7059L70.7812 21.6471M69.8375 20.7059L68.8937 21.6471M69.8375 20.7059L70.7812 21.6471M68.8937 21.6471L69.8375 22.5883L70.7812 21.6471M68.8937 21.6471L67.95 22.5883M70.7812 21.6471L71.725 22.5883"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask39_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="71"
        y="18"
      >
        <path d="M75.5 18.8235H71.725V22.5883H75.5V18.8235Z" fill="white" />
      </mask>
      <g mask="url(#mask39_2057_43870)">
        <mask
          height="5"
          id="mask40_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="71"
          y="18"
        >
          <path d="M75.5 18.8235H71.725V22.5883H75.5V18.8235Z" fill="white" />
        </mask>
        <g mask="url(#mask40_2057_43870)">
          <mask
            height="5"
            id="mask41_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="71"
            y="18"
          >
            <path d="M75.5 18.8235H71.725V22.5883H75.5V18.8235Z" fill="white" />
          </mask>
          <g mask="url(#mask41_2057_43870)">
            <path
              d="M71.725 18.8235L72.6687 19.7647M72.6687 19.7647L73.6125 18.8235L74.5562 19.7647M72.6687 19.7647L73.6125 20.7059M72.6687 19.7647L71.725 20.7059L72.6687 21.6471M74.5562 19.7647L73.6125 20.7059M74.5562 19.7647L75.5 18.8235M74.5562 19.7647L75.5 20.7059L74.5562 21.6471M73.6125 20.7059L72.6687 21.6471M73.6125 20.7059L74.5562 21.6471M72.6687 21.6471L73.6125 22.5883L74.5562 21.6471M72.6687 21.6471L71.725 22.5883M74.5562 21.6471L75.5 22.5883"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask42_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="109"
        y="18"
      >
        <path d="M113.25 18.8235H109.475V22.5883H113.25V18.8235Z" fill="white" />
      </mask>
      <g mask="url(#mask42_2057_43870)">
        <mask
          height="5"
          id="mask43_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="109"
          y="18"
        >
          <path d="M113.25 18.8235H109.475V22.5883H113.25V18.8235Z" fill="white" />
        </mask>
        <g mask="url(#mask43_2057_43870)">
          <mask
            height="5"
            id="mask44_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="109"
            y="18"
          >
            <path d="M113.25 18.8235H109.475V22.5883H113.25V18.8235Z" fill="white" />
          </mask>
          <g mask="url(#mask44_2057_43870)">
            <path
              d="M109.475 18.8235L110.419 19.7647M110.419 19.7647L111.362 18.8235L112.306 19.7647M110.419 19.7647L111.362 20.7059M110.419 19.7647L109.475 20.7059L110.419 21.6471M112.306 19.7647L111.362 20.7059M112.306 19.7647L113.25 18.8235M112.306 19.7647L113.25 20.7059L112.306 21.6471M111.362 20.7059L110.419 21.6471M111.362 20.7059L112.306 21.6471M110.419 21.6471L111.362 22.5883L112.306 21.6471M110.419 21.6471L109.475 22.5883M112.306 21.6471L113.25 22.5883"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask45_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="113"
        y="18"
      >
        <path d="M117.025 18.8235H113.25V22.5883H117.025V18.8235Z" fill="white" />
      </mask>
      <g mask="url(#mask45_2057_43870)">
        <mask
          height="5"
          id="mask46_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="113"
          y="18"
        >
          <path d="M117.025 18.8235H113.25V22.5883H117.025V18.8235Z" fill="white" />
        </mask>
        <g mask="url(#mask46_2057_43870)">
          <mask
            height="5"
            id="mask47_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="113"
            y="18"
          >
            <path d="M117.025 18.8235H113.25V22.5883H117.025V18.8235Z" fill="white" />
          </mask>
          <g mask="url(#mask47_2057_43870)">
            <path
              d="M113.25 18.8235L114.194 19.7647M114.194 19.7647L115.137 18.8235L116.081 19.7647M114.194 19.7647L115.137 20.7059M114.194 19.7647L113.25 20.7059L114.194 21.6471M116.081 19.7647L115.137 20.7059M116.081 19.7647L117.025 18.8235M116.081 19.7647L117.025 20.7059L116.081 21.6471M115.137 20.7059L114.194 21.6471M115.137 20.7059L116.081 21.6471M114.194 21.6471L115.137 22.5883L116.081 21.6471M114.194 21.6471L113.25 22.5883M116.081 21.6471L117.025 22.5883"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask48_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="117"
        y="18"
      >
        <path d="M120.8 18.8235H117.025V22.5883H120.8V18.8235Z" fill="white" />
      </mask>
      <g mask="url(#mask48_2057_43870)">
        <mask
          height="5"
          id="mask49_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="117"
          y="18"
        >
          <path d="M120.8 18.8235H117.025V22.5883H120.8V18.8235Z" fill="white" />
        </mask>
        <g mask="url(#mask49_2057_43870)">
          <mask
            height="5"
            id="mask50_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="117"
            y="18"
          >
            <path d="M120.8 18.8235H117.025V22.5883H120.8V18.8235Z" fill="white" />
          </mask>
          <g mask="url(#mask50_2057_43870)">
            <path
              d="M117.025 18.8235L117.969 19.7647M117.969 19.7647L118.913 18.8235L119.856 19.7647M117.969 19.7647L118.913 20.7059M117.969 19.7647L117.025 20.7059L117.969 21.6471M119.856 19.7647L118.913 20.7059M119.856 19.7647L120.8 18.8235M119.856 19.7647L120.8 20.7059L119.856 21.6471M118.913 20.7059L117.969 21.6471M118.913 20.7059L119.856 21.6471M117.969 21.6471L118.913 22.5883L119.856 21.6471M117.969 21.6471L117.025 22.5883M119.856 21.6471L120.8 22.5883"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask51_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="143"
        y="18"
      >
        <path d="M147.225 18.8235H143.45V22.5883H147.225V18.8235Z" fill="white" />
      </mask>
      <g mask="url(#mask51_2057_43870)">
        <mask
          height="5"
          id="mask52_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="143"
          y="18"
        >
          <path d="M147.225 18.8235H143.45V22.5883H147.225V18.8235Z" fill="white" />
        </mask>
        <g mask="url(#mask52_2057_43870)">
          <mask
            height="5"
            id="mask53_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="143"
            y="18"
          >
            <path d="M147.225 18.8235H143.45V22.5883H147.225V18.8235Z" fill="white" />
          </mask>
          <g mask="url(#mask53_2057_43870)">
            <path
              d="M143.45 18.8235L144.394 19.7647M144.394 19.7647L145.337 18.8235L146.281 19.7647M144.394 19.7647L145.337 20.7059M144.394 19.7647L143.45 20.7059L144.394 21.6471M146.281 19.7647L145.337 20.7059M146.281 19.7647L147.225 18.8235M146.281 19.7647L147.225 20.7059L146.281 21.6471M145.337 20.7059L144.394 21.6471M145.337 20.7059L146.281 21.6471M144.394 21.6471L145.337 22.5883L146.281 21.6471M144.394 21.6471L143.45 22.5883M146.281 21.6471L147.225 22.5883"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask54_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="147"
        y="18"
      >
        <path d="M151 18.8235H147.225V22.5883H151V18.8235Z" fill="white" />
      </mask>
      <g mask="url(#mask54_2057_43870)">
        <mask
          height="5"
          id="mask55_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="147"
          y="18"
        >
          <path d="M151 18.8235H147.225V22.5883H151V18.8235Z" fill="white" />
        </mask>
        <g mask="url(#mask55_2057_43870)">
          <mask
            height="5"
            id="mask56_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="147"
            y="18"
          >
            <path d="M151 18.8235H147.225V22.5883H151V18.8235Z" fill="white" />
          </mask>
          <g mask="url(#mask56_2057_43870)">
            <path
              d="M147.225 18.8235L148.169 19.7647M148.169 19.7647L149.112 18.8235L150.056 19.7647M148.169 19.7647L149.112 20.7059M148.169 19.7647L147.225 20.7059L148.169 21.6471M150.056 19.7647L149.112 20.7059M150.056 19.7647L151 18.8235M150.056 19.7647L151 20.7059L150.056 21.6471M149.112 20.7059L148.169 21.6471M149.112 20.7059L150.056 21.6471M148.169 21.6471L149.112 22.5883L150.056 21.6471M148.169 21.6471L147.225 22.5883M150.056 21.6471L151 22.5883"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask57_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="151"
        y="18"
      >
        <path d="M154.775 18.8235H151V22.5883H154.775V18.8235Z" fill="white" />
      </mask>
      <g mask="url(#mask57_2057_43870)">
        <mask
          height="5"
          id="mask58_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="151"
          y="18"
        >
          <path d="M154.775 18.8235H151V22.5883H154.775V18.8235Z" fill="white" />
        </mask>
        <g mask="url(#mask58_2057_43870)">
          <mask
            height="5"
            id="mask59_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="151"
            y="18"
          >
            <path d="M154.775 18.8235H151V22.5883H154.775V18.8235Z" fill="white" />
          </mask>
          <g mask="url(#mask59_2057_43870)">
            <path
              d="M151 18.8235L151.944 19.7647M151.944 19.7647L152.887 18.8235L153.831 19.7647M151.944 19.7647L152.887 20.7059M151.944 19.7647L151 20.7059L151.944 21.6471M153.831 19.7647L152.887 20.7059M153.831 19.7647L154.775 18.8235M153.831 19.7647L154.775 20.7059L153.831 21.6471M152.887 20.7059L151.944 21.6471M152.887 20.7059L153.831 21.6471M151.944 21.6471L152.887 22.5883L153.831 21.6471M151.944 21.6471L151 22.5883M153.831 21.6471L154.775 22.5883"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask60_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="154"
        y="18"
      >
        <path d="M158.55 18.8235H154.775V22.5883H158.55V18.8235Z" fill="white" />
      </mask>
      <g mask="url(#mask60_2057_43870)">
        <mask
          height="5"
          id="mask61_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="154"
          y="18"
        >
          <path d="M158.55 18.8235H154.775V22.5883H158.55V18.8235Z" fill="white" />
        </mask>
        <g mask="url(#mask61_2057_43870)">
          <mask
            height="5"
            id="mask62_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="154"
            y="18"
          >
            <path d="M158.55 18.8235H154.775V22.5883H158.55V18.8235Z" fill="white" />
          </mask>
          <g mask="url(#mask62_2057_43870)">
            <path
              d="M154.775 18.8235L155.719 19.7647M155.719 19.7647L156.663 18.8235L157.606 19.7647M155.719 19.7647L156.663 20.7059M155.719 19.7647L154.775 20.7059L155.719 21.6471M157.606 19.7647L156.663 20.7059M157.606 19.7647L158.55 18.8235M157.606 19.7647L158.55 20.7059L157.606 21.6471M156.663 20.7059L155.719 21.6471M156.663 20.7059L157.606 21.6471M155.719 21.6471L156.663 22.5883L157.606 21.6471M155.719 21.6471L154.775 22.5883M157.606 21.6471L158.55 22.5883"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask63_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="158"
        y="18"
      >
        <path d="M162.325 18.8235H158.55V22.5883H162.325V18.8235Z" fill="white" />
      </mask>
      <g mask="url(#mask63_2057_43870)">
        <mask
          height="5"
          id="mask64_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="158"
          y="18"
        >
          <path d="M162.325 18.8235H158.55V22.5883H162.325V18.8235Z" fill="white" />
        </mask>
        <g mask="url(#mask64_2057_43870)">
          <mask
            height="5"
            id="mask65_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="158"
            y="18"
          >
            <path d="M162.325 18.8235H158.55V22.5883H162.325V18.8235Z" fill="white" />
          </mask>
          <g mask="url(#mask65_2057_43870)">
            <path
              d="M158.55 18.8235L159.494 19.7647M159.494 19.7647L160.438 18.8235L161.381 19.7647M159.494 19.7647L160.438 20.7059M159.494 19.7647L158.55 20.7059L159.494 21.6471M161.381 19.7647L160.438 20.7059M161.381 19.7647L162.325 18.8235M161.381 19.7647L162.325 20.7059L161.381 21.6471M160.438 20.7059L159.494 21.6471M160.438 20.7059L161.381 21.6471M159.494 21.6471L160.438 22.5883L161.381 21.6471M159.494 21.6471L158.55 22.5883M161.381 21.6471L162.325 22.5883"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask66_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="162"
        y="18"
      >
        <path d="M166.1 18.8235H162.325V22.5883H166.1V18.8235Z" fill="white" />
      </mask>
      <g mask="url(#mask66_2057_43870)">
        <mask
          height="5"
          id="mask67_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="162"
          y="18"
        >
          <path d="M166.1 18.8235H162.325V22.5883H166.1V18.8235Z" fill="white" />
        </mask>
        <g mask="url(#mask67_2057_43870)">
          <mask
            height="5"
            id="mask68_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="162"
            y="18"
          >
            <path d="M166.1 18.8235H162.325V22.5883H166.1V18.8235Z" fill="white" />
          </mask>
          <g mask="url(#mask68_2057_43870)">
            <path
              d="M162.325 18.8235L163.269 19.7647M163.269 19.7647L164.212 18.8235L165.156 19.7647M163.269 19.7647L164.212 20.7059M163.269 19.7647L162.325 20.7059L163.269 21.6471M165.156 19.7647L164.212 20.7059M165.156 19.7647L166.1 18.8235M165.156 19.7647L166.1 20.7059L165.156 21.6471M164.212 20.7059L163.269 21.6471M164.212 20.7059L165.156 21.6471M163.269 21.6471L164.212 22.5883L165.156 21.6471M163.269 21.6471L162.325 22.5883M165.156 21.6471L166.1 22.5883"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask69_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="166"
        y="18"
      >
        <path d="M169.875 18.8235H166.1V22.5883H169.875V18.8235Z" fill="white" />
      </mask>
      <g mask="url(#mask69_2057_43870)">
        <mask
          height="5"
          id="mask70_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="166"
          y="18"
        >
          <path d="M169.875 18.8235H166.1V22.5883H169.875V18.8235Z" fill="white" />
        </mask>
        <g mask="url(#mask70_2057_43870)">
          <mask
            height="5"
            id="mask71_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="166"
            y="18"
          >
            <path d="M169.875 18.8235H166.1V22.5883H169.875V18.8235Z" fill="white" />
          </mask>
          <g mask="url(#mask71_2057_43870)">
            <path
              d="M166.1 18.8235L167.044 19.7647M167.044 19.7647L167.987 18.8235L168.931 19.7647M167.044 19.7647L167.987 20.7059M167.044 19.7647L166.1 20.7059L167.044 21.6471M168.931 19.7647L167.987 20.7059M168.931 19.7647L169.875 18.8235M168.931 19.7647L169.875 20.7059L168.931 21.6471M167.987 20.7059L167.044 21.6471M167.987 20.7059L168.931 21.6471M167.044 21.6471L167.987 22.5883L168.931 21.6471M167.044 21.6471L166.1 22.5883M168.931 21.6471L169.875 22.5883"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask72_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="169"
        y="18"
      >
        <path d="M173.65 18.8235H169.875V22.5883H173.65V18.8235Z" fill="white" />
      </mask>
      <g mask="url(#mask72_2057_43870)">
        <mask
          height="5"
          id="mask73_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="169"
          y="18"
        >
          <path d="M173.65 18.8235H169.875V22.5883H173.65V18.8235Z" fill="white" />
        </mask>
        <g mask="url(#mask73_2057_43870)">
          <mask
            height="5"
            id="mask74_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="169"
            y="18"
          >
            <path d="M173.65 18.8235H169.875V22.5883H173.65V18.8235Z" fill="white" />
          </mask>
          <g mask="url(#mask74_2057_43870)">
            <path
              d="M169.875 18.8235L170.819 19.7647M170.819 19.7647L171.762 18.8235L172.706 19.7647M170.819 19.7647L171.762 20.7059M170.819 19.7647L169.875 20.7059L170.819 21.6471M172.706 19.7647L171.762 20.7059M172.706 19.7647L173.65 18.8235M172.706 19.7647L173.65 20.7059L172.706 21.6471M171.762 20.7059L170.819 21.6471M171.762 20.7059L172.706 21.6471M170.819 21.6471L171.762 22.5883L172.706 21.6471M170.819 21.6471L169.875 22.5883M172.706 21.6471L173.65 22.5883"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask75_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="207"
        y="18"
      >
        <path d="M211.4 18.8235H207.625V22.5883H211.4V18.8235Z" fill="white" />
      </mask>
      <g mask="url(#mask75_2057_43870)">
        <mask
          height="5"
          id="mask76_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="207"
          y="18"
        >
          <path d="M211.4 18.8235H207.625V22.5883H211.4V18.8235Z" fill="white" />
        </mask>
        <g mask="url(#mask76_2057_43870)">
          <mask
            height="5"
            id="mask77_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="207"
            y="18"
          >
            <path d="M211.4 18.8235H207.625V22.5883H211.4V18.8235Z" fill="white" />
          </mask>
          <g mask="url(#mask77_2057_43870)">
            <path
              d="M207.625 18.8235L208.569 19.7647M208.569 19.7647L209.512 18.8235L210.456 19.7647M208.569 19.7647L209.512 20.7059M208.569 19.7647L207.625 20.7059L208.569 21.6471M210.456 19.7647L209.512 20.7059M210.456 19.7647L211.4 18.8235M210.456 19.7647L211.4 20.7059L210.456 21.6471M209.512 20.7059L208.569 21.6471M209.512 20.7059L210.456 21.6471M208.569 21.6471L209.512 22.5883L210.456 21.6471M208.569 21.6471L207.625 22.5883M210.456 21.6471L211.4 22.5883"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask78_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="211"
        y="18"
      >
        <path d="M215.175 18.8235H211.4V22.5883H215.175V18.8235Z" fill="white" />
      </mask>
      <g mask="url(#mask78_2057_43870)">
        <mask
          height="5"
          id="mask79_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="211"
          y="18"
        >
          <path d="M215.175 18.8235H211.4V22.5883H215.175V18.8235Z" fill="white" />
        </mask>
        <g mask="url(#mask79_2057_43870)">
          <mask
            height="5"
            id="mask80_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="211"
            y="18"
          >
            <path d="M215.175 18.8235H211.4V22.5883H215.175V18.8235Z" fill="white" />
          </mask>
          <g mask="url(#mask80_2057_43870)">
            <path
              d="M211.4 18.8235L212.344 19.7647M212.344 19.7647L213.288 18.8235L214.231 19.7647M212.344 19.7647L213.288 20.7059M212.344 19.7647L211.4 20.7059L212.344 21.6471M214.231 19.7647L213.288 20.7059M214.231 19.7647L215.175 18.8235M214.231 19.7647L215.175 20.7059L214.231 21.6471M213.288 20.7059L212.344 21.6471M213.288 20.7059L214.231 21.6471M212.344 21.6471L213.288 22.5883L214.231 21.6471M212.344 21.6471L211.4 22.5883M214.231 21.6471L215.175 22.5883"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask81_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="215"
        y="18"
      >
        <path d="M218.95 18.8235H215.175V22.5883H218.95V18.8235Z" fill="white" />
      </mask>
      <g mask="url(#mask81_2057_43870)">
        <mask
          height="5"
          id="mask82_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="215"
          y="18"
        >
          <path d="M218.95 18.8235H215.175V22.5883H218.95V18.8235Z" fill="white" />
        </mask>
        <g mask="url(#mask82_2057_43870)">
          <mask
            height="5"
            id="mask83_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="215"
            y="18"
          >
            <path d="M218.95 18.8235H215.175V22.5883H218.95V18.8235Z" fill="white" />
          </mask>
          <g mask="url(#mask83_2057_43870)">
            <path
              d="M215.175 18.8235L216.119 19.7647M216.119 19.7647L217.063 18.8235L218.006 19.7647M216.119 19.7647L217.063 20.7059M216.119 19.7647L215.175 20.7059L216.119 21.6471M218.006 19.7647L217.063 20.7059M218.006 19.7647L218.95 18.8235M218.006 19.7647L218.95 20.7059L218.006 21.6471M217.063 20.7059L216.119 21.6471M217.063 20.7059L218.006 21.6471M216.119 21.6471L217.063 22.5883L218.006 21.6471M216.119 21.6471L215.175 22.5883M218.006 21.6471L218.95 22.5883"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask84_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="218"
        y="18"
      >
        <path d="M222.725 18.8235H218.95V22.5883H222.725V18.8235Z" fill="white" />
      </mask>
      <g mask="url(#mask84_2057_43870)">
        <mask
          height="5"
          id="mask85_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="218"
          y="18"
        >
          <path d="M222.725 18.8235H218.95V22.5883H222.725V18.8235Z" fill="white" />
        </mask>
        <g mask="url(#mask85_2057_43870)">
          <mask
            height="5"
            id="mask86_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="218"
            y="18"
          >
            <path d="M222.725 18.8235H218.95V22.5883H222.725V18.8235Z" fill="white" />
          </mask>
          <g mask="url(#mask86_2057_43870)">
            <path
              d="M218.95 18.8235L219.894 19.7647M219.894 19.7647L220.837 18.8235L221.781 19.7647M219.894 19.7647L220.837 20.7059M219.894 19.7647L218.95 20.7059L219.894 21.6471M221.781 19.7647L220.837 20.7059M221.781 19.7647L222.725 18.8235M221.781 19.7647L222.725 20.7059L221.781 21.6471M220.837 20.7059L219.894 21.6471M220.837 20.7059L221.781 21.6471M219.894 21.6471L220.837 22.5883L221.781 21.6471M219.894 21.6471L218.95 22.5883M221.781 21.6471L222.725 22.5883"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask87_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="222"
        y="18"
      >
        <path d="M226.5 18.8235H222.725V22.5883H226.5V18.8235Z" fill="white" />
      </mask>
      <g mask="url(#mask87_2057_43870)">
        <mask
          height="5"
          id="mask88_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="222"
          y="18"
        >
          <path d="M226.5 18.8235H222.725V22.5883H226.5V18.8235Z" fill="white" />
        </mask>
        <g mask="url(#mask88_2057_43870)">
          <mask
            height="5"
            id="mask89_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="222"
            y="18"
          >
            <path d="M226.5 18.8235H222.725V22.5883H226.5V18.8235Z" fill="white" />
          </mask>
          <g mask="url(#mask89_2057_43870)">
            <path
              d="M222.725 18.8235L223.669 19.7647M223.669 19.7647L224.612 18.8235L225.556 19.7647M223.669 19.7647L224.612 20.7059M223.669 19.7647L222.725 20.7059L223.669 21.6471M225.556 19.7647L224.612 20.7059M225.556 19.7647L226.5 18.8235M225.556 19.7647L226.5 20.7059L225.556 21.6471M224.612 20.7059L223.669 21.6471M224.612 20.7059L225.556 21.6471M223.669 21.6471L224.612 22.5883L225.556 21.6471M223.669 21.6471L222.725 22.5883M225.556 21.6471L226.5 22.5883"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask90_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="249"
        y="18"
      >
        <path d="M252.925 18.8235H249.15V22.5883H252.925V18.8235Z" fill="white" />
      </mask>
      <g mask="url(#mask90_2057_43870)">
        <mask
          height="5"
          id="mask91_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="249"
          y="18"
        >
          <path d="M252.925 18.8235H249.15V22.5883H252.925V18.8235Z" fill="white" />
        </mask>
        <g mask="url(#mask91_2057_43870)">
          <mask
            height="5"
            id="mask92_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="249"
            y="18"
          >
            <path d="M252.925 18.8235H249.15V22.5883H252.925V18.8235Z" fill="white" />
          </mask>
          <g mask="url(#mask92_2057_43870)">
            <path
              d="M249.15 18.8235L250.094 19.7647M250.094 19.7647L251.038 18.8235L251.981 19.7647M250.094 19.7647L251.038 20.7059M250.094 19.7647L249.15 20.7059L250.094 21.6471M251.981 19.7647L251.038 20.7059M251.981 19.7647L252.925 18.8235M251.981 19.7647L252.925 20.7059L251.981 21.6471M251.038 20.7059L250.094 21.6471M251.038 20.7059L251.981 21.6471M250.094 21.6471L251.038 22.5883L251.981 21.6471M250.094 21.6471L249.15 22.5883M251.981 21.6471L252.925 22.5883"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask93_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="252"
        y="18"
      >
        <path d="M256.7 18.8235H252.925V22.5883H256.7V18.8235Z" fill="white" />
      </mask>
      <g mask="url(#mask93_2057_43870)">
        <mask
          height="5"
          id="mask94_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="252"
          y="18"
        >
          <path d="M256.7 18.8235H252.925V22.5883H256.7V18.8235Z" fill="white" />
        </mask>
        <g mask="url(#mask94_2057_43870)">
          <mask
            height="5"
            id="mask95_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="252"
            y="18"
          >
            <path d="M256.7 18.8235H252.925V22.5883H256.7V18.8235Z" fill="white" />
          </mask>
          <g mask="url(#mask95_2057_43870)">
            <path
              d="M252.925 18.8235L253.869 19.7647M253.869 19.7647L254.813 18.8235L255.756 19.7647M253.869 19.7647L254.813 20.7059M253.869 19.7647L252.925 20.7059L253.869 21.6471M255.756 19.7647L254.813 20.7059M255.756 19.7647L256.7 18.8235M255.756 19.7647L256.7 20.7059L255.756 21.6471M254.813 20.7059L253.869 21.6471M254.813 20.7059L255.756 21.6471M253.869 21.6471L254.813 22.5883L255.756 21.6471M253.869 21.6471L252.925 22.5883M255.756 21.6471L256.7 22.5883"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask96_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="256"
        y="18"
      >
        <path d="M260.475 18.8235H256.7V22.5883H260.475V18.8235Z" fill="white" />
      </mask>
      <g mask="url(#mask96_2057_43870)">
        <mask
          height="5"
          id="mask97_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="256"
          y="18"
        >
          <path d="M260.475 18.8235H256.7V22.5883H260.475V18.8235Z" fill="white" />
        </mask>
        <g mask="url(#mask97_2057_43870)">
          <mask
            height="5"
            id="mask98_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="256"
            y="18"
          >
            <path d="M260.475 18.8235H256.7V22.5883H260.475V18.8235Z" fill="white" />
          </mask>
          <g mask="url(#mask98_2057_43870)">
            <path
              d="M256.7 18.8235L257.644 19.7647M257.644 19.7647L258.587 18.8235L259.531 19.7647M257.644 19.7647L258.587 20.7059M257.644 19.7647L256.7 20.7059L257.644 21.6471M259.531 19.7647L258.587 20.7059M259.531 19.7647L260.475 18.8235M259.531 19.7647L260.475 20.7059L259.531 21.6471M258.587 20.7059L257.644 21.6471M258.587 20.7059L259.531 21.6471M257.644 21.6471L258.587 22.5883L259.531 21.6471M257.644 21.6471L256.7 22.5883M259.531 21.6471L260.475 22.5883"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask99_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="271"
        y="18"
      >
        <path d="M275.575 18.8235H271.8V22.5883H275.575V18.8235Z" fill="white" />
      </mask>
      <g mask="url(#mask99_2057_43870)">
        <mask
          height="5"
          id="mask100_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="271"
          y="18"
        >
          <path d="M275.575 18.8235H271.8V22.5883H275.575V18.8235Z" fill="white" />
        </mask>
        <g mask="url(#mask100_2057_43870)">
          <mask
            height="5"
            id="mask101_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="271"
            y="18"
          >
            <path d="M275.575 18.8235H271.8V22.5883H275.575V18.8235Z" fill="white" />
          </mask>
          <g mask="url(#mask101_2057_43870)">
            <path
              d="M271.8 18.8235L272.744 19.7647M272.744 19.7647L273.688 18.8235L274.631 19.7647M272.744 19.7647L273.688 20.7059M272.744 19.7647L271.8 20.7059L272.744 21.6471M274.631 19.7647L273.688 20.7059M274.631 19.7647L275.575 18.8235M274.631 19.7647L275.575 20.7059L274.631 21.6471M273.688 20.7059L272.744 21.6471M273.688 20.7059L274.631 21.6471M272.744 21.6471L273.688 22.5883L274.631 21.6471M272.744 21.6471L271.8 22.5883M274.631 21.6471L275.575 22.5883"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask102_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="275"
        y="18"
      >
        <path d="M279.35 18.8235H275.575V22.5883H279.35V18.8235Z" fill="white" />
      </mask>
      <g mask="url(#mask102_2057_43870)">
        <mask
          height="5"
          id="mask103_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="275"
          y="18"
        >
          <path d="M279.35 18.8235H275.575V22.5883H279.35V18.8235Z" fill="white" />
        </mask>
        <g mask="url(#mask103_2057_43870)">
          <mask
            height="5"
            id="mask104_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="275"
            y="18"
          >
            <path d="M279.35 18.8235H275.575V22.5883H279.35V18.8235Z" fill="white" />
          </mask>
          <g mask="url(#mask104_2057_43870)">
            <path
              d="M275.575 18.8235L276.519 19.7647M276.519 19.7647L277.462 18.8235L278.406 19.7647M276.519 19.7647L277.462 20.7059M276.519 19.7647L275.575 20.7059L276.519 21.6471M278.406 19.7647L277.462 20.7059M278.406 19.7647L279.35 18.8235M278.406 19.7647L279.35 20.7059L278.406 21.6471M277.462 20.7059L276.519 21.6471M277.462 20.7059L278.406 21.6471M276.519 21.6471L277.462 22.5883L278.406 21.6471M276.519 21.6471L275.575 22.5883M278.406 21.6471L279.35 22.5883"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask105_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="279"
        y="18"
      >
        <path d="M283.125 18.8235H279.35V22.5883H283.125V18.8235Z" fill="white" />
      </mask>
      <g mask="url(#mask105_2057_43870)">
        <mask
          height="5"
          id="mask106_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="279"
          y="18"
        >
          <path d="M283.125 18.8235H279.35V22.5883H283.125V18.8235Z" fill="white" />
        </mask>
        <g mask="url(#mask106_2057_43870)">
          <mask
            height="5"
            id="mask107_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="279"
            y="18"
          >
            <path d="M283.125 18.8235H279.35V22.5883H283.125V18.8235Z" fill="white" />
          </mask>
          <g mask="url(#mask107_2057_43870)">
            <path
              d="M279.35 18.8235L280.294 19.7647M280.294 19.7647L281.237 18.8235L282.181 19.7647M280.294 19.7647L281.237 20.7059M280.294 19.7647L279.35 20.7059L280.294 21.6471M282.181 19.7647L281.237 20.7059M282.181 19.7647L283.125 18.8235M282.181 19.7647L283.125 20.7059L282.181 21.6471M281.237 20.7059L280.294 21.6471M281.237 20.7059L282.181 21.6471M280.294 21.6471L281.237 22.5883L282.181 21.6471M280.294 21.6471L279.35 22.5883M282.181 21.6471L283.125 22.5883"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="3"
        id="mask108_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="12"
        y="23"
      >
        <path d="M14.3065 23.3027H12.0415V25.5616H14.3065V23.3027Z" fill="white" />
      </mask>
      <g mask="url(#mask108_2057_43870)">
        <mask
          height="3"
          id="mask109_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="12"
          y="23"
        >
          <path d="M14.3065 23.3027H12.0415V25.5616H14.3065V23.3027Z" fill="white" />
        </mask>
        <g mask="url(#mask109_2057_43870)">
          <path
            d="M12.0415 23.3027L13.174 24.4321M13.174 24.4321L14.3065 23.3027M13.174 24.4321L14.3065 25.5616M13.174 24.4321L12.0415 25.5616"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask110_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="15"
        y="23"
      >
        <path d="M18.0814 23.3027H15.8164V25.5616H18.0814V23.3027Z" fill="white" />
      </mask>
      <g mask="url(#mask110_2057_43870)">
        <mask
          height="3"
          id="mask111_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="15"
          y="23"
        >
          <path d="M18.0814 23.3027H15.8164V25.5616H18.0814V23.3027Z" fill="white" />
        </mask>
        <g mask="url(#mask111_2057_43870)">
          <path
            d="M15.8164 23.3027L16.9489 24.4321M16.9489 24.4321L18.0814 23.3027M16.9489 24.4321L18.0814 25.5616M16.9489 24.4321L15.8164 25.5616"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask112_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="19"
        y="23"
      >
        <path d="M21.8564 23.3027H19.5914V25.5616H21.8564V23.3027Z" fill="white" />
      </mask>
      <g mask="url(#mask112_2057_43870)">
        <mask
          height="3"
          id="mask113_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="19"
          y="23"
        >
          <path d="M21.8564 23.3027H19.5914V25.5616H21.8564V23.3027Z" fill="white" />
        </mask>
        <g mask="url(#mask113_2057_43870)">
          <path
            d="M19.5914 23.3027L20.7239 24.4321M20.7239 24.4321L21.8564 23.3027M20.7239 24.4321L21.8564 25.5616M20.7239 24.4321L19.5914 25.5616"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask114_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="23"
        y="23"
      >
        <path d="M25.6315 23.3027H23.3665V25.5616H25.6315V23.3027Z" fill="white" />
      </mask>
      <g mask="url(#mask114_2057_43870)">
        <mask
          height="3"
          id="mask115_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="23"
          y="23"
        >
          <path d="M25.6315 23.3027H23.3665V25.5616H25.6315V23.3027Z" fill="white" />
        </mask>
        <g mask="url(#mask115_2057_43870)">
          <path
            d="M23.3665 23.3027L24.499 24.4321M24.499 24.4321L25.6315 23.3027M24.499 24.4321L25.6315 25.5616M24.499 24.4321L23.3665 25.5616"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask116_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="27"
        y="23"
      >
        <path d="M29.4065 23.3027H27.1415V25.5616H29.4065V23.3027Z" fill="white" />
      </mask>
      <g mask="url(#mask116_2057_43870)">
        <mask
          height="3"
          id="mask117_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="27"
          y="23"
        >
          <path d="M29.4065 23.3027H27.1415V25.5616H29.4065V23.3027Z" fill="white" />
        </mask>
        <g mask="url(#mask117_2057_43870)">
          <path
            d="M27.1415 23.3027L28.274 24.4321M28.274 24.4321L29.4065 23.3027M28.274 24.4321L29.4065 25.5616M28.274 24.4321L27.1415 25.5616"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask118_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="30"
        y="23"
      >
        <path d="M33.1815 23.3027H30.9165V25.5616H33.1815V23.3027Z" fill="white" />
      </mask>
      <g mask="url(#mask118_2057_43870)">
        <mask
          height="3"
          id="mask119_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="30"
          y="23"
        >
          <path d="M33.1815 23.3027H30.9165V25.5616H33.1815V23.3027Z" fill="white" />
        </mask>
        <g mask="url(#mask119_2057_43870)">
          <path
            d="M30.9165 23.3027L32.049 24.4321M32.049 24.4321L33.1815 23.3027M32.049 24.4321L33.1815 25.5616M32.049 24.4321L30.9165 25.5616"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask120_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="34"
        y="23"
      >
        <path d="M36.9564 23.3027H34.6914V25.5616H36.9564V23.3027Z" fill="white" />
      </mask>
      <g mask="url(#mask120_2057_43870)">
        <mask
          height="3"
          id="mask121_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="34"
          y="23"
        >
          <path d="M36.9564 23.3027H34.6914V25.5616H36.9564V23.3027Z" fill="white" />
        </mask>
        <g mask="url(#mask121_2057_43870)">
          <path
            d="M34.6914 23.3027L35.8239 24.4321M35.8239 24.4321L36.9564 23.3027M35.8239 24.4321L36.9564 25.5616M35.8239 24.4321L34.6914 25.5616"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask122_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="38"
        y="23"
      >
        <path d="M40.7316 23.3027H38.4666V25.5616H40.7316V23.3027Z" fill="white" />
      </mask>
      <g mask="url(#mask122_2057_43870)">
        <mask
          height="3"
          id="mask123_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="38"
          y="23"
        >
          <path d="M40.7316 23.3027H38.4666V25.5616H40.7316V23.3027Z" fill="white" />
        </mask>
        <g mask="url(#mask123_2057_43870)">
          <path
            d="M38.4666 23.3027L39.5991 24.4321M39.5991 24.4321L40.7316 23.3027M39.5991 24.4321L40.7316 25.5616M39.5991 24.4321L38.4666 25.5616"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask124_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="42"
        y="23"
      >
        <path d="M44.5065 23.3027H42.2415V25.5616H44.5065V23.3027Z" fill="white" />
      </mask>
      <g mask="url(#mask124_2057_43870)">
        <mask
          height="3"
          id="mask125_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="42"
          y="23"
        >
          <path d="M44.5065 23.3027H42.2415V25.5616H44.5065V23.3027Z" fill="white" />
        </mask>
        <g mask="url(#mask125_2057_43870)">
          <path
            d="M42.2415 23.3027L43.374 24.4321M43.374 24.4321L44.5065 23.3027M43.374 24.4321L44.5065 25.5616M43.374 24.4321L42.2415 25.5616"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask126_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="46"
        y="23"
      >
        <path d="M48.2815 23.3027H46.0165V25.5616H48.2815V23.3027Z" fill="white" />
      </mask>
      <g mask="url(#mask126_2057_43870)">
        <mask
          height="3"
          id="mask127_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="46"
          y="23"
        >
          <path d="M48.2815 23.3027H46.0165V25.5616H48.2815V23.3027Z" fill="white" />
        </mask>
        <g mask="url(#mask127_2057_43870)">
          <path
            d="M46.0165 23.3027L47.149 24.4321M47.149 24.4321L48.2815 23.3027M47.149 24.4321L48.2815 25.5616M47.149 24.4321L46.0165 25.5616"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask128_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="49"
        y="23"
      >
        <path d="M52.0565 23.3027H49.7915V25.5616H52.0565V23.3027Z" fill="white" />
      </mask>
      <g mask="url(#mask128_2057_43870)">
        <mask
          height="3"
          id="mask129_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="49"
          y="23"
        >
          <path d="M52.0565 23.3027H49.7915V25.5616H52.0565V23.3027Z" fill="white" />
        </mask>
        <g mask="url(#mask129_2057_43870)">
          <path
            d="M49.7915 23.3027L50.924 24.4321M50.924 24.4321L52.0565 23.3027M50.924 24.4321L52.0565 25.5616M50.924 24.4321L49.7915 25.5616"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask130_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="53"
        y="23"
      >
        <path d="M55.8315 23.3027H53.5665V25.5616H55.8315V23.3027Z" fill="white" />
      </mask>
      <g mask="url(#mask130_2057_43870)">
        <mask
          height="3"
          id="mask131_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="53"
          y="23"
        >
          <path d="M55.8315 23.3027H53.5665V25.5616H55.8315V23.3027Z" fill="white" />
        </mask>
        <g mask="url(#mask131_2057_43870)">
          <path
            d="M53.5665 23.3027L54.699 24.4321M54.699 24.4321L55.8315 23.3027M54.699 24.4321L55.8315 25.5616M54.699 24.4321L53.5665 25.5616"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="5"
        id="mask132_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="67"
        y="22"
      >
        <path d="M71.725 22.5883H67.95V26.353H71.725V22.5883Z" fill="white" />
      </mask>
      <g mask="url(#mask132_2057_43870)">
        <mask
          height="5"
          id="mask133_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="67"
          y="22"
        >
          <path d="M71.725 22.5883H67.95V26.353H71.725V22.5883Z" fill="white" />
        </mask>
        <g mask="url(#mask133_2057_43870)">
          <mask
            height="5"
            id="mask134_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="67"
            y="22"
          >
            <path d="M71.725 22.5883H67.95V26.353H71.725V22.5883Z" fill="white" />
          </mask>
          <g mask="url(#mask134_2057_43870)">
            <path
              d="M67.95 22.5883L68.8937 23.5294M68.8937 23.5294L69.8375 22.5883L70.7812 23.5294M68.8937 23.5294L69.8375 24.4706M68.8937 23.5294L67.95 24.4706L68.8937 25.4118M70.7812 23.5294L69.8375 24.4706M70.7812 23.5294L71.725 22.5883M70.7812 23.5294L71.725 24.4706L70.7812 25.4118M69.8375 24.4706L68.8937 25.4118M69.8375 24.4706L70.7812 25.4118M68.8937 25.4118L69.8375 26.353L70.7812 25.4118M68.8937 25.4118L67.95 26.353M70.7812 25.4118L71.725 26.353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask135_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="71"
        y="22"
      >
        <path d="M75.5 22.5883H71.725V26.353H75.5V22.5883Z" fill="white" />
      </mask>
      <g mask="url(#mask135_2057_43870)">
        <mask
          height="5"
          id="mask136_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="71"
          y="22"
        >
          <path d="M75.5 22.5883H71.725V26.353H75.5V22.5883Z" fill="white" />
        </mask>
        <g mask="url(#mask136_2057_43870)">
          <mask
            height="5"
            id="mask137_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="71"
            y="22"
          >
            <path d="M75.5 22.5883H71.725V26.353H75.5V22.5883Z" fill="white" />
          </mask>
          <g mask="url(#mask137_2057_43870)">
            <path
              d="M71.725 22.5883L72.6687 23.5294M72.6687 23.5294L73.6125 22.5883L74.5562 23.5294M72.6687 23.5294L73.6125 24.4706M72.6687 23.5294L71.725 24.4706L72.6687 25.4118M74.5562 23.5294L73.6125 24.4706M74.5562 23.5294L75.5 22.5883M74.5562 23.5294L75.5 24.4706L74.5562 25.4118M73.6125 24.4706L72.6687 25.4118M73.6125 24.4706L74.5562 25.4118M72.6687 25.4118L73.6125 26.353L74.5562 25.4118M72.6687 25.4118L71.725 26.353M74.5562 25.4118L75.5 26.353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask138_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="109"
        y="22"
      >
        <path d="M113.25 22.5883H109.475V26.353H113.25V22.5883Z" fill="white" />
      </mask>
      <g mask="url(#mask138_2057_43870)">
        <mask
          height="5"
          id="mask139_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="109"
          y="22"
        >
          <path d="M113.25 22.5883H109.475V26.353H113.25V22.5883Z" fill="white" />
        </mask>
        <g mask="url(#mask139_2057_43870)">
          <mask
            height="5"
            id="mask140_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="109"
            y="22"
          >
            <path d="M113.25 22.5883H109.475V26.353H113.25V22.5883Z" fill="white" />
          </mask>
          <g mask="url(#mask140_2057_43870)">
            <path
              d="M109.475 22.5883L110.419 23.5294M110.419 23.5294L111.362 22.5883L112.306 23.5294M110.419 23.5294L111.362 24.4706M110.419 23.5294L109.475 24.4706L110.419 25.4118M112.306 23.5294L111.362 24.4706M112.306 23.5294L113.25 22.5883M112.306 23.5294L113.25 24.4706L112.306 25.4118M111.362 24.4706L110.419 25.4118M111.362 24.4706L112.306 25.4118M110.419 25.4118L111.362 26.353L112.306 25.4118M110.419 25.4118L109.475 26.353M112.306 25.4118L113.25 26.353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask141_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="113"
        y="22"
      >
        <path d="M117.025 22.5883H113.25V26.353H117.025V22.5883Z" fill="white" />
      </mask>
      <g mask="url(#mask141_2057_43870)">
        <mask
          height="5"
          id="mask142_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="113"
          y="22"
        >
          <path d="M117.025 22.5883H113.25V26.353H117.025V22.5883Z" fill="white" />
        </mask>
        <g mask="url(#mask142_2057_43870)">
          <mask
            height="5"
            id="mask143_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="113"
            y="22"
          >
            <path d="M117.025 22.5883H113.25V26.353H117.025V22.5883Z" fill="white" />
          </mask>
          <g mask="url(#mask143_2057_43870)">
            <path
              d="M113.25 22.5883L114.194 23.5294M114.194 23.5294L115.137 22.5883L116.081 23.5294M114.194 23.5294L115.137 24.4706M114.194 23.5294L113.25 24.4706L114.194 25.4118M116.081 23.5294L115.137 24.4706M116.081 23.5294L117.025 22.5883M116.081 23.5294L117.025 24.4706L116.081 25.4118M115.137 24.4706L114.194 25.4118M115.137 24.4706L116.081 25.4118M114.194 25.4118L115.137 26.353L116.081 25.4118M114.194 25.4118L113.25 26.353M116.081 25.4118L117.025 26.353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask144_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="117"
        y="22"
      >
        <path d="M120.8 22.5883H117.025V26.353H120.8V22.5883Z" fill="white" />
      </mask>
      <g mask="url(#mask144_2057_43870)">
        <mask
          height="5"
          id="mask145_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="117"
          y="22"
        >
          <path d="M120.8 22.5883H117.025V26.353H120.8V22.5883Z" fill="white" />
        </mask>
        <g mask="url(#mask145_2057_43870)">
          <mask
            height="5"
            id="mask146_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="117"
            y="22"
          >
            <path d="M120.8 22.5883H117.025V26.353H120.8V22.5883Z" fill="white" />
          </mask>
          <g mask="url(#mask146_2057_43870)">
            <path
              d="M117.025 22.5883L117.969 23.5294M117.969 23.5294L118.913 22.5883L119.856 23.5294M117.969 23.5294L118.913 24.4706M117.969 23.5294L117.025 24.4706L117.969 25.4118M119.856 23.5294L118.913 24.4706M119.856 23.5294L120.8 22.5883M119.856 23.5294L120.8 24.4706L119.856 25.4118M118.913 24.4706L117.969 25.4118M118.913 24.4706L119.856 25.4118M117.969 25.4118L118.913 26.353L119.856 25.4118M117.969 25.4118L117.025 26.353M119.856 25.4118L120.8 26.353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask147_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="143"
        y="22"
      >
        <path d="M147.225 22.5883H143.45V26.353H147.225V22.5883Z" fill="white" />
      </mask>
      <g mask="url(#mask147_2057_43870)">
        <mask
          height="5"
          id="mask148_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="143"
          y="22"
        >
          <path d="M147.225 22.5883H143.45V26.353H147.225V22.5883Z" fill="white" />
        </mask>
        <g mask="url(#mask148_2057_43870)">
          <mask
            height="5"
            id="mask149_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="143"
            y="22"
          >
            <path d="M147.225 22.5883H143.45V26.353H147.225V22.5883Z" fill="white" />
          </mask>
          <g mask="url(#mask149_2057_43870)">
            <path
              d="M143.45 22.5883L144.394 23.5294M144.394 23.5294L145.337 22.5883L146.281 23.5294M144.394 23.5294L145.337 24.4706M144.394 23.5294L143.45 24.4706L144.394 25.4118M146.281 23.5294L145.337 24.4706M146.281 23.5294L147.225 22.5883M146.281 23.5294L147.225 24.4706L146.281 25.4118M145.337 24.4706L144.394 25.4118M145.337 24.4706L146.281 25.4118M144.394 25.4118L145.337 26.353L146.281 25.4118M144.394 25.4118L143.45 26.353M146.281 25.4118L147.225 26.353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask150_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="147"
        y="22"
      >
        <path d="M151 22.5883H147.225V26.353H151V22.5883Z" fill="white" />
      </mask>
      <g mask="url(#mask150_2057_43870)">
        <mask
          height="5"
          id="mask151_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="147"
          y="22"
        >
          <path d="M151 22.5883H147.225V26.353H151V22.5883Z" fill="white" />
        </mask>
        <g mask="url(#mask151_2057_43870)">
          <mask
            height="5"
            id="mask152_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="147"
            y="22"
          >
            <path d="M151 22.5883H147.225V26.353H151V22.5883Z" fill="white" />
          </mask>
          <g mask="url(#mask152_2057_43870)">
            <path
              d="M147.225 22.5883L148.169 23.5294M148.169 23.5294L149.112 22.5883L150.056 23.5294M148.169 23.5294L149.112 24.4706M148.169 23.5294L147.225 24.4706L148.169 25.4118M150.056 23.5294L149.112 24.4706M150.056 23.5294L151 22.5883M150.056 23.5294L151 24.4706L150.056 25.4118M149.112 24.4706L148.169 25.4118M149.112 24.4706L150.056 25.4118M148.169 25.4118L149.112 26.353L150.056 25.4118M148.169 25.4118L147.225 26.353M150.056 25.4118L151 26.353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask153_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="151"
        y="22"
      >
        <path d="M154.775 22.5883H151V26.353H154.775V22.5883Z" fill="white" />
      </mask>
      <g mask="url(#mask153_2057_43870)">
        <mask
          height="5"
          id="mask154_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="151"
          y="22"
        >
          <path d="M154.775 22.5883H151V26.353H154.775V22.5883Z" fill="white" />
        </mask>
        <g mask="url(#mask154_2057_43870)">
          <mask
            height="5"
            id="mask155_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="151"
            y="22"
          >
            <path d="M154.775 22.5883H151V26.353H154.775V22.5883Z" fill="white" />
          </mask>
          <g mask="url(#mask155_2057_43870)">
            <path
              d="M151 22.5883L151.944 23.5294M151.944 23.5294L152.887 22.5883L153.831 23.5294M151.944 23.5294L152.887 24.4706M151.944 23.5294L151 24.4706L151.944 25.4118M153.831 23.5294L152.887 24.4706M153.831 23.5294L154.775 22.5883M153.831 23.5294L154.775 24.4706L153.831 25.4118M152.887 24.4706L151.944 25.4118M152.887 24.4706L153.831 25.4118M151.944 25.4118L152.887 26.353L153.831 25.4118M151.944 25.4118L151 26.353M153.831 25.4118L154.775 26.353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask156_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="154"
        y="22"
      >
        <path d="M158.55 22.5883H154.775V26.353H158.55V22.5883Z" fill="white" />
      </mask>
      <g mask="url(#mask156_2057_43870)">
        <mask
          height="5"
          id="mask157_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="154"
          y="22"
        >
          <path d="M158.55 22.5883H154.775V26.353H158.55V22.5883Z" fill="white" />
        </mask>
        <g mask="url(#mask157_2057_43870)">
          <mask
            height="5"
            id="mask158_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="154"
            y="22"
          >
            <path d="M158.55 22.5883H154.775V26.353H158.55V22.5883Z" fill="white" />
          </mask>
          <g mask="url(#mask158_2057_43870)">
            <path
              d="M154.775 22.5883L155.719 23.5294M155.719 23.5294L156.663 22.5883L157.606 23.5294M155.719 23.5294L156.663 24.4706M155.719 23.5294L154.775 24.4706L155.719 25.4118M157.606 23.5294L156.663 24.4706M157.606 23.5294L158.55 22.5883M157.606 23.5294L158.55 24.4706L157.606 25.4118M156.663 24.4706L155.719 25.4118M156.663 24.4706L157.606 25.4118M155.719 25.4118L156.663 26.353L157.606 25.4118M155.719 25.4118L154.775 26.353M157.606 25.4118L158.55 26.353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask159_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="158"
        y="22"
      >
        <path d="M162.325 22.5883H158.55V26.353H162.325V22.5883Z" fill="white" />
      </mask>
      <g mask="url(#mask159_2057_43870)">
        <mask
          height="5"
          id="mask160_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="158"
          y="22"
        >
          <path d="M162.325 22.5883H158.55V26.353H162.325V22.5883Z" fill="white" />
        </mask>
        <g mask="url(#mask160_2057_43870)">
          <mask
            height="5"
            id="mask161_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="158"
            y="22"
          >
            <path d="M162.325 22.5883H158.55V26.353H162.325V22.5883Z" fill="white" />
          </mask>
          <g mask="url(#mask161_2057_43870)">
            <path
              d="M158.55 22.5883L159.494 23.5294M159.494 23.5294L160.438 22.5883L161.381 23.5294M159.494 23.5294L160.438 24.4706M159.494 23.5294L158.55 24.4706L159.494 25.4118M161.381 23.5294L160.438 24.4706M161.381 23.5294L162.325 22.5883M161.381 23.5294L162.325 24.4706L161.381 25.4118M160.438 24.4706L159.494 25.4118M160.438 24.4706L161.381 25.4118M159.494 25.4118L160.438 26.353L161.381 25.4118M159.494 25.4118L158.55 26.353M161.381 25.4118L162.325 26.353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask162_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="162"
        y="22"
      >
        <path d="M166.1 22.5883H162.325V26.353H166.1V22.5883Z" fill="white" />
      </mask>
      <g mask="url(#mask162_2057_43870)">
        <mask
          height="5"
          id="mask163_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="162"
          y="22"
        >
          <path d="M166.1 22.5883H162.325V26.353H166.1V22.5883Z" fill="white" />
        </mask>
        <g mask="url(#mask163_2057_43870)">
          <mask
            height="5"
            id="mask164_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="162"
            y="22"
          >
            <path d="M166.1 22.5883H162.325V26.353H166.1V22.5883Z" fill="white" />
          </mask>
          <g mask="url(#mask164_2057_43870)">
            <path
              d="M162.325 22.5883L163.269 23.5294M163.269 23.5294L164.212 22.5883L165.156 23.5294M163.269 23.5294L164.212 24.4706M163.269 23.5294L162.325 24.4706L163.269 25.4118M165.156 23.5294L164.212 24.4706M165.156 23.5294L166.1 22.5883M165.156 23.5294L166.1 24.4706L165.156 25.4118M164.212 24.4706L163.269 25.4118M164.212 24.4706L165.156 25.4118M163.269 25.4118L164.212 26.353L165.156 25.4118M163.269 25.4118L162.325 26.353M165.156 25.4118L166.1 26.353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask165_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="166"
        y="22"
      >
        <path d="M169.875 22.5883H166.1V26.353H169.875V22.5883Z" fill="white" />
      </mask>
      <g mask="url(#mask165_2057_43870)">
        <mask
          height="5"
          id="mask166_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="166"
          y="22"
        >
          <path d="M169.875 22.5883H166.1V26.353H169.875V22.5883Z" fill="white" />
        </mask>
        <g mask="url(#mask166_2057_43870)">
          <mask
            height="5"
            id="mask167_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="166"
            y="22"
          >
            <path d="M169.875 22.5883H166.1V26.353H169.875V22.5883Z" fill="white" />
          </mask>
          <g mask="url(#mask167_2057_43870)">
            <path
              d="M166.1 22.5883L167.044 23.5294M167.044 23.5294L167.987 22.5883L168.931 23.5294M167.044 23.5294L167.987 24.4706M167.044 23.5294L166.1 24.4706L167.044 25.4118M168.931 23.5294L167.987 24.4706M168.931 23.5294L169.875 22.5883M168.931 23.5294L169.875 24.4706L168.931 25.4118M167.987 24.4706L167.044 25.4118M167.987 24.4706L168.931 25.4118M167.044 25.4118L167.987 26.353L168.931 25.4118M167.044 25.4118L166.1 26.353M168.931 25.4118L169.875 26.353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask168_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="169"
        y="22"
      >
        <path d="M173.65 22.5883H169.875V26.353H173.65V22.5883Z" fill="white" />
      </mask>
      <g mask="url(#mask168_2057_43870)">
        <mask
          height="5"
          id="mask169_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="169"
          y="22"
        >
          <path d="M173.65 22.5883H169.875V26.353H173.65V22.5883Z" fill="white" />
        </mask>
        <g mask="url(#mask169_2057_43870)">
          <mask
            height="5"
            id="mask170_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="169"
            y="22"
          >
            <path d="M173.65 22.5883H169.875V26.353H173.65V22.5883Z" fill="white" />
          </mask>
          <g mask="url(#mask170_2057_43870)">
            <path
              d="M169.875 22.5883L170.819 23.5294M170.819 23.5294L171.762 22.5883L172.706 23.5294M170.819 23.5294L171.762 24.4706M170.819 23.5294L169.875 24.4706L170.819 25.4118M172.706 23.5294L171.762 24.4706M172.706 23.5294L173.65 22.5883M172.706 23.5294L173.65 24.4706L172.706 25.4118M171.762 24.4706L170.819 25.4118M171.762 24.4706L172.706 25.4118M170.819 25.4118L171.762 26.353L172.706 25.4118M170.819 25.4118L169.875 26.353M172.706 25.4118L173.65 26.353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask171_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="207"
        y="22"
      >
        <path d="M211.4 22.5883H207.625V26.353H211.4V22.5883Z" fill="white" />
      </mask>
      <g mask="url(#mask171_2057_43870)">
        <mask
          height="5"
          id="mask172_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="207"
          y="22"
        >
          <path d="M211.4 22.5883H207.625V26.353H211.4V22.5883Z" fill="white" />
        </mask>
        <g mask="url(#mask172_2057_43870)">
          <mask
            height="5"
            id="mask173_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="207"
            y="22"
          >
            <path d="M211.4 22.5883H207.625V26.353H211.4V22.5883Z" fill="white" />
          </mask>
          <g mask="url(#mask173_2057_43870)">
            <path
              d="M207.625 22.5883L208.569 23.5294M208.569 23.5294L209.512 22.5883L210.456 23.5294M208.569 23.5294L209.512 24.4706M208.569 23.5294L207.625 24.4706L208.569 25.4118M210.456 23.5294L209.512 24.4706M210.456 23.5294L211.4 22.5883M210.456 23.5294L211.4 24.4706L210.456 25.4118M209.512 24.4706L208.569 25.4118M209.512 24.4706L210.456 25.4118M208.569 25.4118L209.512 26.353L210.456 25.4118M208.569 25.4118L207.625 26.353M210.456 25.4118L211.4 26.353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask174_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="211"
        y="22"
      >
        <path d="M215.175 22.5883H211.4V26.353H215.175V22.5883Z" fill="white" />
      </mask>
      <g mask="url(#mask174_2057_43870)">
        <mask
          height="5"
          id="mask175_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="211"
          y="22"
        >
          <path d="M215.175 22.5883H211.4V26.353H215.175V22.5883Z" fill="white" />
        </mask>
        <g mask="url(#mask175_2057_43870)">
          <mask
            height="5"
            id="mask176_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="211"
            y="22"
          >
            <path d="M215.175 22.5883H211.4V26.353H215.175V22.5883Z" fill="white" />
          </mask>
          <g mask="url(#mask176_2057_43870)">
            <path
              d="M211.4 22.5883L212.344 23.5294M212.344 23.5294L213.288 22.5883L214.231 23.5294M212.344 23.5294L213.288 24.4706M212.344 23.5294L211.4 24.4706L212.344 25.4118M214.231 23.5294L213.288 24.4706M214.231 23.5294L215.175 22.5883M214.231 23.5294L215.175 24.4706L214.231 25.4118M213.288 24.4706L212.344 25.4118M213.288 24.4706L214.231 25.4118M212.344 25.4118L213.288 26.353L214.231 25.4118M212.344 25.4118L211.4 26.353M214.231 25.4118L215.175 26.353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask177_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="215"
        y="22"
      >
        <path d="M218.95 22.5883H215.175V26.353H218.95V22.5883Z" fill="white" />
      </mask>
      <g mask="url(#mask177_2057_43870)">
        <mask
          height="5"
          id="mask178_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="215"
          y="22"
        >
          <path d="M218.95 22.5883H215.175V26.353H218.95V22.5883Z" fill="white" />
        </mask>
        <g mask="url(#mask178_2057_43870)">
          <mask
            height="5"
            id="mask179_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="215"
            y="22"
          >
            <path d="M218.95 22.5883H215.175V26.353H218.95V22.5883Z" fill="white" />
          </mask>
          <g mask="url(#mask179_2057_43870)">
            <path
              d="M215.175 22.5883L216.119 23.5294M216.119 23.5294L217.063 22.5883L218.006 23.5294M216.119 23.5294L217.063 24.4706M216.119 23.5294L215.175 24.4706L216.119 25.4118M218.006 23.5294L217.063 24.4706M218.006 23.5294L218.95 22.5883M218.006 23.5294L218.95 24.4706L218.006 25.4118M217.063 24.4706L216.119 25.4118M217.063 24.4706L218.006 25.4118M216.119 25.4118L217.063 26.353L218.006 25.4118M216.119 25.4118L215.175 26.353M218.006 25.4118L218.95 26.353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask180_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="218"
        y="22"
      >
        <path d="M222.725 22.5883H218.95V26.353H222.725V22.5883Z" fill="white" />
      </mask>
      <g mask="url(#mask180_2057_43870)">
        <mask
          height="5"
          id="mask181_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="218"
          y="22"
        >
          <path d="M222.725 22.5883H218.95V26.353H222.725V22.5883Z" fill="white" />
        </mask>
        <g mask="url(#mask181_2057_43870)">
          <mask
            height="5"
            id="mask182_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="218"
            y="22"
          >
            <path d="M222.725 22.5883H218.95V26.353H222.725V22.5883Z" fill="white" />
          </mask>
          <g mask="url(#mask182_2057_43870)">
            <path
              d="M218.95 22.5883L219.894 23.5294M219.894 23.5294L220.837 22.5883L221.781 23.5294M219.894 23.5294L220.837 24.4706M219.894 23.5294L218.95 24.4706L219.894 25.4118M221.781 23.5294L220.837 24.4706M221.781 23.5294L222.725 22.5883M221.781 23.5294L222.725 24.4706L221.781 25.4118M220.837 24.4706L219.894 25.4118M220.837 24.4706L221.781 25.4118M219.894 25.4118L220.837 26.353L221.781 25.4118M219.894 25.4118L218.95 26.353M221.781 25.4118L222.725 26.353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask183_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="222"
        y="22"
      >
        <path d="M226.5 22.5883H222.725V26.353H226.5V22.5883Z" fill="white" />
      </mask>
      <g mask="url(#mask183_2057_43870)">
        <mask
          height="5"
          id="mask184_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="222"
          y="22"
        >
          <path d="M226.5 22.5883H222.725V26.353H226.5V22.5883Z" fill="white" />
        </mask>
        <g mask="url(#mask184_2057_43870)">
          <mask
            height="5"
            id="mask185_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="222"
            y="22"
          >
            <path d="M226.5 22.5883H222.725V26.353H226.5V22.5883Z" fill="white" />
          </mask>
          <g mask="url(#mask185_2057_43870)">
            <path
              d="M222.725 22.5883L223.669 23.5294M223.669 23.5294L224.612 22.5883L225.556 23.5294M223.669 23.5294L224.612 24.4706M223.669 23.5294L222.725 24.4706L223.669 25.4118M225.556 23.5294L224.612 24.4706M225.556 23.5294L226.5 22.5883M225.556 23.5294L226.5 24.4706L225.556 25.4118M224.612 24.4706L223.669 25.4118M224.612 24.4706L225.556 25.4118M223.669 25.4118L224.612 26.353L225.556 25.4118M223.669 25.4118L222.725 26.353M225.556 25.4118L226.5 26.353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask186_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="249"
        y="22"
      >
        <path d="M252.925 22.5883H249.15V26.353H252.925V22.5883Z" fill="white" />
      </mask>
      <g mask="url(#mask186_2057_43870)">
        <mask
          height="5"
          id="mask187_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="249"
          y="22"
        >
          <path d="M252.925 22.5883H249.15V26.353H252.925V22.5883Z" fill="white" />
        </mask>
        <g mask="url(#mask187_2057_43870)">
          <mask
            height="5"
            id="mask188_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="249"
            y="22"
          >
            <path d="M252.925 22.5883H249.15V26.353H252.925V22.5883Z" fill="white" />
          </mask>
          <g mask="url(#mask188_2057_43870)">
            <path
              d="M249.15 22.5883L250.094 23.5294M250.094 23.5294L251.038 22.5883L251.981 23.5294M250.094 23.5294L251.038 24.4706M250.094 23.5294L249.15 24.4706L250.094 25.4118M251.981 23.5294L251.038 24.4706M251.981 23.5294L252.925 22.5883M251.981 23.5294L252.925 24.4706L251.981 25.4118M251.038 24.4706L250.094 25.4118M251.038 24.4706L251.981 25.4118M250.094 25.4118L251.038 26.353L251.981 25.4118M250.094 25.4118L249.15 26.353M251.981 25.4118L252.925 26.353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask189_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="252"
        y="22"
      >
        <path d="M256.7 22.5883H252.925V26.353H256.7V22.5883Z" fill="white" />
      </mask>
      <g mask="url(#mask189_2057_43870)">
        <mask
          height="5"
          id="mask190_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="252"
          y="22"
        >
          <path d="M256.7 22.5883H252.925V26.353H256.7V22.5883Z" fill="white" />
        </mask>
        <g mask="url(#mask190_2057_43870)">
          <mask
            height="5"
            id="mask191_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="252"
            y="22"
          >
            <path d="M256.7 22.5883H252.925V26.353H256.7V22.5883Z" fill="white" />
          </mask>
          <g mask="url(#mask191_2057_43870)">
            <path
              d="M252.925 22.5883L253.869 23.5294M253.869 23.5294L254.813 22.5883L255.756 23.5294M253.869 23.5294L254.813 24.4706M253.869 23.5294L252.925 24.4706L253.869 25.4118M255.756 23.5294L254.813 24.4706M255.756 23.5294L256.7 22.5883M255.756 23.5294L256.7 24.4706L255.756 25.4118M254.813 24.4706L253.869 25.4118M254.813 24.4706L255.756 25.4118M253.869 25.4118L254.813 26.353L255.756 25.4118M253.869 25.4118L252.925 26.353M255.756 25.4118L256.7 26.353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask192_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="256"
        y="22"
      >
        <path d="M260.475 22.5883H256.7V26.353H260.475V22.5883Z" fill="white" />
      </mask>
      <g mask="url(#mask192_2057_43870)">
        <mask
          height="5"
          id="mask193_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="256"
          y="22"
        >
          <path d="M260.475 22.5883H256.7V26.353H260.475V22.5883Z" fill="white" />
        </mask>
        <g mask="url(#mask193_2057_43870)">
          <mask
            height="5"
            id="mask194_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="256"
            y="22"
          >
            <path d="M260.475 22.5883H256.7V26.353H260.475V22.5883Z" fill="white" />
          </mask>
          <g mask="url(#mask194_2057_43870)">
            <path
              d="M256.7 22.5883L257.644 23.5294M257.644 23.5294L258.587 22.5883L259.531 23.5294M257.644 23.5294L258.587 24.4706M257.644 23.5294L256.7 24.4706L257.644 25.4118M259.531 23.5294L258.587 24.4706M259.531 23.5294L260.475 22.5883M259.531 23.5294L260.475 24.4706L259.531 25.4118M258.587 24.4706L257.644 25.4118M258.587 24.4706L259.531 25.4118M257.644 25.4118L258.587 26.353L259.531 25.4118M257.644 25.4118L256.7 26.353M259.531 25.4118L260.475 26.353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask195_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="271"
        y="22"
      >
        <path d="M275.575 22.5883H271.8V26.353H275.575V22.5883Z" fill="white" />
      </mask>
      <g mask="url(#mask195_2057_43870)">
        <mask
          height="5"
          id="mask196_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="271"
          y="22"
        >
          <path d="M275.575 22.5883H271.8V26.353H275.575V22.5883Z" fill="white" />
        </mask>
        <g mask="url(#mask196_2057_43870)">
          <mask
            height="5"
            id="mask197_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="271"
            y="22"
          >
            <path d="M275.575 22.5883H271.8V26.353H275.575V22.5883Z" fill="white" />
          </mask>
          <g mask="url(#mask197_2057_43870)">
            <path
              d="M271.8 22.5883L272.744 23.5294M272.744 23.5294L273.688 22.5883L274.631 23.5294M272.744 23.5294L273.688 24.4706M272.744 23.5294L271.8 24.4706L272.744 25.4118M274.631 23.5294L273.688 24.4706M274.631 23.5294L275.575 22.5883M274.631 23.5294L275.575 24.4706L274.631 25.4118M273.688 24.4706L272.744 25.4118M273.688 24.4706L274.631 25.4118M272.744 25.4118L273.688 26.353L274.631 25.4118M272.744 25.4118L271.8 26.353M274.631 25.4118L275.575 26.353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask198_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="275"
        y="22"
      >
        <path d="M279.35 22.5883H275.575V26.353H279.35V22.5883Z" fill="white" />
      </mask>
      <g mask="url(#mask198_2057_43870)">
        <mask
          height="5"
          id="mask199_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="275"
          y="22"
        >
          <path d="M279.35 22.5883H275.575V26.353H279.35V22.5883Z" fill="white" />
        </mask>
        <g mask="url(#mask199_2057_43870)">
          <mask
            height="5"
            id="mask200_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="275"
            y="22"
          >
            <path d="M279.35 22.5883H275.575V26.353H279.35V22.5883Z" fill="white" />
          </mask>
          <g mask="url(#mask200_2057_43870)">
            <path
              d="M275.575 22.5883L276.519 23.5294M276.519 23.5294L277.462 22.5883L278.406 23.5294M276.519 23.5294L277.462 24.4706M276.519 23.5294L275.575 24.4706L276.519 25.4118M278.406 23.5294L277.462 24.4706M278.406 23.5294L279.35 22.5883M278.406 23.5294L279.35 24.4706L278.406 25.4118M277.462 24.4706L276.519 25.4118M277.462 24.4706L278.406 25.4118M276.519 25.4118L277.462 26.353L278.406 25.4118M276.519 25.4118L275.575 26.353M278.406 25.4118L279.35 26.353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask201_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="279"
        y="22"
      >
        <path d="M283.125 22.5883H279.35V26.353H283.125V22.5883Z" fill="white" />
      </mask>
      <g mask="url(#mask201_2057_43870)">
        <mask
          height="5"
          id="mask202_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="279"
          y="22"
        >
          <path d="M283.125 22.5883H279.35V26.353H283.125V22.5883Z" fill="white" />
        </mask>
        <g mask="url(#mask202_2057_43870)">
          <mask
            height="5"
            id="mask203_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="279"
            y="22"
          >
            <path d="M283.125 22.5883H279.35V26.353H283.125V22.5883Z" fill="white" />
          </mask>
          <g mask="url(#mask203_2057_43870)">
            <path
              d="M279.35 22.5883L280.294 23.5294M280.294 23.5294L281.237 22.5883L282.181 23.5294M280.294 23.5294L281.237 24.4706M280.294 23.5294L279.35 24.4706L280.294 25.4118M282.181 23.5294L281.237 24.4706M282.181 23.5294L283.125 22.5883M282.181 23.5294L283.125 24.4706L282.181 25.4118M281.237 24.4706L280.294 25.4118M281.237 24.4706L282.181 25.4118M280.294 25.4118L281.237 26.353L282.181 25.4118M280.294 25.4118L279.35 26.353M282.181 25.4118L283.125 26.353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="3"
        id="mask204_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="12"
        y="27"
      >
        <path d="M14.3065 27.0674H12.0415V29.3263H14.3065V27.0674Z" fill="white" />
      </mask>
      <g mask="url(#mask204_2057_43870)">
        <mask
          height="3"
          id="mask205_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="12"
          y="27"
        >
          <path d="M14.3065 27.0674H12.0415V29.3263H14.3065V27.0674Z" fill="white" />
        </mask>
        <g mask="url(#mask205_2057_43870)">
          <path
            d="M12.0415 27.0674L13.174 28.1969M13.174 28.1969L14.3065 27.0674M13.174 28.1969L14.3065 29.3263M13.174 28.1969L12.0415 29.3263"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask206_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="15"
        y="27"
      >
        <path d="M18.0814 27.0674H15.8164V29.3263H18.0814V27.0674Z" fill="white" />
      </mask>
      <g mask="url(#mask206_2057_43870)">
        <mask
          height="3"
          id="mask207_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="15"
          y="27"
        >
          <path d="M18.0814 27.0674H15.8164V29.3263H18.0814V27.0674Z" fill="white" />
        </mask>
        <g mask="url(#mask207_2057_43870)">
          <path
            d="M15.8164 27.0674L16.9489 28.1969M16.9489 28.1969L18.0814 27.0674M16.9489 28.1969L18.0814 29.3263M16.9489 28.1969L15.8164 29.3263"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask208_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="19"
        y="27"
      >
        <path d="M21.8564 27.0674H19.5914V29.3263H21.8564V27.0674Z" fill="white" />
      </mask>
      <g mask="url(#mask208_2057_43870)">
        <mask
          height="3"
          id="mask209_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="19"
          y="27"
        >
          <path d="M21.8564 27.0674H19.5914V29.3263H21.8564V27.0674Z" fill="white" />
        </mask>
        <g mask="url(#mask209_2057_43870)">
          <path
            d="M19.5914 27.0674L20.7239 28.1969M20.7239 28.1969L21.8564 27.0674M20.7239 28.1969L21.8564 29.3263M20.7239 28.1969L19.5914 29.3263"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask210_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="23"
        y="27"
      >
        <path d="M25.6315 27.0674H23.3665V29.3263H25.6315V27.0674Z" fill="white" />
      </mask>
      <g mask="url(#mask210_2057_43870)">
        <mask
          height="3"
          id="mask211_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="23"
          y="27"
        >
          <path d="M25.6315 27.0674H23.3665V29.3263H25.6315V27.0674Z" fill="white" />
        </mask>
        <g mask="url(#mask211_2057_43870)">
          <path
            d="M23.3665 27.0674L24.499 28.1969M24.499 28.1969L25.6315 27.0674M24.499 28.1969L25.6315 29.3263M24.499 28.1969L23.3665 29.3263"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask212_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="27"
        y="27"
      >
        <path d="M29.4065 27.0674H27.1415V29.3263H29.4065V27.0674Z" fill="white" />
      </mask>
      <g mask="url(#mask212_2057_43870)">
        <mask
          height="3"
          id="mask213_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="27"
          y="27"
        >
          <path d="M29.4065 27.0674H27.1415V29.3263H29.4065V27.0674Z" fill="white" />
        </mask>
        <g mask="url(#mask213_2057_43870)">
          <path
            d="M27.1415 27.0674L28.274 28.1969M28.274 28.1969L29.4065 27.0674M28.274 28.1969L29.4065 29.3263M28.274 28.1969L27.1415 29.3263"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask214_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="30"
        y="27"
      >
        <path d="M33.1815 27.0674H30.9165V29.3263H33.1815V27.0674Z" fill="white" />
      </mask>
      <g mask="url(#mask214_2057_43870)">
        <mask
          height="3"
          id="mask215_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="30"
          y="27"
        >
          <path d="M33.1815 27.0674H30.9165V29.3263H33.1815V27.0674Z" fill="white" />
        </mask>
        <g mask="url(#mask215_2057_43870)">
          <path
            d="M30.9165 27.0674L32.049 28.1969M32.049 28.1969L33.1815 27.0674M32.049 28.1969L33.1815 29.3263M32.049 28.1969L30.9165 29.3263"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask216_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="34"
        y="27"
      >
        <path d="M36.9564 27.0674H34.6914V29.3263H36.9564V27.0674Z" fill="white" />
      </mask>
      <g mask="url(#mask216_2057_43870)">
        <mask
          height="3"
          id="mask217_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="34"
          y="27"
        >
          <path d="M36.9564 27.0674H34.6914V29.3263H36.9564V27.0674Z" fill="white" />
        </mask>
        <g mask="url(#mask217_2057_43870)">
          <path
            d="M34.6914 27.0674L35.8239 28.1969M35.8239 28.1969L36.9564 27.0674M35.8239 28.1969L36.9564 29.3263M35.8239 28.1969L34.6914 29.3263"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask218_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="38"
        y="27"
      >
        <path d="M40.7316 27.0674H38.4666V29.3263H40.7316V27.0674Z" fill="white" />
      </mask>
      <g mask="url(#mask218_2057_43870)">
        <mask
          height="3"
          id="mask219_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="38"
          y="27"
        >
          <path d="M40.7316 27.0674H38.4666V29.3263H40.7316V27.0674Z" fill="white" />
        </mask>
        <g mask="url(#mask219_2057_43870)">
          <path
            d="M38.4666 27.0674L39.5991 28.1969M39.5991 28.1969L40.7316 27.0674M39.5991 28.1969L40.7316 29.3263M39.5991 28.1969L38.4666 29.3263"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask220_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="42"
        y="27"
      >
        <path d="M44.5065 27.0674H42.2415V29.3263H44.5065V27.0674Z" fill="white" />
      </mask>
      <g mask="url(#mask220_2057_43870)">
        <mask
          height="3"
          id="mask221_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="42"
          y="27"
        >
          <path d="M44.5065 27.0674H42.2415V29.3263H44.5065V27.0674Z" fill="white" />
        </mask>
        <g mask="url(#mask221_2057_43870)">
          <path
            d="M42.2415 27.0674L43.374 28.1969M43.374 28.1969L44.5065 27.0674M43.374 28.1969L44.5065 29.3263M43.374 28.1969L42.2415 29.3263"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask222_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="46"
        y="27"
      >
        <path d="M48.2815 27.0674H46.0165V29.3263H48.2815V27.0674Z" fill="white" />
      </mask>
      <g mask="url(#mask222_2057_43870)">
        <mask
          height="3"
          id="mask223_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="46"
          y="27"
        >
          <path d="M48.2815 27.0674H46.0165V29.3263H48.2815V27.0674Z" fill="white" />
        </mask>
        <g mask="url(#mask223_2057_43870)">
          <path
            d="M46.0165 27.0674L47.149 28.1969M47.149 28.1969L48.2815 27.0674M47.149 28.1969L48.2815 29.3263M47.149 28.1969L46.0165 29.3263"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask224_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="49"
        y="27"
      >
        <path d="M52.0565 27.0674H49.7915V29.3263H52.0565V27.0674Z" fill="white" />
      </mask>
      <g mask="url(#mask224_2057_43870)">
        <mask
          height="3"
          id="mask225_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="49"
          y="27"
        >
          <path d="M52.0565 27.0674H49.7915V29.3263H52.0565V27.0674Z" fill="white" />
        </mask>
        <g mask="url(#mask225_2057_43870)">
          <path
            d="M49.7915 27.0674L50.924 28.1969M50.924 28.1969L52.0565 27.0674M50.924 28.1969L52.0565 29.3263M50.924 28.1969L49.7915 29.3263"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask226_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="53"
        y="27"
      >
        <path d="M55.8315 27.0674H53.5665V29.3263H55.8315V27.0674Z" fill="white" />
      </mask>
      <g mask="url(#mask226_2057_43870)">
        <mask
          height="3"
          id="mask227_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="53"
          y="27"
        >
          <path d="M55.8315 27.0674H53.5665V29.3263H55.8315V27.0674Z" fill="white" />
        </mask>
        <g mask="url(#mask227_2057_43870)">
          <path
            d="M53.5665 27.0674L54.699 28.1969M54.699 28.1969L55.8315 27.0674M54.699 28.1969L55.8315 29.3263M54.699 28.1969L53.5665 29.3263"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="5"
        id="mask228_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="67"
        y="26"
      >
        <path d="M71.725 26.353H67.95V30.1177H71.725V26.353Z" fill="white" />
      </mask>
      <g mask="url(#mask228_2057_43870)">
        <mask
          height="5"
          id="mask229_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="67"
          y="26"
        >
          <path d="M71.725 26.353H67.95V30.1177H71.725V26.353Z" fill="white" />
        </mask>
        <g mask="url(#mask229_2057_43870)">
          <mask
            height="5"
            id="mask230_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="67"
            y="26"
          >
            <path d="M71.725 26.353H67.95V30.1177H71.725V26.353Z" fill="white" />
          </mask>
          <g mask="url(#mask230_2057_43870)">
            <path
              d="M67.95 26.353L68.8937 27.2941M68.8937 27.2941L69.8375 26.353L70.7812 27.2941M68.8937 27.2941L69.8375 28.2353M68.8937 27.2941L67.95 28.2353L68.8937 29.1765M70.7812 27.2941L69.8375 28.2353M70.7812 27.2941L71.725 26.353M70.7812 27.2941L71.725 28.2353L70.7812 29.1765M69.8375 28.2353L68.8937 29.1765M69.8375 28.2353L70.7812 29.1765M68.8937 29.1765L69.8375 30.1177L70.7812 29.1765M68.8937 29.1765L67.95 30.1177M70.7812 29.1765L71.725 30.1177"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask231_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="71"
        y="26"
      >
        <path d="M75.5 26.353H71.725V30.1177H75.5V26.353Z" fill="white" />
      </mask>
      <g mask="url(#mask231_2057_43870)">
        <mask
          height="5"
          id="mask232_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="71"
          y="26"
        >
          <path d="M75.5 26.353H71.725V30.1177H75.5V26.353Z" fill="white" />
        </mask>
        <g mask="url(#mask232_2057_43870)">
          <mask
            height="5"
            id="mask233_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="71"
            y="26"
          >
            <path d="M75.5 26.353H71.725V30.1177H75.5V26.353Z" fill="white" />
          </mask>
          <g mask="url(#mask233_2057_43870)">
            <path
              d="M71.725 26.353L72.6687 27.2941M72.6687 27.2941L73.6125 26.353L74.5562 27.2941M72.6687 27.2941L73.6125 28.2353M72.6687 27.2941L71.725 28.2353L72.6687 29.1765M74.5562 27.2941L73.6125 28.2353M74.5562 27.2941L75.5 26.353M74.5562 27.2941L75.5 28.2353L74.5562 29.1765M73.6125 28.2353L72.6687 29.1765M73.6125 28.2353L74.5562 29.1765M72.6687 29.1765L73.6125 30.1177L74.5562 29.1765M72.6687 29.1765L71.725 30.1177M74.5562 29.1765L75.5 30.1177"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask234_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="109"
        y="26"
      >
        <path d="M113.25 26.353H109.475V30.1177H113.25V26.353Z" fill="white" />
      </mask>
      <g mask="url(#mask234_2057_43870)">
        <mask
          height="5"
          id="mask235_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="109"
          y="26"
        >
          <path d="M113.25 26.353H109.475V30.1177H113.25V26.353Z" fill="white" />
        </mask>
        <g mask="url(#mask235_2057_43870)">
          <mask
            height="5"
            id="mask236_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="109"
            y="26"
          >
            <path d="M113.25 26.353H109.475V30.1177H113.25V26.353Z" fill="white" />
          </mask>
          <g mask="url(#mask236_2057_43870)">
            <path
              d="M109.475 26.353L110.419 27.2941M110.419 27.2941L111.362 26.353L112.306 27.2941M110.419 27.2941L111.362 28.2353M110.419 27.2941L109.475 28.2353L110.419 29.1765M112.306 27.2941L111.362 28.2353M112.306 27.2941L113.25 26.353M112.306 27.2941L113.25 28.2353L112.306 29.1765M111.362 28.2353L110.419 29.1765M111.362 28.2353L112.306 29.1765M110.419 29.1765L111.362 30.1177L112.306 29.1765M110.419 29.1765L109.475 30.1177M112.306 29.1765L113.25 30.1177"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask237_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="113"
        y="26"
      >
        <path d="M117.025 26.353H113.25V30.1177H117.025V26.353Z" fill="white" />
      </mask>
      <g mask="url(#mask237_2057_43870)">
        <mask
          height="5"
          id="mask238_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="113"
          y="26"
        >
          <path d="M117.025 26.353H113.25V30.1177H117.025V26.353Z" fill="white" />
        </mask>
        <g mask="url(#mask238_2057_43870)">
          <mask
            height="5"
            id="mask239_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="113"
            y="26"
          >
            <path d="M117.025 26.353H113.25V30.1177H117.025V26.353Z" fill="white" />
          </mask>
          <g mask="url(#mask239_2057_43870)">
            <path
              d="M113.25 26.353L114.194 27.2941M114.194 27.2941L115.137 26.353L116.081 27.2941M114.194 27.2941L115.137 28.2353M114.194 27.2941L113.25 28.2353L114.194 29.1765M116.081 27.2941L115.137 28.2353M116.081 27.2941L117.025 26.353M116.081 27.2941L117.025 28.2353L116.081 29.1765M115.137 28.2353L114.194 29.1765M115.137 28.2353L116.081 29.1765M114.194 29.1765L115.137 30.1177L116.081 29.1765M114.194 29.1765L113.25 30.1177M116.081 29.1765L117.025 30.1177"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask240_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="117"
        y="26"
      >
        <path d="M120.8 26.353H117.025V30.1177H120.8V26.353Z" fill="white" />
      </mask>
      <g mask="url(#mask240_2057_43870)">
        <mask
          height="5"
          id="mask241_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="117"
          y="26"
        >
          <path d="M120.8 26.353H117.025V30.1177H120.8V26.353Z" fill="white" />
        </mask>
        <g mask="url(#mask241_2057_43870)">
          <mask
            height="5"
            id="mask242_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="117"
            y="26"
          >
            <path d="M120.8 26.353H117.025V30.1177H120.8V26.353Z" fill="white" />
          </mask>
          <g mask="url(#mask242_2057_43870)">
            <path
              d="M117.025 26.353L117.969 27.2941M117.969 27.2941L118.913 26.353L119.856 27.2941M117.969 27.2941L118.913 28.2353M117.969 27.2941L117.025 28.2353L117.969 29.1765M119.856 27.2941L118.913 28.2353M119.856 27.2941L120.8 26.353M119.856 27.2941L120.8 28.2353L119.856 29.1765M118.913 28.2353L117.969 29.1765M118.913 28.2353L119.856 29.1765M117.969 29.1765L118.913 30.1177L119.856 29.1765M117.969 29.1765L117.025 30.1177M119.856 29.1765L120.8 30.1177"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask243_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="143"
        y="26"
      >
        <path d="M147.225 26.353H143.45V30.1177H147.225V26.353Z" fill="white" />
      </mask>
      <g mask="url(#mask243_2057_43870)">
        <mask
          height="5"
          id="mask244_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="143"
          y="26"
        >
          <path d="M147.225 26.353H143.45V30.1177H147.225V26.353Z" fill="white" />
        </mask>
        <g mask="url(#mask244_2057_43870)">
          <mask
            height="5"
            id="mask245_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="143"
            y="26"
          >
            <path d="M147.225 26.353H143.45V30.1177H147.225V26.353Z" fill="white" />
          </mask>
          <g mask="url(#mask245_2057_43870)">
            <path
              d="M143.45 26.353L144.394 27.2941M144.394 27.2941L145.337 26.353L146.281 27.2941M144.394 27.2941L145.337 28.2353M144.394 27.2941L143.45 28.2353L144.394 29.1765M146.281 27.2941L145.337 28.2353M146.281 27.2941L147.225 26.353M146.281 27.2941L147.225 28.2353L146.281 29.1765M145.337 28.2353L144.394 29.1765M145.337 28.2353L146.281 29.1765M144.394 29.1765L145.337 30.1177L146.281 29.1765M144.394 29.1765L143.45 30.1177M146.281 29.1765L147.225 30.1177"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask246_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="147"
        y="26"
      >
        <path d="M151 26.353H147.225V30.1177H151V26.353Z" fill="white" />
      </mask>
      <g mask="url(#mask246_2057_43870)">
        <mask
          height="5"
          id="mask247_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="147"
          y="26"
        >
          <path d="M151 26.353H147.225V30.1177H151V26.353Z" fill="white" />
        </mask>
        <g mask="url(#mask247_2057_43870)">
          <mask
            height="5"
            id="mask248_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="147"
            y="26"
          >
            <path d="M151 26.353H147.225V30.1177H151V26.353Z" fill="white" />
          </mask>
          <g mask="url(#mask248_2057_43870)">
            <path
              d="M147.225 26.353L148.169 27.2941M148.169 27.2941L149.112 26.353L150.056 27.2941M148.169 27.2941L149.112 28.2353M148.169 27.2941L147.225 28.2353L148.169 29.1765M150.056 27.2941L149.112 28.2353M150.056 27.2941L151 26.353M150.056 27.2941L151 28.2353L150.056 29.1765M149.112 28.2353L148.169 29.1765M149.112 28.2353L150.056 29.1765M148.169 29.1765L149.112 30.1177L150.056 29.1765M148.169 29.1765L147.225 30.1177M150.056 29.1765L151 30.1177"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask249_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="151"
        y="26"
      >
        <path d="M154.775 26.353H151V30.1177H154.775V26.353Z" fill="white" />
      </mask>
      <g mask="url(#mask249_2057_43870)">
        <mask
          height="5"
          id="mask250_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="151"
          y="26"
        >
          <path d="M154.775 26.353H151V30.1177H154.775V26.353Z" fill="white" />
        </mask>
        <g mask="url(#mask250_2057_43870)">
          <mask
            height="5"
            id="mask251_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="151"
            y="26"
          >
            <path d="M154.775 26.353H151V30.1177H154.775V26.353Z" fill="white" />
          </mask>
          <g mask="url(#mask251_2057_43870)">
            <path
              d="M151 26.353L151.944 27.2941M151.944 27.2941L152.887 26.353L153.831 27.2941M151.944 27.2941L152.887 28.2353M151.944 27.2941L151 28.2353L151.944 29.1765M153.831 27.2941L152.887 28.2353M153.831 27.2941L154.775 26.353M153.831 27.2941L154.775 28.2353L153.831 29.1765M152.887 28.2353L151.944 29.1765M152.887 28.2353L153.831 29.1765M151.944 29.1765L152.887 30.1177L153.831 29.1765M151.944 29.1765L151 30.1177M153.831 29.1765L154.775 30.1177"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask252_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="154"
        y="26"
      >
        <path d="M158.55 26.353H154.775V30.1177H158.55V26.353Z" fill="white" />
      </mask>
      <g mask="url(#mask252_2057_43870)">
        <mask
          height="5"
          id="mask253_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="154"
          y="26"
        >
          <path d="M158.55 26.353H154.775V30.1177H158.55V26.353Z" fill="white" />
        </mask>
        <g mask="url(#mask253_2057_43870)">
          <mask
            height="5"
            id="mask254_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="154"
            y="26"
          >
            <path d="M158.55 26.353H154.775V30.1177H158.55V26.353Z" fill="white" />
          </mask>
          <g mask="url(#mask254_2057_43870)">
            <path
              d="M154.775 26.353L155.719 27.2941M155.719 27.2941L156.663 26.353L157.606 27.2941M155.719 27.2941L156.663 28.2353M155.719 27.2941L154.775 28.2353L155.719 29.1765M157.606 27.2941L156.663 28.2353M157.606 27.2941L158.55 26.353M157.606 27.2941L158.55 28.2353L157.606 29.1765M156.663 28.2353L155.719 29.1765M156.663 28.2353L157.606 29.1765M155.719 29.1765L156.663 30.1177L157.606 29.1765M155.719 29.1765L154.775 30.1177M157.606 29.1765L158.55 30.1177"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask255_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="158"
        y="26"
      >
        <path d="M162.325 26.353H158.55V30.1177H162.325V26.353Z" fill="white" />
      </mask>
      <g mask="url(#mask255_2057_43870)">
        <mask
          height="5"
          id="mask256_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="158"
          y="26"
        >
          <path d="M162.325 26.353H158.55V30.1177H162.325V26.353Z" fill="white" />
        </mask>
        <g mask="url(#mask256_2057_43870)">
          <mask
            height="5"
            id="mask257_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="158"
            y="26"
          >
            <path d="M162.325 26.353H158.55V30.1177H162.325V26.353Z" fill="white" />
          </mask>
          <g mask="url(#mask257_2057_43870)">
            <path
              d="M158.55 26.353L159.494 27.2941M159.494 27.2941L160.438 26.353L161.381 27.2941M159.494 27.2941L160.438 28.2353M159.494 27.2941L158.55 28.2353L159.494 29.1765M161.381 27.2941L160.438 28.2353M161.381 27.2941L162.325 26.353M161.381 27.2941L162.325 28.2353L161.381 29.1765M160.438 28.2353L159.494 29.1765M160.438 28.2353L161.381 29.1765M159.494 29.1765L160.438 30.1177L161.381 29.1765M159.494 29.1765L158.55 30.1177M161.381 29.1765L162.325 30.1177"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask258_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="162"
        y="26"
      >
        <path d="M166.1 26.353H162.325V30.1177H166.1V26.353Z" fill="white" />
      </mask>
      <g mask="url(#mask258_2057_43870)">
        <mask
          height="5"
          id="mask259_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="162"
          y="26"
        >
          <path d="M166.1 26.353H162.325V30.1177H166.1V26.353Z" fill="white" />
        </mask>
        <g mask="url(#mask259_2057_43870)">
          <mask
            height="5"
            id="mask260_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="162"
            y="26"
          >
            <path d="M166.1 26.353H162.325V30.1177H166.1V26.353Z" fill="white" />
          </mask>
          <g mask="url(#mask260_2057_43870)">
            <path
              d="M162.325 26.353L163.269 27.2941M163.269 27.2941L164.212 26.353L165.156 27.2941M163.269 27.2941L164.212 28.2353M163.269 27.2941L162.325 28.2353L163.269 29.1765M165.156 27.2941L164.212 28.2353M165.156 27.2941L166.1 26.353M165.156 27.2941L166.1 28.2353L165.156 29.1765M164.212 28.2353L163.269 29.1765M164.212 28.2353L165.156 29.1765M163.269 29.1765L164.212 30.1177L165.156 29.1765M163.269 29.1765L162.325 30.1177M165.156 29.1765L166.1 30.1177"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask261_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="166"
        y="26"
      >
        <path d="M169.875 26.353H166.1V30.1177H169.875V26.353Z" fill="white" />
      </mask>
      <g mask="url(#mask261_2057_43870)">
        <mask
          height="5"
          id="mask262_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="166"
          y="26"
        >
          <path d="M169.875 26.353H166.1V30.1177H169.875V26.353Z" fill="white" />
        </mask>
        <g mask="url(#mask262_2057_43870)">
          <mask
            height="5"
            id="mask263_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="166"
            y="26"
          >
            <path d="M169.875 26.353H166.1V30.1177H169.875V26.353Z" fill="white" />
          </mask>
          <g mask="url(#mask263_2057_43870)">
            <path
              d="M166.1 26.353L167.044 27.2941M167.044 27.2941L167.987 26.353L168.931 27.2941M167.044 27.2941L167.987 28.2353M167.044 27.2941L166.1 28.2353L167.044 29.1765M168.931 27.2941L167.987 28.2353M168.931 27.2941L169.875 26.353M168.931 27.2941L169.875 28.2353L168.931 29.1765M167.987 28.2353L167.044 29.1765M167.987 28.2353L168.931 29.1765M167.044 29.1765L167.987 30.1177L168.931 29.1765M167.044 29.1765L166.1 30.1177M168.931 29.1765L169.875 30.1177"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask264_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="169"
        y="26"
      >
        <path d="M173.65 26.353H169.875V30.1177H173.65V26.353Z" fill="white" />
      </mask>
      <g mask="url(#mask264_2057_43870)">
        <mask
          height="5"
          id="mask265_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="169"
          y="26"
        >
          <path d="M173.65 26.353H169.875V30.1177H173.65V26.353Z" fill="white" />
        </mask>
        <g mask="url(#mask265_2057_43870)">
          <mask
            height="5"
            id="mask266_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="169"
            y="26"
          >
            <path d="M173.65 26.353H169.875V30.1177H173.65V26.353Z" fill="white" />
          </mask>
          <g mask="url(#mask266_2057_43870)">
            <path
              d="M169.875 26.353L170.819 27.2941M170.819 27.2941L171.762 26.353L172.706 27.2941M170.819 27.2941L171.762 28.2353M170.819 27.2941L169.875 28.2353L170.819 29.1765M172.706 27.2941L171.762 28.2353M172.706 27.2941L173.65 26.353M172.706 27.2941L173.65 28.2353L172.706 29.1765M171.762 28.2353L170.819 29.1765M171.762 28.2353L172.706 29.1765M170.819 29.1765L171.762 30.1177L172.706 29.1765M170.819 29.1765L169.875 30.1177M172.706 29.1765L173.65 30.1177"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask267_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="207"
        y="26"
      >
        <path d="M211.4 26.353H207.625V30.1177H211.4V26.353Z" fill="white" />
      </mask>
      <g mask="url(#mask267_2057_43870)">
        <mask
          height="5"
          id="mask268_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="207"
          y="26"
        >
          <path d="M211.4 26.353H207.625V30.1177H211.4V26.353Z" fill="white" />
        </mask>
        <g mask="url(#mask268_2057_43870)">
          <mask
            height="5"
            id="mask269_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="207"
            y="26"
          >
            <path d="M211.4 26.353H207.625V30.1177H211.4V26.353Z" fill="white" />
          </mask>
          <g mask="url(#mask269_2057_43870)">
            <path
              d="M207.625 26.353L208.569 27.2941M208.569 27.2941L209.512 26.353L210.456 27.2941M208.569 27.2941L209.512 28.2353M208.569 27.2941L207.625 28.2353L208.569 29.1765M210.456 27.2941L209.512 28.2353M210.456 27.2941L211.4 26.353M210.456 27.2941L211.4 28.2353L210.456 29.1765M209.512 28.2353L208.569 29.1765M209.512 28.2353L210.456 29.1765M208.569 29.1765L209.512 30.1177L210.456 29.1765M208.569 29.1765L207.625 30.1177M210.456 29.1765L211.4 30.1177"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask270_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="211"
        y="26"
      >
        <path d="M215.175 26.353H211.4V30.1177H215.175V26.353Z" fill="white" />
      </mask>
      <g mask="url(#mask270_2057_43870)">
        <mask
          height="5"
          id="mask271_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="211"
          y="26"
        >
          <path d="M215.175 26.353H211.4V30.1177H215.175V26.353Z" fill="white" />
        </mask>
        <g mask="url(#mask271_2057_43870)">
          <mask
            height="5"
            id="mask272_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="211"
            y="26"
          >
            <path d="M215.175 26.353H211.4V30.1177H215.175V26.353Z" fill="white" />
          </mask>
          <g mask="url(#mask272_2057_43870)">
            <path
              d="M211.4 26.353L212.344 27.2941M212.344 27.2941L213.288 26.353L214.231 27.2941M212.344 27.2941L213.288 28.2353M212.344 27.2941L211.4 28.2353L212.344 29.1765M214.231 27.2941L213.288 28.2353M214.231 27.2941L215.175 26.353M214.231 27.2941L215.175 28.2353L214.231 29.1765M213.288 28.2353L212.344 29.1765M213.288 28.2353L214.231 29.1765M212.344 29.1765L213.288 30.1177L214.231 29.1765M212.344 29.1765L211.4 30.1177M214.231 29.1765L215.175 30.1177"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask273_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="215"
        y="26"
      >
        <path d="M218.95 26.353H215.175V30.1177H218.95V26.353Z" fill="white" />
      </mask>
      <g mask="url(#mask273_2057_43870)">
        <mask
          height="5"
          id="mask274_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="215"
          y="26"
        >
          <path d="M218.95 26.353H215.175V30.1177H218.95V26.353Z" fill="white" />
        </mask>
        <g mask="url(#mask274_2057_43870)">
          <mask
            height="5"
            id="mask275_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="215"
            y="26"
          >
            <path d="M218.95 26.353H215.175V30.1177H218.95V26.353Z" fill="white" />
          </mask>
          <g mask="url(#mask275_2057_43870)">
            <path
              d="M215.175 26.353L216.119 27.2941M216.119 27.2941L217.063 26.353L218.006 27.2941M216.119 27.2941L217.063 28.2353M216.119 27.2941L215.175 28.2353L216.119 29.1765M218.006 27.2941L217.063 28.2353M218.006 27.2941L218.95 26.353M218.006 27.2941L218.95 28.2353L218.006 29.1765M217.063 28.2353L216.119 29.1765M217.063 28.2353L218.006 29.1765M216.119 29.1765L217.063 30.1177L218.006 29.1765M216.119 29.1765L215.175 30.1177M218.006 29.1765L218.95 30.1177"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask276_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="218"
        y="26"
      >
        <path d="M222.725 26.353H218.95V30.1177H222.725V26.353Z" fill="white" />
      </mask>
      <g mask="url(#mask276_2057_43870)">
        <mask
          height="5"
          id="mask277_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="218"
          y="26"
        >
          <path d="M222.725 26.353H218.95V30.1177H222.725V26.353Z" fill="white" />
        </mask>
        <g mask="url(#mask277_2057_43870)">
          <mask
            height="5"
            id="mask278_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="218"
            y="26"
          >
            <path d="M222.725 26.353H218.95V30.1177H222.725V26.353Z" fill="white" />
          </mask>
          <g mask="url(#mask278_2057_43870)">
            <path
              d="M218.95 26.353L219.894 27.2941M219.894 27.2941L220.837 26.353L221.781 27.2941M219.894 27.2941L220.837 28.2353M219.894 27.2941L218.95 28.2353L219.894 29.1765M221.781 27.2941L220.837 28.2353M221.781 27.2941L222.725 26.353M221.781 27.2941L222.725 28.2353L221.781 29.1765M220.837 28.2353L219.894 29.1765M220.837 28.2353L221.781 29.1765M219.894 29.1765L220.837 30.1177L221.781 29.1765M219.894 29.1765L218.95 30.1177M221.781 29.1765L222.725 30.1177"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask279_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="222"
        y="26"
      >
        <path d="M226.5 26.353H222.725V30.1177H226.5V26.353Z" fill="white" />
      </mask>
      <g mask="url(#mask279_2057_43870)">
        <mask
          height="5"
          id="mask280_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="222"
          y="26"
        >
          <path d="M226.5 26.353H222.725V30.1177H226.5V26.353Z" fill="white" />
        </mask>
        <g mask="url(#mask280_2057_43870)">
          <mask
            height="5"
            id="mask281_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="222"
            y="26"
          >
            <path d="M226.5 26.353H222.725V30.1177H226.5V26.353Z" fill="white" />
          </mask>
          <g mask="url(#mask281_2057_43870)">
            <path
              d="M222.725 26.353L223.669 27.2941M223.669 27.2941L224.612 26.353L225.556 27.2941M223.669 27.2941L224.612 28.2353M223.669 27.2941L222.725 28.2353L223.669 29.1765M225.556 27.2941L224.612 28.2353M225.556 27.2941L226.5 26.353M225.556 27.2941L226.5 28.2353L225.556 29.1765M224.612 28.2353L223.669 29.1765M224.612 28.2353L225.556 29.1765M223.669 29.1765L224.612 30.1177L225.556 29.1765M223.669 29.1765L222.725 30.1177M225.556 29.1765L226.5 30.1177"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask282_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="249"
        y="26"
      >
        <path d="M252.925 26.353H249.15V30.1177H252.925V26.353Z" fill="white" />
      </mask>
      <g mask="url(#mask282_2057_43870)">
        <mask
          height="5"
          id="mask283_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="249"
          y="26"
        >
          <path d="M252.925 26.353H249.15V30.1177H252.925V26.353Z" fill="white" />
        </mask>
        <g mask="url(#mask283_2057_43870)">
          <mask
            height="5"
            id="mask284_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="249"
            y="26"
          >
            <path d="M252.925 26.353H249.15V30.1177H252.925V26.353Z" fill="white" />
          </mask>
          <g mask="url(#mask284_2057_43870)">
            <path
              d="M249.15 26.353L250.094 27.2941M250.094 27.2941L251.038 26.353L251.981 27.2941M250.094 27.2941L251.038 28.2353M250.094 27.2941L249.15 28.2353L250.094 29.1765M251.981 27.2941L251.038 28.2353M251.981 27.2941L252.925 26.353M251.981 27.2941L252.925 28.2353L251.981 29.1765M251.038 28.2353L250.094 29.1765M251.038 28.2353L251.981 29.1765M250.094 29.1765L251.038 30.1177L251.981 29.1765M250.094 29.1765L249.15 30.1177M251.981 29.1765L252.925 30.1177"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask285_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="252"
        y="26"
      >
        <path d="M256.7 26.353H252.925V30.1177H256.7V26.353Z" fill="white" />
      </mask>
      <g mask="url(#mask285_2057_43870)">
        <mask
          height="5"
          id="mask286_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="252"
          y="26"
        >
          <path d="M256.7 26.353H252.925V30.1177H256.7V26.353Z" fill="white" />
        </mask>
        <g mask="url(#mask286_2057_43870)">
          <mask
            height="5"
            id="mask287_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="252"
            y="26"
          >
            <path d="M256.7 26.353H252.925V30.1177H256.7V26.353Z" fill="white" />
          </mask>
          <g mask="url(#mask287_2057_43870)">
            <path
              d="M252.925 26.353L253.869 27.2941M253.869 27.2941L254.813 26.353L255.756 27.2941M253.869 27.2941L254.813 28.2353M253.869 27.2941L252.925 28.2353L253.869 29.1765M255.756 27.2941L254.813 28.2353M255.756 27.2941L256.7 26.353M255.756 27.2941L256.7 28.2353L255.756 29.1765M254.813 28.2353L253.869 29.1765M254.813 28.2353L255.756 29.1765M253.869 29.1765L254.813 30.1177L255.756 29.1765M253.869 29.1765L252.925 30.1177M255.756 29.1765L256.7 30.1177"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask288_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="256"
        y="26"
      >
        <path d="M260.475 26.353H256.7V30.1177H260.475V26.353Z" fill="white" />
      </mask>
      <g mask="url(#mask288_2057_43870)">
        <mask
          height="5"
          id="mask289_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="256"
          y="26"
        >
          <path d="M260.475 26.353H256.7V30.1177H260.475V26.353Z" fill="white" />
        </mask>
        <g mask="url(#mask289_2057_43870)">
          <mask
            height="5"
            id="mask290_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="256"
            y="26"
          >
            <path d="M260.475 26.353H256.7V30.1177H260.475V26.353Z" fill="white" />
          </mask>
          <g mask="url(#mask290_2057_43870)">
            <path
              d="M256.7 26.353L257.644 27.2941M257.644 27.2941L258.587 26.353L259.531 27.2941M257.644 27.2941L258.587 28.2353M257.644 27.2941L256.7 28.2353L257.644 29.1765M259.531 27.2941L258.587 28.2353M259.531 27.2941L260.475 26.353M259.531 27.2941L260.475 28.2353L259.531 29.1765M258.587 28.2353L257.644 29.1765M258.587 28.2353L259.531 29.1765M257.644 29.1765L258.587 30.1177L259.531 29.1765M257.644 29.1765L256.7 30.1177M259.531 29.1765L260.475 30.1177"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask291_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="271"
        y="26"
      >
        <path d="M275.575 26.353H271.8V30.1177H275.575V26.353Z" fill="white" />
      </mask>
      <g mask="url(#mask291_2057_43870)">
        <mask
          height="5"
          id="mask292_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="271"
          y="26"
        >
          <path d="M275.575 26.353H271.8V30.1177H275.575V26.353Z" fill="white" />
        </mask>
        <g mask="url(#mask292_2057_43870)">
          <mask
            height="5"
            id="mask293_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="271"
            y="26"
          >
            <path d="M275.575 26.353H271.8V30.1177H275.575V26.353Z" fill="white" />
          </mask>
          <g mask="url(#mask293_2057_43870)">
            <path
              d="M271.8 26.353L272.744 27.2941M272.744 27.2941L273.688 26.353L274.631 27.2941M272.744 27.2941L273.688 28.2353M272.744 27.2941L271.8 28.2353L272.744 29.1765M274.631 27.2941L273.688 28.2353M274.631 27.2941L275.575 26.353M274.631 27.2941L275.575 28.2353L274.631 29.1765M273.688 28.2353L272.744 29.1765M273.688 28.2353L274.631 29.1765M272.744 29.1765L273.688 30.1177L274.631 29.1765M272.744 29.1765L271.8 30.1177M274.631 29.1765L275.575 30.1177"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask294_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="275"
        y="26"
      >
        <path d="M279.35 26.353H275.575V30.1177H279.35V26.353Z" fill="white" />
      </mask>
      <g mask="url(#mask294_2057_43870)">
        <mask
          height="5"
          id="mask295_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="275"
          y="26"
        >
          <path d="M279.35 26.353H275.575V30.1177H279.35V26.353Z" fill="white" />
        </mask>
        <g mask="url(#mask295_2057_43870)">
          <mask
            height="5"
            id="mask296_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="275"
            y="26"
          >
            <path d="M279.35 26.353H275.575V30.1177H279.35V26.353Z" fill="white" />
          </mask>
          <g mask="url(#mask296_2057_43870)">
            <path
              d="M275.575 26.353L276.519 27.2941M276.519 27.2941L277.462 26.353L278.406 27.2941M276.519 27.2941L277.462 28.2353M276.519 27.2941L275.575 28.2353L276.519 29.1765M278.406 27.2941L277.462 28.2353M278.406 27.2941L279.35 26.353M278.406 27.2941L279.35 28.2353L278.406 29.1765M277.462 28.2353L276.519 29.1765M277.462 28.2353L278.406 29.1765M276.519 29.1765L277.462 30.1177L278.406 29.1765M276.519 29.1765L275.575 30.1177M278.406 29.1765L279.35 30.1177"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask297_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="279"
        y="26"
      >
        <path d="M283.125 26.353H279.35V30.1177H283.125V26.353Z" fill="white" />
      </mask>
      <g mask="url(#mask297_2057_43870)">
        <mask
          height="5"
          id="mask298_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="279"
          y="26"
        >
          <path d="M283.125 26.353H279.35V30.1177H283.125V26.353Z" fill="white" />
        </mask>
        <g mask="url(#mask298_2057_43870)">
          <mask
            height="5"
            id="mask299_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="279"
            y="26"
          >
            <path d="M283.125 26.353H279.35V30.1177H283.125V26.353Z" fill="white" />
          </mask>
          <g mask="url(#mask299_2057_43870)">
            <path
              d="M279.35 26.353L280.294 27.2941M280.294 27.2941L281.237 26.353L282.181 27.2941M280.294 27.2941L281.237 28.2353M280.294 27.2941L279.35 28.2353L280.294 29.1765M282.181 27.2941L281.237 28.2353M282.181 27.2941L283.125 26.353M282.181 27.2941L283.125 28.2353L282.181 29.1765M281.237 28.2353L280.294 29.1765M281.237 28.2353L282.181 29.1765M280.294 29.1765L281.237 30.1177L282.181 29.1765M280.294 29.1765L279.35 30.1177M282.181 29.1765L283.125 30.1177"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask300_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="0"
        y="30"
      >
        <path d="M2.98143 30.8322H0.716431V33.091H2.98143V30.8322Z" fill="white" />
      </mask>
      <g mask="url(#mask300_2057_43870)">
        <mask
          height="4"
          id="mask301_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="0"
          y="30"
        >
          <path d="M2.98143 30.8322H0.716431V33.091H2.98143V30.8322Z" fill="white" />
        </mask>
        <g mask="url(#mask301_2057_43870)">
          <path
            d="M0.716431 30.8322L1.84893 31.9616M1.84893 31.9616L2.98143 30.8322M1.84893 31.9616L2.98143 33.091M1.84893 31.9616L0.716431 33.091"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="4"
        id="mask302_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="4"
        y="30"
      >
        <path d="M6.75646 30.8322H4.49146V33.091H6.75646V30.8322Z" fill="white" />
      </mask>
      <g mask="url(#mask302_2057_43870)">
        <mask
          height="4"
          id="mask303_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="4"
          y="30"
        >
          <path d="M6.75646 30.8322H4.49146V33.091H6.75646V30.8322Z" fill="white" />
        </mask>
        <g mask="url(#mask303_2057_43870)">
          <path
            d="M4.49146 30.8322L5.62396 31.9616M5.62396 31.9616L6.75646 30.8322M5.62396 31.9616L6.75646 33.091M5.62396 31.9616L4.49146 33.091"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="4"
        id="mask304_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="8"
        y="30"
      >
        <path d="M10.5315 30.8322H8.26648V33.091H10.5315V30.8322Z" fill="white" />
      </mask>
      <g mask="url(#mask304_2057_43870)">
        <mask
          height="4"
          id="mask305_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="8"
          y="30"
        >
          <path d="M10.5315 30.8322H8.26648V33.091H10.5315V30.8322Z" fill="white" />
        </mask>
        <g mask="url(#mask305_2057_43870)">
          <path
            d="M8.26648 30.8322L9.39898 31.9616M9.39898 31.9616L10.5315 30.8322M9.39898 31.9616L10.5315 33.091M9.39898 31.9616L8.26648 33.091"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="4"
        id="mask306_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="67"
        y="30"
      >
        <path d="M71.725 30.1177H67.95V33.8824H71.725V30.1177Z" fill="white" />
      </mask>
      <g mask="url(#mask306_2057_43870)">
        <mask
          height="4"
          id="mask307_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="67"
          y="30"
        >
          <path d="M71.725 30.1177H67.95V33.8824H71.725V30.1177Z" fill="white" />
        </mask>
        <g mask="url(#mask307_2057_43870)">
          <mask
            height="4"
            id="mask308_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="67"
            y="30"
          >
            <path d="M71.725 30.1177H67.95V33.8824H71.725V30.1177Z" fill="white" />
          </mask>
          <g mask="url(#mask308_2057_43870)">
            <path
              d="M67.95 30.1177L68.8937 31.0589M68.8937 31.0589L69.8375 30.1177L70.7812 31.0589M68.8937 31.0589L69.8375 32M68.8937 31.0589L67.95 32L68.8937 32.9412M70.7812 31.0589L69.8375 32M70.7812 31.0589L71.725 30.1177M70.7812 31.0589L71.725 32L70.7812 32.9412M69.8375 32L68.8937 32.9412M69.8375 32L70.7812 32.9412M68.8937 32.9412L69.8375 33.8824L70.7812 32.9412M68.8937 32.9412L67.95 33.8824M70.7812 32.9412L71.725 33.8824"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask309_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="71"
        y="30"
      >
        <path d="M75.5 30.1177H71.725V33.8824H75.5V30.1177Z" fill="white" />
      </mask>
      <g mask="url(#mask309_2057_43870)">
        <mask
          height="4"
          id="mask310_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="71"
          y="30"
        >
          <path d="M75.5 30.1177H71.725V33.8824H75.5V30.1177Z" fill="white" />
        </mask>
        <g mask="url(#mask310_2057_43870)">
          <mask
            height="4"
            id="mask311_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="71"
            y="30"
          >
            <path d="M75.5 30.1177H71.725V33.8824H75.5V30.1177Z" fill="white" />
          </mask>
          <g mask="url(#mask311_2057_43870)">
            <path
              d="M71.725 30.1177L72.6687 31.0589M72.6687 31.0589L73.6125 30.1177L74.5562 31.0589M72.6687 31.0589L73.6125 32M72.6687 31.0589L71.725 32L72.6687 32.9412M74.5562 31.0589L73.6125 32M74.5562 31.0589L75.5 30.1177M74.5562 31.0589L75.5 32L74.5562 32.9412M73.6125 32L72.6687 32.9412M73.6125 32L74.5562 32.9412M72.6687 32.9412L73.6125 33.8824L74.5562 32.9412M72.6687 32.9412L71.725 33.8824M74.5562 32.9412L75.5 33.8824"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask312_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="86"
        y="30"
      >
        <path d="M90.6 30.1177H86.825V33.8824H90.6V30.1177Z" fill="white" />
      </mask>
      <g mask="url(#mask312_2057_43870)">
        <mask
          height="4"
          id="mask313_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="86"
          y="30"
        >
          <path d="M90.6 30.1177H86.825V33.8824H90.6V30.1177Z" fill="white" />
        </mask>
        <g mask="url(#mask313_2057_43870)">
          <mask
            height="4"
            id="mask314_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="86"
            y="30"
          >
            <path d="M90.6 30.1177H86.825V33.8824H90.6V30.1177Z" fill="white" />
          </mask>
          <g mask="url(#mask314_2057_43870)">
            <path
              d="M86.825 30.1177L87.7687 31.0589M87.7687 31.0589L88.7125 30.1177L89.6562 31.0589M87.7687 31.0589L88.7125 32M87.7687 31.0589L86.825 32L87.7687 32.9412M89.6562 31.0589L88.7125 32M89.6562 31.0589L90.6 30.1177M89.6562 31.0589L90.6 32L89.6562 32.9412M88.7125 32L87.7687 32.9412M88.7125 32L89.6562 32.9412M87.7687 32.9412L88.7125 33.8824L89.6562 32.9412M87.7687 32.9412L86.825 33.8824M89.6562 32.9412L90.6 33.8824"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask315_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="90"
        y="30"
      >
        <path d="M94.375 30.1177H90.6V33.8824H94.375V30.1177Z" fill="white" />
      </mask>
      <g mask="url(#mask315_2057_43870)">
        <mask
          height="4"
          id="mask316_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="90"
          y="30"
        >
          <path d="M94.375 30.1177H90.6V33.8824H94.375V30.1177Z" fill="white" />
        </mask>
        <g mask="url(#mask316_2057_43870)">
          <mask
            height="4"
            id="mask317_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="90"
            y="30"
          >
            <path d="M94.375 30.1177H90.6V33.8824H94.375V30.1177Z" fill="white" />
          </mask>
          <g mask="url(#mask317_2057_43870)">
            <path
              d="M90.6 30.1177L91.5437 31.0589M91.5437 31.0589L92.4875 30.1177L93.4312 31.0589M91.5437 31.0589L92.4875 32M91.5437 31.0589L90.6 32L91.5437 32.9412M93.4312 31.0589L92.4875 32M93.4312 31.0589L94.375 30.1177M93.4312 31.0589L94.375 32L93.4312 32.9412M92.4875 32L91.5437 32.9412M92.4875 32L93.4312 32.9412M91.5437 32.9412L92.4875 33.8824L93.4312 32.9412M91.5437 32.9412L90.6 33.8824M93.4312 32.9412L94.375 33.8824"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask318_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="94"
        y="30"
      >
        <path d="M98.15 30.1177H94.375V33.8824H98.15V30.1177Z" fill="white" />
      </mask>
      <g mask="url(#mask318_2057_43870)">
        <mask
          height="4"
          id="mask319_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="94"
          y="30"
        >
          <path d="M98.15 30.1177H94.375V33.8824H98.15V30.1177Z" fill="white" />
        </mask>
        <g mask="url(#mask319_2057_43870)">
          <mask
            height="4"
            id="mask320_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="94"
            y="30"
          >
            <path d="M98.15 30.1177H94.375V33.8824H98.15V30.1177Z" fill="white" />
          </mask>
          <g mask="url(#mask320_2057_43870)">
            <path
              d="M94.375 30.1177L95.3187 31.0589M95.3187 31.0589L96.2625 30.1177L97.2062 31.0589M95.3187 31.0589L96.2625 32M95.3187 31.0589L94.375 32L95.3187 32.9412M97.2062 31.0589L96.2625 32M97.2062 31.0589L98.15 30.1177M97.2062 31.0589L98.15 32L97.2062 32.9412M96.2625 32L95.3187 32.9412M96.2625 32L97.2062 32.9412M95.3187 32.9412L96.2625 33.8824L97.2062 32.9412M95.3187 32.9412L94.375 33.8824M97.2062 32.9412L98.15 33.8824"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask321_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="109"
        y="30"
      >
        <path d="M113.25 30.1177H109.475V33.8824H113.25V30.1177Z" fill="white" />
      </mask>
      <g mask="url(#mask321_2057_43870)">
        <mask
          height="4"
          id="mask322_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="109"
          y="30"
        >
          <path d="M113.25 30.1177H109.475V33.8824H113.25V30.1177Z" fill="white" />
        </mask>
        <g mask="url(#mask322_2057_43870)">
          <mask
            height="4"
            id="mask323_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="109"
            y="30"
          >
            <path d="M113.25 30.1177H109.475V33.8824H113.25V30.1177Z" fill="white" />
          </mask>
          <g mask="url(#mask323_2057_43870)">
            <path
              d="M109.475 30.1177L110.419 31.0589M110.419 31.0589L111.362 30.1177L112.306 31.0589M110.419 31.0589L111.362 32M110.419 31.0589L109.475 32L110.419 32.9412M112.306 31.0589L111.362 32M112.306 31.0589L113.25 30.1177M112.306 31.0589L113.25 32L112.306 32.9412M111.362 32L110.419 32.9412M111.362 32L112.306 32.9412M110.419 32.9412L111.362 33.8824L112.306 32.9412M110.419 32.9412L109.475 33.8824M112.306 32.9412L113.25 33.8824"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask324_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="113"
        y="30"
      >
        <path d="M117.025 30.1177H113.25V33.8824H117.025V30.1177Z" fill="white" />
      </mask>
      <g mask="url(#mask324_2057_43870)">
        <mask
          height="4"
          id="mask325_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="113"
          y="30"
        >
          <path d="M117.025 30.1177H113.25V33.8824H117.025V30.1177Z" fill="white" />
        </mask>
        <g mask="url(#mask325_2057_43870)">
          <mask
            height="4"
            id="mask326_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="113"
            y="30"
          >
            <path d="M117.025 30.1177H113.25V33.8824H117.025V30.1177Z" fill="white" />
          </mask>
          <g mask="url(#mask326_2057_43870)">
            <path
              d="M113.25 30.1177L114.194 31.0589M114.194 31.0589L115.137 30.1177L116.081 31.0589M114.194 31.0589L115.137 32M114.194 31.0589L113.25 32L114.194 32.9412M116.081 31.0589L115.137 32M116.081 31.0589L117.025 30.1177M116.081 31.0589L117.025 32L116.081 32.9412M115.137 32L114.194 32.9412M115.137 32L116.081 32.9412M114.194 32.9412L115.137 33.8824L116.081 32.9412M114.194 32.9412L113.25 33.8824M116.081 32.9412L117.025 33.8824"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask327_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="117"
        y="30"
      >
        <path d="M120.8 30.1177H117.025V33.8824H120.8V30.1177Z" fill="white" />
      </mask>
      <g mask="url(#mask327_2057_43870)">
        <mask
          height="4"
          id="mask328_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="117"
          y="30"
        >
          <path d="M120.8 30.1177H117.025V33.8824H120.8V30.1177Z" fill="white" />
        </mask>
        <g mask="url(#mask328_2057_43870)">
          <mask
            height="4"
            id="mask329_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="117"
            y="30"
          >
            <path d="M120.8 30.1177H117.025V33.8824H120.8V30.1177Z" fill="white" />
          </mask>
          <g mask="url(#mask329_2057_43870)">
            <path
              d="M117.025 30.1177L117.969 31.0589M117.969 31.0589L118.913 30.1177L119.856 31.0589M117.969 31.0589L118.913 32M117.969 31.0589L117.025 32L117.969 32.9412M119.856 31.0589L118.913 32M119.856 31.0589L120.8 30.1177M119.856 31.0589L120.8 32L119.856 32.9412M118.913 32L117.969 32.9412M118.913 32L119.856 32.9412M117.969 32.9412L118.913 33.8824L119.856 32.9412M117.969 32.9412L117.025 33.8824M119.856 32.9412L120.8 33.8824"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask330_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="132"
        y="30"
      >
        <path d="M135.9 30.1177H132.125V33.8824H135.9V30.1177Z" fill="white" />
      </mask>
      <g mask="url(#mask330_2057_43870)">
        <mask
          height="4"
          id="mask331_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="132"
          y="30"
        >
          <path d="M135.9 30.1177H132.125V33.8824H135.9V30.1177Z" fill="white" />
        </mask>
        <g mask="url(#mask331_2057_43870)">
          <mask
            height="4"
            id="mask332_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="132"
            y="30"
          >
            <path d="M135.9 30.1177H132.125V33.8824H135.9V30.1177Z" fill="white" />
          </mask>
          <g mask="url(#mask332_2057_43870)">
            <path
              d="M132.125 30.1177L133.069 31.0589M133.069 31.0589L134.012 30.1177L134.956 31.0589M133.069 31.0589L134.012 32M133.069 31.0589L132.125 32L133.069 32.9412M134.956 31.0589L134.012 32M134.956 31.0589L135.9 30.1177M134.956 31.0589L135.9 32L134.956 32.9412M134.012 32L133.069 32.9412M134.012 32L134.956 32.9412M133.069 32.9412L134.012 33.8824L134.956 32.9412M133.069 32.9412L132.125 33.8824M134.956 32.9412L135.9 33.8824"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask333_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="135"
        y="30"
      >
        <path d="M139.675 30.1177H135.9V33.8824H139.675V30.1177Z" fill="white" />
      </mask>
      <g mask="url(#mask333_2057_43870)">
        <mask
          height="4"
          id="mask334_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="135"
          y="30"
        >
          <path d="M139.675 30.1177H135.9V33.8824H139.675V30.1177Z" fill="white" />
        </mask>
        <g mask="url(#mask334_2057_43870)">
          <mask
            height="4"
            id="mask335_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="135"
            y="30"
          >
            <path d="M139.675 30.1177H135.9V33.8824H139.675V30.1177Z" fill="white" />
          </mask>
          <g mask="url(#mask335_2057_43870)">
            <path
              d="M135.9 30.1177L136.844 31.0589M136.844 31.0589L137.788 30.1177L138.731 31.0589M136.844 31.0589L137.788 32M136.844 31.0589L135.9 32L136.844 32.9412M138.731 31.0589L137.788 32M138.731 31.0589L139.675 30.1177M138.731 31.0589L139.675 32L138.731 32.9412M137.788 32L136.844 32.9412M137.788 32L138.731 32.9412M136.844 32.9412L137.788 33.8824L138.731 32.9412M136.844 32.9412L135.9 33.8824M138.731 32.9412L139.675 33.8824"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask336_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="139"
        y="30"
      >
        <path d="M143.45 30.1177H139.675V33.8824H143.45V30.1177Z" fill="white" />
      </mask>
      <g mask="url(#mask336_2057_43870)">
        <mask
          height="4"
          id="mask337_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="139"
          y="30"
        >
          <path d="M143.45 30.1177H139.675V33.8824H143.45V30.1177Z" fill="white" />
        </mask>
        <g mask="url(#mask337_2057_43870)">
          <mask
            height="4"
            id="mask338_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="139"
            y="30"
          >
            <path d="M143.45 30.1177H139.675V33.8824H143.45V30.1177Z" fill="white" />
          </mask>
          <g mask="url(#mask338_2057_43870)">
            <path
              d="M139.675 30.1177L140.619 31.0589M140.619 31.0589L141.563 30.1177L142.506 31.0589M140.619 31.0589L141.563 32M140.619 31.0589L139.675 32L140.619 32.9412M142.506 31.0589L141.563 32M142.506 31.0589L143.45 30.1177M142.506 31.0589L143.45 32L142.506 32.9412M141.563 32L140.619 32.9412M141.563 32L142.506 32.9412M140.619 32.9412L141.563 33.8824L142.506 32.9412M140.619 32.9412L139.675 33.8824M142.506 32.9412L143.45 33.8824"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask339_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="173"
        y="30"
      >
        <path d="M177.425 30.1177H173.65V33.8824H177.425V30.1177Z" fill="white" />
      </mask>
      <g mask="url(#mask339_2057_43870)">
        <mask
          height="4"
          id="mask340_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="173"
          y="30"
        >
          <path d="M177.425 30.1177H173.65V33.8824H177.425V30.1177Z" fill="white" />
        </mask>
        <g mask="url(#mask340_2057_43870)">
          <mask
            height="4"
            id="mask341_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="173"
            y="30"
          >
            <path d="M177.425 30.1177H173.65V33.8824H177.425V30.1177Z" fill="white" />
          </mask>
          <g mask="url(#mask341_2057_43870)">
            <path
              d="M173.65 30.1177L174.594 31.0589M174.594 31.0589L175.538 30.1177L176.481 31.0589M174.594 31.0589L175.538 32M174.594 31.0589L173.65 32L174.594 32.9412M176.481 31.0589L175.538 32M176.481 31.0589L177.425 30.1177M176.481 31.0589L177.425 32L176.481 32.9412M175.538 32L174.594 32.9412M175.538 32L176.481 32.9412M174.594 32.9412L175.538 33.8824L176.481 32.9412M174.594 32.9412L173.65 33.8824M176.481 32.9412L177.425 33.8824"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask342_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="177"
        y="30"
      >
        <path d="M181.2 30.1177H177.425V33.8824H181.2V30.1177Z" fill="white" />
      </mask>
      <g mask="url(#mask342_2057_43870)">
        <mask
          height="4"
          id="mask343_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="177"
          y="30"
        >
          <path d="M181.2 30.1177H177.425V33.8824H181.2V30.1177Z" fill="white" />
        </mask>
        <g mask="url(#mask343_2057_43870)">
          <mask
            height="4"
            id="mask344_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="177"
            y="30"
          >
            <path d="M181.2 30.1177H177.425V33.8824H181.2V30.1177Z" fill="white" />
          </mask>
          <g mask="url(#mask344_2057_43870)">
            <path
              d="M177.425 30.1177L178.369 31.0589M178.369 31.0589L179.313 30.1177L180.256 31.0589M178.369 31.0589L179.313 32M178.369 31.0589L177.425 32L178.369 32.9412M180.256 31.0589L179.313 32M180.256 31.0589L181.2 30.1177M180.256 31.0589L181.2 32L180.256 32.9412M179.313 32L178.369 32.9412M179.313 32L180.256 32.9412M178.369 32.9412L179.313 33.8824L180.256 32.9412M178.369 32.9412L177.425 33.8824M180.256 32.9412L181.2 33.8824"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask345_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="181"
        y="30"
      >
        <path d="M184.975 30.1177H181.2V33.8824H184.975V30.1177Z" fill="white" />
      </mask>
      <g mask="url(#mask345_2057_43870)">
        <mask
          height="4"
          id="mask346_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="181"
          y="30"
        >
          <path d="M184.975 30.1177H181.2V33.8824H184.975V30.1177Z" fill="white" />
        </mask>
        <g mask="url(#mask346_2057_43870)">
          <mask
            height="4"
            id="mask347_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="181"
            y="30"
          >
            <path d="M184.975 30.1177H181.2V33.8824H184.975V30.1177Z" fill="white" />
          </mask>
          <g mask="url(#mask347_2057_43870)">
            <path
              d="M181.2 30.1177L182.144 31.0589M182.144 31.0589L183.087 30.1177L184.031 31.0589M182.144 31.0589L183.087 32M182.144 31.0589L181.2 32L182.144 32.9412M184.031 31.0589L183.087 32M184.031 31.0589L184.975 30.1177M184.031 31.0589L184.975 32L184.031 32.9412M183.087 32L182.144 32.9412M183.087 32L184.031 32.9412M182.144 32.9412L183.087 33.8824L184.031 32.9412M182.144 32.9412L181.2 33.8824M184.031 32.9412L184.975 33.8824"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask348_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="196"
        y="30"
      >
        <path d="M200.075 30.1177H196.3V33.8824H200.075V30.1177Z" fill="white" />
      </mask>
      <g mask="url(#mask348_2057_43870)">
        <mask
          height="4"
          id="mask349_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="196"
          y="30"
        >
          <path d="M200.075 30.1177H196.3V33.8824H200.075V30.1177Z" fill="white" />
        </mask>
        <g mask="url(#mask349_2057_43870)">
          <mask
            height="4"
            id="mask350_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="196"
            y="30"
          >
            <path d="M200.075 30.1177H196.3V33.8824H200.075V30.1177Z" fill="white" />
          </mask>
          <g mask="url(#mask350_2057_43870)">
            <path
              d="M196.3 30.1177L197.244 31.0589M197.244 31.0589L198.188 30.1177L199.131 31.0589M197.244 31.0589L198.188 32M197.244 31.0589L196.3 32L197.244 32.9412M199.131 31.0589L198.188 32M199.131 31.0589L200.075 30.1177M199.131 31.0589L200.075 32L199.131 32.9412M198.188 32L197.244 32.9412M198.188 32L199.131 32.9412M197.244 32.9412L198.188 33.8824L199.131 32.9412M197.244 32.9412L196.3 33.8824M199.131 32.9412L200.075 33.8824"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask351_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="200"
        y="30"
      >
        <path d="M203.85 30.1177H200.075V33.8824H203.85V30.1177Z" fill="white" />
      </mask>
      <g mask="url(#mask351_2057_43870)">
        <mask
          height="4"
          id="mask352_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="200"
          y="30"
        >
          <path d="M203.85 30.1177H200.075V33.8824H203.85V30.1177Z" fill="white" />
        </mask>
        <g mask="url(#mask352_2057_43870)">
          <mask
            height="4"
            id="mask353_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="200"
            y="30"
          >
            <path d="M203.85 30.1177H200.075V33.8824H203.85V30.1177Z" fill="white" />
          </mask>
          <g mask="url(#mask353_2057_43870)">
            <path
              d="M200.075 30.1177L201.019 31.0589M201.019 31.0589L201.962 30.1177L202.906 31.0589M201.019 31.0589L201.962 32M201.019 31.0589L200.075 32L201.019 32.9412M202.906 31.0589L201.962 32M202.906 31.0589L203.85 30.1177M202.906 31.0589L203.85 32L202.906 32.9412M201.962 32L201.019 32.9412M201.962 32L202.906 32.9412M201.019 32.9412L201.962 33.8824L202.906 32.9412M201.019 32.9412L200.075 33.8824M202.906 32.9412L203.85 33.8824"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask354_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="203"
        y="30"
      >
        <path d="M207.625 30.1177H203.85V33.8824H207.625V30.1177Z" fill="white" />
      </mask>
      <g mask="url(#mask354_2057_43870)">
        <mask
          height="4"
          id="mask355_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="203"
          y="30"
        >
          <path d="M207.625 30.1177H203.85V33.8824H207.625V30.1177Z" fill="white" />
        </mask>
        <g mask="url(#mask355_2057_43870)">
          <mask
            height="4"
            id="mask356_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="203"
            y="30"
          >
            <path d="M207.625 30.1177H203.85V33.8824H207.625V30.1177Z" fill="white" />
          </mask>
          <g mask="url(#mask356_2057_43870)">
            <path
              d="M203.85 30.1177L204.794 31.0589M204.794 31.0589L205.737 30.1177L206.681 31.0589M204.794 31.0589L205.737 32M204.794 31.0589L203.85 32L204.794 32.9412M206.681 31.0589L205.737 32M206.681 31.0589L207.625 30.1177M206.681 31.0589L207.625 32L206.681 32.9412M205.737 32L204.794 32.9412M205.737 32L206.681 32.9412M204.794 32.9412L205.737 33.8824L206.681 32.9412M204.794 32.9412L203.85 33.8824M206.681 32.9412L207.625 33.8824"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask357_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="237"
        y="30"
      >
        <path d="M241.6 30.1177H237.825V33.8824H241.6V30.1177Z" fill="white" />
      </mask>
      <g mask="url(#mask357_2057_43870)">
        <mask
          height="4"
          id="mask358_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="237"
          y="30"
        >
          <path d="M241.6 30.1177H237.825V33.8824H241.6V30.1177Z" fill="white" />
        </mask>
        <g mask="url(#mask358_2057_43870)">
          <mask
            height="4"
            id="mask359_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="237"
            y="30"
          >
            <path d="M241.6 30.1177H237.825V33.8824H241.6V30.1177Z" fill="white" />
          </mask>
          <g mask="url(#mask359_2057_43870)">
            <path
              d="M237.825 30.1177L238.769 31.0589M238.769 31.0589L239.712 30.1177L240.656 31.0589M238.769 31.0589L239.712 32M238.769 31.0589L237.825 32L238.769 32.9412M240.656 31.0589L239.712 32M240.656 31.0589L241.6 30.1177M240.656 31.0589L241.6 32L240.656 32.9412M239.712 32L238.769 32.9412M239.712 32L240.656 32.9412M238.769 32.9412L239.712 33.8824L240.656 32.9412M238.769 32.9412L237.825 33.8824M240.656 32.9412L241.6 33.8824"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask360_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="241"
        y="30"
      >
        <path d="M245.375 30.1177H241.6V33.8824H245.375V30.1177Z" fill="white" />
      </mask>
      <g mask="url(#mask360_2057_43870)">
        <mask
          height="4"
          id="mask361_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="241"
          y="30"
        >
          <path d="M245.375 30.1177H241.6V33.8824H245.375V30.1177Z" fill="white" />
        </mask>
        <g mask="url(#mask361_2057_43870)">
          <mask
            height="4"
            id="mask362_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="241"
            y="30"
          >
            <path d="M245.375 30.1177H241.6V33.8824H245.375V30.1177Z" fill="white" />
          </mask>
          <g mask="url(#mask362_2057_43870)">
            <path
              d="M241.6 30.1177L242.544 31.0589M242.544 31.0589L243.487 30.1177L244.431 31.0589M242.544 31.0589L243.487 32M242.544 31.0589L241.6 32L242.544 32.9412M244.431 31.0589L243.487 32M244.431 31.0589L245.375 30.1177M244.431 31.0589L245.375 32L244.431 32.9412M243.487 32L242.544 32.9412M243.487 32L244.431 32.9412M242.544 32.9412L243.487 33.8824L244.431 32.9412M242.544 32.9412L241.6 33.8824M244.431 32.9412L245.375 33.8824"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask363_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="245"
        y="30"
      >
        <path d="M249.15 30.1177H245.375V33.8824H249.15V30.1177Z" fill="white" />
      </mask>
      <g mask="url(#mask363_2057_43870)">
        <mask
          height="4"
          id="mask364_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="245"
          y="30"
        >
          <path d="M249.15 30.1177H245.375V33.8824H249.15V30.1177Z" fill="white" />
        </mask>
        <g mask="url(#mask364_2057_43870)">
          <mask
            height="4"
            id="mask365_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="245"
            y="30"
          >
            <path d="M249.15 30.1177H245.375V33.8824H249.15V30.1177Z" fill="white" />
          </mask>
          <g mask="url(#mask365_2057_43870)">
            <path
              d="M245.375 30.1177L246.319 31.0589M246.319 31.0589L247.262 30.1177L248.206 31.0589M246.319 31.0589L247.262 32M246.319 31.0589L245.375 32L246.319 32.9412M248.206 31.0589L247.262 32M248.206 31.0589L249.15 30.1177M248.206 31.0589L249.15 32L248.206 32.9412M247.262 32L246.319 32.9412M247.262 32L248.206 32.9412M246.319 32.9412L247.262 33.8824L248.206 32.9412M246.319 32.9412L245.375 33.8824M248.206 32.9412L249.15 33.8824"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask366_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="260"
        y="30"
      >
        <path d="M264.25 30.1177H260.475V33.8824H264.25V30.1177Z" fill="white" />
      </mask>
      <g mask="url(#mask366_2057_43870)">
        <mask
          height="4"
          id="mask367_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="260"
          y="30"
        >
          <path d="M264.25 30.1177H260.475V33.8824H264.25V30.1177Z" fill="white" />
        </mask>
        <g mask="url(#mask367_2057_43870)">
          <mask
            height="4"
            id="mask368_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="260"
            y="30"
          >
            <path d="M264.25 30.1177H260.475V33.8824H264.25V30.1177Z" fill="white" />
          </mask>
          <g mask="url(#mask368_2057_43870)">
            <path
              d="M260.475 30.1177L261.419 31.0589M261.419 31.0589L262.362 30.1177L263.306 31.0589M261.419 31.0589L262.362 32M261.419 31.0589L260.475 32L261.419 32.9412M263.306 31.0589L262.362 32M263.306 31.0589L264.25 30.1177M263.306 31.0589L264.25 32L263.306 32.9412M262.362 32L261.419 32.9412M262.362 32L263.306 32.9412M261.419 32.9412L262.362 33.8824L263.306 32.9412M261.419 32.9412L260.475 33.8824M263.306 32.9412L264.25 33.8824"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask369_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="264"
        y="30"
      >
        <path d="M268.025 30.1177H264.25V33.8824H268.025V30.1177Z" fill="white" />
      </mask>
      <g mask="url(#mask369_2057_43870)">
        <mask
          height="4"
          id="mask370_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="264"
          y="30"
        >
          <path d="M268.025 30.1177H264.25V33.8824H268.025V30.1177Z" fill="white" />
        </mask>
        <g mask="url(#mask370_2057_43870)">
          <mask
            height="4"
            id="mask371_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="264"
            y="30"
          >
            <path d="M268.025 30.1177H264.25V33.8824H268.025V30.1177Z" fill="white" />
          </mask>
          <g mask="url(#mask371_2057_43870)">
            <path
              d="M264.25 30.1177L265.194 31.0589M265.194 31.0589L266.137 30.1177L267.081 31.0589M265.194 31.0589L266.137 32M265.194 31.0589L264.25 32L265.194 32.9412M267.081 31.0589L266.137 32M267.081 31.0589L268.025 30.1177M267.081 31.0589L268.025 32L267.081 32.9412M266.137 32L265.194 32.9412M266.137 32L267.081 32.9412M265.194 32.9412L266.137 33.8824L267.081 32.9412M265.194 32.9412L264.25 33.8824M267.081 32.9412L268.025 33.8824"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask372_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="268"
        y="30"
      >
        <path d="M271.8 30.1177H268.025V33.8824H271.8V30.1177Z" fill="white" />
      </mask>
      <g mask="url(#mask372_2057_43870)">
        <mask
          height="4"
          id="mask373_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="268"
          y="30"
        >
          <path d="M271.8 30.1177H268.025V33.8824H271.8V30.1177Z" fill="white" />
        </mask>
        <g mask="url(#mask373_2057_43870)">
          <mask
            height="4"
            id="mask374_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="268"
            y="30"
          >
            <path d="M271.8 30.1177H268.025V33.8824H271.8V30.1177Z" fill="white" />
          </mask>
          <g mask="url(#mask374_2057_43870)">
            <path
              d="M268.025 30.1177L268.969 31.0589M268.969 31.0589L269.913 30.1177L270.856 31.0589M268.969 31.0589L269.913 32M268.969 31.0589L268.025 32L268.969 32.9412M270.856 31.0589L269.913 32M270.856 31.0589L271.8 30.1177M270.856 31.0589L271.8 32L270.856 32.9412M269.913 32L268.969 32.9412M269.913 32L270.856 32.9412M268.969 32.9412L269.913 33.8824L270.856 32.9412M268.969 32.9412L268.025 33.8824M270.856 32.9412L271.8 33.8824"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask375_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="283"
        y="30"
      >
        <path d="M286.9 30.1177H283.125V33.8824H286.9V30.1177Z" fill="white" />
      </mask>
      <g mask="url(#mask375_2057_43870)">
        <mask
          height="4"
          id="mask376_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="283"
          y="30"
        >
          <path d="M286.9 30.1177H283.125V33.8824H286.9V30.1177Z" fill="white" />
        </mask>
        <g mask="url(#mask376_2057_43870)">
          <mask
            height="4"
            id="mask377_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="283"
            y="30"
          >
            <path d="M286.9 30.1177H283.125V33.8824H286.9V30.1177Z" fill="white" />
          </mask>
          <g mask="url(#mask377_2057_43870)">
            <path
              d="M283.125 30.1177L284.069 31.0589M284.069 31.0589L285.012 30.1177L285.956 31.0589M284.069 31.0589L285.012 32M284.069 31.0589L283.125 32L284.069 32.9412M285.956 31.0589L285.012 32M285.956 31.0589L286.9 30.1177M285.956 31.0589L286.9 32L285.956 32.9412M285.012 32L284.069 32.9412M285.012 32L285.956 32.9412M284.069 32.9412L285.012 33.8824L285.956 32.9412M284.069 32.9412L283.125 33.8824M285.956 32.9412L286.9 33.8824"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask378_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="286"
        y="30"
      >
        <path d="M290.675 30.1177H286.9V33.8824H290.675V30.1177Z" fill="white" />
      </mask>
      <g mask="url(#mask378_2057_43870)">
        <mask
          height="4"
          id="mask379_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="286"
          y="30"
        >
          <path d="M290.675 30.1177H286.9V33.8824H290.675V30.1177Z" fill="white" />
        </mask>
        <g mask="url(#mask379_2057_43870)">
          <mask
            height="4"
            id="mask380_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="286"
            y="30"
          >
            <path d="M290.675 30.1177H286.9V33.8824H290.675V30.1177Z" fill="white" />
          </mask>
          <g mask="url(#mask380_2057_43870)">
            <path
              d="M286.9 30.1177L287.844 31.0589M287.844 31.0589L288.788 30.1177L289.731 31.0589M287.844 31.0589L288.788 32M287.844 31.0589L286.9 32L287.844 32.9412M289.731 31.0589L288.788 32M289.731 31.0589L290.675 30.1177M289.731 31.0589L290.675 32L289.731 32.9412M288.788 32L287.844 32.9412M288.788 32L289.731 32.9412M287.844 32.9412L288.788 33.8824L289.731 32.9412M287.844 32.9412L286.9 33.8824M289.731 32.9412L290.675 33.8824"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask381_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="290"
        y="30"
      >
        <path d="M294.45 30.1177H290.675V33.8824H294.45V30.1177Z" fill="white" />
      </mask>
      <g mask="url(#mask381_2057_43870)">
        <mask
          height="4"
          id="mask382_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="290"
          y="30"
        >
          <path d="M294.45 30.1177H290.675V33.8824H294.45V30.1177Z" fill="white" />
        </mask>
        <g mask="url(#mask382_2057_43870)">
          <mask
            height="4"
            id="mask383_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="290"
            y="30"
          >
            <path d="M294.45 30.1177H290.675V33.8824H294.45V30.1177Z" fill="white" />
          </mask>
          <g mask="url(#mask383_2057_43870)">
            <path
              d="M290.675 30.1177L291.619 31.0589M291.619 31.0589L292.563 30.1177L293.506 31.0589M291.619 31.0589L292.563 32M291.619 31.0589L290.675 32L291.619 32.9412M293.506 31.0589L292.563 32M293.506 31.0589L294.45 30.1177M293.506 31.0589L294.45 32L293.506 32.9412M292.563 32L291.619 32.9412M292.563 32L293.506 32.9412M291.619 32.9412L292.563 33.8824L293.506 32.9412M291.619 32.9412L290.675 33.8824M293.506 32.9412L294.45 33.8824"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="3"
        id="mask384_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="0"
        y="34"
      >
        <path d="M2.98143 34.5969H0.716431V36.8557H2.98143V34.5969Z" fill="white" />
      </mask>
      <g mask="url(#mask384_2057_43870)">
        <mask
          height="3"
          id="mask385_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="0"
          y="34"
        >
          <path d="M2.98143 34.5969H0.716431V36.8557H2.98143V34.5969Z" fill="white" />
        </mask>
        <g mask="url(#mask385_2057_43870)">
          <path
            d="M0.716431 34.5969L1.84893 35.7263M1.84893 35.7263L2.98143 34.5969M1.84893 35.7263L2.98143 36.8557M1.84893 35.7263L0.716431 36.8557"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask386_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="4"
        y="34"
      >
        <path d="M6.75646 34.5969H4.49146V36.8557H6.75646V34.5969Z" fill="white" />
      </mask>
      <g mask="url(#mask386_2057_43870)">
        <mask
          height="3"
          id="mask387_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="4"
          y="34"
        >
          <path d="M6.75646 34.5969H4.49146V36.8557H6.75646V34.5969Z" fill="white" />
        </mask>
        <g mask="url(#mask387_2057_43870)">
          <path
            d="M4.49146 34.5969L5.62396 35.7263M5.62396 35.7263L6.75646 34.5969M5.62396 35.7263L6.75646 36.8557M5.62396 35.7263L4.49146 36.8557"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask388_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="8"
        y="34"
      >
        <path d="M10.5315 34.5969H8.26648V36.8557H10.5315V34.5969Z" fill="white" />
      </mask>
      <g mask="url(#mask388_2057_43870)">
        <mask
          height="3"
          id="mask389_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="8"
          y="34"
        >
          <path d="M10.5315 34.5969H8.26648V36.8557H10.5315V34.5969Z" fill="white" />
        </mask>
        <g mask="url(#mask389_2057_43870)">
          <path
            d="M8.26648 34.5969L9.39898 35.7263M9.39898 35.7263L10.5315 34.5969M9.39898 35.7263L10.5315 36.8557M9.39898 35.7263L8.26648 36.8557"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="5"
        id="mask390_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="67"
        y="33"
      >
        <path d="M71.725 33.8823H67.95V37.647H71.725V33.8823Z" fill="white" />
      </mask>
      <g mask="url(#mask390_2057_43870)">
        <mask
          height="5"
          id="mask391_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="67"
          y="33"
        >
          <path d="M71.725 33.8823H67.95V37.647H71.725V33.8823Z" fill="white" />
        </mask>
        <g mask="url(#mask391_2057_43870)">
          <mask
            height="5"
            id="mask392_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="67"
            y="33"
          >
            <path d="M71.725 33.8823H67.95V37.647H71.725V33.8823Z" fill="white" />
          </mask>
          <g mask="url(#mask392_2057_43870)">
            <path
              d="M67.95 33.8823L68.8937 34.8235M68.8937 34.8235L69.8375 33.8823L70.7812 34.8235M68.8937 34.8235L69.8375 35.7647M68.8937 34.8235L67.95 35.7647L68.8937 36.7059M70.7812 34.8235L69.8375 35.7647M70.7812 34.8235L71.725 33.8823M70.7812 34.8235L71.725 35.7647L70.7812 36.7059M69.8375 35.7647L68.8937 36.7059M69.8375 35.7647L70.7812 36.7059M68.8937 36.7059L69.8375 37.647L70.7812 36.7059M68.8937 36.7059L67.95 37.647M70.7812 36.7059L71.725 37.647"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask393_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="71"
        y="33"
      >
        <path d="M75.5 33.8823H71.725V37.647H75.5V33.8823Z" fill="white" />
      </mask>
      <g mask="url(#mask393_2057_43870)">
        <mask
          height="5"
          id="mask394_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="71"
          y="33"
        >
          <path d="M75.5 33.8823H71.725V37.647H75.5V33.8823Z" fill="white" />
        </mask>
        <g mask="url(#mask394_2057_43870)">
          <mask
            height="5"
            id="mask395_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="71"
            y="33"
          >
            <path d="M75.5 33.8823H71.725V37.647H75.5V33.8823Z" fill="white" />
          </mask>
          <g mask="url(#mask395_2057_43870)">
            <path
              d="M71.725 33.8823L72.6687 34.8235M72.6687 34.8235L73.6125 33.8823L74.5562 34.8235M72.6687 34.8235L73.6125 35.7647M72.6687 34.8235L71.725 35.7647L72.6687 36.7059M74.5562 34.8235L73.6125 35.7647M74.5562 34.8235L75.5 33.8823M74.5562 34.8235L75.5 35.7647L74.5562 36.7059M73.6125 35.7647L72.6687 36.7059M73.6125 35.7647L74.5562 36.7059M72.6687 36.7059L73.6125 37.647L74.5562 36.7059M72.6687 36.7059L71.725 37.647M74.5562 36.7059L75.5 37.647"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask396_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="86"
        y="33"
      >
        <path d="M90.6 33.8823H86.825V37.647H90.6V33.8823Z" fill="white" />
      </mask>
      <g mask="url(#mask396_2057_43870)">
        <mask
          height="5"
          id="mask397_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="86"
          y="33"
        >
          <path d="M90.6 33.8823H86.825V37.647H90.6V33.8823Z" fill="white" />
        </mask>
        <g mask="url(#mask397_2057_43870)">
          <mask
            height="5"
            id="mask398_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="86"
            y="33"
          >
            <path d="M90.6 33.8823H86.825V37.647H90.6V33.8823Z" fill="white" />
          </mask>
          <g mask="url(#mask398_2057_43870)">
            <path
              d="M86.825 33.8823L87.7687 34.8235M87.7687 34.8235L88.7125 33.8823L89.6562 34.8235M87.7687 34.8235L88.7125 35.7647M87.7687 34.8235L86.825 35.7647L87.7687 36.7059M89.6562 34.8235L88.7125 35.7647M89.6562 34.8235L90.6 33.8823M89.6562 34.8235L90.6 35.7647L89.6562 36.7059M88.7125 35.7647L87.7687 36.7059M88.7125 35.7647L89.6562 36.7059M87.7687 36.7059L88.7125 37.647L89.6562 36.7059M87.7687 36.7059L86.825 37.647M89.6562 36.7059L90.6 37.647"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask399_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="90"
        y="33"
      >
        <path d="M94.375 33.8823H90.6V37.647H94.375V33.8823Z" fill="white" />
      </mask>
      <g mask="url(#mask399_2057_43870)">
        <mask
          height="5"
          id="mask400_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="90"
          y="33"
        >
          <path d="M94.375 33.8823H90.6V37.647H94.375V33.8823Z" fill="white" />
        </mask>
        <g mask="url(#mask400_2057_43870)">
          <mask
            height="5"
            id="mask401_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="90"
            y="33"
          >
            <path d="M94.375 33.8823H90.6V37.647H94.375V33.8823Z" fill="white" />
          </mask>
          <g mask="url(#mask401_2057_43870)">
            <path
              d="M90.6 33.8823L91.5437 34.8235M91.5437 34.8235L92.4875 33.8823L93.4312 34.8235M91.5437 34.8235L92.4875 35.7647M91.5437 34.8235L90.6 35.7647L91.5437 36.7059M93.4312 34.8235L92.4875 35.7647M93.4312 34.8235L94.375 33.8823M93.4312 34.8235L94.375 35.7647L93.4312 36.7059M92.4875 35.7647L91.5437 36.7059M92.4875 35.7647L93.4312 36.7059M91.5437 36.7059L92.4875 37.647L93.4312 36.7059M91.5437 36.7059L90.6 37.647M93.4312 36.7059L94.375 37.647"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask402_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="94"
        y="33"
      >
        <path d="M98.15 33.8823H94.375V37.647H98.15V33.8823Z" fill="white" />
      </mask>
      <g mask="url(#mask402_2057_43870)">
        <mask
          height="5"
          id="mask403_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="94"
          y="33"
        >
          <path d="M98.15 33.8823H94.375V37.647H98.15V33.8823Z" fill="white" />
        </mask>
        <g mask="url(#mask403_2057_43870)">
          <mask
            height="5"
            id="mask404_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="94"
            y="33"
          >
            <path d="M98.15 33.8823H94.375V37.647H98.15V33.8823Z" fill="white" />
          </mask>
          <g mask="url(#mask404_2057_43870)">
            <path
              d="M94.375 33.8823L95.3187 34.8235M95.3187 34.8235L96.2625 33.8823L97.2062 34.8235M95.3187 34.8235L96.2625 35.7647M95.3187 34.8235L94.375 35.7647L95.3187 36.7059M97.2062 34.8235L96.2625 35.7647M97.2062 34.8235L98.15 33.8823M97.2062 34.8235L98.15 35.7647L97.2062 36.7059M96.2625 35.7647L95.3187 36.7059M96.2625 35.7647L97.2062 36.7059M95.3187 36.7059L96.2625 37.647L97.2062 36.7059M95.3187 36.7059L94.375 37.647M97.2062 36.7059L98.15 37.647"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask405_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="109"
        y="33"
      >
        <path d="M113.25 33.8823H109.475V37.647H113.25V33.8823Z" fill="white" />
      </mask>
      <g mask="url(#mask405_2057_43870)">
        <mask
          height="5"
          id="mask406_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="109"
          y="33"
        >
          <path d="M113.25 33.8823H109.475V37.647H113.25V33.8823Z" fill="white" />
        </mask>
        <g mask="url(#mask406_2057_43870)">
          <mask
            height="5"
            id="mask407_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="109"
            y="33"
          >
            <path d="M113.25 33.8823H109.475V37.647H113.25V33.8823Z" fill="white" />
          </mask>
          <g mask="url(#mask407_2057_43870)">
            <path
              d="M109.475 33.8823L110.419 34.8235M110.419 34.8235L111.362 33.8823L112.306 34.8235M110.419 34.8235L111.362 35.7647M110.419 34.8235L109.475 35.7647L110.419 36.7059M112.306 34.8235L111.362 35.7647M112.306 34.8235L113.25 33.8823M112.306 34.8235L113.25 35.7647L112.306 36.7059M111.362 35.7647L110.419 36.7059M111.362 35.7647L112.306 36.7059M110.419 36.7059L111.362 37.647L112.306 36.7059M110.419 36.7059L109.475 37.647M112.306 36.7059L113.25 37.647"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask408_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="113"
        y="33"
      >
        <path d="M117.025 33.8823H113.25V37.647H117.025V33.8823Z" fill="white" />
      </mask>
      <g mask="url(#mask408_2057_43870)">
        <mask
          height="5"
          id="mask409_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="113"
          y="33"
        >
          <path d="M117.025 33.8823H113.25V37.647H117.025V33.8823Z" fill="white" />
        </mask>
        <g mask="url(#mask409_2057_43870)">
          <mask
            height="5"
            id="mask410_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="113"
            y="33"
          >
            <path d="M117.025 33.8823H113.25V37.647H117.025V33.8823Z" fill="white" />
          </mask>
          <g mask="url(#mask410_2057_43870)">
            <path
              d="M113.25 33.8823L114.194 34.8235M114.194 34.8235L115.137 33.8823L116.081 34.8235M114.194 34.8235L115.137 35.7647M114.194 34.8235L113.25 35.7647L114.194 36.7059M116.081 34.8235L115.137 35.7647M116.081 34.8235L117.025 33.8823M116.081 34.8235L117.025 35.7647L116.081 36.7059M115.137 35.7647L114.194 36.7059M115.137 35.7647L116.081 36.7059M114.194 36.7059L115.137 37.647L116.081 36.7059M114.194 36.7059L113.25 37.647M116.081 36.7059L117.025 37.647"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask411_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="117"
        y="33"
      >
        <path d="M120.8 33.8823H117.025V37.647H120.8V33.8823Z" fill="white" />
      </mask>
      <g mask="url(#mask411_2057_43870)">
        <mask
          height="5"
          id="mask412_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="117"
          y="33"
        >
          <path d="M120.8 33.8823H117.025V37.647H120.8V33.8823Z" fill="white" />
        </mask>
        <g mask="url(#mask412_2057_43870)">
          <mask
            height="5"
            id="mask413_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="117"
            y="33"
          >
            <path d="M120.8 33.8823H117.025V37.647H120.8V33.8823Z" fill="white" />
          </mask>
          <g mask="url(#mask413_2057_43870)">
            <path
              d="M117.025 33.8823L117.969 34.8235M117.969 34.8235L118.913 33.8823L119.856 34.8235M117.969 34.8235L118.913 35.7647M117.969 34.8235L117.025 35.7647L117.969 36.7059M119.856 34.8235L118.913 35.7647M119.856 34.8235L120.8 33.8823M119.856 34.8235L120.8 35.7647L119.856 36.7059M118.913 35.7647L117.969 36.7059M118.913 35.7647L119.856 36.7059M117.969 36.7059L118.913 37.647L119.856 36.7059M117.969 36.7059L117.025 37.647M119.856 36.7059L120.8 37.647"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask414_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="132"
        y="33"
      >
        <path d="M135.9 33.8823H132.125V37.647H135.9V33.8823Z" fill="white" />
      </mask>
      <g mask="url(#mask414_2057_43870)">
        <mask
          height="5"
          id="mask415_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="132"
          y="33"
        >
          <path d="M135.9 33.8823H132.125V37.647H135.9V33.8823Z" fill="white" />
        </mask>
        <g mask="url(#mask415_2057_43870)">
          <mask
            height="5"
            id="mask416_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="132"
            y="33"
          >
            <path d="M135.9 33.8823H132.125V37.647H135.9V33.8823Z" fill="white" />
          </mask>
          <g mask="url(#mask416_2057_43870)">
            <path
              d="M132.125 33.8823L133.069 34.8235M133.069 34.8235L134.012 33.8823L134.956 34.8235M133.069 34.8235L134.012 35.7647M133.069 34.8235L132.125 35.7647L133.069 36.7059M134.956 34.8235L134.012 35.7647M134.956 34.8235L135.9 33.8823M134.956 34.8235L135.9 35.7647L134.956 36.7059M134.012 35.7647L133.069 36.7059M134.012 35.7647L134.956 36.7059M133.069 36.7059L134.012 37.647L134.956 36.7059M133.069 36.7059L132.125 37.647M134.956 36.7059L135.9 37.647"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask417_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="135"
        y="33"
      >
        <path d="M139.675 33.8823H135.9V37.647H139.675V33.8823Z" fill="white" />
      </mask>
      <g mask="url(#mask417_2057_43870)">
        <mask
          height="5"
          id="mask418_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="135"
          y="33"
        >
          <path d="M139.675 33.8823H135.9V37.647H139.675V33.8823Z" fill="white" />
        </mask>
        <g mask="url(#mask418_2057_43870)">
          <mask
            height="5"
            id="mask419_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="135"
            y="33"
          >
            <path d="M139.675 33.8823H135.9V37.647H139.675V33.8823Z" fill="white" />
          </mask>
          <g mask="url(#mask419_2057_43870)">
            <path
              d="M135.9 33.8823L136.844 34.8235M136.844 34.8235L137.788 33.8823L138.731 34.8235M136.844 34.8235L137.788 35.7647M136.844 34.8235L135.9 35.7647L136.844 36.7059M138.731 34.8235L137.788 35.7647M138.731 34.8235L139.675 33.8823M138.731 34.8235L139.675 35.7647L138.731 36.7059M137.788 35.7647L136.844 36.7059M137.788 35.7647L138.731 36.7059M136.844 36.7059L137.788 37.647L138.731 36.7059M136.844 36.7059L135.9 37.647M138.731 36.7059L139.675 37.647"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask420_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="139"
        y="33"
      >
        <path d="M143.45 33.8823H139.675V37.647H143.45V33.8823Z" fill="white" />
      </mask>
      <g mask="url(#mask420_2057_43870)">
        <mask
          height="5"
          id="mask421_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="139"
          y="33"
        >
          <path d="M143.45 33.8823H139.675V37.647H143.45V33.8823Z" fill="white" />
        </mask>
        <g mask="url(#mask421_2057_43870)">
          <mask
            height="5"
            id="mask422_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="139"
            y="33"
          >
            <path d="M143.45 33.8823H139.675V37.647H143.45V33.8823Z" fill="white" />
          </mask>
          <g mask="url(#mask422_2057_43870)">
            <path
              d="M139.675 33.8823L140.619 34.8235M140.619 34.8235L141.563 33.8823L142.506 34.8235M140.619 34.8235L141.563 35.7647M140.619 34.8235L139.675 35.7647L140.619 36.7059M142.506 34.8235L141.563 35.7647M142.506 34.8235L143.45 33.8823M142.506 34.8235L143.45 35.7647L142.506 36.7059M141.563 35.7647L140.619 36.7059M141.563 35.7647L142.506 36.7059M140.619 36.7059L141.563 37.647L142.506 36.7059M140.619 36.7059L139.675 37.647M142.506 36.7059L143.45 37.647"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask423_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="173"
        y="33"
      >
        <path d="M177.425 33.8823H173.65V37.647H177.425V33.8823Z" fill="white" />
      </mask>
      <g mask="url(#mask423_2057_43870)">
        <mask
          height="5"
          id="mask424_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="173"
          y="33"
        >
          <path d="M177.425 33.8823H173.65V37.647H177.425V33.8823Z" fill="white" />
        </mask>
        <g mask="url(#mask424_2057_43870)">
          <mask
            height="5"
            id="mask425_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="173"
            y="33"
          >
            <path d="M177.425 33.8823H173.65V37.647H177.425V33.8823Z" fill="white" />
          </mask>
          <g mask="url(#mask425_2057_43870)">
            <path
              d="M173.65 33.8823L174.594 34.8235M174.594 34.8235L175.538 33.8823L176.481 34.8235M174.594 34.8235L175.538 35.7647M174.594 34.8235L173.65 35.7647L174.594 36.7059M176.481 34.8235L175.538 35.7647M176.481 34.8235L177.425 33.8823M176.481 34.8235L177.425 35.7647L176.481 36.7059M175.538 35.7647L174.594 36.7059M175.538 35.7647L176.481 36.7059M174.594 36.7059L175.538 37.647L176.481 36.7059M174.594 36.7059L173.65 37.647M176.481 36.7059L177.425 37.647"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask426_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="177"
        y="33"
      >
        <path d="M181.2 33.8823H177.425V37.647H181.2V33.8823Z" fill="white" />
      </mask>
      <g mask="url(#mask426_2057_43870)">
        <mask
          height="5"
          id="mask427_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="177"
          y="33"
        >
          <path d="M181.2 33.8823H177.425V37.647H181.2V33.8823Z" fill="white" />
        </mask>
        <g mask="url(#mask427_2057_43870)">
          <mask
            height="5"
            id="mask428_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="177"
            y="33"
          >
            <path d="M181.2 33.8823H177.425V37.647H181.2V33.8823Z" fill="white" />
          </mask>
          <g mask="url(#mask428_2057_43870)">
            <path
              d="M177.425 33.8823L178.369 34.8235M178.369 34.8235L179.313 33.8823L180.256 34.8235M178.369 34.8235L179.313 35.7647M178.369 34.8235L177.425 35.7647L178.369 36.7059M180.256 34.8235L179.313 35.7647M180.256 34.8235L181.2 33.8823M180.256 34.8235L181.2 35.7647L180.256 36.7059M179.313 35.7647L178.369 36.7059M179.313 35.7647L180.256 36.7059M178.369 36.7059L179.313 37.647L180.256 36.7059M178.369 36.7059L177.425 37.647M180.256 36.7059L181.2 37.647"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask429_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="181"
        y="33"
      >
        <path d="M184.975 33.8823H181.2V37.647H184.975V33.8823Z" fill="white" />
      </mask>
      <g mask="url(#mask429_2057_43870)">
        <mask
          height="5"
          id="mask430_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="181"
          y="33"
        >
          <path d="M184.975 33.8823H181.2V37.647H184.975V33.8823Z" fill="white" />
        </mask>
        <g mask="url(#mask430_2057_43870)">
          <mask
            height="5"
            id="mask431_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="181"
            y="33"
          >
            <path d="M184.975 33.8823H181.2V37.647H184.975V33.8823Z" fill="white" />
          </mask>
          <g mask="url(#mask431_2057_43870)">
            <path
              d="M181.2 33.8823L182.144 34.8235M182.144 34.8235L183.087 33.8823L184.031 34.8235M182.144 34.8235L183.087 35.7647M182.144 34.8235L181.2 35.7647L182.144 36.7059M184.031 34.8235L183.087 35.7647M184.031 34.8235L184.975 33.8823M184.031 34.8235L184.975 35.7647L184.031 36.7059M183.087 35.7647L182.144 36.7059M183.087 35.7647L184.031 36.7059M182.144 36.7059L183.087 37.647L184.031 36.7059M182.144 36.7059L181.2 37.647M184.031 36.7059L184.975 37.647"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask432_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="196"
        y="33"
      >
        <path d="M200.075 33.8823H196.3V37.647H200.075V33.8823Z" fill="white" />
      </mask>
      <g mask="url(#mask432_2057_43870)">
        <mask
          height="5"
          id="mask433_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="196"
          y="33"
        >
          <path d="M200.075 33.8823H196.3V37.647H200.075V33.8823Z" fill="white" />
        </mask>
        <g mask="url(#mask433_2057_43870)">
          <mask
            height="5"
            id="mask434_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="196"
            y="33"
          >
            <path d="M200.075 33.8823H196.3V37.647H200.075V33.8823Z" fill="white" />
          </mask>
          <g mask="url(#mask434_2057_43870)">
            <path
              d="M196.3 33.8823L197.244 34.8235M197.244 34.8235L198.188 33.8823L199.131 34.8235M197.244 34.8235L198.188 35.7647M197.244 34.8235L196.3 35.7647L197.244 36.7059M199.131 34.8235L198.188 35.7647M199.131 34.8235L200.075 33.8823M199.131 34.8235L200.075 35.7647L199.131 36.7059M198.188 35.7647L197.244 36.7059M198.188 35.7647L199.131 36.7059M197.244 36.7059L198.188 37.647L199.131 36.7059M197.244 36.7059L196.3 37.647M199.131 36.7059L200.075 37.647"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask435_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="200"
        y="33"
      >
        <path d="M203.85 33.8823H200.075V37.647H203.85V33.8823Z" fill="white" />
      </mask>
      <g mask="url(#mask435_2057_43870)">
        <mask
          height="5"
          id="mask436_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="200"
          y="33"
        >
          <path d="M203.85 33.8823H200.075V37.647H203.85V33.8823Z" fill="white" />
        </mask>
        <g mask="url(#mask436_2057_43870)">
          <mask
            height="5"
            id="mask437_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="200"
            y="33"
          >
            <path d="M203.85 33.8823H200.075V37.647H203.85V33.8823Z" fill="white" />
          </mask>
          <g mask="url(#mask437_2057_43870)">
            <path
              d="M200.075 33.8823L201.019 34.8235M201.019 34.8235L201.962 33.8823L202.906 34.8235M201.019 34.8235L201.962 35.7647M201.019 34.8235L200.075 35.7647L201.019 36.7059M202.906 34.8235L201.962 35.7647M202.906 34.8235L203.85 33.8823M202.906 34.8235L203.85 35.7647L202.906 36.7059M201.962 35.7647L201.019 36.7059M201.962 35.7647L202.906 36.7059M201.019 36.7059L201.962 37.647L202.906 36.7059M201.019 36.7059L200.075 37.647M202.906 36.7059L203.85 37.647"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask438_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="203"
        y="33"
      >
        <path d="M207.625 33.8823H203.85V37.647H207.625V33.8823Z" fill="white" />
      </mask>
      <g mask="url(#mask438_2057_43870)">
        <mask
          height="5"
          id="mask439_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="203"
          y="33"
        >
          <path d="M207.625 33.8823H203.85V37.647H207.625V33.8823Z" fill="white" />
        </mask>
        <g mask="url(#mask439_2057_43870)">
          <mask
            height="5"
            id="mask440_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="203"
            y="33"
          >
            <path d="M207.625 33.8823H203.85V37.647H207.625V33.8823Z" fill="white" />
          </mask>
          <g mask="url(#mask440_2057_43870)">
            <path
              d="M203.85 33.8823L204.794 34.8235M204.794 34.8235L205.737 33.8823L206.681 34.8235M204.794 34.8235L205.737 35.7647M204.794 34.8235L203.85 35.7647L204.794 36.7059M206.681 34.8235L205.737 35.7647M206.681 34.8235L207.625 33.8823M206.681 34.8235L207.625 35.7647L206.681 36.7059M205.737 35.7647L204.794 36.7059M205.737 35.7647L206.681 36.7059M204.794 36.7059L205.737 37.647L206.681 36.7059M204.794 36.7059L203.85 37.647M206.681 36.7059L207.625 37.647"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask441_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="237"
        y="33"
      >
        <path d="M241.6 33.8823H237.825V37.647H241.6V33.8823Z" fill="white" />
      </mask>
      <g mask="url(#mask441_2057_43870)">
        <mask
          height="5"
          id="mask442_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="237"
          y="33"
        >
          <path d="M241.6 33.8823H237.825V37.647H241.6V33.8823Z" fill="white" />
        </mask>
        <g mask="url(#mask442_2057_43870)">
          <mask
            height="5"
            id="mask443_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="237"
            y="33"
          >
            <path d="M241.6 33.8823H237.825V37.647H241.6V33.8823Z" fill="white" />
          </mask>
          <g mask="url(#mask443_2057_43870)">
            <path
              d="M237.825 33.8823L238.769 34.8235M238.769 34.8235L239.712 33.8823L240.656 34.8235M238.769 34.8235L239.712 35.7647M238.769 34.8235L237.825 35.7647L238.769 36.7059M240.656 34.8235L239.712 35.7647M240.656 34.8235L241.6 33.8823M240.656 34.8235L241.6 35.7647L240.656 36.7059M239.712 35.7647L238.769 36.7059M239.712 35.7647L240.656 36.7059M238.769 36.7059L239.712 37.647L240.656 36.7059M238.769 36.7059L237.825 37.647M240.656 36.7059L241.6 37.647"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask444_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="241"
        y="33"
      >
        <path d="M245.375 33.8823H241.6V37.647H245.375V33.8823Z" fill="white" />
      </mask>
      <g mask="url(#mask444_2057_43870)">
        <mask
          height="5"
          id="mask445_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="241"
          y="33"
        >
          <path d="M245.375 33.8823H241.6V37.647H245.375V33.8823Z" fill="white" />
        </mask>
        <g mask="url(#mask445_2057_43870)">
          <mask
            height="5"
            id="mask446_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="241"
            y="33"
          >
            <path d="M245.375 33.8823H241.6V37.647H245.375V33.8823Z" fill="white" />
          </mask>
          <g mask="url(#mask446_2057_43870)">
            <path
              d="M241.6 33.8823L242.544 34.8235M242.544 34.8235L243.487 33.8823L244.431 34.8235M242.544 34.8235L243.487 35.7647M242.544 34.8235L241.6 35.7647L242.544 36.7059M244.431 34.8235L243.487 35.7647M244.431 34.8235L245.375 33.8823M244.431 34.8235L245.375 35.7647L244.431 36.7059M243.487 35.7647L242.544 36.7059M243.487 35.7647L244.431 36.7059M242.544 36.7059L243.487 37.647L244.431 36.7059M242.544 36.7059L241.6 37.647M244.431 36.7059L245.375 37.647"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask447_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="245"
        y="33"
      >
        <path d="M249.15 33.8823H245.375V37.647H249.15V33.8823Z" fill="white" />
      </mask>
      <g mask="url(#mask447_2057_43870)">
        <mask
          height="5"
          id="mask448_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="245"
          y="33"
        >
          <path d="M249.15 33.8823H245.375V37.647H249.15V33.8823Z" fill="white" />
        </mask>
        <g mask="url(#mask448_2057_43870)">
          <mask
            height="5"
            id="mask449_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="245"
            y="33"
          >
            <path d="M249.15 33.8823H245.375V37.647H249.15V33.8823Z" fill="white" />
          </mask>
          <g mask="url(#mask449_2057_43870)">
            <path
              d="M245.375 33.8823L246.319 34.8235M246.319 34.8235L247.262 33.8823L248.206 34.8235M246.319 34.8235L247.262 35.7647M246.319 34.8235L245.375 35.7647L246.319 36.7059M248.206 34.8235L247.262 35.7647M248.206 34.8235L249.15 33.8823M248.206 34.8235L249.15 35.7647L248.206 36.7059M247.262 35.7647L246.319 36.7059M247.262 35.7647L248.206 36.7059M246.319 36.7059L247.262 37.647L248.206 36.7059M246.319 36.7059L245.375 37.647M248.206 36.7059L249.15 37.647"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask450_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="260"
        y="33"
      >
        <path d="M264.25 33.8823H260.475V37.647H264.25V33.8823Z" fill="white" />
      </mask>
      <g mask="url(#mask450_2057_43870)">
        <mask
          height="5"
          id="mask451_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="260"
          y="33"
        >
          <path d="M264.25 33.8823H260.475V37.647H264.25V33.8823Z" fill="white" />
        </mask>
        <g mask="url(#mask451_2057_43870)">
          <mask
            height="5"
            id="mask452_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="260"
            y="33"
          >
            <path d="M264.25 33.8823H260.475V37.647H264.25V33.8823Z" fill="white" />
          </mask>
          <g mask="url(#mask452_2057_43870)">
            <path
              d="M260.475 33.8823L261.419 34.8235M261.419 34.8235L262.362 33.8823L263.306 34.8235M261.419 34.8235L262.362 35.7647M261.419 34.8235L260.475 35.7647L261.419 36.7059M263.306 34.8235L262.362 35.7647M263.306 34.8235L264.25 33.8823M263.306 34.8235L264.25 35.7647L263.306 36.7059M262.362 35.7647L261.419 36.7059M262.362 35.7647L263.306 36.7059M261.419 36.7059L262.362 37.647L263.306 36.7059M261.419 36.7059L260.475 37.647M263.306 36.7059L264.25 37.647"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask453_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="264"
        y="33"
      >
        <path d="M268.025 33.8823H264.25V37.647H268.025V33.8823Z" fill="white" />
      </mask>
      <g mask="url(#mask453_2057_43870)">
        <mask
          height="5"
          id="mask454_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="264"
          y="33"
        >
          <path d="M268.025 33.8823H264.25V37.647H268.025V33.8823Z" fill="white" />
        </mask>
        <g mask="url(#mask454_2057_43870)">
          <mask
            height="5"
            id="mask455_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="264"
            y="33"
          >
            <path d="M268.025 33.8823H264.25V37.647H268.025V33.8823Z" fill="white" />
          </mask>
          <g mask="url(#mask455_2057_43870)">
            <path
              d="M264.25 33.8823L265.194 34.8235M265.194 34.8235L266.137 33.8823L267.081 34.8235M265.194 34.8235L266.137 35.7647M265.194 34.8235L264.25 35.7647L265.194 36.7059M267.081 34.8235L266.137 35.7647M267.081 34.8235L268.025 33.8823M267.081 34.8235L268.025 35.7647L267.081 36.7059M266.137 35.7647L265.194 36.7059M266.137 35.7647L267.081 36.7059M265.194 36.7059L266.137 37.647L267.081 36.7059M265.194 36.7059L264.25 37.647M267.081 36.7059L268.025 37.647"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask456_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="268"
        y="33"
      >
        <path d="M271.8 33.8823H268.025V37.647H271.8V33.8823Z" fill="white" />
      </mask>
      <g mask="url(#mask456_2057_43870)">
        <mask
          height="5"
          id="mask457_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="268"
          y="33"
        >
          <path d="M271.8 33.8823H268.025V37.647H271.8V33.8823Z" fill="white" />
        </mask>
        <g mask="url(#mask457_2057_43870)">
          <mask
            height="5"
            id="mask458_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="268"
            y="33"
          >
            <path d="M271.8 33.8823H268.025V37.647H271.8V33.8823Z" fill="white" />
          </mask>
          <g mask="url(#mask458_2057_43870)">
            <path
              d="M268.025 33.8823L268.969 34.8235M268.969 34.8235L269.913 33.8823L270.856 34.8235M268.969 34.8235L269.913 35.7647M268.969 34.8235L268.025 35.7647L268.969 36.7059M270.856 34.8235L269.913 35.7647M270.856 34.8235L271.8 33.8823M270.856 34.8235L271.8 35.7647L270.856 36.7059M269.913 35.7647L268.969 36.7059M269.913 35.7647L270.856 36.7059M268.969 36.7059L269.913 37.647L270.856 36.7059M268.969 36.7059L268.025 37.647M270.856 36.7059L271.8 37.647"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask459_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="283"
        y="33"
      >
        <path d="M286.9 33.8823H283.125V37.647H286.9V33.8823Z" fill="white" />
      </mask>
      <g mask="url(#mask459_2057_43870)">
        <mask
          height="5"
          id="mask460_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="283"
          y="33"
        >
          <path d="M286.9 33.8823H283.125V37.647H286.9V33.8823Z" fill="white" />
        </mask>
        <g mask="url(#mask460_2057_43870)">
          <mask
            height="5"
            id="mask461_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="283"
            y="33"
          >
            <path d="M286.9 33.8823H283.125V37.647H286.9V33.8823Z" fill="white" />
          </mask>
          <g mask="url(#mask461_2057_43870)">
            <path
              d="M283.125 33.8823L284.069 34.8235M284.069 34.8235L285.012 33.8823L285.956 34.8235M284.069 34.8235L285.012 35.7647M284.069 34.8235L283.125 35.7647L284.069 36.7059M285.956 34.8235L285.012 35.7647M285.956 34.8235L286.9 33.8823M285.956 34.8235L286.9 35.7647L285.956 36.7059M285.012 35.7647L284.069 36.7059M285.012 35.7647L285.956 36.7059M284.069 36.7059L285.012 37.647L285.956 36.7059M284.069 36.7059L283.125 37.647M285.956 36.7059L286.9 37.647"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask462_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="286"
        y="33"
      >
        <path d="M290.675 33.8823H286.9V37.647H290.675V33.8823Z" fill="white" />
      </mask>
      <g mask="url(#mask462_2057_43870)">
        <mask
          height="5"
          id="mask463_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="286"
          y="33"
        >
          <path d="M290.675 33.8823H286.9V37.647H290.675V33.8823Z" fill="white" />
        </mask>
        <g mask="url(#mask463_2057_43870)">
          <mask
            height="5"
            id="mask464_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="286"
            y="33"
          >
            <path d="M290.675 33.8823H286.9V37.647H290.675V33.8823Z" fill="white" />
          </mask>
          <g mask="url(#mask464_2057_43870)">
            <path
              d="M286.9 33.8823L287.844 34.8235M287.844 34.8235L288.788 33.8823L289.731 34.8235M287.844 34.8235L288.788 35.7647M287.844 34.8235L286.9 35.7647L287.844 36.7059M289.731 34.8235L288.788 35.7647M289.731 34.8235L290.675 33.8823M289.731 34.8235L290.675 35.7647L289.731 36.7059M288.788 35.7647L287.844 36.7059M288.788 35.7647L289.731 36.7059M287.844 36.7059L288.788 37.647L289.731 36.7059M287.844 36.7059L286.9 37.647M289.731 36.7059L290.675 37.647"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask465_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="290"
        y="33"
      >
        <path d="M294.45 33.8823H290.675V37.647H294.45V33.8823Z" fill="white" />
      </mask>
      <g mask="url(#mask465_2057_43870)">
        <mask
          height="5"
          id="mask466_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="290"
          y="33"
        >
          <path d="M294.45 33.8823H290.675V37.647H294.45V33.8823Z" fill="white" />
        </mask>
        <g mask="url(#mask466_2057_43870)">
          <mask
            height="5"
            id="mask467_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="290"
            y="33"
          >
            <path d="M294.45 33.8823H290.675V37.647H294.45V33.8823Z" fill="white" />
          </mask>
          <g mask="url(#mask467_2057_43870)">
            <path
              d="M290.675 33.8823L291.619 34.8235M291.619 34.8235L292.563 33.8823L293.506 34.8235M291.619 34.8235L292.563 35.7647M291.619 34.8235L290.675 35.7647L291.619 36.7059M293.506 34.8235L292.563 35.7647M293.506 34.8235L294.45 33.8823M293.506 34.8235L294.45 35.7647L293.506 36.7059M292.563 35.7647L291.619 36.7059M292.563 35.7647L293.506 36.7059M291.619 36.7059L292.563 37.647L293.506 36.7059M291.619 36.7059L290.675 37.647M293.506 36.7059L294.45 37.647"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="3"
        id="mask468_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="0"
        y="38"
      >
        <path d="M2.98143 38.3616H0.716431V40.6204H2.98143V38.3616Z" fill="white" />
      </mask>
      <g mask="url(#mask468_2057_43870)">
        <mask
          height="3"
          id="mask469_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="0"
          y="38"
        >
          <path d="M2.98143 38.3616H0.716431V40.6204H2.98143V38.3616Z" fill="white" />
        </mask>
        <g mask="url(#mask469_2057_43870)">
          <path
            d="M0.716431 38.3616L1.84893 39.491M1.84893 39.491L2.98143 38.3616M1.84893 39.491L2.98143 40.6204M1.84893 39.491L0.716431 40.6204"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask470_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="4"
        y="38"
      >
        <path d="M6.75646 38.3616H4.49146V40.6204H6.75646V38.3616Z" fill="white" />
      </mask>
      <g mask="url(#mask470_2057_43870)">
        <mask
          height="3"
          id="mask471_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="4"
          y="38"
        >
          <path d="M6.75646 38.3616H4.49146V40.6204H6.75646V38.3616Z" fill="white" />
        </mask>
        <g mask="url(#mask471_2057_43870)">
          <path
            d="M4.49146 38.3616L5.62396 39.491M5.62396 39.491L6.75646 38.3616M5.62396 39.491L6.75646 40.6204M5.62396 39.491L4.49146 40.6204"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask472_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="8"
        y="38"
      >
        <path d="M10.5315 38.3616H8.26648V40.6204H10.5315V38.3616Z" fill="white" />
      </mask>
      <g mask="url(#mask472_2057_43870)">
        <mask
          height="3"
          id="mask473_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="8"
          y="38"
        >
          <path d="M10.5315 38.3616H8.26648V40.6204H10.5315V38.3616Z" fill="white" />
        </mask>
        <g mask="url(#mask473_2057_43870)">
          <path
            d="M8.26648 38.3616L9.39898 39.491M9.39898 39.491L10.5315 38.3616M9.39898 39.491L10.5315 40.6204M9.39898 39.491L8.26648 40.6204"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="5"
        id="mask474_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="67"
        y="37"
      >
        <path d="M71.725 37.647H67.95V41.4117H71.725V37.647Z" fill="white" />
      </mask>
      <g mask="url(#mask474_2057_43870)">
        <mask
          height="5"
          id="mask475_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="67"
          y="37"
        >
          <path d="M71.725 37.647H67.95V41.4117H71.725V37.647Z" fill="white" />
        </mask>
        <g mask="url(#mask475_2057_43870)">
          <mask
            height="5"
            id="mask476_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="67"
            y="37"
          >
            <path d="M71.725 37.647H67.95V41.4117H71.725V37.647Z" fill="white" />
          </mask>
          <g mask="url(#mask476_2057_43870)">
            <path
              d="M67.95 37.647L68.8937 38.5882M68.8937 38.5882L69.8375 37.647L70.7812 38.5882M68.8937 38.5882L69.8375 39.5294M68.8937 38.5882L67.95 39.5294L68.8937 40.4706M70.7812 38.5882L69.8375 39.5294M70.7812 38.5882L71.725 37.647M70.7812 38.5882L71.725 39.5294L70.7812 40.4706M69.8375 39.5294L68.8937 40.4706M69.8375 39.5294L70.7812 40.4706M68.8937 40.4706L69.8375 41.4117L70.7812 40.4706M68.8937 40.4706L67.95 41.4117M70.7812 40.4706L71.725 41.4117"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask477_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="71"
        y="37"
      >
        <path d="M75.5 37.647H71.725V41.4117H75.5V37.647Z" fill="white" />
      </mask>
      <g mask="url(#mask477_2057_43870)">
        <mask
          height="5"
          id="mask478_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="71"
          y="37"
        >
          <path d="M75.5 37.647H71.725V41.4117H75.5V37.647Z" fill="white" />
        </mask>
        <g mask="url(#mask478_2057_43870)">
          <mask
            height="5"
            id="mask479_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="71"
            y="37"
          >
            <path d="M75.5 37.647H71.725V41.4117H75.5V37.647Z" fill="white" />
          </mask>
          <g mask="url(#mask479_2057_43870)">
            <path
              d="M71.725 37.647L72.6687 38.5882M72.6687 38.5882L73.6125 37.647L74.5562 38.5882M72.6687 38.5882L73.6125 39.5294M72.6687 38.5882L71.725 39.5294L72.6687 40.4706M74.5562 38.5882L73.6125 39.5294M74.5562 38.5882L75.5 37.647M74.5562 38.5882L75.5 39.5294L74.5562 40.4706M73.6125 39.5294L72.6687 40.4706M73.6125 39.5294L74.5562 40.4706M72.6687 40.4706L73.6125 41.4117L74.5562 40.4706M72.6687 40.4706L71.725 41.4117M74.5562 40.4706L75.5 41.4117"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask480_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="86"
        y="37"
      >
        <path d="M90.6 37.647H86.825V41.4117H90.6V37.647Z" fill="white" />
      </mask>
      <g mask="url(#mask480_2057_43870)">
        <mask
          height="5"
          id="mask481_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="86"
          y="37"
        >
          <path d="M90.6 37.647H86.825V41.4117H90.6V37.647Z" fill="white" />
        </mask>
        <g mask="url(#mask481_2057_43870)">
          <mask
            height="5"
            id="mask482_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="86"
            y="37"
          >
            <path d="M90.6 37.647H86.825V41.4117H90.6V37.647Z" fill="white" />
          </mask>
          <g mask="url(#mask482_2057_43870)">
            <path
              d="M86.825 37.647L87.7687 38.5882M87.7687 38.5882L88.7125 37.647L89.6562 38.5882M87.7687 38.5882L88.7125 39.5294M87.7687 38.5882L86.825 39.5294L87.7687 40.4706M89.6562 38.5882L88.7125 39.5294M89.6562 38.5882L90.6 37.647M89.6562 38.5882L90.6 39.5294L89.6562 40.4706M88.7125 39.5294L87.7687 40.4706M88.7125 39.5294L89.6562 40.4706M87.7687 40.4706L88.7125 41.4117L89.6562 40.4706M87.7687 40.4706L86.825 41.4117M89.6562 40.4706L90.6 41.4117"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask483_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="90"
        y="37"
      >
        <path d="M94.375 37.647H90.6V41.4117H94.375V37.647Z" fill="white" />
      </mask>
      <g mask="url(#mask483_2057_43870)">
        <mask
          height="5"
          id="mask484_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="90"
          y="37"
        >
          <path d="M94.375 37.647H90.6V41.4117H94.375V37.647Z" fill="white" />
        </mask>
        <g mask="url(#mask484_2057_43870)">
          <mask
            height="5"
            id="mask485_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="90"
            y="37"
          >
            <path d="M94.375 37.647H90.6V41.4117H94.375V37.647Z" fill="white" />
          </mask>
          <g mask="url(#mask485_2057_43870)">
            <path
              d="M90.6 37.647L91.5437 38.5882M91.5437 38.5882L92.4875 37.647L93.4312 38.5882M91.5437 38.5882L92.4875 39.5294M91.5437 38.5882L90.6 39.5294L91.5437 40.4706M93.4312 38.5882L92.4875 39.5294M93.4312 38.5882L94.375 37.647M93.4312 38.5882L94.375 39.5294L93.4312 40.4706M92.4875 39.5294L91.5437 40.4706M92.4875 39.5294L93.4312 40.4706M91.5437 40.4706L92.4875 41.4117L93.4312 40.4706M91.5437 40.4706L90.6 41.4117M93.4312 40.4706L94.375 41.4117"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask486_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="94"
        y="37"
      >
        <path d="M98.15 37.647H94.375V41.4117H98.15V37.647Z" fill="white" />
      </mask>
      <g mask="url(#mask486_2057_43870)">
        <mask
          height="5"
          id="mask487_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="94"
          y="37"
        >
          <path d="M98.15 37.647H94.375V41.4117H98.15V37.647Z" fill="white" />
        </mask>
        <g mask="url(#mask487_2057_43870)">
          <mask
            height="5"
            id="mask488_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="94"
            y="37"
          >
            <path d="M98.15 37.647H94.375V41.4117H98.15V37.647Z" fill="white" />
          </mask>
          <g mask="url(#mask488_2057_43870)">
            <path
              d="M94.375 37.647L95.3187 38.5882M95.3187 38.5882L96.2625 37.647L97.2062 38.5882M95.3187 38.5882L96.2625 39.5294M95.3187 38.5882L94.375 39.5294L95.3187 40.4706M97.2062 38.5882L96.2625 39.5294M97.2062 38.5882L98.15 37.647M97.2062 38.5882L98.15 39.5294L97.2062 40.4706M96.2625 39.5294L95.3187 40.4706M96.2625 39.5294L97.2062 40.4706M95.3187 40.4706L96.2625 41.4117L97.2062 40.4706M95.3187 40.4706L94.375 41.4117M97.2062 40.4706L98.15 41.4117"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask489_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="109"
        y="37"
      >
        <path d="M113.25 37.647H109.475V41.4117H113.25V37.647Z" fill="white" />
      </mask>
      <g mask="url(#mask489_2057_43870)">
        <mask
          height="5"
          id="mask490_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="109"
          y="37"
        >
          <path d="M113.25 37.647H109.475V41.4117H113.25V37.647Z" fill="white" />
        </mask>
        <g mask="url(#mask490_2057_43870)">
          <mask
            height="5"
            id="mask491_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="109"
            y="37"
          >
            <path d="M113.25 37.647H109.475V41.4117H113.25V37.647Z" fill="white" />
          </mask>
          <g mask="url(#mask491_2057_43870)">
            <path
              d="M109.475 37.647L110.419 38.5882M110.419 38.5882L111.362 37.647L112.306 38.5882M110.419 38.5882L111.362 39.5294M110.419 38.5882L109.475 39.5294L110.419 40.4706M112.306 38.5882L111.362 39.5294M112.306 38.5882L113.25 37.647M112.306 38.5882L113.25 39.5294L112.306 40.4706M111.362 39.5294L110.419 40.4706M111.362 39.5294L112.306 40.4706M110.419 40.4706L111.362 41.4117L112.306 40.4706M110.419 40.4706L109.475 41.4117M112.306 40.4706L113.25 41.4117"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask492_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="113"
        y="37"
      >
        <path d="M117.025 37.647H113.25V41.4117H117.025V37.647Z" fill="white" />
      </mask>
      <g mask="url(#mask492_2057_43870)">
        <mask
          height="5"
          id="mask493_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="113"
          y="37"
        >
          <path d="M117.025 37.647H113.25V41.4117H117.025V37.647Z" fill="white" />
        </mask>
        <g mask="url(#mask493_2057_43870)">
          <mask
            height="5"
            id="mask494_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="113"
            y="37"
          >
            <path d="M117.025 37.647H113.25V41.4117H117.025V37.647Z" fill="white" />
          </mask>
          <g mask="url(#mask494_2057_43870)">
            <path
              d="M113.25 37.647L114.194 38.5882M114.194 38.5882L115.137 37.647L116.081 38.5882M114.194 38.5882L115.137 39.5294M114.194 38.5882L113.25 39.5294L114.194 40.4706M116.081 38.5882L115.137 39.5294M116.081 38.5882L117.025 37.647M116.081 38.5882L117.025 39.5294L116.081 40.4706M115.137 39.5294L114.194 40.4706M115.137 39.5294L116.081 40.4706M114.194 40.4706L115.137 41.4117L116.081 40.4706M114.194 40.4706L113.25 41.4117M116.081 40.4706L117.025 41.4117"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask495_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="117"
        y="37"
      >
        <path d="M120.8 37.647H117.025V41.4117H120.8V37.647Z" fill="white" />
      </mask>
      <g mask="url(#mask495_2057_43870)">
        <mask
          height="5"
          id="mask496_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="117"
          y="37"
        >
          <path d="M120.8 37.647H117.025V41.4117H120.8V37.647Z" fill="white" />
        </mask>
        <g mask="url(#mask496_2057_43870)">
          <mask
            height="5"
            id="mask497_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="117"
            y="37"
          >
            <path d="M120.8 37.647H117.025V41.4117H120.8V37.647Z" fill="white" />
          </mask>
          <g mask="url(#mask497_2057_43870)">
            <path
              d="M117.025 37.647L117.969 38.5882M117.969 38.5882L118.913 37.647L119.856 38.5882M117.969 38.5882L118.913 39.5294M117.969 38.5882L117.025 39.5294L117.969 40.4706M119.856 38.5882L118.913 39.5294M119.856 38.5882L120.8 37.647M119.856 38.5882L120.8 39.5294L119.856 40.4706M118.913 39.5294L117.969 40.4706M118.913 39.5294L119.856 40.4706M117.969 40.4706L118.913 41.4117L119.856 40.4706M117.969 40.4706L117.025 41.4117M119.856 40.4706L120.8 41.4117"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask498_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="132"
        y="37"
      >
        <path d="M135.9 37.647H132.125V41.4117H135.9V37.647Z" fill="white" />
      </mask>
      <g mask="url(#mask498_2057_43870)">
        <mask
          height="5"
          id="mask499_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="132"
          y="37"
        >
          <path d="M135.9 37.647H132.125V41.4117H135.9V37.647Z" fill="white" />
        </mask>
        <g mask="url(#mask499_2057_43870)">
          <mask
            height="5"
            id="mask500_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="132"
            y="37"
          >
            <path d="M135.9 37.647H132.125V41.4117H135.9V37.647Z" fill="white" />
          </mask>
          <g mask="url(#mask500_2057_43870)">
            <path
              d="M132.125 37.647L133.069 38.5882M133.069 38.5882L134.012 37.647L134.956 38.5882M133.069 38.5882L134.012 39.5294M133.069 38.5882L132.125 39.5294L133.069 40.4706M134.956 38.5882L134.012 39.5294M134.956 38.5882L135.9 37.647M134.956 38.5882L135.9 39.5294L134.956 40.4706M134.012 39.5294L133.069 40.4706M134.012 39.5294L134.956 40.4706M133.069 40.4706L134.012 41.4117L134.956 40.4706M133.069 40.4706L132.125 41.4117M134.956 40.4706L135.9 41.4117"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask501_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="135"
        y="37"
      >
        <path d="M139.675 37.647H135.9V41.4117H139.675V37.647Z" fill="white" />
      </mask>
      <g mask="url(#mask501_2057_43870)">
        <mask
          height="5"
          id="mask502_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="135"
          y="37"
        >
          <path d="M139.675 37.647H135.9V41.4117H139.675V37.647Z" fill="white" />
        </mask>
        <g mask="url(#mask502_2057_43870)">
          <mask
            height="5"
            id="mask503_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="135"
            y="37"
          >
            <path d="M139.675 37.647H135.9V41.4117H139.675V37.647Z" fill="white" />
          </mask>
          <g mask="url(#mask503_2057_43870)">
            <path
              d="M135.9 37.647L136.844 38.5882M136.844 38.5882L137.788 37.647L138.731 38.5882M136.844 38.5882L137.788 39.5294M136.844 38.5882L135.9 39.5294L136.844 40.4706M138.731 38.5882L137.788 39.5294M138.731 38.5882L139.675 37.647M138.731 38.5882L139.675 39.5294L138.731 40.4706M137.788 39.5294L136.844 40.4706M137.788 39.5294L138.731 40.4706M136.844 40.4706L137.788 41.4117L138.731 40.4706M136.844 40.4706L135.9 41.4117M138.731 40.4706L139.675 41.4117"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask504_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="139"
        y="37"
      >
        <path d="M143.45 37.647H139.675V41.4117H143.45V37.647Z" fill="white" />
      </mask>
      <g mask="url(#mask504_2057_43870)">
        <mask
          height="5"
          id="mask505_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="139"
          y="37"
        >
          <path d="M143.45 37.647H139.675V41.4117H143.45V37.647Z" fill="white" />
        </mask>
        <g mask="url(#mask505_2057_43870)">
          <mask
            height="5"
            id="mask506_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="139"
            y="37"
          >
            <path d="M143.45 37.647H139.675V41.4117H143.45V37.647Z" fill="white" />
          </mask>
          <g mask="url(#mask506_2057_43870)">
            <path
              d="M139.675 37.647L140.619 38.5882M140.619 38.5882L141.563 37.647L142.506 38.5882M140.619 38.5882L141.563 39.5294M140.619 38.5882L139.675 39.5294L140.619 40.4706M142.506 38.5882L141.563 39.5294M142.506 38.5882L143.45 37.647M142.506 38.5882L143.45 39.5294L142.506 40.4706M141.563 39.5294L140.619 40.4706M141.563 39.5294L142.506 40.4706M140.619 40.4706L141.563 41.4117L142.506 40.4706M140.619 40.4706L139.675 41.4117M142.506 40.4706L143.45 41.4117"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask507_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="173"
        y="37"
      >
        <path d="M177.425 37.647H173.65V41.4117H177.425V37.647Z" fill="white" />
      </mask>
      <g mask="url(#mask507_2057_43870)">
        <mask
          height="5"
          id="mask508_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="173"
          y="37"
        >
          <path d="M177.425 37.647H173.65V41.4117H177.425V37.647Z" fill="white" />
        </mask>
        <g mask="url(#mask508_2057_43870)">
          <mask
            height="5"
            id="mask509_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="173"
            y="37"
          >
            <path d="M177.425 37.647H173.65V41.4117H177.425V37.647Z" fill="white" />
          </mask>
          <g mask="url(#mask509_2057_43870)">
            <path
              d="M173.65 37.647L174.594 38.5882M174.594 38.5882L175.538 37.647L176.481 38.5882M174.594 38.5882L175.538 39.5294M174.594 38.5882L173.65 39.5294L174.594 40.4706M176.481 38.5882L175.538 39.5294M176.481 38.5882L177.425 37.647M176.481 38.5882L177.425 39.5294L176.481 40.4706M175.538 39.5294L174.594 40.4706M175.538 39.5294L176.481 40.4706M174.594 40.4706L175.538 41.4117L176.481 40.4706M174.594 40.4706L173.65 41.4117M176.481 40.4706L177.425 41.4117"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask510_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="177"
        y="37"
      >
        <path d="M181.2 37.647H177.425V41.4117H181.2V37.647Z" fill="white" />
      </mask>
      <g mask="url(#mask510_2057_43870)">
        <mask
          height="5"
          id="mask511_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="177"
          y="37"
        >
          <path d="M181.2 37.647H177.425V41.4117H181.2V37.647Z" fill="white" />
        </mask>
        <g mask="url(#mask511_2057_43870)">
          <mask
            height="5"
            id="mask512_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="177"
            y="37"
          >
            <path d="M181.2 37.647H177.425V41.4117H181.2V37.647Z" fill="white" />
          </mask>
          <g mask="url(#mask512_2057_43870)">
            <path
              d="M177.425 37.647L178.369 38.5882M178.369 38.5882L179.313 37.647L180.256 38.5882M178.369 38.5882L179.313 39.5294M178.369 38.5882L177.425 39.5294L178.369 40.4706M180.256 38.5882L179.313 39.5294M180.256 38.5882L181.2 37.647M180.256 38.5882L181.2 39.5294L180.256 40.4706M179.313 39.5294L178.369 40.4706M179.313 39.5294L180.256 40.4706M178.369 40.4706L179.313 41.4117L180.256 40.4706M178.369 40.4706L177.425 41.4117M180.256 40.4706L181.2 41.4117"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask513_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="181"
        y="37"
      >
        <path d="M184.975 37.647H181.2V41.4117H184.975V37.647Z" fill="white" />
      </mask>
      <g mask="url(#mask513_2057_43870)">
        <mask
          height="5"
          id="mask514_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="181"
          y="37"
        >
          <path d="M184.975 37.647H181.2V41.4117H184.975V37.647Z" fill="white" />
        </mask>
        <g mask="url(#mask514_2057_43870)">
          <mask
            height="5"
            id="mask515_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="181"
            y="37"
          >
            <path d="M184.975 37.647H181.2V41.4117H184.975V37.647Z" fill="white" />
          </mask>
          <g mask="url(#mask515_2057_43870)">
            <path
              d="M181.2 37.647L182.144 38.5882M182.144 38.5882L183.087 37.647L184.031 38.5882M182.144 38.5882L183.087 39.5294M182.144 38.5882L181.2 39.5294L182.144 40.4706M184.031 38.5882L183.087 39.5294M184.031 38.5882L184.975 37.647M184.031 38.5882L184.975 39.5294L184.031 40.4706M183.087 39.5294L182.144 40.4706M183.087 39.5294L184.031 40.4706M182.144 40.4706L183.087 41.4117L184.031 40.4706M182.144 40.4706L181.2 41.4117M184.031 40.4706L184.975 41.4117"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask516_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="196"
        y="37"
      >
        <path d="M200.075 37.647H196.3V41.4117H200.075V37.647Z" fill="white" />
      </mask>
      <g mask="url(#mask516_2057_43870)">
        <mask
          height="5"
          id="mask517_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="196"
          y="37"
        >
          <path d="M200.075 37.647H196.3V41.4117H200.075V37.647Z" fill="white" />
        </mask>
        <g mask="url(#mask517_2057_43870)">
          <mask
            height="5"
            id="mask518_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="196"
            y="37"
          >
            <path d="M200.075 37.647H196.3V41.4117H200.075V37.647Z" fill="white" />
          </mask>
          <g mask="url(#mask518_2057_43870)">
            <path
              d="M196.3 37.647L197.244 38.5882M197.244 38.5882L198.188 37.647L199.131 38.5882M197.244 38.5882L198.188 39.5294M197.244 38.5882L196.3 39.5294L197.244 40.4706M199.131 38.5882L198.188 39.5294M199.131 38.5882L200.075 37.647M199.131 38.5882L200.075 39.5294L199.131 40.4706M198.188 39.5294L197.244 40.4706M198.188 39.5294L199.131 40.4706M197.244 40.4706L198.188 41.4117L199.131 40.4706M197.244 40.4706L196.3 41.4117M199.131 40.4706L200.075 41.4117"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask519_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="200"
        y="37"
      >
        <path d="M203.85 37.647H200.075V41.4117H203.85V37.647Z" fill="white" />
      </mask>
      <g mask="url(#mask519_2057_43870)">
        <mask
          height="5"
          id="mask520_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="200"
          y="37"
        >
          <path d="M203.85 37.647H200.075V41.4117H203.85V37.647Z" fill="white" />
        </mask>
        <g mask="url(#mask520_2057_43870)">
          <mask
            height="5"
            id="mask521_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="200"
            y="37"
          >
            <path d="M203.85 37.647H200.075V41.4117H203.85V37.647Z" fill="white" />
          </mask>
          <g mask="url(#mask521_2057_43870)">
            <path
              d="M200.075 37.647L201.019 38.5882M201.019 38.5882L201.962 37.647L202.906 38.5882M201.019 38.5882L201.962 39.5294M201.019 38.5882L200.075 39.5294L201.019 40.4706M202.906 38.5882L201.962 39.5294M202.906 38.5882L203.85 37.647M202.906 38.5882L203.85 39.5294L202.906 40.4706M201.962 39.5294L201.019 40.4706M201.962 39.5294L202.906 40.4706M201.019 40.4706L201.962 41.4117L202.906 40.4706M201.019 40.4706L200.075 41.4117M202.906 40.4706L203.85 41.4117"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask522_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="203"
        y="37"
      >
        <path d="M207.625 37.647H203.85V41.4117H207.625V37.647Z" fill="white" />
      </mask>
      <g mask="url(#mask522_2057_43870)">
        <mask
          height="5"
          id="mask523_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="203"
          y="37"
        >
          <path d="M207.625 37.647H203.85V41.4117H207.625V37.647Z" fill="white" />
        </mask>
        <g mask="url(#mask523_2057_43870)">
          <mask
            height="5"
            id="mask524_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="203"
            y="37"
          >
            <path d="M207.625 37.647H203.85V41.4117H207.625V37.647Z" fill="white" />
          </mask>
          <g mask="url(#mask524_2057_43870)">
            <path
              d="M203.85 37.647L204.794 38.5882M204.794 38.5882L205.737 37.647L206.681 38.5882M204.794 38.5882L205.737 39.5294M204.794 38.5882L203.85 39.5294L204.794 40.4706M206.681 38.5882L205.737 39.5294M206.681 38.5882L207.625 37.647M206.681 38.5882L207.625 39.5294L206.681 40.4706M205.737 39.5294L204.794 40.4706M205.737 39.5294L206.681 40.4706M204.794 40.4706L205.737 41.4117L206.681 40.4706M204.794 40.4706L203.85 41.4117M206.681 40.4706L207.625 41.4117"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask525_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="237"
        y="37"
      >
        <path d="M241.6 37.647H237.825V41.4117H241.6V37.647Z" fill="white" />
      </mask>
      <g mask="url(#mask525_2057_43870)">
        <mask
          height="5"
          id="mask526_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="237"
          y="37"
        >
          <path d="M241.6 37.647H237.825V41.4117H241.6V37.647Z" fill="white" />
        </mask>
        <g mask="url(#mask526_2057_43870)">
          <mask
            height="5"
            id="mask527_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="237"
            y="37"
          >
            <path d="M241.6 37.647H237.825V41.4117H241.6V37.647Z" fill="white" />
          </mask>
          <g mask="url(#mask527_2057_43870)">
            <path
              d="M237.825 37.647L238.769 38.5882M238.769 38.5882L239.712 37.647L240.656 38.5882M238.769 38.5882L239.712 39.5294M238.769 38.5882L237.825 39.5294L238.769 40.4706M240.656 38.5882L239.712 39.5294M240.656 38.5882L241.6 37.647M240.656 38.5882L241.6 39.5294L240.656 40.4706M239.712 39.5294L238.769 40.4706M239.712 39.5294L240.656 40.4706M238.769 40.4706L239.712 41.4117L240.656 40.4706M238.769 40.4706L237.825 41.4117M240.656 40.4706L241.6 41.4117"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask528_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="241"
        y="37"
      >
        <path d="M245.375 37.647H241.6V41.4117H245.375V37.647Z" fill="white" />
      </mask>
      <g mask="url(#mask528_2057_43870)">
        <mask
          height="5"
          id="mask529_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="241"
          y="37"
        >
          <path d="M245.375 37.647H241.6V41.4117H245.375V37.647Z" fill="white" />
        </mask>
        <g mask="url(#mask529_2057_43870)">
          <mask
            height="5"
            id="mask530_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="241"
            y="37"
          >
            <path d="M245.375 37.647H241.6V41.4117H245.375V37.647Z" fill="white" />
          </mask>
          <g mask="url(#mask530_2057_43870)">
            <path
              d="M241.6 37.647L242.544 38.5882M242.544 38.5882L243.487 37.647L244.431 38.5882M242.544 38.5882L243.487 39.5294M242.544 38.5882L241.6 39.5294L242.544 40.4706M244.431 38.5882L243.487 39.5294M244.431 38.5882L245.375 37.647M244.431 38.5882L245.375 39.5294L244.431 40.4706M243.487 39.5294L242.544 40.4706M243.487 39.5294L244.431 40.4706M242.544 40.4706L243.487 41.4117L244.431 40.4706M242.544 40.4706L241.6 41.4117M244.431 40.4706L245.375 41.4117"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask531_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="245"
        y="37"
      >
        <path d="M249.15 37.647H245.375V41.4117H249.15V37.647Z" fill="white" />
      </mask>
      <g mask="url(#mask531_2057_43870)">
        <mask
          height="5"
          id="mask532_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="245"
          y="37"
        >
          <path d="M249.15 37.647H245.375V41.4117H249.15V37.647Z" fill="white" />
        </mask>
        <g mask="url(#mask532_2057_43870)">
          <mask
            height="5"
            id="mask533_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="245"
            y="37"
          >
            <path d="M249.15 37.647H245.375V41.4117H249.15V37.647Z" fill="white" />
          </mask>
          <g mask="url(#mask533_2057_43870)">
            <path
              d="M245.375 37.647L246.319 38.5882M246.319 38.5882L247.262 37.647L248.206 38.5882M246.319 38.5882L247.262 39.5294M246.319 38.5882L245.375 39.5294L246.319 40.4706M248.206 38.5882L247.262 39.5294M248.206 38.5882L249.15 37.647M248.206 38.5882L249.15 39.5294L248.206 40.4706M247.262 39.5294L246.319 40.4706M247.262 39.5294L248.206 40.4706M246.319 40.4706L247.262 41.4117L248.206 40.4706M246.319 40.4706L245.375 41.4117M248.206 40.4706L249.15 41.4117"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask534_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="260"
        y="37"
      >
        <path d="M264.25 37.647H260.475V41.4117H264.25V37.647Z" fill="white" />
      </mask>
      <g mask="url(#mask534_2057_43870)">
        <mask
          height="5"
          id="mask535_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="260"
          y="37"
        >
          <path d="M264.25 37.647H260.475V41.4117H264.25V37.647Z" fill="white" />
        </mask>
        <g mask="url(#mask535_2057_43870)">
          <mask
            height="5"
            id="mask536_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="260"
            y="37"
          >
            <path d="M264.25 37.647H260.475V41.4117H264.25V37.647Z" fill="white" />
          </mask>
          <g mask="url(#mask536_2057_43870)">
            <path
              d="M260.475 37.647L261.419 38.5882M261.419 38.5882L262.362 37.647L263.306 38.5882M261.419 38.5882L262.362 39.5294M261.419 38.5882L260.475 39.5294L261.419 40.4706M263.306 38.5882L262.362 39.5294M263.306 38.5882L264.25 37.647M263.306 38.5882L264.25 39.5294L263.306 40.4706M262.362 39.5294L261.419 40.4706M262.362 39.5294L263.306 40.4706M261.419 40.4706L262.362 41.4117L263.306 40.4706M261.419 40.4706L260.475 41.4117M263.306 40.4706L264.25 41.4117"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask537_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="264"
        y="37"
      >
        <path d="M268.025 37.647H264.25V41.4117H268.025V37.647Z" fill="white" />
      </mask>
      <g mask="url(#mask537_2057_43870)">
        <mask
          height="5"
          id="mask538_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="264"
          y="37"
        >
          <path d="M268.025 37.647H264.25V41.4117H268.025V37.647Z" fill="white" />
        </mask>
        <g mask="url(#mask538_2057_43870)">
          <mask
            height="5"
            id="mask539_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="264"
            y="37"
          >
            <path d="M268.025 37.647H264.25V41.4117H268.025V37.647Z" fill="white" />
          </mask>
          <g mask="url(#mask539_2057_43870)">
            <path
              d="M264.25 37.647L265.194 38.5882M265.194 38.5882L266.137 37.647L267.081 38.5882M265.194 38.5882L266.137 39.5294M265.194 38.5882L264.25 39.5294L265.194 40.4706M267.081 38.5882L266.137 39.5294M267.081 38.5882L268.025 37.647M267.081 38.5882L268.025 39.5294L267.081 40.4706M266.137 39.5294L265.194 40.4706M266.137 39.5294L267.081 40.4706M265.194 40.4706L266.137 41.4117L267.081 40.4706M265.194 40.4706L264.25 41.4117M267.081 40.4706L268.025 41.4117"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask540_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="268"
        y="37"
      >
        <path d="M271.8 37.647H268.025V41.4117H271.8V37.647Z" fill="white" />
      </mask>
      <g mask="url(#mask540_2057_43870)">
        <mask
          height="5"
          id="mask541_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="268"
          y="37"
        >
          <path d="M271.8 37.647H268.025V41.4117H271.8V37.647Z" fill="white" />
        </mask>
        <g mask="url(#mask541_2057_43870)">
          <mask
            height="5"
            id="mask542_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="268"
            y="37"
          >
            <path d="M271.8 37.647H268.025V41.4117H271.8V37.647Z" fill="white" />
          </mask>
          <g mask="url(#mask542_2057_43870)">
            <path
              d="M268.025 37.647L268.969 38.5882M268.969 38.5882L269.913 37.647L270.856 38.5882M268.969 38.5882L269.913 39.5294M268.969 38.5882L268.025 39.5294L268.969 40.4706M270.856 38.5882L269.913 39.5294M270.856 38.5882L271.8 37.647M270.856 38.5882L271.8 39.5294L270.856 40.4706M269.913 39.5294L268.969 40.4706M269.913 39.5294L270.856 40.4706M268.969 40.4706L269.913 41.4117L270.856 40.4706M268.969 40.4706L268.025 41.4117M270.856 40.4706L271.8 41.4117"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask543_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="283"
        y="37"
      >
        <path d="M286.9 37.647H283.125V41.4117H286.9V37.647Z" fill="white" />
      </mask>
      <g mask="url(#mask543_2057_43870)">
        <mask
          height="5"
          id="mask544_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="283"
          y="37"
        >
          <path d="M286.9 37.647H283.125V41.4117H286.9V37.647Z" fill="white" />
        </mask>
        <g mask="url(#mask544_2057_43870)">
          <mask
            height="5"
            id="mask545_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="283"
            y="37"
          >
            <path d="M286.9 37.647H283.125V41.4117H286.9V37.647Z" fill="white" />
          </mask>
          <g mask="url(#mask545_2057_43870)">
            <path
              d="M283.125 37.647L284.069 38.5882M284.069 38.5882L285.012 37.647L285.956 38.5882M284.069 38.5882L285.012 39.5294M284.069 38.5882L283.125 39.5294L284.069 40.4706M285.956 38.5882L285.012 39.5294M285.956 38.5882L286.9 37.647M285.956 38.5882L286.9 39.5294L285.956 40.4706M285.012 39.5294L284.069 40.4706M285.012 39.5294L285.956 40.4706M284.069 40.4706L285.012 41.4117L285.956 40.4706M284.069 40.4706L283.125 41.4117M285.956 40.4706L286.9 41.4117"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask546_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="286"
        y="37"
      >
        <path d="M290.675 37.647H286.9V41.4117H290.675V37.647Z" fill="white" />
      </mask>
      <g mask="url(#mask546_2057_43870)">
        <mask
          height="5"
          id="mask547_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="286"
          y="37"
        >
          <path d="M290.675 37.647H286.9V41.4117H290.675V37.647Z" fill="white" />
        </mask>
        <g mask="url(#mask547_2057_43870)">
          <mask
            height="5"
            id="mask548_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="286"
            y="37"
          >
            <path d="M290.675 37.647H286.9V41.4117H290.675V37.647Z" fill="white" />
          </mask>
          <g mask="url(#mask548_2057_43870)">
            <path
              d="M286.9 37.647L287.844 38.5882M287.844 38.5882L288.788 37.647L289.731 38.5882M287.844 38.5882L288.788 39.5294M287.844 38.5882L286.9 39.5294L287.844 40.4706M289.731 38.5882L288.788 39.5294M289.731 38.5882L290.675 37.647M289.731 38.5882L290.675 39.5294L289.731 40.4706M288.788 39.5294L287.844 40.4706M288.788 39.5294L289.731 40.4706M287.844 40.4706L288.788 41.4117L289.731 40.4706M287.844 40.4706L286.9 41.4117M289.731 40.4706L290.675 41.4117"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask549_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="290"
        y="37"
      >
        <path d="M294.45 37.647H290.675V41.4117H294.45V37.647Z" fill="white" />
      </mask>
      <g mask="url(#mask549_2057_43870)">
        <mask
          height="5"
          id="mask550_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="290"
          y="37"
        >
          <path d="M294.45 37.647H290.675V41.4117H294.45V37.647Z" fill="white" />
        </mask>
        <g mask="url(#mask550_2057_43870)">
          <mask
            height="5"
            id="mask551_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="290"
            y="37"
          >
            <path d="M294.45 37.647H290.675V41.4117H294.45V37.647Z" fill="white" />
          </mask>
          <g mask="url(#mask551_2057_43870)">
            <path
              d="M290.675 37.647L291.619 38.5882M291.619 38.5882L292.563 37.647L293.506 38.5882M291.619 38.5882L292.563 39.5294M291.619 38.5882L290.675 39.5294L291.619 40.4706M293.506 38.5882L292.563 39.5294M293.506 38.5882L294.45 37.647M293.506 38.5882L294.45 39.5294L293.506 40.4706M292.563 39.5294L291.619 40.4706M292.563 39.5294L293.506 40.4706M291.619 40.4706L292.563 41.4117L293.506 40.4706M291.619 40.4706L290.675 41.4117M293.506 40.4706L294.45 41.4117"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="3"
        id="mask552_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="12"
        y="42"
      >
        <path d="M14.3065 42.1263H12.0415V44.3851H14.3065V42.1263Z" fill="white" />
      </mask>
      <g mask="url(#mask552_2057_43870)">
        <mask
          height="3"
          id="mask553_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="12"
          y="42"
        >
          <path d="M14.3065 42.1263H12.0415V44.3851H14.3065V42.1263Z" fill="white" />
        </mask>
        <g mask="url(#mask553_2057_43870)">
          <path
            d="M12.0415 42.1263L13.174 43.2557M13.174 43.2557L14.3065 42.1263M13.174 43.2557L14.3065 44.3851M13.174 43.2557L12.0415 44.3851"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask554_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="15"
        y="42"
      >
        <path d="M18.0814 42.1263H15.8164V44.3851H18.0814V42.1263Z" fill="white" />
      </mask>
      <g mask="url(#mask554_2057_43870)">
        <mask
          height="3"
          id="mask555_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="15"
          y="42"
        >
          <path d="M18.0814 42.1263H15.8164V44.3851H18.0814V42.1263Z" fill="white" />
        </mask>
        <g mask="url(#mask555_2057_43870)">
          <path
            d="M15.8164 42.1263L16.9489 43.2557M16.9489 43.2557L18.0814 42.1263M16.9489 43.2557L18.0814 44.3851M16.9489 43.2557L15.8164 44.3851"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask556_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="19"
        y="42"
      >
        <path d="M21.8564 42.1263H19.5914V44.3851H21.8564V42.1263Z" fill="white" />
      </mask>
      <g mask="url(#mask556_2057_43870)">
        <mask
          height="3"
          id="mask557_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="19"
          y="42"
        >
          <path d="M21.8564 42.1263H19.5914V44.3851H21.8564V42.1263Z" fill="white" />
        </mask>
        <g mask="url(#mask557_2057_43870)">
          <path
            d="M19.5914 42.1263L20.7239 43.2557M20.7239 43.2557L21.8564 42.1263M20.7239 43.2557L21.8564 44.3851M20.7239 43.2557L19.5914 44.3851"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask558_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="23"
        y="42"
      >
        <path d="M25.6315 42.1263H23.3665V44.3851H25.6315V42.1263Z" fill="white" />
      </mask>
      <g mask="url(#mask558_2057_43870)">
        <mask
          height="3"
          id="mask559_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="23"
          y="42"
        >
          <path d="M25.6315 42.1263H23.3665V44.3851H25.6315V42.1263Z" fill="white" />
        </mask>
        <g mask="url(#mask559_2057_43870)">
          <path
            d="M23.3665 42.1263L24.499 43.2557M24.499 43.2557L25.6315 42.1263M24.499 43.2557L25.6315 44.3851M24.499 43.2557L23.3665 44.3851"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask560_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="27"
        y="42"
      >
        <path d="M29.4065 42.1263H27.1415V44.3851H29.4065V42.1263Z" fill="white" />
      </mask>
      <g mask="url(#mask560_2057_43870)">
        <mask
          height="3"
          id="mask561_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="27"
          y="42"
        >
          <path d="M29.4065 42.1263H27.1415V44.3851H29.4065V42.1263Z" fill="white" />
        </mask>
        <g mask="url(#mask561_2057_43870)">
          <path
            d="M27.1415 42.1263L28.274 43.2557M28.274 43.2557L29.4065 42.1263M28.274 43.2557L29.4065 44.3851M28.274 43.2557L27.1415 44.3851"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask562_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="30"
        y="42"
      >
        <path d="M33.1815 42.1263H30.9165V44.3851H33.1815V42.1263Z" fill="white" />
      </mask>
      <g mask="url(#mask562_2057_43870)">
        <mask
          height="3"
          id="mask563_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="30"
          y="42"
        >
          <path d="M33.1815 42.1263H30.9165V44.3851H33.1815V42.1263Z" fill="white" />
        </mask>
        <g mask="url(#mask563_2057_43870)">
          <path
            d="M30.9165 42.1263L32.049 43.2557M32.049 43.2557L33.1815 42.1263M32.049 43.2557L33.1815 44.3851M32.049 43.2557L30.9165 44.3851"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask564_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="34"
        y="42"
      >
        <path d="M36.9564 42.1263H34.6914V44.3851H36.9564V42.1263Z" fill="white" />
      </mask>
      <g mask="url(#mask564_2057_43870)">
        <mask
          height="3"
          id="mask565_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="34"
          y="42"
        >
          <path d="M36.9564 42.1263H34.6914V44.3851H36.9564V42.1263Z" fill="white" />
        </mask>
        <g mask="url(#mask565_2057_43870)">
          <path
            d="M34.6914 42.1263L35.8239 43.2557M35.8239 43.2557L36.9564 42.1263M35.8239 43.2557L36.9564 44.3851M35.8239 43.2557L34.6914 44.3851"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask566_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="38"
        y="42"
      >
        <path d="M40.7316 42.1263H38.4666V44.3851H40.7316V42.1263Z" fill="white" />
      </mask>
      <g mask="url(#mask566_2057_43870)">
        <mask
          height="3"
          id="mask567_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="38"
          y="42"
        >
          <path d="M40.7316 42.1263H38.4666V44.3851H40.7316V42.1263Z" fill="white" />
        </mask>
        <g mask="url(#mask567_2057_43870)">
          <path
            d="M38.4666 42.1263L39.5991 43.2557M39.5991 43.2557L40.7316 42.1263M39.5991 43.2557L40.7316 44.3851M39.5991 43.2557L38.4666 44.3851"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask568_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="42"
        y="42"
      >
        <path d="M44.5065 42.1263H42.2415V44.3851H44.5065V42.1263Z" fill="white" />
      </mask>
      <g mask="url(#mask568_2057_43870)">
        <mask
          height="3"
          id="mask569_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="42"
          y="42"
        >
          <path d="M44.5065 42.1263H42.2415V44.3851H44.5065V42.1263Z" fill="white" />
        </mask>
        <g mask="url(#mask569_2057_43870)">
          <path
            d="M42.2415 42.1263L43.374 43.2557M43.374 43.2557L44.5065 42.1263M43.374 43.2557L44.5065 44.3851M43.374 43.2557L42.2415 44.3851"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask570_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="46"
        y="42"
      >
        <path d="M48.2932 42.138H46.0282V44.3968H48.2932V42.138Z" fill="white" />
      </mask>
      <g mask="url(#mask570_2057_43870)">
        <mask
          height="3"
          id="mask571_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="46"
          y="42"
        >
          <path d="M48.2932 42.138H46.0282V44.3968H48.2932V42.138Z" fill="white" />
        </mask>
        <g mask="url(#mask571_2057_43870)">
          <path
            d="M46.0282 42.138L47.1607 43.2674M47.1607 43.2674L48.2932 42.138M47.1607 43.2674L48.2932 44.3968M47.1607 43.2674L46.0282 44.3968"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="5"
        id="mask572_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="67"
        y="41"
      >
        <path d="M71.725 41.4117H67.95V45.1764H71.725V41.4117Z" fill="white" />
      </mask>
      <g mask="url(#mask572_2057_43870)">
        <mask
          height="5"
          id="mask573_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="67"
          y="41"
        >
          <path d="M71.725 41.4117H67.95V45.1764H71.725V41.4117Z" fill="white" />
        </mask>
        <g mask="url(#mask573_2057_43870)">
          <mask
            height="5"
            id="mask574_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="67"
            y="41"
          >
            <path d="M71.725 41.4117H67.95V45.1764H71.725V41.4117Z" fill="white" />
          </mask>
          <g mask="url(#mask574_2057_43870)">
            <path
              d="M67.95 41.4117L68.8937 42.3529M68.8937 42.3529L69.8375 41.4117L70.7812 42.3529M68.8937 42.3529L69.8375 43.2941M68.8937 42.3529L67.95 43.2941L68.8937 44.2353M70.7812 42.3529L69.8375 43.2941M70.7812 42.3529L71.725 41.4117M70.7812 42.3529L71.725 43.2941L70.7812 44.2353M69.8375 43.2941L68.8937 44.2353M69.8375 43.2941L70.7812 44.2353M68.8937 44.2353L69.8375 45.1764L70.7812 44.2353M68.8937 44.2353L67.95 45.1764M70.7812 44.2353L71.725 45.1764"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask575_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="71"
        y="41"
      >
        <path d="M75.5 41.4117H71.725V45.1764H75.5V41.4117Z" fill="white" />
      </mask>
      <g mask="url(#mask575_2057_43870)">
        <mask
          height="5"
          id="mask576_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="71"
          y="41"
        >
          <path d="M75.5 41.4117H71.725V45.1764H75.5V41.4117Z" fill="white" />
        </mask>
        <g mask="url(#mask576_2057_43870)">
          <mask
            height="5"
            id="mask577_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="71"
            y="41"
          >
            <path d="M75.5 41.4117H71.725V45.1764H75.5V41.4117Z" fill="white" />
          </mask>
          <g mask="url(#mask577_2057_43870)">
            <path
              d="M71.725 41.4117L72.6687 42.3529M72.6687 42.3529L73.6125 41.4117L74.5562 42.3529M72.6687 42.3529L73.6125 43.2941M72.6687 42.3529L71.725 43.2941L72.6687 44.2353M74.5562 42.3529L73.6125 43.2941M74.5562 42.3529L75.5 41.4117M74.5562 42.3529L75.5 43.2941L74.5562 44.2353M73.6125 43.2941L72.6687 44.2353M73.6125 43.2941L74.5562 44.2353M72.6687 44.2353L73.6125 45.1764L74.5562 44.2353M72.6687 44.2353L71.725 45.1764M74.5562 44.2353L75.5 45.1764"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask578_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="86"
        y="41"
      >
        <path d="M90.6 41.4117H86.825V45.1764H90.6V41.4117Z" fill="white" />
      </mask>
      <g mask="url(#mask578_2057_43870)">
        <mask
          height="5"
          id="mask579_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="86"
          y="41"
        >
          <path d="M90.6 41.4117H86.825V45.1764H90.6V41.4117Z" fill="white" />
        </mask>
        <g mask="url(#mask579_2057_43870)">
          <mask
            height="5"
            id="mask580_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="86"
            y="41"
          >
            <path d="M90.6 41.4117H86.825V45.1764H90.6V41.4117Z" fill="white" />
          </mask>
          <g mask="url(#mask580_2057_43870)">
            <path
              d="M86.825 41.4117L87.7687 42.3529M87.7687 42.3529L88.7125 41.4117L89.6562 42.3529M87.7687 42.3529L88.7125 43.2941M87.7687 42.3529L86.825 43.2941L87.7687 44.2353M89.6562 42.3529L88.7125 43.2941M89.6562 42.3529L90.6 41.4117M89.6562 42.3529L90.6 43.2941L89.6562 44.2353M88.7125 43.2941L87.7687 44.2353M88.7125 43.2941L89.6562 44.2353M87.7687 44.2353L88.7125 45.1764L89.6562 44.2353M87.7687 44.2353L86.825 45.1764M89.6562 44.2353L90.6 45.1764"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask581_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="90"
        y="41"
      >
        <path d="M94.375 41.4117H90.6V45.1764H94.375V41.4117Z" fill="white" />
      </mask>
      <g mask="url(#mask581_2057_43870)">
        <mask
          height="5"
          id="mask582_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="90"
          y="41"
        >
          <path d="M94.375 41.4117H90.6V45.1764H94.375V41.4117Z" fill="white" />
        </mask>
        <g mask="url(#mask582_2057_43870)">
          <mask
            height="5"
            id="mask583_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="90"
            y="41"
          >
            <path d="M94.375 41.4117H90.6V45.1764H94.375V41.4117Z" fill="white" />
          </mask>
          <g mask="url(#mask583_2057_43870)">
            <path
              d="M90.6 41.4117L91.5437 42.3529M91.5437 42.3529L92.4875 41.4117L93.4312 42.3529M91.5437 42.3529L92.4875 43.2941M91.5437 42.3529L90.6 43.2941L91.5437 44.2353M93.4312 42.3529L92.4875 43.2941M93.4312 42.3529L94.375 41.4117M93.4312 42.3529L94.375 43.2941L93.4312 44.2353M92.4875 43.2941L91.5437 44.2353M92.4875 43.2941L93.4312 44.2353M91.5437 44.2353L92.4875 45.1764L93.4312 44.2353M91.5437 44.2353L90.6 45.1764M93.4312 44.2353L94.375 45.1764"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask584_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="94"
        y="41"
      >
        <path d="M98.15 41.4117H94.375V45.1764H98.15V41.4117Z" fill="white" />
      </mask>
      <g mask="url(#mask584_2057_43870)">
        <mask
          height="5"
          id="mask585_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="94"
          y="41"
        >
          <path d="M98.15 41.4117H94.375V45.1764H98.15V41.4117Z" fill="white" />
        </mask>
        <g mask="url(#mask585_2057_43870)">
          <mask
            height="5"
            id="mask586_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="94"
            y="41"
          >
            <path d="M98.15 41.4117H94.375V45.1764H98.15V41.4117Z" fill="white" />
          </mask>
          <g mask="url(#mask586_2057_43870)">
            <path
              d="M94.375 41.4117L95.3187 42.3529M95.3187 42.3529L96.2625 41.4117L97.2062 42.3529M95.3187 42.3529L96.2625 43.2941M95.3187 42.3529L94.375 43.2941L95.3187 44.2353M97.2062 42.3529L96.2625 43.2941M97.2062 42.3529L98.15 41.4117M97.2062 42.3529L98.15 43.2941L97.2062 44.2353M96.2625 43.2941L95.3187 44.2353M96.2625 43.2941L97.2062 44.2353M95.3187 44.2353L96.2625 45.1764L97.2062 44.2353M95.3187 44.2353L94.375 45.1764M97.2062 44.2353L98.15 45.1764"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask587_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="109"
        y="41"
      >
        <path d="M113.25 41.4117H109.475V45.1764H113.25V41.4117Z" fill="white" />
      </mask>
      <g mask="url(#mask587_2057_43870)">
        <mask
          height="5"
          id="mask588_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="109"
          y="41"
        >
          <path d="M113.25 41.4117H109.475V45.1764H113.25V41.4117Z" fill="white" />
        </mask>
        <g mask="url(#mask588_2057_43870)">
          <mask
            height="5"
            id="mask589_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="109"
            y="41"
          >
            <path d="M113.25 41.4117H109.475V45.1764H113.25V41.4117Z" fill="white" />
          </mask>
          <g mask="url(#mask589_2057_43870)">
            <path
              d="M109.475 41.4117L110.419 42.3529M110.419 42.3529L111.362 41.4117L112.306 42.3529M110.419 42.3529L111.362 43.2941M110.419 42.3529L109.475 43.2941L110.419 44.2353M112.306 42.3529L111.362 43.2941M112.306 42.3529L113.25 41.4117M112.306 42.3529L113.25 43.2941L112.306 44.2353M111.362 43.2941L110.419 44.2353M111.362 43.2941L112.306 44.2353M110.419 44.2353L111.362 45.1764L112.306 44.2353M110.419 44.2353L109.475 45.1764M112.306 44.2353L113.25 45.1764"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask590_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="113"
        y="41"
      >
        <path d="M117.025 41.4117H113.25V45.1764H117.025V41.4117Z" fill="white" />
      </mask>
      <g mask="url(#mask590_2057_43870)">
        <mask
          height="5"
          id="mask591_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="113"
          y="41"
        >
          <path d="M117.025 41.4117H113.25V45.1764H117.025V41.4117Z" fill="white" />
        </mask>
        <g mask="url(#mask591_2057_43870)">
          <mask
            height="5"
            id="mask592_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="113"
            y="41"
          >
            <path d="M117.025 41.4117H113.25V45.1764H117.025V41.4117Z" fill="white" />
          </mask>
          <g mask="url(#mask592_2057_43870)">
            <path
              d="M113.25 41.4117L114.194 42.3529M114.194 42.3529L115.137 41.4117L116.081 42.3529M114.194 42.3529L115.137 43.2941M114.194 42.3529L113.25 43.2941L114.194 44.2353M116.081 42.3529L115.137 43.2941M116.081 42.3529L117.025 41.4117M116.081 42.3529L117.025 43.2941L116.081 44.2353M115.137 43.2941L114.194 44.2353M115.137 43.2941L116.081 44.2353M114.194 44.2353L115.137 45.1764L116.081 44.2353M114.194 44.2353L113.25 45.1764M116.081 44.2353L117.025 45.1764"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask593_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="117"
        y="41"
      >
        <path d="M120.8 41.4117H117.025V45.1764H120.8V41.4117Z" fill="white" />
      </mask>
      <g mask="url(#mask593_2057_43870)">
        <mask
          height="5"
          id="mask594_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="117"
          y="41"
        >
          <path d="M120.8 41.4117H117.025V45.1764H120.8V41.4117Z" fill="white" />
        </mask>
        <g mask="url(#mask594_2057_43870)">
          <mask
            height="5"
            id="mask595_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="117"
            y="41"
          >
            <path d="M120.8 41.4117H117.025V45.1764H120.8V41.4117Z" fill="white" />
          </mask>
          <g mask="url(#mask595_2057_43870)">
            <path
              d="M117.025 41.4117L117.969 42.3529M117.969 42.3529L118.913 41.4117L119.856 42.3529M117.969 42.3529L118.913 43.2941M117.969 42.3529L117.025 43.2941L117.969 44.2353M119.856 42.3529L118.913 43.2941M119.856 42.3529L120.8 41.4117M119.856 42.3529L120.8 43.2941L119.856 44.2353M118.913 43.2941L117.969 44.2353M118.913 43.2941L119.856 44.2353M117.969 44.2353L118.913 45.1764L119.856 44.2353M117.969 44.2353L117.025 45.1764M119.856 44.2353L120.8 45.1764"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask596_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="132"
        y="41"
      >
        <path d="M135.9 41.4117H132.125V45.1764H135.9V41.4117Z" fill="white" />
      </mask>
      <g mask="url(#mask596_2057_43870)">
        <mask
          height="5"
          id="mask597_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="132"
          y="41"
        >
          <path d="M135.9 41.4117H132.125V45.1764H135.9V41.4117Z" fill="white" />
        </mask>
        <g mask="url(#mask597_2057_43870)">
          <mask
            height="5"
            id="mask598_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="132"
            y="41"
          >
            <path d="M135.9 41.4117H132.125V45.1764H135.9V41.4117Z" fill="white" />
          </mask>
          <g mask="url(#mask598_2057_43870)">
            <path
              d="M132.125 41.4117L133.069 42.3529M133.069 42.3529L134.012 41.4117L134.956 42.3529M133.069 42.3529L134.012 43.2941M133.069 42.3529L132.125 43.2941L133.069 44.2353M134.956 42.3529L134.012 43.2941M134.956 42.3529L135.9 41.4117M134.956 42.3529L135.9 43.2941L134.956 44.2353M134.012 43.2941L133.069 44.2353M134.012 43.2941L134.956 44.2353M133.069 44.2353L134.012 45.1764L134.956 44.2353M133.069 44.2353L132.125 45.1764M134.956 44.2353L135.9 45.1764"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask599_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="135"
        y="41"
      >
        <path d="M139.675 41.4117H135.9V45.1764H139.675V41.4117Z" fill="white" />
      </mask>
      <g mask="url(#mask599_2057_43870)">
        <mask
          height="5"
          id="mask600_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="135"
          y="41"
        >
          <path d="M139.675 41.4117H135.9V45.1764H139.675V41.4117Z" fill="white" />
        </mask>
        <g mask="url(#mask600_2057_43870)">
          <mask
            height="5"
            id="mask601_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="135"
            y="41"
          >
            <path d="M139.675 41.4117H135.9V45.1764H139.675V41.4117Z" fill="white" />
          </mask>
          <g mask="url(#mask601_2057_43870)">
            <path
              d="M135.9 41.4117L136.844 42.3529M136.844 42.3529L137.788 41.4117L138.731 42.3529M136.844 42.3529L137.788 43.2941M136.844 42.3529L135.9 43.2941L136.844 44.2353M138.731 42.3529L137.788 43.2941M138.731 42.3529L139.675 41.4117M138.731 42.3529L139.675 43.2941L138.731 44.2353M137.788 43.2941L136.844 44.2353M137.788 43.2941L138.731 44.2353M136.844 44.2353L137.788 45.1764L138.731 44.2353M136.844 44.2353L135.9 45.1764M138.731 44.2353L139.675 45.1764"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask602_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="139"
        y="41"
      >
        <path d="M143.45 41.4117H139.675V45.1764H143.45V41.4117Z" fill="white" />
      </mask>
      <g mask="url(#mask602_2057_43870)">
        <mask
          height="5"
          id="mask603_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="139"
          y="41"
        >
          <path d="M143.45 41.4117H139.675V45.1764H143.45V41.4117Z" fill="white" />
        </mask>
        <g mask="url(#mask603_2057_43870)">
          <mask
            height="5"
            id="mask604_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="139"
            y="41"
          >
            <path d="M143.45 41.4117H139.675V45.1764H143.45V41.4117Z" fill="white" />
          </mask>
          <g mask="url(#mask604_2057_43870)">
            <path
              d="M139.675 41.4117L140.619 42.3529M140.619 42.3529L141.563 41.4117L142.506 42.3529M140.619 42.3529L141.563 43.2941M140.619 42.3529L139.675 43.2941L140.619 44.2353M142.506 42.3529L141.563 43.2941M142.506 42.3529L143.45 41.4117M142.506 42.3529L143.45 43.2941L142.506 44.2353M141.563 43.2941L140.619 44.2353M141.563 43.2941L142.506 44.2353M140.619 44.2353L141.563 45.1764L142.506 44.2353M140.619 44.2353L139.675 45.1764M142.506 44.2353L143.45 45.1764"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask605_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="151"
        y="41"
      >
        <path d="M154.775 41.4117H151V45.1764H154.775V41.4117Z" fill="white" />
      </mask>
      <g mask="url(#mask605_2057_43870)">
        <mask
          height="5"
          id="mask606_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="151"
          y="41"
        >
          <path d="M154.775 41.4117H151V45.1764H154.775V41.4117Z" fill="white" />
        </mask>
        <g mask="url(#mask606_2057_43870)">
          <mask
            height="5"
            id="mask607_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="151"
            y="41"
          >
            <path d="M154.775 41.4117H151V45.1764H154.775V41.4117Z" fill="white" />
          </mask>
          <g mask="url(#mask607_2057_43870)">
            <path
              d="M151 41.4117L151.944 42.3529M151.944 42.3529L152.887 41.4117L153.831 42.3529M151.944 42.3529L152.887 43.2941M151.944 42.3529L151 43.2941L151.944 44.2353M153.831 42.3529L152.887 43.2941M153.831 42.3529L154.775 41.4117M153.831 42.3529L154.775 43.2941L153.831 44.2353M152.887 43.2941L151.944 44.2353M152.887 43.2941L153.831 44.2353M151.944 44.2353L152.887 45.1764L153.831 44.2353M151.944 44.2353L151 45.1764M153.831 44.2353L154.775 45.1764"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask608_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="154"
        y="41"
      >
        <path d="M158.55 41.4117H154.775V45.1764H158.55V41.4117Z" fill="white" />
      </mask>
      <g mask="url(#mask608_2057_43870)">
        <mask
          height="5"
          id="mask609_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="154"
          y="41"
        >
          <path d="M158.55 41.4117H154.775V45.1764H158.55V41.4117Z" fill="white" />
        </mask>
        <g mask="url(#mask609_2057_43870)">
          <mask
            height="5"
            id="mask610_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="154"
            y="41"
          >
            <path d="M158.55 41.4117H154.775V45.1764H158.55V41.4117Z" fill="white" />
          </mask>
          <g mask="url(#mask610_2057_43870)">
            <path
              d="M154.775 41.4117L155.719 42.3529M155.719 42.3529L156.663 41.4117L157.606 42.3529M155.719 42.3529L156.663 43.2941M155.719 42.3529L154.775 43.2941L155.719 44.2353M157.606 42.3529L156.663 43.2941M157.606 42.3529L158.55 41.4117M157.606 42.3529L158.55 43.2941L157.606 44.2353M156.663 43.2941L155.719 44.2353M156.663 43.2941L157.606 44.2353M155.719 44.2353L156.663 45.1764L157.606 44.2353M155.719 44.2353L154.775 45.1764M157.606 44.2353L158.55 45.1764"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask611_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="158"
        y="41"
      >
        <path d="M162.325 41.4117H158.55V45.1764H162.325V41.4117Z" fill="white" />
      </mask>
      <g mask="url(#mask611_2057_43870)">
        <mask
          height="5"
          id="mask612_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="158"
          y="41"
        >
          <path d="M162.325 41.4117H158.55V45.1764H162.325V41.4117Z" fill="white" />
        </mask>
        <g mask="url(#mask612_2057_43870)">
          <mask
            height="5"
            id="mask613_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="158"
            y="41"
          >
            <path d="M162.325 41.4117H158.55V45.1764H162.325V41.4117Z" fill="white" />
          </mask>
          <g mask="url(#mask613_2057_43870)">
            <path
              d="M158.55 41.4117L159.494 42.3529M159.494 42.3529L160.438 41.4117L161.381 42.3529M159.494 42.3529L160.438 43.2941M159.494 42.3529L158.55 43.2941L159.494 44.2353M161.381 42.3529L160.438 43.2941M161.381 42.3529L162.325 41.4117M161.381 42.3529L162.325 43.2941L161.381 44.2353M160.438 43.2941L159.494 44.2353M160.438 43.2941L161.381 44.2353M159.494 44.2353L160.438 45.1764L161.381 44.2353M159.494 44.2353L158.55 45.1764M161.381 44.2353L162.325 45.1764"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask614_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="173"
        y="41"
      >
        <path d="M177.425 41.4117H173.65V45.1764H177.425V41.4117Z" fill="white" />
      </mask>
      <g mask="url(#mask614_2057_43870)">
        <mask
          height="5"
          id="mask615_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="173"
          y="41"
        >
          <path d="M177.425 41.4117H173.65V45.1764H177.425V41.4117Z" fill="white" />
        </mask>
        <g mask="url(#mask615_2057_43870)">
          <mask
            height="5"
            id="mask616_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="173"
            y="41"
          >
            <path d="M177.425 41.4117H173.65V45.1764H177.425V41.4117Z" fill="white" />
          </mask>
          <g mask="url(#mask616_2057_43870)">
            <path
              d="M173.65 41.4117L174.594 42.3529M174.594 42.3529L175.538 41.4117L176.481 42.3529M174.594 42.3529L175.538 43.2941M174.594 42.3529L173.65 43.2941L174.594 44.2353M176.481 42.3529L175.538 43.2941M176.481 42.3529L177.425 41.4117M176.481 42.3529L177.425 43.2941L176.481 44.2353M175.538 43.2941L174.594 44.2353M175.538 43.2941L176.481 44.2353M174.594 44.2353L175.538 45.1764L176.481 44.2353M174.594 44.2353L173.65 45.1764M176.481 44.2353L177.425 45.1764"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask617_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="177"
        y="41"
      >
        <path d="M181.2 41.4117H177.425V45.1764H181.2V41.4117Z" fill="white" />
      </mask>
      <g mask="url(#mask617_2057_43870)">
        <mask
          height="5"
          id="mask618_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="177"
          y="41"
        >
          <path d="M181.2 41.4117H177.425V45.1764H181.2V41.4117Z" fill="white" />
        </mask>
        <g mask="url(#mask618_2057_43870)">
          <mask
            height="5"
            id="mask619_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="177"
            y="41"
          >
            <path d="M181.2 41.4117H177.425V45.1764H181.2V41.4117Z" fill="white" />
          </mask>
          <g mask="url(#mask619_2057_43870)">
            <path
              d="M177.425 41.4117L178.369 42.3529M178.369 42.3529L179.313 41.4117L180.256 42.3529M178.369 42.3529L179.313 43.2941M178.369 42.3529L177.425 43.2941L178.369 44.2353M180.256 42.3529L179.313 43.2941M180.256 42.3529L181.2 41.4117M180.256 42.3529L181.2 43.2941L180.256 44.2353M179.313 43.2941L178.369 44.2353M179.313 43.2941L180.256 44.2353M178.369 44.2353L179.313 45.1764L180.256 44.2353M178.369 44.2353L177.425 45.1764M180.256 44.2353L181.2 45.1764"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask620_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="181"
        y="41"
      >
        <path d="M184.975 41.4117H181.2V45.1764H184.975V41.4117Z" fill="white" />
      </mask>
      <g mask="url(#mask620_2057_43870)">
        <mask
          height="5"
          id="mask621_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="181"
          y="41"
        >
          <path d="M184.975 41.4117H181.2V45.1764H184.975V41.4117Z" fill="white" />
        </mask>
        <g mask="url(#mask621_2057_43870)">
          <mask
            height="5"
            id="mask622_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="181"
            y="41"
          >
            <path d="M184.975 41.4117H181.2V45.1764H184.975V41.4117Z" fill="white" />
          </mask>
          <g mask="url(#mask622_2057_43870)">
            <path
              d="M181.2 41.4117L182.144 42.3529M182.144 42.3529L183.087 41.4117L184.031 42.3529M182.144 42.3529L183.087 43.2941M182.144 42.3529L181.2 43.2941L182.144 44.2353M184.031 42.3529L183.087 43.2941M184.031 42.3529L184.975 41.4117M184.031 42.3529L184.975 43.2941L184.031 44.2353M183.087 43.2941L182.144 44.2353M183.087 43.2941L184.031 44.2353M182.144 44.2353L183.087 45.1764L184.031 44.2353M182.144 44.2353L181.2 45.1764M184.031 44.2353L184.975 45.1764"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask623_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="196"
        y="41"
      >
        <path d="M200.075 41.4117H196.3V45.1764H200.075V41.4117Z" fill="white" />
      </mask>
      <g mask="url(#mask623_2057_43870)">
        <mask
          height="5"
          id="mask624_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="196"
          y="41"
        >
          <path d="M200.075 41.4117H196.3V45.1764H200.075V41.4117Z" fill="white" />
        </mask>
        <g mask="url(#mask624_2057_43870)">
          <mask
            height="5"
            id="mask625_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="196"
            y="41"
          >
            <path d="M200.075 41.4117H196.3V45.1764H200.075V41.4117Z" fill="white" />
          </mask>
          <g mask="url(#mask625_2057_43870)">
            <path
              d="M196.3 41.4117L197.244 42.3529M197.244 42.3529L198.188 41.4117L199.131 42.3529M197.244 42.3529L198.188 43.2941M197.244 42.3529L196.3 43.2941L197.244 44.2353M199.131 42.3529L198.188 43.2941M199.131 42.3529L200.075 41.4117M199.131 42.3529L200.075 43.2941L199.131 44.2353M198.188 43.2941L197.244 44.2353M198.188 43.2941L199.131 44.2353M197.244 44.2353L198.188 45.1764L199.131 44.2353M197.244 44.2353L196.3 45.1764M199.131 44.2353L200.075 45.1764"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask626_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="200"
        y="41"
      >
        <path d="M203.85 41.4117H200.075V45.1764H203.85V41.4117Z" fill="white" />
      </mask>
      <g mask="url(#mask626_2057_43870)">
        <mask
          height="5"
          id="mask627_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="200"
          y="41"
        >
          <path d="M203.85 41.4117H200.075V45.1764H203.85V41.4117Z" fill="white" />
        </mask>
        <g mask="url(#mask627_2057_43870)">
          <mask
            height="5"
            id="mask628_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="200"
            y="41"
          >
            <path d="M203.85 41.4117H200.075V45.1764H203.85V41.4117Z" fill="white" />
          </mask>
          <g mask="url(#mask628_2057_43870)">
            <path
              d="M200.075 41.4117L201.019 42.3529M201.019 42.3529L201.962 41.4117L202.906 42.3529M201.019 42.3529L201.962 43.2941M201.019 42.3529L200.075 43.2941L201.019 44.2353M202.906 42.3529L201.962 43.2941M202.906 42.3529L203.85 41.4117M202.906 42.3529L203.85 43.2941L202.906 44.2353M201.962 43.2941L201.019 44.2353M201.962 43.2941L202.906 44.2353M201.019 44.2353L201.962 45.1764L202.906 44.2353M201.019 44.2353L200.075 45.1764M202.906 44.2353L203.85 45.1764"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask629_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="203"
        y="41"
      >
        <path d="M207.625 41.4117H203.85V45.1764H207.625V41.4117Z" fill="white" />
      </mask>
      <g mask="url(#mask629_2057_43870)">
        <mask
          height="5"
          id="mask630_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="203"
          y="41"
        >
          <path d="M207.625 41.4117H203.85V45.1764H207.625V41.4117Z" fill="white" />
        </mask>
        <g mask="url(#mask630_2057_43870)">
          <mask
            height="5"
            id="mask631_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="203"
            y="41"
          >
            <path d="M207.625 41.4117H203.85V45.1764H207.625V41.4117Z" fill="white" />
          </mask>
          <g mask="url(#mask631_2057_43870)">
            <path
              d="M203.85 41.4117L204.794 42.3529M204.794 42.3529L205.737 41.4117L206.681 42.3529M204.794 42.3529L205.737 43.2941M204.794 42.3529L203.85 43.2941L204.794 44.2353M206.681 42.3529L205.737 43.2941M206.681 42.3529L207.625 41.4117M206.681 42.3529L207.625 43.2941L206.681 44.2353M205.737 43.2941L204.794 44.2353M205.737 43.2941L206.681 44.2353M204.794 44.2353L205.737 45.1764L206.681 44.2353M204.794 44.2353L203.85 45.1764M206.681 44.2353L207.625 45.1764"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask632_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="237"
        y="41"
      >
        <path d="M241.6 41.4117H237.825V45.1764H241.6V41.4117Z" fill="white" />
      </mask>
      <g mask="url(#mask632_2057_43870)">
        <mask
          height="5"
          id="mask633_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="237"
          y="41"
        >
          <path d="M241.6 41.4117H237.825V45.1764H241.6V41.4117Z" fill="white" />
        </mask>
        <g mask="url(#mask633_2057_43870)">
          <mask
            height="5"
            id="mask634_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="237"
            y="41"
          >
            <path d="M241.6 41.4117H237.825V45.1764H241.6V41.4117Z" fill="white" />
          </mask>
          <g mask="url(#mask634_2057_43870)">
            <path
              d="M237.825 41.4117L238.769 42.3529M238.769 42.3529L239.712 41.4117L240.656 42.3529M238.769 42.3529L239.712 43.2941M238.769 42.3529L237.825 43.2941L238.769 44.2353M240.656 42.3529L239.712 43.2941M240.656 42.3529L241.6 41.4117M240.656 42.3529L241.6 43.2941L240.656 44.2353M239.712 43.2941L238.769 44.2353M239.712 43.2941L240.656 44.2353M238.769 44.2353L239.712 45.1764L240.656 44.2353M238.769 44.2353L237.825 45.1764M240.656 44.2353L241.6 45.1764"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask635_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="241"
        y="41"
      >
        <path d="M245.375 41.4117H241.6V45.1764H245.375V41.4117Z" fill="white" />
      </mask>
      <g mask="url(#mask635_2057_43870)">
        <mask
          height="5"
          id="mask636_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="241"
          y="41"
        >
          <path d="M245.375 41.4117H241.6V45.1764H245.375V41.4117Z" fill="white" />
        </mask>
        <g mask="url(#mask636_2057_43870)">
          <mask
            height="5"
            id="mask637_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="241"
            y="41"
          >
            <path d="M245.375 41.4117H241.6V45.1764H245.375V41.4117Z" fill="white" />
          </mask>
          <g mask="url(#mask637_2057_43870)">
            <path
              d="M241.6 41.4117L242.544 42.3529M242.544 42.3529L243.487 41.4117L244.431 42.3529M242.544 42.3529L243.487 43.2941M242.544 42.3529L241.6 43.2941L242.544 44.2353M244.431 42.3529L243.487 43.2941M244.431 42.3529L245.375 41.4117M244.431 42.3529L245.375 43.2941L244.431 44.2353M243.487 43.2941L242.544 44.2353M243.487 43.2941L244.431 44.2353M242.544 44.2353L243.487 45.1764L244.431 44.2353M242.544 44.2353L241.6 45.1764M244.431 44.2353L245.375 45.1764"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask638_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="245"
        y="41"
      >
        <path d="M249.15 41.4117H245.375V45.1764H249.15V41.4117Z" fill="white" />
      </mask>
      <g mask="url(#mask638_2057_43870)">
        <mask
          height="5"
          id="mask639_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="245"
          y="41"
        >
          <path d="M249.15 41.4117H245.375V45.1764H249.15V41.4117Z" fill="white" />
        </mask>
        <g mask="url(#mask639_2057_43870)">
          <mask
            height="5"
            id="mask640_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="245"
            y="41"
          >
            <path d="M249.15 41.4117H245.375V45.1764H249.15V41.4117Z" fill="white" />
          </mask>
          <g mask="url(#mask640_2057_43870)">
            <path
              d="M245.375 41.4117L246.319 42.3529M246.319 42.3529L247.262 41.4117L248.206 42.3529M246.319 42.3529L247.262 43.2941M246.319 42.3529L245.375 43.2941L246.319 44.2353M248.206 42.3529L247.262 43.2941M248.206 42.3529L249.15 41.4117M248.206 42.3529L249.15 43.2941L248.206 44.2353M247.262 43.2941L246.319 44.2353M247.262 43.2941L248.206 44.2353M246.319 44.2353L247.262 45.1764L248.206 44.2353M246.319 44.2353L245.375 45.1764M248.206 44.2353L249.15 45.1764"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask641_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="260"
        y="41"
      >
        <path d="M264.25 41.4117H260.475V45.1764H264.25V41.4117Z" fill="white" />
      </mask>
      <g mask="url(#mask641_2057_43870)">
        <mask
          height="5"
          id="mask642_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="260"
          y="41"
        >
          <path d="M264.25 41.4117H260.475V45.1764H264.25V41.4117Z" fill="white" />
        </mask>
        <g mask="url(#mask642_2057_43870)">
          <mask
            height="5"
            id="mask643_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="260"
            y="41"
          >
            <path d="M264.25 41.4117H260.475V45.1764H264.25V41.4117Z" fill="white" />
          </mask>
          <g mask="url(#mask643_2057_43870)">
            <path
              d="M260.475 41.4117L261.419 42.3529M261.419 42.3529L262.362 41.4117L263.306 42.3529M261.419 42.3529L262.362 43.2941M261.419 42.3529L260.475 43.2941L261.419 44.2353M263.306 42.3529L262.362 43.2941M263.306 42.3529L264.25 41.4117M263.306 42.3529L264.25 43.2941L263.306 44.2353M262.362 43.2941L261.419 44.2353M262.362 43.2941L263.306 44.2353M261.419 44.2353L262.362 45.1764L263.306 44.2353M261.419 44.2353L260.475 45.1764M263.306 44.2353L264.25 45.1764"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask644_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="264"
        y="41"
      >
        <path d="M268.025 41.4117H264.25V45.1764H268.025V41.4117Z" fill="white" />
      </mask>
      <g mask="url(#mask644_2057_43870)">
        <mask
          height="5"
          id="mask645_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="264"
          y="41"
        >
          <path d="M268.025 41.4117H264.25V45.1764H268.025V41.4117Z" fill="white" />
        </mask>
        <g mask="url(#mask645_2057_43870)">
          <mask
            height="5"
            id="mask646_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="264"
            y="41"
          >
            <path d="M268.025 41.4117H264.25V45.1764H268.025V41.4117Z" fill="white" />
          </mask>
          <g mask="url(#mask646_2057_43870)">
            <path
              d="M264.25 41.4117L265.194 42.3529M265.194 42.3529L266.137 41.4117L267.081 42.3529M265.194 42.3529L266.137 43.2941M265.194 42.3529L264.25 43.2941L265.194 44.2353M267.081 42.3529L266.137 43.2941M267.081 42.3529L268.025 41.4117M267.081 42.3529L268.025 43.2941L267.081 44.2353M266.137 43.2941L265.194 44.2353M266.137 43.2941L267.081 44.2353M265.194 44.2353L266.137 45.1764L267.081 44.2353M265.194 44.2353L264.25 45.1764M267.081 44.2353L268.025 45.1764"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask647_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="268"
        y="41"
      >
        <path d="M271.8 41.4117H268.025V45.1764H271.8V41.4117Z" fill="white" />
      </mask>
      <g mask="url(#mask647_2057_43870)">
        <mask
          height="5"
          id="mask648_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="268"
          y="41"
        >
          <path d="M271.8 41.4117H268.025V45.1764H271.8V41.4117Z" fill="white" />
        </mask>
        <g mask="url(#mask648_2057_43870)">
          <mask
            height="5"
            id="mask649_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="268"
            y="41"
          >
            <path d="M271.8 41.4117H268.025V45.1764H271.8V41.4117Z" fill="white" />
          </mask>
          <g mask="url(#mask649_2057_43870)">
            <path
              d="M268.025 41.4117L268.969 42.3529M268.969 42.3529L269.913 41.4117L270.856 42.3529M268.969 42.3529L269.913 43.2941M268.969 42.3529L268.025 43.2941L268.969 44.2353M270.856 42.3529L269.913 43.2941M270.856 42.3529L271.8 41.4117M270.856 42.3529L271.8 43.2941L270.856 44.2353M269.913 43.2941L268.969 44.2353M269.913 43.2941L270.856 44.2353M268.969 44.2353L269.913 45.1764L270.856 44.2353M268.969 44.2353L268.025 45.1764M270.856 44.2353L271.8 45.1764"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask650_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="283"
        y="41"
      >
        <path d="M286.9 41.4117H283.125V45.1764H286.9V41.4117Z" fill="white" />
      </mask>
      <g mask="url(#mask650_2057_43870)">
        <mask
          height="5"
          id="mask651_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="283"
          y="41"
        >
          <path d="M286.9 41.4117H283.125V45.1764H286.9V41.4117Z" fill="white" />
        </mask>
        <g mask="url(#mask651_2057_43870)">
          <mask
            height="5"
            id="mask652_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="283"
            y="41"
          >
            <path d="M286.9 41.4117H283.125V45.1764H286.9V41.4117Z" fill="white" />
          </mask>
          <g mask="url(#mask652_2057_43870)">
            <path
              d="M283.125 41.4117L284.069 42.3529M284.069 42.3529L285.012 41.4117L285.956 42.3529M284.069 42.3529L285.012 43.2941M284.069 42.3529L283.125 43.2941L284.069 44.2353M285.956 42.3529L285.012 43.2941M285.956 42.3529L286.9 41.4117M285.956 42.3529L286.9 43.2941L285.956 44.2353M285.012 43.2941L284.069 44.2353M285.012 43.2941L285.956 44.2353M284.069 44.2353L285.012 45.1764L285.956 44.2353M284.069 44.2353L283.125 45.1764M285.956 44.2353L286.9 45.1764"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask653_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="286"
        y="41"
      >
        <path d="M290.675 41.4117H286.9V45.1764H290.675V41.4117Z" fill="white" />
      </mask>
      <g mask="url(#mask653_2057_43870)">
        <mask
          height="5"
          id="mask654_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="286"
          y="41"
        >
          <path d="M290.675 41.4117H286.9V45.1764H290.675V41.4117Z" fill="white" />
        </mask>
        <g mask="url(#mask654_2057_43870)">
          <mask
            height="5"
            id="mask655_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="286"
            y="41"
          >
            <path d="M290.675 41.4117H286.9V45.1764H290.675V41.4117Z" fill="white" />
          </mask>
          <g mask="url(#mask655_2057_43870)">
            <path
              d="M286.9 41.4117L287.844 42.3529M287.844 42.3529L288.788 41.4117L289.731 42.3529M287.844 42.3529L288.788 43.2941M287.844 42.3529L286.9 43.2941L287.844 44.2353M289.731 42.3529L288.788 43.2941M289.731 42.3529L290.675 41.4117M289.731 42.3529L290.675 43.2941L289.731 44.2353M288.788 43.2941L287.844 44.2353M288.788 43.2941L289.731 44.2353M287.844 44.2353L288.788 45.1764L289.731 44.2353M287.844 44.2353L286.9 45.1764M289.731 44.2353L290.675 45.1764"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask656_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="290"
        y="41"
      >
        <path d="M294.45 41.4117H290.675V45.1764H294.45V41.4117Z" fill="white" />
      </mask>
      <g mask="url(#mask656_2057_43870)">
        <mask
          height="5"
          id="mask657_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="290"
          y="41"
        >
          <path d="M294.45 41.4117H290.675V45.1764H294.45V41.4117Z" fill="white" />
        </mask>
        <g mask="url(#mask657_2057_43870)">
          <mask
            height="5"
            id="mask658_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="290"
            y="41"
          >
            <path d="M294.45 41.4117H290.675V45.1764H294.45V41.4117Z" fill="white" />
          </mask>
          <g mask="url(#mask658_2057_43870)">
            <path
              d="M290.675 41.4117L291.619 42.3529M291.619 42.3529L292.563 41.4117L293.506 42.3529M291.619 42.3529L292.563 43.2941M291.619 42.3529L290.675 43.2941L291.619 44.2353M293.506 42.3529L292.563 43.2941M293.506 42.3529L294.45 41.4117M293.506 42.3529L294.45 43.2941L293.506 44.2353M292.563 43.2941L291.619 44.2353M292.563 43.2941L293.506 44.2353M291.619 44.2353L292.563 45.1764L293.506 44.2353M291.619 44.2353L290.675 45.1764M293.506 44.2353L294.45 45.1764"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask659_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="12"
        y="45"
      >
        <path d="M14.3065 45.891H12.0415V48.1498H14.3065V45.891Z" fill="white" />
      </mask>
      <g mask="url(#mask659_2057_43870)">
        <mask
          height="4"
          id="mask660_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="12"
          y="45"
        >
          <path d="M14.3065 45.891H12.0415V48.1498H14.3065V45.891Z" fill="white" />
        </mask>
        <g mask="url(#mask660_2057_43870)">
          <path
            d="M12.0415 45.891L13.174 47.0204M13.174 47.0204L14.3065 45.891M13.174 47.0204L14.3065 48.1498M13.174 47.0204L12.0415 48.1498"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="4"
        id="mask661_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="15"
        y="45"
      >
        <path d="M18.0814 45.891H15.8164V48.1498H18.0814V45.891Z" fill="white" />
      </mask>
      <g mask="url(#mask661_2057_43870)">
        <mask
          height="4"
          id="mask662_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="15"
          y="45"
        >
          <path d="M18.0814 45.891H15.8164V48.1498H18.0814V45.891Z" fill="white" />
        </mask>
        <g mask="url(#mask662_2057_43870)">
          <path
            d="M15.8164 45.891L16.9489 47.0204M16.9489 47.0204L18.0814 45.891M16.9489 47.0204L18.0814 48.1498M16.9489 47.0204L15.8164 48.1498"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="4"
        id="mask663_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="19"
        y="45"
      >
        <path d="M21.8564 45.891H19.5914V48.1498H21.8564V45.891Z" fill="white" />
      </mask>
      <g mask="url(#mask663_2057_43870)">
        <mask
          height="4"
          id="mask664_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="19"
          y="45"
        >
          <path d="M21.8564 45.891H19.5914V48.1498H21.8564V45.891Z" fill="white" />
        </mask>
        <g mask="url(#mask664_2057_43870)">
          <path
            d="M19.5914 45.891L20.7239 47.0204M20.7239 47.0204L21.8564 45.891M20.7239 47.0204L21.8564 48.1498M20.7239 47.0204L19.5914 48.1498"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="4"
        id="mask665_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="23"
        y="45"
      >
        <path d="M25.6315 45.891H23.3665V48.1498H25.6315V45.891Z" fill="white" />
      </mask>
      <g mask="url(#mask665_2057_43870)">
        <mask
          height="4"
          id="mask666_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="23"
          y="45"
        >
          <path d="M25.6315 45.891H23.3665V48.1498H25.6315V45.891Z" fill="white" />
        </mask>
        <g mask="url(#mask666_2057_43870)">
          <path
            d="M23.3665 45.891L24.499 47.0204M24.499 47.0204L25.6315 45.891M24.499 47.0204L25.6315 48.1498M24.499 47.0204L23.3665 48.1498"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="4"
        id="mask667_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="27"
        y="45"
      >
        <path d="M29.4065 45.891H27.1415V48.1498H29.4065V45.891Z" fill="white" />
      </mask>
      <g mask="url(#mask667_2057_43870)">
        <mask
          height="4"
          id="mask668_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="27"
          y="45"
        >
          <path d="M29.4065 45.891H27.1415V48.1498H29.4065V45.891Z" fill="white" />
        </mask>
        <g mask="url(#mask668_2057_43870)">
          <path
            d="M27.1415 45.891L28.274 47.0204M28.274 47.0204L29.4065 45.891M28.274 47.0204L29.4065 48.1498M28.274 47.0204L27.1415 48.1498"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="4"
        id="mask669_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="30"
        y="45"
      >
        <path d="M33.1815 45.891H30.9165V48.1498H33.1815V45.891Z" fill="white" />
      </mask>
      <g mask="url(#mask669_2057_43870)">
        <mask
          height="4"
          id="mask670_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="30"
          y="45"
        >
          <path d="M33.1815 45.891H30.9165V48.1498H33.1815V45.891Z" fill="white" />
        </mask>
        <g mask="url(#mask670_2057_43870)">
          <path
            d="M30.9165 45.891L32.049 47.0204M32.049 47.0204L33.1815 45.891M32.049 47.0204L33.1815 48.1498M32.049 47.0204L30.9165 48.1498"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="4"
        id="mask671_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="34"
        y="45"
      >
        <path d="M36.9564 45.891H34.6914V48.1498H36.9564V45.891Z" fill="white" />
      </mask>
      <g mask="url(#mask671_2057_43870)">
        <mask
          height="4"
          id="mask672_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="34"
          y="45"
        >
          <path d="M36.9564 45.891H34.6914V48.1498H36.9564V45.891Z" fill="white" />
        </mask>
        <g mask="url(#mask672_2057_43870)">
          <path
            d="M34.6914 45.891L35.8239 47.0204M35.8239 47.0204L36.9564 45.891M35.8239 47.0204L36.9564 48.1498M35.8239 47.0204L34.6914 48.1498"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="4"
        id="mask673_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="38"
        y="45"
      >
        <path d="M40.7316 45.891H38.4666V48.1498H40.7316V45.891Z" fill="white" />
      </mask>
      <g mask="url(#mask673_2057_43870)">
        <mask
          height="4"
          id="mask674_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="38"
          y="45"
        >
          <path d="M40.7316 45.891H38.4666V48.1498H40.7316V45.891Z" fill="white" />
        </mask>
        <g mask="url(#mask674_2057_43870)">
          <path
            d="M38.4666 45.891L39.5991 47.0204M39.5991 47.0204L40.7316 45.891M39.5991 47.0204L40.7316 48.1498M39.5991 47.0204L38.4666 48.1498"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="4"
        id="mask675_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="42"
        y="45"
      >
        <path d="M44.5065 45.891H42.2415V48.1498H44.5065V45.891Z" fill="white" />
      </mask>
      <g mask="url(#mask675_2057_43870)">
        <mask
          height="4"
          id="mask676_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="42"
          y="45"
        >
          <path d="M44.5065 45.891H42.2415V48.1498H44.5065V45.891Z" fill="white" />
        </mask>
        <g mask="url(#mask676_2057_43870)">
          <path
            d="M42.2415 45.891L43.374 47.0204M43.374 47.0204L44.5065 45.891M43.374 47.0204L44.5065 48.1498M43.374 47.0204L42.2415 48.1498"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="4"
        id="mask677_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="46"
        y="45"
      >
        <path d="M48.2815 45.891H46.0165V48.1498H48.2815V45.891Z" fill="white" />
      </mask>
      <g mask="url(#mask677_2057_43870)">
        <mask
          height="4"
          id="mask678_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="46"
          y="45"
        >
          <path d="M48.2815 45.891H46.0165V48.1498H48.2815V45.891Z" fill="white" />
        </mask>
        <g mask="url(#mask678_2057_43870)">
          <path
            d="M46.0165 45.891L47.149 47.0204M47.149 47.0204L48.2815 45.891M47.149 47.0204L48.2815 48.1498M47.149 47.0204L46.0165 48.1498"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="4"
        id="mask679_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="49"
        y="45"
      >
        <path d="M52.0682 45.9027H49.8032V48.1615H52.0682V45.9027Z" fill="white" />
      </mask>
      <g mask="url(#mask679_2057_43870)">
        <mask
          height="4"
          id="mask680_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="49"
          y="45"
        >
          <path d="M52.0682 45.9027H49.8032V48.1615H52.0682V45.9027Z" fill="white" />
        </mask>
        <g mask="url(#mask680_2057_43870)">
          <path
            d="M49.8032 45.9027L50.9357 47.0321M50.9357 47.0321L52.0682 45.9027M50.9357 47.0321L52.0682 48.1615M50.9357 47.0321L49.8032 48.1615"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="4"
        id="mask681_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="67"
        y="45"
      >
        <path d="M71.725 45.1765H67.95V48.9412H71.725V45.1765Z" fill="white" />
      </mask>
      <g mask="url(#mask681_2057_43870)">
        <mask
          height="4"
          id="mask682_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="67"
          y="45"
        >
          <path d="M71.725 45.1765H67.95V48.9412H71.725V45.1765Z" fill="white" />
        </mask>
        <g mask="url(#mask682_2057_43870)">
          <mask
            height="4"
            id="mask683_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="67"
            y="45"
          >
            <path d="M71.725 45.1765H67.95V48.9412H71.725V45.1765Z" fill="white" />
          </mask>
          <g mask="url(#mask683_2057_43870)">
            <path
              d="M67.95 45.1765L68.8937 46.1176M68.8937 46.1176L69.8375 45.1765L70.7812 46.1176M68.8937 46.1176L69.8375 47.0588M68.8937 46.1176L67.95 47.0588L68.8937 48M70.7812 46.1176L69.8375 47.0588M70.7812 46.1176L71.725 45.1765M70.7812 46.1176L71.725 47.0588L70.7812 48M69.8375 47.0588L68.8937 48M69.8375 47.0588L70.7812 48M68.8937 48L69.8375 48.9412L70.7812 48M68.8937 48L67.95 48.9412M70.7812 48L71.725 48.9412"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask684_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="71"
        y="45"
      >
        <path d="M75.5 45.1765H71.725V48.9412H75.5V45.1765Z" fill="white" />
      </mask>
      <g mask="url(#mask684_2057_43870)">
        <mask
          height="4"
          id="mask685_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="71"
          y="45"
        >
          <path d="M75.5 45.1765H71.725V48.9412H75.5V45.1765Z" fill="white" />
        </mask>
        <g mask="url(#mask685_2057_43870)">
          <mask
            height="4"
            id="mask686_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="71"
            y="45"
          >
            <path d="M75.5 45.1765H71.725V48.9412H75.5V45.1765Z" fill="white" />
          </mask>
          <g mask="url(#mask686_2057_43870)">
            <path
              d="M71.725 45.1765L72.6687 46.1176M72.6687 46.1176L73.6125 45.1765L74.5562 46.1176M72.6687 46.1176L73.6125 47.0588M72.6687 46.1176L71.725 47.0588L72.6687 48M74.5562 46.1176L73.6125 47.0588M74.5562 46.1176L75.5 45.1765M74.5562 46.1176L75.5 47.0588L74.5562 48M73.6125 47.0588L72.6687 48M73.6125 47.0588L74.5562 48M72.6687 48L73.6125 48.9412L74.5562 48M72.6687 48L71.725 48.9412M74.5562 48L75.5 48.9412"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask687_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="86"
        y="45"
      >
        <path d="M90.6 45.1765H86.825V48.9412H90.6V45.1765Z" fill="white" />
      </mask>
      <g mask="url(#mask687_2057_43870)">
        <mask
          height="4"
          id="mask688_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="86"
          y="45"
        >
          <path d="M90.6 45.1765H86.825V48.9412H90.6V45.1765Z" fill="white" />
        </mask>
        <g mask="url(#mask688_2057_43870)">
          <mask
            height="4"
            id="mask689_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="86"
            y="45"
          >
            <path d="M90.6 45.1765H86.825V48.9412H90.6V45.1765Z" fill="white" />
          </mask>
          <g mask="url(#mask689_2057_43870)">
            <path
              d="M86.825 45.1765L87.7687 46.1176M87.7687 46.1176L88.7125 45.1765L89.6562 46.1176M87.7687 46.1176L88.7125 47.0588M87.7687 46.1176L86.825 47.0588L87.7687 48M89.6562 46.1176L88.7125 47.0588M89.6562 46.1176L90.6 45.1765M89.6562 46.1176L90.6 47.0588L89.6562 48M88.7125 47.0588L87.7687 48M88.7125 47.0588L89.6562 48M87.7687 48L88.7125 48.9412L89.6562 48M87.7687 48L86.825 48.9412M89.6562 48L90.6 48.9412"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask690_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="90"
        y="45"
      >
        <path d="M94.375 45.1765H90.6V48.9412H94.375V45.1765Z" fill="white" />
      </mask>
      <g mask="url(#mask690_2057_43870)">
        <mask
          height="4"
          id="mask691_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="90"
          y="45"
        >
          <path d="M94.375 45.1765H90.6V48.9412H94.375V45.1765Z" fill="white" />
        </mask>
        <g mask="url(#mask691_2057_43870)">
          <mask
            height="4"
            id="mask692_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="90"
            y="45"
          >
            <path d="M94.375 45.1765H90.6V48.9412H94.375V45.1765Z" fill="white" />
          </mask>
          <g mask="url(#mask692_2057_43870)">
            <path
              d="M90.6 45.1765L91.5437 46.1176M91.5437 46.1176L92.4875 45.1765L93.4312 46.1176M91.5437 46.1176L92.4875 47.0588M91.5437 46.1176L90.6 47.0588L91.5437 48M93.4312 46.1176L92.4875 47.0588M93.4312 46.1176L94.375 45.1765M93.4312 46.1176L94.375 47.0588L93.4312 48M92.4875 47.0588L91.5437 48M92.4875 47.0588L93.4312 48M91.5437 48L92.4875 48.9412L93.4312 48M91.5437 48L90.6 48.9412M93.4312 48L94.375 48.9412"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask693_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="94"
        y="45"
      >
        <path d="M98.15 45.1765H94.375V48.9412H98.15V45.1765Z" fill="white" />
      </mask>
      <g mask="url(#mask693_2057_43870)">
        <mask
          height="4"
          id="mask694_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="94"
          y="45"
        >
          <path d="M98.15 45.1765H94.375V48.9412H98.15V45.1765Z" fill="white" />
        </mask>
        <g mask="url(#mask694_2057_43870)">
          <mask
            height="4"
            id="mask695_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="94"
            y="45"
          >
            <path d="M98.15 45.1765H94.375V48.9412H98.15V45.1765Z" fill="white" />
          </mask>
          <g mask="url(#mask695_2057_43870)">
            <path
              d="M94.375 45.1765L95.3187 46.1176M95.3187 46.1176L96.2625 45.1765L97.2062 46.1176M95.3187 46.1176L96.2625 47.0588M95.3187 46.1176L94.375 47.0588L95.3187 48M97.2062 46.1176L96.2625 47.0588M97.2062 46.1176L98.15 45.1765M97.2062 46.1176L98.15 47.0588L97.2062 48M96.2625 47.0588L95.3187 48M96.2625 47.0588L97.2062 48M95.3187 48L96.2625 48.9412L97.2062 48M95.3187 48L94.375 48.9412M97.2062 48L98.15 48.9412"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask696_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="109"
        y="45"
      >
        <path d="M113.25 45.1765H109.475V48.9412H113.25V45.1765Z" fill="white" />
      </mask>
      <g mask="url(#mask696_2057_43870)">
        <mask
          height="4"
          id="mask697_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="109"
          y="45"
        >
          <path d="M113.25 45.1765H109.475V48.9412H113.25V45.1765Z" fill="white" />
        </mask>
        <g mask="url(#mask697_2057_43870)">
          <mask
            height="4"
            id="mask698_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="109"
            y="45"
          >
            <path d="M113.25 45.1765H109.475V48.9412H113.25V45.1765Z" fill="white" />
          </mask>
          <g mask="url(#mask698_2057_43870)">
            <path
              d="M109.475 45.1765L110.419 46.1176M110.419 46.1176L111.362 45.1765L112.306 46.1176M110.419 46.1176L111.362 47.0588M110.419 46.1176L109.475 47.0588L110.419 48M112.306 46.1176L111.362 47.0588M112.306 46.1176L113.25 45.1765M112.306 46.1176L113.25 47.0588L112.306 48M111.362 47.0588L110.419 48M111.362 47.0588L112.306 48M110.419 48L111.362 48.9412L112.306 48M110.419 48L109.475 48.9412M112.306 48L113.25 48.9412"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask699_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="113"
        y="45"
      >
        <path d="M117.025 45.1765H113.25V48.9412H117.025V45.1765Z" fill="white" />
      </mask>
      <g mask="url(#mask699_2057_43870)">
        <mask
          height="4"
          id="mask700_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="113"
          y="45"
        >
          <path d="M117.025 45.1765H113.25V48.9412H117.025V45.1765Z" fill="white" />
        </mask>
        <g mask="url(#mask700_2057_43870)">
          <mask
            height="4"
            id="mask701_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="113"
            y="45"
          >
            <path d="M117.025 45.1765H113.25V48.9412H117.025V45.1765Z" fill="white" />
          </mask>
          <g mask="url(#mask701_2057_43870)">
            <path
              d="M113.25 45.1765L114.194 46.1176M114.194 46.1176L115.137 45.1765L116.081 46.1176M114.194 46.1176L115.137 47.0588M114.194 46.1176L113.25 47.0588L114.194 48M116.081 46.1176L115.137 47.0588M116.081 46.1176L117.025 45.1765M116.081 46.1176L117.025 47.0588L116.081 48M115.137 47.0588L114.194 48M115.137 47.0588L116.081 48M114.194 48L115.137 48.9412L116.081 48M114.194 48L113.25 48.9412M116.081 48L117.025 48.9412"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask702_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="117"
        y="45"
      >
        <path d="M120.8 45.1765H117.025V48.9412H120.8V45.1765Z" fill="white" />
      </mask>
      <g mask="url(#mask702_2057_43870)">
        <mask
          height="4"
          id="mask703_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="117"
          y="45"
        >
          <path d="M120.8 45.1765H117.025V48.9412H120.8V45.1765Z" fill="white" />
        </mask>
        <g mask="url(#mask703_2057_43870)">
          <mask
            height="4"
            id="mask704_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="117"
            y="45"
          >
            <path d="M120.8 45.1765H117.025V48.9412H120.8V45.1765Z" fill="white" />
          </mask>
          <g mask="url(#mask704_2057_43870)">
            <path
              d="M117.025 45.1765L117.969 46.1176M117.969 46.1176L118.913 45.1765L119.856 46.1176M117.969 46.1176L118.913 47.0588M117.969 46.1176L117.025 47.0588L117.969 48M119.856 46.1176L118.913 47.0588M119.856 46.1176L120.8 45.1765M119.856 46.1176L120.8 47.0588L119.856 48M118.913 47.0588L117.969 48M118.913 47.0588L119.856 48M117.969 48L118.913 48.9412L119.856 48M117.969 48L117.025 48.9412M119.856 48L120.8 48.9412"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask705_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="132"
        y="45"
      >
        <path d="M135.9 45.1765H132.125V48.9412H135.9V45.1765Z" fill="white" />
      </mask>
      <g mask="url(#mask705_2057_43870)">
        <mask
          height="4"
          id="mask706_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="132"
          y="45"
        >
          <path d="M135.9 45.1765H132.125V48.9412H135.9V45.1765Z" fill="white" />
        </mask>
        <g mask="url(#mask706_2057_43870)">
          <mask
            height="4"
            id="mask707_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="132"
            y="45"
          >
            <path d="M135.9 45.1765H132.125V48.9412H135.9V45.1765Z" fill="white" />
          </mask>
          <g mask="url(#mask707_2057_43870)">
            <path
              d="M132.125 45.1765L133.069 46.1176M133.069 46.1176L134.012 45.1765L134.956 46.1176M133.069 46.1176L134.012 47.0588M133.069 46.1176L132.125 47.0588L133.069 48M134.956 46.1176L134.012 47.0588M134.956 46.1176L135.9 45.1765M134.956 46.1176L135.9 47.0588L134.956 48M134.012 47.0588L133.069 48M134.012 47.0588L134.956 48M133.069 48L134.012 48.9412L134.956 48M133.069 48L132.125 48.9412M134.956 48L135.9 48.9412"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask708_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="135"
        y="45"
      >
        <path d="M139.675 45.1765H135.9V48.9412H139.675V45.1765Z" fill="white" />
      </mask>
      <g mask="url(#mask708_2057_43870)">
        <mask
          height="4"
          id="mask709_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="135"
          y="45"
        >
          <path d="M139.675 45.1765H135.9V48.9412H139.675V45.1765Z" fill="white" />
        </mask>
        <g mask="url(#mask709_2057_43870)">
          <mask
            height="4"
            id="mask710_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="135"
            y="45"
          >
            <path d="M139.675 45.1765H135.9V48.9412H139.675V45.1765Z" fill="white" />
          </mask>
          <g mask="url(#mask710_2057_43870)">
            <path
              d="M135.9 45.1765L136.844 46.1176M136.844 46.1176L137.788 45.1765L138.731 46.1176M136.844 46.1176L137.788 47.0588M136.844 46.1176L135.9 47.0588L136.844 48M138.731 46.1176L137.788 47.0588M138.731 46.1176L139.675 45.1765M138.731 46.1176L139.675 47.0588L138.731 48M137.788 47.0588L136.844 48M137.788 47.0588L138.731 48M136.844 48L137.788 48.9412L138.731 48M136.844 48L135.9 48.9412M138.731 48L139.675 48.9412"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask711_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="139"
        y="45"
      >
        <path d="M143.45 45.1765H139.675V48.9412H143.45V45.1765Z" fill="white" />
      </mask>
      <g mask="url(#mask711_2057_43870)">
        <mask
          height="4"
          id="mask712_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="139"
          y="45"
        >
          <path d="M143.45 45.1765H139.675V48.9412H143.45V45.1765Z" fill="white" />
        </mask>
        <g mask="url(#mask712_2057_43870)">
          <mask
            height="4"
            id="mask713_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="139"
            y="45"
          >
            <path d="M143.45 45.1765H139.675V48.9412H143.45V45.1765Z" fill="white" />
          </mask>
          <g mask="url(#mask713_2057_43870)">
            <path
              d="M139.675 45.1765L140.619 46.1176M140.619 46.1176L141.563 45.1765L142.506 46.1176M140.619 46.1176L141.563 47.0588M140.619 46.1176L139.675 47.0588L140.619 48M142.506 46.1176L141.563 47.0588M142.506 46.1176L143.45 45.1765M142.506 46.1176L143.45 47.0588L142.506 48M141.563 47.0588L140.619 48M141.563 47.0588L142.506 48M140.619 48L141.563 48.9412L142.506 48M140.619 48L139.675 48.9412M142.506 48L143.45 48.9412"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask714_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="151"
        y="45"
      >
        <path d="M154.775 45.1765H151V48.9412H154.775V45.1765Z" fill="white" />
      </mask>
      <g mask="url(#mask714_2057_43870)">
        <mask
          height="4"
          id="mask715_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="151"
          y="45"
        >
          <path d="M154.775 45.1765H151V48.9412H154.775V45.1765Z" fill="white" />
        </mask>
        <g mask="url(#mask715_2057_43870)">
          <mask
            height="4"
            id="mask716_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="151"
            y="45"
          >
            <path d="M154.775 45.1765H151V48.9412H154.775V45.1765Z" fill="white" />
          </mask>
          <g mask="url(#mask716_2057_43870)">
            <path
              d="M151 45.1765L151.944 46.1176M151.944 46.1176L152.887 45.1765L153.831 46.1176M151.944 46.1176L152.887 47.0588M151.944 46.1176L151 47.0588L151.944 48M153.831 46.1176L152.887 47.0588M153.831 46.1176L154.775 45.1765M153.831 46.1176L154.775 47.0588L153.831 48M152.887 47.0588L151.944 48M152.887 47.0588L153.831 48M151.944 48L152.887 48.9412L153.831 48M151.944 48L151 48.9412M153.831 48L154.775 48.9412"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask717_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="154"
        y="45"
      >
        <path d="M158.55 45.1765H154.775V48.9412H158.55V45.1765Z" fill="white" />
      </mask>
      <g mask="url(#mask717_2057_43870)">
        <mask
          height="4"
          id="mask718_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="154"
          y="45"
        >
          <path d="M158.55 45.1765H154.775V48.9412H158.55V45.1765Z" fill="white" />
        </mask>
        <g mask="url(#mask718_2057_43870)">
          <mask
            height="4"
            id="mask719_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="154"
            y="45"
          >
            <path d="M158.55 45.1765H154.775V48.9412H158.55V45.1765Z" fill="white" />
          </mask>
          <g mask="url(#mask719_2057_43870)">
            <path
              d="M154.775 45.1765L155.719 46.1176M155.719 46.1176L156.663 45.1765L157.606 46.1176M155.719 46.1176L156.663 47.0588M155.719 46.1176L154.775 47.0588L155.719 48M157.606 46.1176L156.663 47.0588M157.606 46.1176L158.55 45.1765M157.606 46.1176L158.55 47.0588L157.606 48M156.663 47.0588L155.719 48M156.663 47.0588L157.606 48M155.719 48L156.663 48.9412L157.606 48M155.719 48L154.775 48.9412M157.606 48L158.55 48.9412"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask720_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="158"
        y="45"
      >
        <path d="M162.325 45.1765H158.55V48.9412H162.325V45.1765Z" fill="white" />
      </mask>
      <g mask="url(#mask720_2057_43870)">
        <mask
          height="4"
          id="mask721_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="158"
          y="45"
        >
          <path d="M162.325 45.1765H158.55V48.9412H162.325V45.1765Z" fill="white" />
        </mask>
        <g mask="url(#mask721_2057_43870)">
          <mask
            height="4"
            id="mask722_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="158"
            y="45"
          >
            <path d="M162.325 45.1765H158.55V48.9412H162.325V45.1765Z" fill="white" />
          </mask>
          <g mask="url(#mask722_2057_43870)">
            <path
              d="M158.55 45.1765L159.494 46.1176M159.494 46.1176L160.438 45.1765L161.381 46.1176M159.494 46.1176L160.438 47.0588M159.494 46.1176L158.55 47.0588L159.494 48M161.381 46.1176L160.438 47.0588M161.381 46.1176L162.325 45.1765M161.381 46.1176L162.325 47.0588L161.381 48M160.438 47.0588L159.494 48M160.438 47.0588L161.381 48M159.494 48L160.438 48.9412L161.381 48M159.494 48L158.55 48.9412M161.381 48L162.325 48.9412"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask723_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="173"
        y="45"
      >
        <path d="M177.425 45.1765H173.65V48.9412H177.425V45.1765Z" fill="white" />
      </mask>
      <g mask="url(#mask723_2057_43870)">
        <mask
          height="4"
          id="mask724_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="173"
          y="45"
        >
          <path d="M177.425 45.1765H173.65V48.9412H177.425V45.1765Z" fill="white" />
        </mask>
        <g mask="url(#mask724_2057_43870)">
          <mask
            height="4"
            id="mask725_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="173"
            y="45"
          >
            <path d="M177.425 45.1765H173.65V48.9412H177.425V45.1765Z" fill="white" />
          </mask>
          <g mask="url(#mask725_2057_43870)">
            <path
              d="M173.65 45.1765L174.594 46.1176M174.594 46.1176L175.538 45.1765L176.481 46.1176M174.594 46.1176L175.538 47.0588M174.594 46.1176L173.65 47.0588L174.594 48M176.481 46.1176L175.538 47.0588M176.481 46.1176L177.425 45.1765M176.481 46.1176L177.425 47.0588L176.481 48M175.538 47.0588L174.594 48M175.538 47.0588L176.481 48M174.594 48L175.538 48.9412L176.481 48M174.594 48L173.65 48.9412M176.481 48L177.425 48.9412"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask726_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="177"
        y="45"
      >
        <path d="M181.2 45.1765H177.425V48.9412H181.2V45.1765Z" fill="white" />
      </mask>
      <g mask="url(#mask726_2057_43870)">
        <mask
          height="4"
          id="mask727_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="177"
          y="45"
        >
          <path d="M181.2 45.1765H177.425V48.9412H181.2V45.1765Z" fill="white" />
        </mask>
        <g mask="url(#mask727_2057_43870)">
          <mask
            height="4"
            id="mask728_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="177"
            y="45"
          >
            <path d="M181.2 45.1765H177.425V48.9412H181.2V45.1765Z" fill="white" />
          </mask>
          <g mask="url(#mask728_2057_43870)">
            <path
              d="M177.425 45.1765L178.369 46.1176M178.369 46.1176L179.313 45.1765L180.256 46.1176M178.369 46.1176L179.313 47.0588M178.369 46.1176L177.425 47.0588L178.369 48M180.256 46.1176L179.313 47.0588M180.256 46.1176L181.2 45.1765M180.256 46.1176L181.2 47.0588L180.256 48M179.313 47.0588L178.369 48M179.313 47.0588L180.256 48M178.369 48L179.313 48.9412L180.256 48M178.369 48L177.425 48.9412M180.256 48L181.2 48.9412"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask729_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="181"
        y="45"
      >
        <path d="M184.975 45.1765H181.2V48.9412H184.975V45.1765Z" fill="white" />
      </mask>
      <g mask="url(#mask729_2057_43870)">
        <mask
          height="4"
          id="mask730_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="181"
          y="45"
        >
          <path d="M184.975 45.1765H181.2V48.9412H184.975V45.1765Z" fill="white" />
        </mask>
        <g mask="url(#mask730_2057_43870)">
          <mask
            height="4"
            id="mask731_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="181"
            y="45"
          >
            <path d="M184.975 45.1765H181.2V48.9412H184.975V45.1765Z" fill="white" />
          </mask>
          <g mask="url(#mask731_2057_43870)">
            <path
              d="M181.2 45.1765L182.144 46.1176M182.144 46.1176L183.087 45.1765L184.031 46.1176M182.144 46.1176L183.087 47.0588M182.144 46.1176L181.2 47.0588L182.144 48M184.031 46.1176L183.087 47.0588M184.031 46.1176L184.975 45.1765M184.031 46.1176L184.975 47.0588L184.031 48M183.087 47.0588L182.144 48M183.087 47.0588L184.031 48M182.144 48L183.087 48.9412L184.031 48M182.144 48L181.2 48.9412M184.031 48L184.975 48.9412"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask732_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="196"
        y="45"
      >
        <path d="M200.075 45.1765H196.3V48.9412H200.075V45.1765Z" fill="white" />
      </mask>
      <g mask="url(#mask732_2057_43870)">
        <mask
          height="4"
          id="mask733_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="196"
          y="45"
        >
          <path d="M200.075 45.1765H196.3V48.9412H200.075V45.1765Z" fill="white" />
        </mask>
        <g mask="url(#mask733_2057_43870)">
          <mask
            height="4"
            id="mask734_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="196"
            y="45"
          >
            <path d="M200.075 45.1765H196.3V48.9412H200.075V45.1765Z" fill="white" />
          </mask>
          <g mask="url(#mask734_2057_43870)">
            <path
              d="M196.3 45.1765L197.244 46.1176M197.244 46.1176L198.188 45.1765L199.131 46.1176M197.244 46.1176L198.188 47.0588M197.244 46.1176L196.3 47.0588L197.244 48M199.131 46.1176L198.188 47.0588M199.131 46.1176L200.075 45.1765M199.131 46.1176L200.075 47.0588L199.131 48M198.188 47.0588L197.244 48M198.188 47.0588L199.131 48M197.244 48L198.188 48.9412L199.131 48M197.244 48L196.3 48.9412M199.131 48L200.075 48.9412"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask735_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="200"
        y="45"
      >
        <path d="M203.85 45.1765H200.075V48.9412H203.85V45.1765Z" fill="white" />
      </mask>
      <g mask="url(#mask735_2057_43870)">
        <mask
          height="4"
          id="mask736_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="200"
          y="45"
        >
          <path d="M203.85 45.1765H200.075V48.9412H203.85V45.1765Z" fill="white" />
        </mask>
        <g mask="url(#mask736_2057_43870)">
          <mask
            height="4"
            id="mask737_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="200"
            y="45"
          >
            <path d="M203.85 45.1765H200.075V48.9412H203.85V45.1765Z" fill="white" />
          </mask>
          <g mask="url(#mask737_2057_43870)">
            <path
              d="M200.075 45.1765L201.019 46.1176M201.019 46.1176L201.962 45.1765L202.906 46.1176M201.019 46.1176L201.962 47.0588M201.019 46.1176L200.075 47.0588L201.019 48M202.906 46.1176L201.962 47.0588M202.906 46.1176L203.85 45.1765M202.906 46.1176L203.85 47.0588L202.906 48M201.962 47.0588L201.019 48M201.962 47.0588L202.906 48M201.019 48L201.962 48.9412L202.906 48M201.019 48L200.075 48.9412M202.906 48L203.85 48.9412"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask738_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="203"
        y="45"
      >
        <path d="M207.625 45.1765H203.85V48.9412H207.625V45.1765Z" fill="white" />
      </mask>
      <g mask="url(#mask738_2057_43870)">
        <mask
          height="4"
          id="mask739_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="203"
          y="45"
        >
          <path d="M207.625 45.1765H203.85V48.9412H207.625V45.1765Z" fill="white" />
        </mask>
        <g mask="url(#mask739_2057_43870)">
          <mask
            height="4"
            id="mask740_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="203"
            y="45"
          >
            <path d="M207.625 45.1765H203.85V48.9412H207.625V45.1765Z" fill="white" />
          </mask>
          <g mask="url(#mask740_2057_43870)">
            <path
              d="M203.85 45.1765L204.794 46.1176M204.794 46.1176L205.737 45.1765L206.681 46.1176M204.794 46.1176L205.737 47.0588M204.794 46.1176L203.85 47.0588L204.794 48M206.681 46.1176L205.737 47.0588M206.681 46.1176L207.625 45.1765M206.681 46.1176L207.625 47.0588L206.681 48M205.737 47.0588L204.794 48M205.737 47.0588L206.681 48M204.794 48L205.737 48.9412L206.681 48M204.794 48L203.85 48.9412M206.681 48L207.625 48.9412"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask741_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="237"
        y="45"
      >
        <path d="M241.6 45.1765H237.825V48.9412H241.6V45.1765Z" fill="white" />
      </mask>
      <g mask="url(#mask741_2057_43870)">
        <mask
          height="4"
          id="mask742_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="237"
          y="45"
        >
          <path d="M241.6 45.1765H237.825V48.9412H241.6V45.1765Z" fill="white" />
        </mask>
        <g mask="url(#mask742_2057_43870)">
          <mask
            height="4"
            id="mask743_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="237"
            y="45"
          >
            <path d="M241.6 45.1765H237.825V48.9412H241.6V45.1765Z" fill="white" />
          </mask>
          <g mask="url(#mask743_2057_43870)">
            <path
              d="M237.825 45.1765L238.769 46.1176M238.769 46.1176L239.712 45.1765L240.656 46.1176M238.769 46.1176L239.712 47.0588M238.769 46.1176L237.825 47.0588L238.769 48M240.656 46.1176L239.712 47.0588M240.656 46.1176L241.6 45.1765M240.656 46.1176L241.6 47.0588L240.656 48M239.712 47.0588L238.769 48M239.712 47.0588L240.656 48M238.769 48L239.712 48.9412L240.656 48M238.769 48L237.825 48.9412M240.656 48L241.6 48.9412"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask744_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="241"
        y="45"
      >
        <path d="M245.375 45.1765H241.6V48.9412H245.375V45.1765Z" fill="white" />
      </mask>
      <g mask="url(#mask744_2057_43870)">
        <mask
          height="4"
          id="mask745_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="241"
          y="45"
        >
          <path d="M245.375 45.1765H241.6V48.9412H245.375V45.1765Z" fill="white" />
        </mask>
        <g mask="url(#mask745_2057_43870)">
          <mask
            height="4"
            id="mask746_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="241"
            y="45"
          >
            <path d="M245.375 45.1765H241.6V48.9412H245.375V45.1765Z" fill="white" />
          </mask>
          <g mask="url(#mask746_2057_43870)">
            <path
              d="M241.6 45.1765L242.544 46.1176M242.544 46.1176L243.487 45.1765L244.431 46.1176M242.544 46.1176L243.487 47.0588M242.544 46.1176L241.6 47.0588L242.544 48M244.431 46.1176L243.487 47.0588M244.431 46.1176L245.375 45.1765M244.431 46.1176L245.375 47.0588L244.431 48M243.487 47.0588L242.544 48M243.487 47.0588L244.431 48M242.544 48L243.487 48.9412L244.431 48M242.544 48L241.6 48.9412M244.431 48L245.375 48.9412"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask747_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="245"
        y="45"
      >
        <path d="M249.15 45.1765H245.375V48.9412H249.15V45.1765Z" fill="white" />
      </mask>
      <g mask="url(#mask747_2057_43870)">
        <mask
          height="4"
          id="mask748_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="245"
          y="45"
        >
          <path d="M249.15 45.1765H245.375V48.9412H249.15V45.1765Z" fill="white" />
        </mask>
        <g mask="url(#mask748_2057_43870)">
          <mask
            height="4"
            id="mask749_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="245"
            y="45"
          >
            <path d="M249.15 45.1765H245.375V48.9412H249.15V45.1765Z" fill="white" />
          </mask>
          <g mask="url(#mask749_2057_43870)">
            <path
              d="M245.375 45.1765L246.319 46.1176M246.319 46.1176L247.262 45.1765L248.206 46.1176M246.319 46.1176L247.262 47.0588M246.319 46.1176L245.375 47.0588L246.319 48M248.206 46.1176L247.262 47.0588M248.206 46.1176L249.15 45.1765M248.206 46.1176L249.15 47.0588L248.206 48M247.262 47.0588L246.319 48M247.262 47.0588L248.206 48M246.319 48L247.262 48.9412L248.206 48M246.319 48L245.375 48.9412M248.206 48L249.15 48.9412"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask750_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="260"
        y="45"
      >
        <path d="M264.25 45.1765H260.475V48.9412H264.25V45.1765Z" fill="white" />
      </mask>
      <g mask="url(#mask750_2057_43870)">
        <mask
          height="4"
          id="mask751_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="260"
          y="45"
        >
          <path d="M264.25 45.1765H260.475V48.9412H264.25V45.1765Z" fill="white" />
        </mask>
        <g mask="url(#mask751_2057_43870)">
          <mask
            height="4"
            id="mask752_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="260"
            y="45"
          >
            <path d="M264.25 45.1765H260.475V48.9412H264.25V45.1765Z" fill="white" />
          </mask>
          <g mask="url(#mask752_2057_43870)">
            <path
              d="M260.475 45.1765L261.419 46.1176M261.419 46.1176L262.362 45.1765L263.306 46.1176M261.419 46.1176L262.362 47.0588M261.419 46.1176L260.475 47.0588L261.419 48M263.306 46.1176L262.362 47.0588M263.306 46.1176L264.25 45.1765M263.306 46.1176L264.25 47.0588L263.306 48M262.362 47.0588L261.419 48M262.362 47.0588L263.306 48M261.419 48L262.362 48.9412L263.306 48M261.419 48L260.475 48.9412M263.306 48L264.25 48.9412"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask753_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="264"
        y="45"
      >
        <path d="M268.025 45.1765H264.25V48.9412H268.025V45.1765Z" fill="white" />
      </mask>
      <g mask="url(#mask753_2057_43870)">
        <mask
          height="4"
          id="mask754_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="264"
          y="45"
        >
          <path d="M268.025 45.1765H264.25V48.9412H268.025V45.1765Z" fill="white" />
        </mask>
        <g mask="url(#mask754_2057_43870)">
          <mask
            height="4"
            id="mask755_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="264"
            y="45"
          >
            <path d="M268.025 45.1765H264.25V48.9412H268.025V45.1765Z" fill="white" />
          </mask>
          <g mask="url(#mask755_2057_43870)">
            <path
              d="M264.25 45.1765L265.194 46.1176M265.194 46.1176L266.137 45.1765L267.081 46.1176M265.194 46.1176L266.137 47.0588M265.194 46.1176L264.25 47.0588L265.194 48M267.081 46.1176L266.137 47.0588M267.081 46.1176L268.025 45.1765M267.081 46.1176L268.025 47.0588L267.081 48M266.137 47.0588L265.194 48M266.137 47.0588L267.081 48M265.194 48L266.137 48.9412L267.081 48M265.194 48L264.25 48.9412M267.081 48L268.025 48.9412"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask756_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="268"
        y="45"
      >
        <path d="M271.8 45.1765H268.025V48.9412H271.8V45.1765Z" fill="white" />
      </mask>
      <g mask="url(#mask756_2057_43870)">
        <mask
          height="4"
          id="mask757_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="268"
          y="45"
        >
          <path d="M271.8 45.1765H268.025V48.9412H271.8V45.1765Z" fill="white" />
        </mask>
        <g mask="url(#mask757_2057_43870)">
          <mask
            height="4"
            id="mask758_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="268"
            y="45"
          >
            <path d="M271.8 45.1765H268.025V48.9412H271.8V45.1765Z" fill="white" />
          </mask>
          <g mask="url(#mask758_2057_43870)">
            <path
              d="M268.025 45.1765L268.969 46.1176M268.969 46.1176L269.913 45.1765L270.856 46.1176M268.969 46.1176L269.913 47.0588M268.969 46.1176L268.025 47.0588L268.969 48M270.856 46.1176L269.913 47.0588M270.856 46.1176L271.8 45.1765M270.856 46.1176L271.8 47.0588L270.856 48M269.913 47.0588L268.969 48M269.913 47.0588L270.856 48M268.969 48L269.913 48.9412L270.856 48M268.969 48L268.025 48.9412M270.856 48L271.8 48.9412"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask759_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="283"
        y="45"
      >
        <path d="M286.9 45.1765H283.125V48.9412H286.9V45.1765Z" fill="white" />
      </mask>
      <g mask="url(#mask759_2057_43870)">
        <mask
          height="4"
          id="mask760_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="283"
          y="45"
        >
          <path d="M286.9 45.1765H283.125V48.9412H286.9V45.1765Z" fill="white" />
        </mask>
        <g mask="url(#mask760_2057_43870)">
          <mask
            height="4"
            id="mask761_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="283"
            y="45"
          >
            <path d="M286.9 45.1765H283.125V48.9412H286.9V45.1765Z" fill="white" />
          </mask>
          <g mask="url(#mask761_2057_43870)">
            <path
              d="M283.125 45.1765L284.069 46.1176M284.069 46.1176L285.012 45.1765L285.956 46.1176M284.069 46.1176L285.012 47.0588M284.069 46.1176L283.125 47.0588L284.069 48M285.956 46.1176L285.012 47.0588M285.956 46.1176L286.9 45.1765M285.956 46.1176L286.9 47.0588L285.956 48M285.012 47.0588L284.069 48M285.012 47.0588L285.956 48M284.069 48L285.012 48.9412L285.956 48M284.069 48L283.125 48.9412M285.956 48L286.9 48.9412"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask762_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="286"
        y="45"
      >
        <path d="M290.675 45.1765H286.9V48.9412H290.675V45.1765Z" fill="white" />
      </mask>
      <g mask="url(#mask762_2057_43870)">
        <mask
          height="4"
          id="mask763_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="286"
          y="45"
        >
          <path d="M290.675 45.1765H286.9V48.9412H290.675V45.1765Z" fill="white" />
        </mask>
        <g mask="url(#mask763_2057_43870)">
          <mask
            height="4"
            id="mask764_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="286"
            y="45"
          >
            <path d="M290.675 45.1765H286.9V48.9412H290.675V45.1765Z" fill="white" />
          </mask>
          <g mask="url(#mask764_2057_43870)">
            <path
              d="M286.9 45.1765L287.844 46.1176M287.844 46.1176L288.788 45.1765L289.731 46.1176M287.844 46.1176L288.788 47.0588M287.844 46.1176L286.9 47.0588L287.844 48M289.731 46.1176L288.788 47.0588M289.731 46.1176L290.675 45.1765M289.731 46.1176L290.675 47.0588L289.731 48M288.788 47.0588L287.844 48M288.788 47.0588L289.731 48M287.844 48L288.788 48.9412L289.731 48M287.844 48L286.9 48.9412M289.731 48L290.675 48.9412"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask765_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="290"
        y="45"
      >
        <path d="M294.45 45.1765H290.675V48.9412H294.45V45.1765Z" fill="white" />
      </mask>
      <g mask="url(#mask765_2057_43870)">
        <mask
          height="4"
          id="mask766_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="290"
          y="45"
        >
          <path d="M294.45 45.1765H290.675V48.9412H294.45V45.1765Z" fill="white" />
        </mask>
        <g mask="url(#mask766_2057_43870)">
          <mask
            height="4"
            id="mask767_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="290"
            y="45"
          >
            <path d="M294.45 45.1765H290.675V48.9412H294.45V45.1765Z" fill="white" />
          </mask>
          <g mask="url(#mask767_2057_43870)">
            <path
              d="M290.675 45.1765L291.619 46.1176M291.619 46.1176L292.563 45.1765L293.506 46.1176M291.619 46.1176L292.563 47.0588M291.619 46.1176L290.675 47.0588L291.619 48M293.506 46.1176L292.563 47.0588M293.506 46.1176L294.45 45.1765M293.506 46.1176L294.45 47.0588L293.506 48M292.563 47.0588L291.619 48M292.563 47.0588L293.506 48M291.619 48L292.563 48.9412L293.506 48M291.619 48L290.675 48.9412M293.506 48L294.45 48.9412"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="3"
        id="mask768_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="12"
        y="49"
      >
        <path d="M14.3065 49.6557H12.0415V51.9145H14.3065V49.6557Z" fill="white" />
      </mask>
      <g mask="url(#mask768_2057_43870)">
        <mask
          height="3"
          id="mask769_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="12"
          y="49"
        >
          <path d="M14.3065 49.6557H12.0415V51.9145H14.3065V49.6557Z" fill="white" />
        </mask>
        <g mask="url(#mask769_2057_43870)">
          <path
            d="M12.0415 49.6557L13.174 50.7851M13.174 50.7851L14.3065 49.6557M13.174 50.7851L14.3065 51.9145M13.174 50.7851L12.0415 51.9145"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask770_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="15"
        y="49"
      >
        <path d="M18.0814 49.6557H15.8164V51.9145H18.0814V49.6557Z" fill="white" />
      </mask>
      <g mask="url(#mask770_2057_43870)">
        <mask
          height="3"
          id="mask771_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="15"
          y="49"
        >
          <path d="M18.0814 49.6557H15.8164V51.9145H18.0814V49.6557Z" fill="white" />
        </mask>
        <g mask="url(#mask771_2057_43870)">
          <path
            d="M15.8164 49.6557L16.9489 50.7851M16.9489 50.7851L18.0814 49.6557M16.9489 50.7851L18.0814 51.9145M16.9489 50.7851L15.8164 51.9145"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask772_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="19"
        y="49"
      >
        <path d="M21.8564 49.6557H19.5914V51.9145H21.8564V49.6557Z" fill="white" />
      </mask>
      <g mask="url(#mask772_2057_43870)">
        <mask
          height="3"
          id="mask773_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="19"
          y="49"
        >
          <path d="M21.8564 49.6557H19.5914V51.9145H21.8564V49.6557Z" fill="white" />
        </mask>
        <g mask="url(#mask773_2057_43870)">
          <path
            d="M19.5914 49.6557L20.7239 50.7851M20.7239 50.7851L21.8564 49.6557M20.7239 50.7851L21.8564 51.9145M20.7239 50.7851L19.5914 51.9145"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask774_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="23"
        y="49"
      >
        <path d="M25.6315 49.6557H23.3665V51.9145H25.6315V49.6557Z" fill="white" />
      </mask>
      <g mask="url(#mask774_2057_43870)">
        <mask
          height="3"
          id="mask775_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="23"
          y="49"
        >
          <path d="M25.6315 49.6557H23.3665V51.9145H25.6315V49.6557Z" fill="white" />
        </mask>
        <g mask="url(#mask775_2057_43870)">
          <path
            d="M23.3665 49.6557L24.499 50.7851M24.499 50.7851L25.6315 49.6557M24.499 50.7851L25.6315 51.9145M24.499 50.7851L23.3665 51.9145"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask776_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="27"
        y="49"
      >
        <path d="M29.4065 49.6557H27.1415V51.9145H29.4065V49.6557Z" fill="white" />
      </mask>
      <g mask="url(#mask776_2057_43870)">
        <mask
          height="3"
          id="mask777_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="27"
          y="49"
        >
          <path d="M29.4065 49.6557H27.1415V51.9145H29.4065V49.6557Z" fill="white" />
        </mask>
        <g mask="url(#mask777_2057_43870)">
          <path
            d="M27.1415 49.6557L28.274 50.7851M28.274 50.7851L29.4065 49.6557M28.274 50.7851L29.4065 51.9145M28.274 50.7851L27.1415 51.9145"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask778_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="30"
        y="49"
      >
        <path d="M33.1815 49.6557H30.9165V51.9145H33.1815V49.6557Z" fill="white" />
      </mask>
      <g mask="url(#mask778_2057_43870)">
        <mask
          height="3"
          id="mask779_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="30"
          y="49"
        >
          <path d="M33.1815 49.6557H30.9165V51.9145H33.1815V49.6557Z" fill="white" />
        </mask>
        <g mask="url(#mask779_2057_43870)">
          <path
            d="M30.9165 49.6557L32.049 50.7851M32.049 50.7851L33.1815 49.6557M32.049 50.7851L33.1815 51.9145M32.049 50.7851L30.9165 51.9145"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask780_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="34"
        y="49"
      >
        <path d="M36.9564 49.6557H34.6914V51.9145H36.9564V49.6557Z" fill="white" />
      </mask>
      <g mask="url(#mask780_2057_43870)">
        <mask
          height="3"
          id="mask781_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="34"
          y="49"
        >
          <path d="M36.9564 49.6557H34.6914V51.9145H36.9564V49.6557Z" fill="white" />
        </mask>
        <g mask="url(#mask781_2057_43870)">
          <path
            d="M34.6914 49.6557L35.8239 50.7851M35.8239 50.7851L36.9564 49.6557M35.8239 50.7851L36.9564 51.9145M35.8239 50.7851L34.6914 51.9145"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask782_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="38"
        y="49"
      >
        <path d="M40.7316 49.6557H38.4666V51.9145H40.7316V49.6557Z" fill="white" />
      </mask>
      <g mask="url(#mask782_2057_43870)">
        <mask
          height="3"
          id="mask783_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="38"
          y="49"
        >
          <path d="M40.7316 49.6557H38.4666V51.9145H40.7316V49.6557Z" fill="white" />
        </mask>
        <g mask="url(#mask783_2057_43870)">
          <path
            d="M38.4666 49.6557L39.5991 50.7851M39.5991 50.7851L40.7316 49.6557M39.5991 50.7851L40.7316 51.9145M39.5991 50.7851L38.4666 51.9145"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask784_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="42"
        y="49"
      >
        <path d="M44.5065 49.6557H42.2415V51.9145H44.5065V49.6557Z" fill="white" />
      </mask>
      <g mask="url(#mask784_2057_43870)">
        <mask
          height="3"
          id="mask785_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="42"
          y="49"
        >
          <path d="M44.5065 49.6557H42.2415V51.9145H44.5065V49.6557Z" fill="white" />
        </mask>
        <g mask="url(#mask785_2057_43870)">
          <path
            d="M42.2415 49.6557L43.374 50.7851M43.374 50.7851L44.5065 49.6557M43.374 50.7851L44.5065 51.9145M43.374 50.7851L42.2415 51.9145"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask786_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="46"
        y="49"
      >
        <path d="M48.2815 49.6557H46.0165V51.9145H48.2815V49.6557Z" fill="white" />
      </mask>
      <g mask="url(#mask786_2057_43870)">
        <mask
          height="3"
          id="mask787_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="46"
          y="49"
        >
          <path d="M48.2815 49.6557H46.0165V51.9145H48.2815V49.6557Z" fill="white" />
        </mask>
        <g mask="url(#mask787_2057_43870)">
          <path
            d="M46.0165 49.6557L47.149 50.7851M47.149 50.7851L48.2815 49.6557M47.149 50.7851L48.2815 51.9145M47.149 50.7851L46.0165 51.9145"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask788_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="49"
        y="49"
      >
        <path d="M52.0565 49.6557H49.7915V51.9145H52.0565V49.6557Z" fill="white" />
      </mask>
      <g mask="url(#mask788_2057_43870)">
        <mask
          height="3"
          id="mask789_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="49"
          y="49"
        >
          <path d="M52.0565 49.6557H49.7915V51.9145H52.0565V49.6557Z" fill="white" />
        </mask>
        <g mask="url(#mask789_2057_43870)">
          <path
            d="M49.7915 49.6557L50.924 50.7851M50.924 50.7851L52.0565 49.6557M50.924 50.7851L52.0565 51.9145M50.924 50.7851L49.7915 51.9145"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask790_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="53"
        y="49"
      >
        <path d="M55.8432 49.6674H53.5782V51.9262H55.8432V49.6674Z" fill="white" />
      </mask>
      <g mask="url(#mask790_2057_43870)">
        <mask
          height="3"
          id="mask791_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="53"
          y="49"
        >
          <path d="M55.8432 49.6674H53.5782V51.9262H55.8432V49.6674Z" fill="white" />
        </mask>
        <g mask="url(#mask791_2057_43870)">
          <path
            d="M53.5782 49.6674L54.7107 50.7968M54.7107 50.7968L55.8432 49.6674M54.7107 50.7968L55.8432 51.9262M54.7107 50.7968L53.5782 51.9262"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="5"
        id="mask792_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="67"
        y="48"
      >
        <path d="M71.725 48.9412H67.95V52.7059H71.725V48.9412Z" fill="white" />
      </mask>
      <g mask="url(#mask792_2057_43870)">
        <mask
          height="5"
          id="mask793_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="67"
          y="48"
        >
          <path d="M71.725 48.9412H67.95V52.7059H71.725V48.9412Z" fill="white" />
        </mask>
        <g mask="url(#mask793_2057_43870)">
          <mask
            height="5"
            id="mask794_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="67"
            y="48"
          >
            <path d="M71.725 48.9412H67.95V52.7059H71.725V48.9412Z" fill="white" />
          </mask>
          <g mask="url(#mask794_2057_43870)">
            <path
              d="M67.95 48.9412L68.8937 49.8823M68.8937 49.8823L69.8375 48.9412L70.7812 49.8823M68.8937 49.8823L69.8375 50.8235M68.8937 49.8823L67.95 50.8235L68.8937 51.7647M70.7812 49.8823L69.8375 50.8235M70.7812 49.8823L71.725 48.9412M70.7812 49.8823L71.725 50.8235L70.7812 51.7647M69.8375 50.8235L68.8937 51.7647M69.8375 50.8235L70.7812 51.7647M68.8937 51.7647L69.8375 52.7059L70.7812 51.7647M68.8937 51.7647L67.95 52.7059M70.7812 51.7647L71.725 52.7059"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask795_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="71"
        y="48"
      >
        <path d="M75.5 48.9412H71.725V52.7059H75.5V48.9412Z" fill="white" />
      </mask>
      <g mask="url(#mask795_2057_43870)">
        <mask
          height="5"
          id="mask796_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="71"
          y="48"
        >
          <path d="M75.5 48.9412H71.725V52.7059H75.5V48.9412Z" fill="white" />
        </mask>
        <g mask="url(#mask796_2057_43870)">
          <mask
            height="5"
            id="mask797_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="71"
            y="48"
          >
            <path d="M75.5 48.9412H71.725V52.7059H75.5V48.9412Z" fill="white" />
          </mask>
          <g mask="url(#mask797_2057_43870)">
            <path
              d="M71.725 48.9412L72.6687 49.8823M72.6687 49.8823L73.6125 48.9412L74.5562 49.8823M72.6687 49.8823L73.6125 50.8235M72.6687 49.8823L71.725 50.8235L72.6687 51.7647M74.5562 49.8823L73.6125 50.8235M74.5562 49.8823L75.5 48.9412M74.5562 49.8823L75.5 50.8235L74.5562 51.7647M73.6125 50.8235L72.6687 51.7647M73.6125 50.8235L74.5562 51.7647M72.6687 51.7647L73.6125 52.7059L74.5562 51.7647M72.6687 51.7647L71.725 52.7059M74.5562 51.7647L75.5 52.7059"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask798_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="86"
        y="48"
      >
        <path d="M90.6 48.9412H86.825V52.7059H90.6V48.9412Z" fill="white" />
      </mask>
      <g mask="url(#mask798_2057_43870)">
        <mask
          height="5"
          id="mask799_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="86"
          y="48"
        >
          <path d="M90.6 48.9412H86.825V52.7059H90.6V48.9412Z" fill="white" />
        </mask>
        <g mask="url(#mask799_2057_43870)">
          <mask
            height="5"
            id="mask800_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="86"
            y="48"
          >
            <path d="M90.6 48.9412H86.825V52.7059H90.6V48.9412Z" fill="white" />
          </mask>
          <g mask="url(#mask800_2057_43870)">
            <path
              d="M86.825 48.9412L87.7687 49.8823M87.7687 49.8823L88.7125 48.9412L89.6562 49.8823M87.7687 49.8823L88.7125 50.8235M87.7687 49.8823L86.825 50.8235L87.7687 51.7647M89.6562 49.8823L88.7125 50.8235M89.6562 49.8823L90.6 48.9412M89.6562 49.8823L90.6 50.8235L89.6562 51.7647M88.7125 50.8235L87.7687 51.7647M88.7125 50.8235L89.6562 51.7647M87.7687 51.7647L88.7125 52.7059L89.6562 51.7647M87.7687 51.7647L86.825 52.7059M89.6562 51.7647L90.6 52.7059"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask801_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="90"
        y="48"
      >
        <path d="M94.375 48.9412H90.6V52.7059H94.375V48.9412Z" fill="white" />
      </mask>
      <g mask="url(#mask801_2057_43870)">
        <mask
          height="5"
          id="mask802_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="90"
          y="48"
        >
          <path d="M94.375 48.9412H90.6V52.7059H94.375V48.9412Z" fill="white" />
        </mask>
        <g mask="url(#mask802_2057_43870)">
          <mask
            height="5"
            id="mask803_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="90"
            y="48"
          >
            <path d="M94.375 48.9412H90.6V52.7059H94.375V48.9412Z" fill="white" />
          </mask>
          <g mask="url(#mask803_2057_43870)">
            <path
              d="M90.6 48.9412L91.5437 49.8823M91.5437 49.8823L92.4875 48.9412L93.4312 49.8823M91.5437 49.8823L92.4875 50.8235M91.5437 49.8823L90.6 50.8235L91.5437 51.7647M93.4312 49.8823L92.4875 50.8235M93.4312 49.8823L94.375 48.9412M93.4312 49.8823L94.375 50.8235L93.4312 51.7647M92.4875 50.8235L91.5437 51.7647M92.4875 50.8235L93.4312 51.7647M91.5437 51.7647L92.4875 52.7059L93.4312 51.7647M91.5437 51.7647L90.6 52.7059M93.4312 51.7647L94.375 52.7059"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask804_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="94"
        y="48"
      >
        <path d="M98.15 48.9412H94.375V52.7059H98.15V48.9412Z" fill="white" />
      </mask>
      <g mask="url(#mask804_2057_43870)">
        <mask
          height="5"
          id="mask805_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="94"
          y="48"
        >
          <path d="M98.15 48.9412H94.375V52.7059H98.15V48.9412Z" fill="white" />
        </mask>
        <g mask="url(#mask805_2057_43870)">
          <mask
            height="5"
            id="mask806_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="94"
            y="48"
          >
            <path d="M98.15 48.9412H94.375V52.7059H98.15V48.9412Z" fill="white" />
          </mask>
          <g mask="url(#mask806_2057_43870)">
            <path
              d="M94.375 48.9412L95.3187 49.8823M95.3187 49.8823L96.2625 48.9412L97.2062 49.8823M95.3187 49.8823L96.2625 50.8235M95.3187 49.8823L94.375 50.8235L95.3187 51.7647M97.2062 49.8823L96.2625 50.8235M97.2062 49.8823L98.15 48.9412M97.2062 49.8823L98.15 50.8235L97.2062 51.7647M96.2625 50.8235L95.3187 51.7647M96.2625 50.8235L97.2062 51.7647M95.3187 51.7647L96.2625 52.7059L97.2062 51.7647M95.3187 51.7647L94.375 52.7059M97.2062 51.7647L98.15 52.7059"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask807_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="109"
        y="48"
      >
        <path d="M113.25 48.9412H109.475V52.7059H113.25V48.9412Z" fill="white" />
      </mask>
      <g mask="url(#mask807_2057_43870)">
        <mask
          height="5"
          id="mask808_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="109"
          y="48"
        >
          <path d="M113.25 48.9412H109.475V52.7059H113.25V48.9412Z" fill="white" />
        </mask>
        <g mask="url(#mask808_2057_43870)">
          <mask
            height="5"
            id="mask809_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="109"
            y="48"
          >
            <path d="M113.25 48.9412H109.475V52.7059H113.25V48.9412Z" fill="white" />
          </mask>
          <g mask="url(#mask809_2057_43870)">
            <path
              d="M109.475 48.9412L110.419 49.8823M110.419 49.8823L111.362 48.9412L112.306 49.8823M110.419 49.8823L111.362 50.8235M110.419 49.8823L109.475 50.8235L110.419 51.7647M112.306 49.8823L111.362 50.8235M112.306 49.8823L113.25 48.9412M112.306 49.8823L113.25 50.8235L112.306 51.7647M111.362 50.8235L110.419 51.7647M111.362 50.8235L112.306 51.7647M110.419 51.7647L111.362 52.7059L112.306 51.7647M110.419 51.7647L109.475 52.7059M112.306 51.7647L113.25 52.7059"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask810_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="113"
        y="48"
      >
        <path d="M117.025 48.9412H113.25V52.7059H117.025V48.9412Z" fill="white" />
      </mask>
      <g mask="url(#mask810_2057_43870)">
        <mask
          height="5"
          id="mask811_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="113"
          y="48"
        >
          <path d="M117.025 48.9412H113.25V52.7059H117.025V48.9412Z" fill="white" />
        </mask>
        <g mask="url(#mask811_2057_43870)">
          <mask
            height="5"
            id="mask812_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="113"
            y="48"
          >
            <path d="M117.025 48.9412H113.25V52.7059H117.025V48.9412Z" fill="white" />
          </mask>
          <g mask="url(#mask812_2057_43870)">
            <path
              d="M113.25 48.9412L114.194 49.8823M114.194 49.8823L115.137 48.9412L116.081 49.8823M114.194 49.8823L115.137 50.8235M114.194 49.8823L113.25 50.8235L114.194 51.7647M116.081 49.8823L115.137 50.8235M116.081 49.8823L117.025 48.9412M116.081 49.8823L117.025 50.8235L116.081 51.7647M115.137 50.8235L114.194 51.7647M115.137 50.8235L116.081 51.7647M114.194 51.7647L115.137 52.7059L116.081 51.7647M114.194 51.7647L113.25 52.7059M116.081 51.7647L117.025 52.7059"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask813_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="117"
        y="48"
      >
        <path d="M120.8 48.9412H117.025V52.7059H120.8V48.9412Z" fill="white" />
      </mask>
      <g mask="url(#mask813_2057_43870)">
        <mask
          height="5"
          id="mask814_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="117"
          y="48"
        >
          <path d="M120.8 48.9412H117.025V52.7059H120.8V48.9412Z" fill="white" />
        </mask>
        <g mask="url(#mask814_2057_43870)">
          <mask
            height="5"
            id="mask815_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="117"
            y="48"
          >
            <path d="M120.8 48.9412H117.025V52.7059H120.8V48.9412Z" fill="white" />
          </mask>
          <g mask="url(#mask815_2057_43870)">
            <path
              d="M117.025 48.9412L117.969 49.8823M117.969 49.8823L118.913 48.9412L119.856 49.8823M117.969 49.8823L118.913 50.8235M117.969 49.8823L117.025 50.8235L117.969 51.7647M119.856 49.8823L118.913 50.8235M119.856 49.8823L120.8 48.9412M119.856 49.8823L120.8 50.8235L119.856 51.7647M118.913 50.8235L117.969 51.7647M118.913 50.8235L119.856 51.7647M117.969 51.7647L118.913 52.7059L119.856 51.7647M117.969 51.7647L117.025 52.7059M119.856 51.7647L120.8 52.7059"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask816_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="132"
        y="48"
      >
        <path d="M135.9 48.9412H132.125V52.7059H135.9V48.9412Z" fill="white" />
      </mask>
      <g mask="url(#mask816_2057_43870)">
        <mask
          height="5"
          id="mask817_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="132"
          y="48"
        >
          <path d="M135.9 48.9412H132.125V52.7059H135.9V48.9412Z" fill="white" />
        </mask>
        <g mask="url(#mask817_2057_43870)">
          <mask
            height="5"
            id="mask818_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="132"
            y="48"
          >
            <path d="M135.9 48.9412H132.125V52.7059H135.9V48.9412Z" fill="white" />
          </mask>
          <g mask="url(#mask818_2057_43870)">
            <path
              d="M132.125 48.9412L133.069 49.8823M133.069 49.8823L134.012 48.9412L134.956 49.8823M133.069 49.8823L134.012 50.8235M133.069 49.8823L132.125 50.8235L133.069 51.7647M134.956 49.8823L134.012 50.8235M134.956 49.8823L135.9 48.9412M134.956 49.8823L135.9 50.8235L134.956 51.7647M134.012 50.8235L133.069 51.7647M134.012 50.8235L134.956 51.7647M133.069 51.7647L134.012 52.7059L134.956 51.7647M133.069 51.7647L132.125 52.7059M134.956 51.7647L135.9 52.7059"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask819_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="135"
        y="48"
      >
        <path d="M139.675 48.9412H135.9V52.7059H139.675V48.9412Z" fill="white" />
      </mask>
      <g mask="url(#mask819_2057_43870)">
        <mask
          height="5"
          id="mask820_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="135"
          y="48"
        >
          <path d="M139.675 48.9412H135.9V52.7059H139.675V48.9412Z" fill="white" />
        </mask>
        <g mask="url(#mask820_2057_43870)">
          <mask
            height="5"
            id="mask821_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="135"
            y="48"
          >
            <path d="M139.675 48.9412H135.9V52.7059H139.675V48.9412Z" fill="white" />
          </mask>
          <g mask="url(#mask821_2057_43870)">
            <path
              d="M135.9 48.9412L136.844 49.8823M136.844 49.8823L137.788 48.9412L138.731 49.8823M136.844 49.8823L137.788 50.8235M136.844 49.8823L135.9 50.8235L136.844 51.7647M138.731 49.8823L137.788 50.8235M138.731 49.8823L139.675 48.9412M138.731 49.8823L139.675 50.8235L138.731 51.7647M137.788 50.8235L136.844 51.7647M137.788 50.8235L138.731 51.7647M136.844 51.7647L137.788 52.7059L138.731 51.7647M136.844 51.7647L135.9 52.7059M138.731 51.7647L139.675 52.7059"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask822_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="139"
        y="48"
      >
        <path d="M143.45 48.9412H139.675V52.7059H143.45V48.9412Z" fill="white" />
      </mask>
      <g mask="url(#mask822_2057_43870)">
        <mask
          height="5"
          id="mask823_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="139"
          y="48"
        >
          <path d="M143.45 48.9412H139.675V52.7059H143.45V48.9412Z" fill="white" />
        </mask>
        <g mask="url(#mask823_2057_43870)">
          <mask
            height="5"
            id="mask824_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="139"
            y="48"
          >
            <path d="M143.45 48.9412H139.675V52.7059H143.45V48.9412Z" fill="white" />
          </mask>
          <g mask="url(#mask824_2057_43870)">
            <path
              d="M139.675 48.9412L140.619 49.8823M140.619 49.8823L141.563 48.9412L142.506 49.8823M140.619 49.8823L141.563 50.8235M140.619 49.8823L139.675 50.8235L140.619 51.7647M142.506 49.8823L141.563 50.8235M142.506 49.8823L143.45 48.9412M142.506 49.8823L143.45 50.8235L142.506 51.7647M141.563 50.8235L140.619 51.7647M141.563 50.8235L142.506 51.7647M140.619 51.7647L141.563 52.7059L142.506 51.7647M140.619 51.7647L139.675 52.7059M142.506 51.7647L143.45 52.7059"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask825_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="151"
        y="48"
      >
        <path d="M154.775 48.9412H151V52.7059H154.775V48.9412Z" fill="white" />
      </mask>
      <g mask="url(#mask825_2057_43870)">
        <mask
          height="5"
          id="mask826_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="151"
          y="48"
        >
          <path d="M154.775 48.9412H151V52.7059H154.775V48.9412Z" fill="white" />
        </mask>
        <g mask="url(#mask826_2057_43870)">
          <mask
            height="5"
            id="mask827_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="151"
            y="48"
          >
            <path d="M154.775 48.9412H151V52.7059H154.775V48.9412Z" fill="white" />
          </mask>
          <g mask="url(#mask827_2057_43870)">
            <path
              d="M151 48.9412L151.944 49.8823M151.944 49.8823L152.887 48.9412L153.831 49.8823M151.944 49.8823L152.887 50.8235M151.944 49.8823L151 50.8235L151.944 51.7647M153.831 49.8823L152.887 50.8235M153.831 49.8823L154.775 48.9412M153.831 49.8823L154.775 50.8235L153.831 51.7647M152.887 50.8235L151.944 51.7647M152.887 50.8235L153.831 51.7647M151.944 51.7647L152.887 52.7059L153.831 51.7647M151.944 51.7647L151 52.7059M153.831 51.7647L154.775 52.7059"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask828_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="154"
        y="48"
      >
        <path d="M158.55 48.9412H154.775V52.7059H158.55V48.9412Z" fill="white" />
      </mask>
      <g mask="url(#mask828_2057_43870)">
        <mask
          height="5"
          id="mask829_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="154"
          y="48"
        >
          <path d="M158.55 48.9412H154.775V52.7059H158.55V48.9412Z" fill="white" />
        </mask>
        <g mask="url(#mask829_2057_43870)">
          <mask
            height="5"
            id="mask830_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="154"
            y="48"
          >
            <path d="M158.55 48.9412H154.775V52.7059H158.55V48.9412Z" fill="white" />
          </mask>
          <g mask="url(#mask830_2057_43870)">
            <path
              d="M154.775 48.9412L155.719 49.8823M155.719 49.8823L156.663 48.9412L157.606 49.8823M155.719 49.8823L156.663 50.8235M155.719 49.8823L154.775 50.8235L155.719 51.7647M157.606 49.8823L156.663 50.8235M157.606 49.8823L158.55 48.9412M157.606 49.8823L158.55 50.8235L157.606 51.7647M156.663 50.8235L155.719 51.7647M156.663 50.8235L157.606 51.7647M155.719 51.7647L156.663 52.7059L157.606 51.7647M155.719 51.7647L154.775 52.7059M157.606 51.7647L158.55 52.7059"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask831_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="158"
        y="48"
      >
        <path d="M162.325 48.9412H158.55V52.7059H162.325V48.9412Z" fill="white" />
      </mask>
      <g mask="url(#mask831_2057_43870)">
        <mask
          height="5"
          id="mask832_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="158"
          y="48"
        >
          <path d="M162.325 48.9412H158.55V52.7059H162.325V48.9412Z" fill="white" />
        </mask>
        <g mask="url(#mask832_2057_43870)">
          <mask
            height="5"
            id="mask833_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="158"
            y="48"
          >
            <path d="M162.325 48.9412H158.55V52.7059H162.325V48.9412Z" fill="white" />
          </mask>
          <g mask="url(#mask833_2057_43870)">
            <path
              d="M158.55 48.9412L159.494 49.8823M159.494 49.8823L160.438 48.9412L161.381 49.8823M159.494 49.8823L160.438 50.8235M159.494 49.8823L158.55 50.8235L159.494 51.7647M161.381 49.8823L160.438 50.8235M161.381 49.8823L162.325 48.9412M161.381 49.8823L162.325 50.8235L161.381 51.7647M160.438 50.8235L159.494 51.7647M160.438 50.8235L161.381 51.7647M159.494 51.7647L160.438 52.7059L161.381 51.7647M159.494 51.7647L158.55 52.7059M161.381 51.7647L162.325 52.7059"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask834_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="173"
        y="48"
      >
        <path d="M177.425 48.9412H173.65V52.7059H177.425V48.9412Z" fill="white" />
      </mask>
      <g mask="url(#mask834_2057_43870)">
        <mask
          height="5"
          id="mask835_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="173"
          y="48"
        >
          <path d="M177.425 48.9412H173.65V52.7059H177.425V48.9412Z" fill="white" />
        </mask>
        <g mask="url(#mask835_2057_43870)">
          <mask
            height="5"
            id="mask836_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="173"
            y="48"
          >
            <path d="M177.425 48.9412H173.65V52.7059H177.425V48.9412Z" fill="white" />
          </mask>
          <g mask="url(#mask836_2057_43870)">
            <path
              d="M173.65 48.9412L174.594 49.8823M174.594 49.8823L175.538 48.9412L176.481 49.8823M174.594 49.8823L175.538 50.8235M174.594 49.8823L173.65 50.8235L174.594 51.7647M176.481 49.8823L175.538 50.8235M176.481 49.8823L177.425 48.9412M176.481 49.8823L177.425 50.8235L176.481 51.7647M175.538 50.8235L174.594 51.7647M175.538 50.8235L176.481 51.7647M174.594 51.7647L175.538 52.7059L176.481 51.7647M174.594 51.7647L173.65 52.7059M176.481 51.7647L177.425 52.7059"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask837_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="177"
        y="48"
      >
        <path d="M181.2 48.9412H177.425V52.7059H181.2V48.9412Z" fill="white" />
      </mask>
      <g mask="url(#mask837_2057_43870)">
        <mask
          height="5"
          id="mask838_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="177"
          y="48"
        >
          <path d="M181.2 48.9412H177.425V52.7059H181.2V48.9412Z" fill="white" />
        </mask>
        <g mask="url(#mask838_2057_43870)">
          <mask
            height="5"
            id="mask839_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="177"
            y="48"
          >
            <path d="M181.2 48.9412H177.425V52.7059H181.2V48.9412Z" fill="white" />
          </mask>
          <g mask="url(#mask839_2057_43870)">
            <path
              d="M177.425 48.9412L178.369 49.8823M178.369 49.8823L179.313 48.9412L180.256 49.8823M178.369 49.8823L179.313 50.8235M178.369 49.8823L177.425 50.8235L178.369 51.7647M180.256 49.8823L179.313 50.8235M180.256 49.8823L181.2 48.9412M180.256 49.8823L181.2 50.8235L180.256 51.7647M179.313 50.8235L178.369 51.7647M179.313 50.8235L180.256 51.7647M178.369 51.7647L179.313 52.7059L180.256 51.7647M178.369 51.7647L177.425 52.7059M180.256 51.7647L181.2 52.7059"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask840_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="181"
        y="48"
      >
        <path d="M184.975 48.9412H181.2V52.7059H184.975V48.9412Z" fill="white" />
      </mask>
      <g mask="url(#mask840_2057_43870)">
        <mask
          height="5"
          id="mask841_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="181"
          y="48"
        >
          <path d="M184.975 48.9412H181.2V52.7059H184.975V48.9412Z" fill="white" />
        </mask>
        <g mask="url(#mask841_2057_43870)">
          <mask
            height="5"
            id="mask842_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="181"
            y="48"
          >
            <path d="M184.975 48.9412H181.2V52.7059H184.975V48.9412Z" fill="white" />
          </mask>
          <g mask="url(#mask842_2057_43870)">
            <path
              d="M181.2 48.9412L182.144 49.8823M182.144 49.8823L183.087 48.9412L184.031 49.8823M182.144 49.8823L183.087 50.8235M182.144 49.8823L181.2 50.8235L182.144 51.7647M184.031 49.8823L183.087 50.8235M184.031 49.8823L184.975 48.9412M184.031 49.8823L184.975 50.8235L184.031 51.7647M183.087 50.8235L182.144 51.7647M183.087 50.8235L184.031 51.7647M182.144 51.7647L183.087 52.7059L184.031 51.7647M182.144 51.7647L181.2 52.7059M184.031 51.7647L184.975 52.7059"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask843_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="196"
        y="48"
      >
        <path d="M200.075 48.9412H196.3V52.7059H200.075V48.9412Z" fill="white" />
      </mask>
      <g mask="url(#mask843_2057_43870)">
        <mask
          height="5"
          id="mask844_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="196"
          y="48"
        >
          <path d="M200.075 48.9412H196.3V52.7059H200.075V48.9412Z" fill="white" />
        </mask>
        <g mask="url(#mask844_2057_43870)">
          <mask
            height="5"
            id="mask845_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="196"
            y="48"
          >
            <path d="M200.075 48.9412H196.3V52.7059H200.075V48.9412Z" fill="white" />
          </mask>
          <g mask="url(#mask845_2057_43870)">
            <path
              d="M196.3 48.9412L197.244 49.8823M197.244 49.8823L198.188 48.9412L199.131 49.8823M197.244 49.8823L198.188 50.8235M197.244 49.8823L196.3 50.8235L197.244 51.7647M199.131 49.8823L198.188 50.8235M199.131 49.8823L200.075 48.9412M199.131 49.8823L200.075 50.8235L199.131 51.7647M198.188 50.8235L197.244 51.7647M198.188 50.8235L199.131 51.7647M197.244 51.7647L198.188 52.7059L199.131 51.7647M197.244 51.7647L196.3 52.7059M199.131 51.7647L200.075 52.7059"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask846_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="200"
        y="48"
      >
        <path d="M203.85 48.9412H200.075V52.7059H203.85V48.9412Z" fill="white" />
      </mask>
      <g mask="url(#mask846_2057_43870)">
        <mask
          height="5"
          id="mask847_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="200"
          y="48"
        >
          <path d="M203.85 48.9412H200.075V52.7059H203.85V48.9412Z" fill="white" />
        </mask>
        <g mask="url(#mask847_2057_43870)">
          <mask
            height="5"
            id="mask848_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="200"
            y="48"
          >
            <path d="M203.85 48.9412H200.075V52.7059H203.85V48.9412Z" fill="white" />
          </mask>
          <g mask="url(#mask848_2057_43870)">
            <path
              d="M200.075 48.9412L201.019 49.8823M201.019 49.8823L201.962 48.9412L202.906 49.8823M201.019 49.8823L201.962 50.8235M201.019 49.8823L200.075 50.8235L201.019 51.7647M202.906 49.8823L201.962 50.8235M202.906 49.8823L203.85 48.9412M202.906 49.8823L203.85 50.8235L202.906 51.7647M201.962 50.8235L201.019 51.7647M201.962 50.8235L202.906 51.7647M201.019 51.7647L201.962 52.7059L202.906 51.7647M201.019 51.7647L200.075 52.7059M202.906 51.7647L203.85 52.7059"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask849_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="203"
        y="48"
      >
        <path d="M207.625 48.9412H203.85V52.7059H207.625V48.9412Z" fill="white" />
      </mask>
      <g mask="url(#mask849_2057_43870)">
        <mask
          height="5"
          id="mask850_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="203"
          y="48"
        >
          <path d="M207.625 48.9412H203.85V52.7059H207.625V48.9412Z" fill="white" />
        </mask>
        <g mask="url(#mask850_2057_43870)">
          <mask
            height="5"
            id="mask851_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="203"
            y="48"
          >
            <path d="M207.625 48.9412H203.85V52.7059H207.625V48.9412Z" fill="white" />
          </mask>
          <g mask="url(#mask851_2057_43870)">
            <path
              d="M203.85 48.9412L204.794 49.8823M204.794 49.8823L205.737 48.9412L206.681 49.8823M204.794 49.8823L205.737 50.8235M204.794 49.8823L203.85 50.8235L204.794 51.7647M206.681 49.8823L205.737 50.8235M206.681 49.8823L207.625 48.9412M206.681 49.8823L207.625 50.8235L206.681 51.7647M205.737 50.8235L204.794 51.7647M205.737 50.8235L206.681 51.7647M204.794 51.7647L205.737 52.7059L206.681 51.7647M204.794 51.7647L203.85 52.7059M206.681 51.7647L207.625 52.7059"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask852_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="237"
        y="48"
      >
        <path d="M241.6 48.9412H237.825V52.7059H241.6V48.9412Z" fill="white" />
      </mask>
      <g mask="url(#mask852_2057_43870)">
        <mask
          height="5"
          id="mask853_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="237"
          y="48"
        >
          <path d="M241.6 48.9412H237.825V52.7059H241.6V48.9412Z" fill="white" />
        </mask>
        <g mask="url(#mask853_2057_43870)">
          <mask
            height="5"
            id="mask854_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="237"
            y="48"
          >
            <path d="M241.6 48.9412H237.825V52.7059H241.6V48.9412Z" fill="white" />
          </mask>
          <g mask="url(#mask854_2057_43870)">
            <path
              d="M237.825 48.9412L238.769 49.8823M238.769 49.8823L239.712 48.9412L240.656 49.8823M238.769 49.8823L239.712 50.8235M238.769 49.8823L237.825 50.8235L238.769 51.7647M240.656 49.8823L239.712 50.8235M240.656 49.8823L241.6 48.9412M240.656 49.8823L241.6 50.8235L240.656 51.7647M239.712 50.8235L238.769 51.7647M239.712 50.8235L240.656 51.7647M238.769 51.7647L239.712 52.7059L240.656 51.7647M238.769 51.7647L237.825 52.7059M240.656 51.7647L241.6 52.7059"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask855_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="241"
        y="48"
      >
        <path d="M245.375 48.9412H241.6V52.7059H245.375V48.9412Z" fill="white" />
      </mask>
      <g mask="url(#mask855_2057_43870)">
        <mask
          height="5"
          id="mask856_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="241"
          y="48"
        >
          <path d="M245.375 48.9412H241.6V52.7059H245.375V48.9412Z" fill="white" />
        </mask>
        <g mask="url(#mask856_2057_43870)">
          <mask
            height="5"
            id="mask857_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="241"
            y="48"
          >
            <path d="M245.375 48.9412H241.6V52.7059H245.375V48.9412Z" fill="white" />
          </mask>
          <g mask="url(#mask857_2057_43870)">
            <path
              d="M241.6 48.9412L242.544 49.8823M242.544 49.8823L243.487 48.9412L244.431 49.8823M242.544 49.8823L243.487 50.8235M242.544 49.8823L241.6 50.8235L242.544 51.7647M244.431 49.8823L243.487 50.8235M244.431 49.8823L245.375 48.9412M244.431 49.8823L245.375 50.8235L244.431 51.7647M243.487 50.8235L242.544 51.7647M243.487 50.8235L244.431 51.7647M242.544 51.7647L243.487 52.7059L244.431 51.7647M242.544 51.7647L241.6 52.7059M244.431 51.7647L245.375 52.7059"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask858_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="245"
        y="48"
      >
        <path d="M249.15 48.9412H245.375V52.7059H249.15V48.9412Z" fill="white" />
      </mask>
      <g mask="url(#mask858_2057_43870)">
        <mask
          height="5"
          id="mask859_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="245"
          y="48"
        >
          <path d="M249.15 48.9412H245.375V52.7059H249.15V48.9412Z" fill="white" />
        </mask>
        <g mask="url(#mask859_2057_43870)">
          <mask
            height="5"
            id="mask860_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="245"
            y="48"
          >
            <path d="M249.15 48.9412H245.375V52.7059H249.15V48.9412Z" fill="white" />
          </mask>
          <g mask="url(#mask860_2057_43870)">
            <path
              d="M245.375 48.9412L246.319 49.8823M246.319 49.8823L247.262 48.9412L248.206 49.8823M246.319 49.8823L247.262 50.8235M246.319 49.8823L245.375 50.8235L246.319 51.7647M248.206 49.8823L247.262 50.8235M248.206 49.8823L249.15 48.9412M248.206 49.8823L249.15 50.8235L248.206 51.7647M247.262 50.8235L246.319 51.7647M247.262 50.8235L248.206 51.7647M246.319 51.7647L247.262 52.7059L248.206 51.7647M246.319 51.7647L245.375 52.7059M248.206 51.7647L249.15 52.7059"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask861_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="260"
        y="48"
      >
        <path d="M264.25 48.9412H260.475V52.7059H264.25V48.9412Z" fill="white" />
      </mask>
      <g mask="url(#mask861_2057_43870)">
        <mask
          height="5"
          id="mask862_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="260"
          y="48"
        >
          <path d="M264.25 48.9412H260.475V52.7059H264.25V48.9412Z" fill="white" />
        </mask>
        <g mask="url(#mask862_2057_43870)">
          <mask
            height="5"
            id="mask863_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="260"
            y="48"
          >
            <path d="M264.25 48.9412H260.475V52.7059H264.25V48.9412Z" fill="white" />
          </mask>
          <g mask="url(#mask863_2057_43870)">
            <path
              d="M260.475 48.9412L261.419 49.8823M261.419 49.8823L262.362 48.9412L263.306 49.8823M261.419 49.8823L262.362 50.8235M261.419 49.8823L260.475 50.8235L261.419 51.7647M263.306 49.8823L262.362 50.8235M263.306 49.8823L264.25 48.9412M263.306 49.8823L264.25 50.8235L263.306 51.7647M262.362 50.8235L261.419 51.7647M262.362 50.8235L263.306 51.7647M261.419 51.7647L262.362 52.7059L263.306 51.7647M261.419 51.7647L260.475 52.7059M263.306 51.7647L264.25 52.7059"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask864_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="264"
        y="48"
      >
        <path d="M268.025 48.9412H264.25V52.7059H268.025V48.9412Z" fill="white" />
      </mask>
      <g mask="url(#mask864_2057_43870)">
        <mask
          height="5"
          id="mask865_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="264"
          y="48"
        >
          <path d="M268.025 48.9412H264.25V52.7059H268.025V48.9412Z" fill="white" />
        </mask>
        <g mask="url(#mask865_2057_43870)">
          <mask
            height="5"
            id="mask866_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="264"
            y="48"
          >
            <path d="M268.025 48.9412H264.25V52.7059H268.025V48.9412Z" fill="white" />
          </mask>
          <g mask="url(#mask866_2057_43870)">
            <path
              d="M264.25 48.9412L265.194 49.8823M265.194 49.8823L266.137 48.9412L267.081 49.8823M265.194 49.8823L266.137 50.8235M265.194 49.8823L264.25 50.8235L265.194 51.7647M267.081 49.8823L266.137 50.8235M267.081 49.8823L268.025 48.9412M267.081 49.8823L268.025 50.8235L267.081 51.7647M266.137 50.8235L265.194 51.7647M266.137 50.8235L267.081 51.7647M265.194 51.7647L266.137 52.7059L267.081 51.7647M265.194 51.7647L264.25 52.7059M267.081 51.7647L268.025 52.7059"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask867_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="268"
        y="48"
      >
        <path d="M271.8 48.9412H268.025V52.7059H271.8V48.9412Z" fill="white" />
      </mask>
      <g mask="url(#mask867_2057_43870)">
        <mask
          height="5"
          id="mask868_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="268"
          y="48"
        >
          <path d="M271.8 48.9412H268.025V52.7059H271.8V48.9412Z" fill="white" />
        </mask>
        <g mask="url(#mask868_2057_43870)">
          <mask
            height="5"
            id="mask869_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="268"
            y="48"
          >
            <path d="M271.8 48.9412H268.025V52.7059H271.8V48.9412Z" fill="white" />
          </mask>
          <g mask="url(#mask869_2057_43870)">
            <path
              d="M268.025 48.9412L268.969 49.8823M268.969 49.8823L269.913 48.9412L270.856 49.8823M268.969 49.8823L269.913 50.8235M268.969 49.8823L268.025 50.8235L268.969 51.7647M270.856 49.8823L269.913 50.8235M270.856 49.8823L271.8 48.9412M270.856 49.8823L271.8 50.8235L270.856 51.7647M269.913 50.8235L268.969 51.7647M269.913 50.8235L270.856 51.7647M268.969 51.7647L269.913 52.7059L270.856 51.7647M268.969 51.7647L268.025 52.7059M270.856 51.7647L271.8 52.7059"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask870_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="283"
        y="48"
      >
        <path d="M286.9 48.9412H283.125V52.7059H286.9V48.9412Z" fill="white" />
      </mask>
      <g mask="url(#mask870_2057_43870)">
        <mask
          height="5"
          id="mask871_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="283"
          y="48"
        >
          <path d="M286.9 48.9412H283.125V52.7059H286.9V48.9412Z" fill="white" />
        </mask>
        <g mask="url(#mask871_2057_43870)">
          <mask
            height="5"
            id="mask872_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="283"
            y="48"
          >
            <path d="M286.9 48.9412H283.125V52.7059H286.9V48.9412Z" fill="white" />
          </mask>
          <g mask="url(#mask872_2057_43870)">
            <path
              d="M283.125 48.9412L284.069 49.8823M284.069 49.8823L285.012 48.9412L285.956 49.8823M284.069 49.8823L285.012 50.8235M284.069 49.8823L283.125 50.8235L284.069 51.7647M285.956 49.8823L285.012 50.8235M285.956 49.8823L286.9 48.9412M285.956 49.8823L286.9 50.8235L285.956 51.7647M285.012 50.8235L284.069 51.7647M285.012 50.8235L285.956 51.7647M284.069 51.7647L285.012 52.7059L285.956 51.7647M284.069 51.7647L283.125 52.7059M285.956 51.7647L286.9 52.7059"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask873_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="286"
        y="48"
      >
        <path d="M290.675 48.9412H286.9V52.7059H290.675V48.9412Z" fill="white" />
      </mask>
      <g mask="url(#mask873_2057_43870)">
        <mask
          height="5"
          id="mask874_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="286"
          y="48"
        >
          <path d="M290.675 48.9412H286.9V52.7059H290.675V48.9412Z" fill="white" />
        </mask>
        <g mask="url(#mask874_2057_43870)">
          <mask
            height="5"
            id="mask875_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="286"
            y="48"
          >
            <path d="M290.675 48.9412H286.9V52.7059H290.675V48.9412Z" fill="white" />
          </mask>
          <g mask="url(#mask875_2057_43870)">
            <path
              d="M286.9 48.9412L287.844 49.8823M287.844 49.8823L288.788 48.9412L289.731 49.8823M287.844 49.8823L288.788 50.8235M287.844 49.8823L286.9 50.8235L287.844 51.7647M289.731 49.8823L288.788 50.8235M289.731 49.8823L290.675 48.9412M289.731 49.8823L290.675 50.8235L289.731 51.7647M288.788 50.8235L287.844 51.7647M288.788 50.8235L289.731 51.7647M287.844 51.7647L288.788 52.7059L289.731 51.7647M287.844 51.7647L286.9 52.7059M289.731 51.7647L290.675 52.7059"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask876_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="290"
        y="48"
      >
        <path d="M294.45 48.9412H290.675V52.7059H294.45V48.9412Z" fill="white" />
      </mask>
      <g mask="url(#mask876_2057_43870)">
        <mask
          height="5"
          id="mask877_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="290"
          y="48"
        >
          <path d="M294.45 48.9412H290.675V52.7059H294.45V48.9412Z" fill="white" />
        </mask>
        <g mask="url(#mask877_2057_43870)">
          <mask
            height="5"
            id="mask878_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="290"
            y="48"
          >
            <path d="M294.45 48.9412H290.675V52.7059H294.45V48.9412Z" fill="white" />
          </mask>
          <g mask="url(#mask878_2057_43870)">
            <path
              d="M290.675 48.9412L291.619 49.8823M291.619 49.8823L292.563 48.9412L293.506 49.8823M291.619 49.8823L292.563 50.8235M291.619 49.8823L290.675 50.8235L291.619 51.7647M293.506 49.8823L292.563 50.8235M293.506 49.8823L294.45 48.9412M293.506 49.8823L294.45 50.8235L293.506 51.7647M292.563 50.8235L291.619 51.7647M292.563 50.8235L293.506 51.7647M291.619 51.7647L292.563 52.7059L293.506 51.7647M291.619 51.7647L290.675 52.7059M293.506 51.7647L294.45 52.7059"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="3"
        id="mask879_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="0"
        y="53"
      >
        <path d="M2.98143 53.4204H0.716431V55.6792H2.98143V53.4204Z" fill="white" />
      </mask>
      <g mask="url(#mask879_2057_43870)">
        <mask
          height="3"
          id="mask880_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="0"
          y="53"
        >
          <path d="M2.98143 53.4204H0.716431V55.6792H2.98143V53.4204Z" fill="white" />
        </mask>
        <g mask="url(#mask880_2057_43870)">
          <path
            d="M0.716431 53.4204L1.84893 54.5498M1.84893 54.5498L2.98143 53.4204M1.84893 54.5498L2.98143 55.6792M1.84893 54.5498L0.716431 55.6792"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask881_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="4"
        y="53"
      >
        <path d="M6.75646 53.4204H4.49146V55.6792H6.75646V53.4204Z" fill="white" />
      </mask>
      <g mask="url(#mask881_2057_43870)">
        <mask
          height="3"
          id="mask882_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="4"
          y="53"
        >
          <path d="M6.75646 53.4204H4.49146V55.6792H6.75646V53.4204Z" fill="white" />
        </mask>
        <g mask="url(#mask882_2057_43870)">
          <path
            d="M4.49146 53.4204L5.62396 54.5498M5.62396 54.5498L6.75646 53.4204M5.62396 54.5498L6.75646 55.6792M5.62396 54.5498L4.49146 55.6792"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask883_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="8"
        y="53"
      >
        <path d="M10.5315 53.4204H8.26648V55.6792H10.5315V53.4204Z" fill="white" />
      </mask>
      <g mask="url(#mask883_2057_43870)">
        <mask
          height="3"
          id="mask884_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="8"
          y="53"
        >
          <path d="M10.5315 53.4204H8.26648V55.6792H10.5315V53.4204Z" fill="white" />
        </mask>
        <g mask="url(#mask884_2057_43870)">
          <path
            d="M8.26648 53.4204L9.39898 54.5498M9.39898 54.5498L10.5315 53.4204M9.39898 54.5498L10.5315 55.6792M9.39898 54.5498L8.26648 55.6792"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask885_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="46"
        y="53"
      >
        <path d="M48.2815 53.4204H46.0165V55.6792H48.2815V53.4204Z" fill="white" />
      </mask>
      <g mask="url(#mask885_2057_43870)">
        <mask
          height="3"
          id="mask886_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="46"
          y="53"
        >
          <path d="M48.2815 53.4204H46.0165V55.6792H48.2815V53.4204Z" fill="white" />
        </mask>
        <g mask="url(#mask886_2057_43870)">
          <path
            d="M46.0165 53.4204L47.149 54.5498M47.149 54.5498L48.2815 53.4204M47.149 54.5498L48.2815 55.6792M47.149 54.5498L46.0165 55.6792"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask887_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="49"
        y="53"
      >
        <path d="M52.0565 53.4204H49.7915V55.6792H52.0565V53.4204Z" fill="white" />
      </mask>
      <g mask="url(#mask887_2057_43870)">
        <mask
          height="3"
          id="mask888_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="49"
          y="53"
        >
          <path d="M52.0565 53.4204H49.7915V55.6792H52.0565V53.4204Z" fill="white" />
        </mask>
        <g mask="url(#mask888_2057_43870)">
          <path
            d="M49.7915 53.4204L50.924 54.5498M50.924 54.5498L52.0565 53.4204M50.924 54.5498L52.0565 55.6792M50.924 54.5498L49.7915 55.6792"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask889_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="53"
        y="53"
      >
        <path d="M55.8315 53.4204H53.5665V55.6792H55.8315V53.4204Z" fill="white" />
      </mask>
      <g mask="url(#mask889_2057_43870)">
        <mask
          height="3"
          id="mask890_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="53"
          y="53"
        >
          <path d="M55.8315 53.4204H53.5665V55.6792H55.8315V53.4204Z" fill="white" />
        </mask>
        <g mask="url(#mask890_2057_43870)">
          <path
            d="M53.5665 53.4204L54.699 54.5498M54.699 54.5498L55.8315 53.4204M54.699 54.5498L55.8315 55.6792M54.699 54.5498L53.5665 55.6792"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="5"
        id="mask891_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="75"
        y="52"
      >
        <path d="M79.275 52.7059H75.5V56.4706H79.275V52.7059Z" fill="white" />
      </mask>
      <g mask="url(#mask891_2057_43870)">
        <mask
          height="5"
          id="mask892_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="75"
          y="52"
        >
          <path d="M79.275 52.7059H75.5V56.4706H79.275V52.7059Z" fill="white" />
        </mask>
        <g mask="url(#mask892_2057_43870)">
          <mask
            height="5"
            id="mask893_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="75"
            y="52"
          >
            <path d="M79.275 52.7059H75.5V56.4706H79.275V52.7059Z" fill="white" />
          </mask>
          <g mask="url(#mask893_2057_43870)">
            <path
              d="M75.5 52.7059L76.4437 53.647M76.4437 53.647L77.3875 52.7059L78.3312 53.647M76.4437 53.647L77.3875 54.5882M76.4437 53.647L75.5 54.5882L76.4437 55.5294M78.3312 53.647L77.3875 54.5882M78.3312 53.647L79.275 52.7059M78.3312 53.647L79.275 54.5882L78.3312 55.5294M77.3875 54.5882L76.4437 55.5294M77.3875 54.5882L78.3312 55.5294M76.4437 55.5294L77.3875 56.4706L78.3312 55.5294M76.4437 55.5294L75.5 56.4706M78.3312 55.5294L79.275 56.4706"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask894_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="79"
        y="52"
      >
        <path d="M83.05 52.7059H79.275V56.4706H83.05V52.7059Z" fill="white" />
      </mask>
      <g mask="url(#mask894_2057_43870)">
        <mask
          height="5"
          id="mask895_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="79"
          y="52"
        >
          <path d="M83.05 52.7059H79.275V56.4706H83.05V52.7059Z" fill="white" />
        </mask>
        <g mask="url(#mask895_2057_43870)">
          <mask
            height="5"
            id="mask896_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="79"
            y="52"
          >
            <path d="M83.05 52.7059H79.275V56.4706H83.05V52.7059Z" fill="white" />
          </mask>
          <g mask="url(#mask896_2057_43870)">
            <path
              d="M79.275 52.7059L80.2188 53.647M80.2188 53.647L81.1625 52.7059L82.1063 53.647M80.2188 53.647L81.1625 54.5882M80.2188 53.647L79.275 54.5882L80.2188 55.5294M82.1063 53.647L81.1625 54.5882M82.1063 53.647L83.05 52.7059M82.1063 53.647L83.05 54.5882L82.1063 55.5294M81.1625 54.5882L80.2188 55.5294M81.1625 54.5882L82.1063 55.5294M80.2188 55.5294L81.1625 56.4706L82.1063 55.5294M80.2188 55.5294L79.275 56.4706M82.1063 55.5294L83.05 56.4706"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask897_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="83"
        y="52"
      >
        <path d="M86.825 52.7059H83.05V56.4706H86.825V52.7059Z" fill="white" />
      </mask>
      <g mask="url(#mask897_2057_43870)">
        <mask
          height="5"
          id="mask898_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="83"
          y="52"
        >
          <path d="M86.825 52.7059H83.05V56.4706H86.825V52.7059Z" fill="white" />
        </mask>
        <g mask="url(#mask898_2057_43870)">
          <mask
            height="5"
            id="mask899_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="83"
            y="52"
          >
            <path d="M86.825 52.7059H83.05V56.4706H86.825V52.7059Z" fill="white" />
          </mask>
          <g mask="url(#mask899_2057_43870)">
            <path
              d="M83.05 52.7059L83.9938 53.647M83.9938 53.647L84.9375 52.7059L85.8813 53.647M83.9938 53.647L84.9375 54.5882M83.9938 53.647L83.05 54.5882L83.9938 55.5294M85.8813 53.647L84.9375 54.5882M85.8813 53.647L86.825 52.7059M85.8813 53.647L86.825 54.5882L85.8813 55.5294M84.9375 54.5882L83.9938 55.5294M84.9375 54.5882L85.8813 55.5294M83.9938 55.5294L84.9375 56.4706L85.8813 55.5294M83.9938 55.5294L83.05 56.4706M85.8813 55.5294L86.825 56.4706"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask900_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="98"
        y="52"
      >
        <path d="M101.925 52.7059H98.15V56.4706H101.925V52.7059Z" fill="white" />
      </mask>
      <g mask="url(#mask900_2057_43870)">
        <mask
          height="5"
          id="mask901_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="98"
          y="52"
        >
          <path d="M101.925 52.7059H98.15V56.4706H101.925V52.7059Z" fill="white" />
        </mask>
        <g mask="url(#mask901_2057_43870)">
          <mask
            height="5"
            id="mask902_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="98"
            y="52"
          >
            <path d="M101.925 52.7059H98.15V56.4706H101.925V52.7059Z" fill="white" />
          </mask>
          <g mask="url(#mask902_2057_43870)">
            <path
              d="M98.15 52.7059L99.0938 53.647M99.0938 53.647L100.038 52.7059L100.981 53.647M99.0938 53.647L100.038 54.5882M99.0938 53.647L98.15 54.5882L99.0938 55.5294M100.981 53.647L100.038 54.5882M100.981 53.647L101.925 52.7059M100.981 53.647L101.925 54.5882L100.981 55.5294M100.038 54.5882L99.0938 55.5294M100.038 54.5882L100.981 55.5294M99.0938 55.5294L100.038 56.4706L100.981 55.5294M99.0938 55.5294L98.15 56.4706M100.981 55.5294L101.925 56.4706"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask903_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="101"
        y="52"
      >
        <path d="M105.7 52.7059H101.925V56.4706H105.7V52.7059Z" fill="white" />
      </mask>
      <g mask="url(#mask903_2057_43870)">
        <mask
          height="5"
          id="mask904_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="101"
          y="52"
        >
          <path d="M105.7 52.7059H101.925V56.4706H105.7V52.7059Z" fill="white" />
        </mask>
        <g mask="url(#mask904_2057_43870)">
          <mask
            height="5"
            id="mask905_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="101"
            y="52"
          >
            <path d="M105.7 52.7059H101.925V56.4706H105.7V52.7059Z" fill="white" />
          </mask>
          <g mask="url(#mask905_2057_43870)">
            <path
              d="M101.925 52.7059L102.869 53.647M102.869 53.647L103.813 52.7059L104.756 53.647M102.869 53.647L103.813 54.5882M102.869 53.647L101.925 54.5882L102.869 55.5294M104.756 53.647L103.813 54.5882M104.756 53.647L105.7 52.7059M104.756 53.647L105.7 54.5882L104.756 55.5294M103.813 54.5882L102.869 55.5294M103.813 54.5882L104.756 55.5294M102.869 55.5294L103.813 56.4706L104.756 55.5294M102.869 55.5294L101.925 56.4706M104.756 55.5294L105.7 56.4706"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask906_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="105"
        y="52"
      >
        <path d="M109.475 52.7059H105.7V56.4706H109.475V52.7059Z" fill="white" />
      </mask>
      <g mask="url(#mask906_2057_43870)">
        <mask
          height="5"
          id="mask907_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="105"
          y="52"
        >
          <path d="M109.475 52.7059H105.7V56.4706H109.475V52.7059Z" fill="white" />
        </mask>
        <g mask="url(#mask907_2057_43870)">
          <mask
            height="5"
            id="mask908_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="105"
            y="52"
          >
            <path d="M109.475 52.7059H105.7V56.4706H109.475V52.7059Z" fill="white" />
          </mask>
          <g mask="url(#mask908_2057_43870)">
            <path
              d="M105.7 52.7059L106.644 53.647M106.644 53.647L107.587 52.7059L108.531 53.647M106.644 53.647L107.587 54.5882M106.644 53.647L105.7 54.5882L106.644 55.5294M108.531 53.647L107.587 54.5882M108.531 53.647L109.475 52.7059M108.531 53.647L109.475 54.5882L108.531 55.5294M107.587 54.5882L106.644 55.5294M107.587 54.5882L108.531 55.5294M106.644 55.5294L107.587 56.4706L108.531 55.5294M106.644 55.5294L105.7 56.4706M108.531 55.5294L109.475 56.4706"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask909_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="132"
        y="52"
      >
        <path d="M135.9 52.7059H132.125V56.4706H135.9V52.7059Z" fill="white" />
      </mask>
      <g mask="url(#mask909_2057_43870)">
        <mask
          height="5"
          id="mask910_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="132"
          y="52"
        >
          <path d="M135.9 52.7059H132.125V56.4706H135.9V52.7059Z" fill="white" />
        </mask>
        <g mask="url(#mask910_2057_43870)">
          <mask
            height="5"
            id="mask911_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="132"
            y="52"
          >
            <path d="M135.9 52.7059H132.125V56.4706H135.9V52.7059Z" fill="white" />
          </mask>
          <g mask="url(#mask911_2057_43870)">
            <path
              d="M132.125 52.7059L133.069 53.647M133.069 53.647L134.012 52.7059L134.956 53.647M133.069 53.647L134.012 54.5882M133.069 53.647L132.125 54.5882L133.069 55.5294M134.956 53.647L134.012 54.5882M134.956 53.647L135.9 52.7059M134.956 53.647L135.9 54.5882L134.956 55.5294M134.012 54.5882L133.069 55.5294M134.012 54.5882L134.956 55.5294M133.069 55.5294L134.012 56.4706L134.956 55.5294M133.069 55.5294L132.125 56.4706M134.956 55.5294L135.9 56.4706"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask912_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="135"
        y="52"
      >
        <path d="M139.675 52.7059H135.9V56.4706H139.675V52.7059Z" fill="white" />
      </mask>
      <g mask="url(#mask912_2057_43870)">
        <mask
          height="5"
          id="mask913_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="135"
          y="52"
        >
          <path d="M139.675 52.7059H135.9V56.4706H139.675V52.7059Z" fill="white" />
        </mask>
        <g mask="url(#mask913_2057_43870)">
          <mask
            height="5"
            id="mask914_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="135"
            y="52"
          >
            <path d="M139.675 52.7059H135.9V56.4706H139.675V52.7059Z" fill="white" />
          </mask>
          <g mask="url(#mask914_2057_43870)">
            <path
              d="M135.9 52.7059L136.844 53.647M136.844 53.647L137.788 52.7059L138.731 53.647M136.844 53.647L137.788 54.5882M136.844 53.647L135.9 54.5882L136.844 55.5294M138.731 53.647L137.788 54.5882M138.731 53.647L139.675 52.7059M138.731 53.647L139.675 54.5882L138.731 55.5294M137.788 54.5882L136.844 55.5294M137.788 54.5882L138.731 55.5294M136.844 55.5294L137.788 56.4706L138.731 55.5294M136.844 55.5294L135.9 56.4706M138.731 55.5294L139.675 56.4706"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask915_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="139"
        y="52"
      >
        <path d="M143.45 52.7059H139.675V56.4706H143.45V52.7059Z" fill="white" />
      </mask>
      <g mask="url(#mask915_2057_43870)">
        <mask
          height="5"
          id="mask916_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="139"
          y="52"
        >
          <path d="M143.45 52.7059H139.675V56.4706H143.45V52.7059Z" fill="white" />
        </mask>
        <g mask="url(#mask916_2057_43870)">
          <mask
            height="5"
            id="mask917_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="139"
            y="52"
          >
            <path d="M143.45 52.7059H139.675V56.4706H143.45V52.7059Z" fill="white" />
          </mask>
          <g mask="url(#mask917_2057_43870)">
            <path
              d="M139.675 52.7059L140.619 53.647M140.619 53.647L141.563 52.7059L142.506 53.647M140.619 53.647L141.563 54.5882M140.619 53.647L139.675 54.5882L140.619 55.5294M142.506 53.647L141.563 54.5882M142.506 53.647L143.45 52.7059M142.506 53.647L143.45 54.5882L142.506 55.5294M141.563 54.5882L140.619 55.5294M141.563 54.5882L142.506 55.5294M140.619 55.5294L141.563 56.4706L142.506 55.5294M140.619 55.5294L139.675 56.4706M142.506 55.5294L143.45 56.4706"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask918_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="173"
        y="52"
      >
        <path d="M177.425 52.7059H173.65V56.4706H177.425V52.7059Z" fill="white" />
      </mask>
      <g mask="url(#mask918_2057_43870)">
        <mask
          height="5"
          id="mask919_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="173"
          y="52"
        >
          <path d="M177.425 52.7059H173.65V56.4706H177.425V52.7059Z" fill="white" />
        </mask>
        <g mask="url(#mask919_2057_43870)">
          <mask
            height="5"
            id="mask920_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="173"
            y="52"
          >
            <path d="M177.425 52.7059H173.65V56.4706H177.425V52.7059Z" fill="white" />
          </mask>
          <g mask="url(#mask920_2057_43870)">
            <path
              d="M173.65 52.7059L174.594 53.647M174.594 53.647L175.538 52.7059L176.481 53.647M174.594 53.647L175.538 54.5882M174.594 53.647L173.65 54.5882L174.594 55.5294M176.481 53.647L175.538 54.5882M176.481 53.647L177.425 52.7059M176.481 53.647L177.425 54.5882L176.481 55.5294M175.538 54.5882L174.594 55.5294M175.538 54.5882L176.481 55.5294M174.594 55.5294L175.538 56.4706L176.481 55.5294M174.594 55.5294L173.65 56.4706M176.481 55.5294L177.425 56.4706"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask921_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="177"
        y="52"
      >
        <path d="M181.2 52.7059H177.425V56.4706H181.2V52.7059Z" fill="white" />
      </mask>
      <g mask="url(#mask921_2057_43870)">
        <mask
          height="5"
          id="mask922_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="177"
          y="52"
        >
          <path d="M181.2 52.7059H177.425V56.4706H181.2V52.7059Z" fill="white" />
        </mask>
        <g mask="url(#mask922_2057_43870)">
          <mask
            height="5"
            id="mask923_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="177"
            y="52"
          >
            <path d="M181.2 52.7059H177.425V56.4706H181.2V52.7059Z" fill="white" />
          </mask>
          <g mask="url(#mask923_2057_43870)">
            <path
              d="M177.425 52.7059L178.369 53.647M178.369 53.647L179.313 52.7059L180.256 53.647M178.369 53.647L179.313 54.5882M178.369 53.647L177.425 54.5882L178.369 55.5294M180.256 53.647L179.313 54.5882M180.256 53.647L181.2 52.7059M180.256 53.647L181.2 54.5882L180.256 55.5294M179.313 54.5882L178.369 55.5294M179.313 54.5882L180.256 55.5294M178.369 55.5294L179.313 56.4706L180.256 55.5294M178.369 55.5294L177.425 56.4706M180.256 55.5294L181.2 56.4706"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask924_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="181"
        y="52"
      >
        <path d="M184.975 52.7059H181.2V56.4706H184.975V52.7059Z" fill="white" />
      </mask>
      <g mask="url(#mask924_2057_43870)">
        <mask
          height="5"
          id="mask925_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="181"
          y="52"
        >
          <path d="M184.975 52.7059H181.2V56.4706H184.975V52.7059Z" fill="white" />
        </mask>
        <g mask="url(#mask925_2057_43870)">
          <mask
            height="5"
            id="mask926_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="181"
            y="52"
          >
            <path d="M184.975 52.7059H181.2V56.4706H184.975V52.7059Z" fill="white" />
          </mask>
          <g mask="url(#mask926_2057_43870)">
            <path
              d="M181.2 52.7059L182.144 53.647M182.144 53.647L183.087 52.7059L184.031 53.647M182.144 53.647L183.087 54.5882M182.144 53.647L181.2 54.5882L182.144 55.5294M184.031 53.647L183.087 54.5882M184.031 53.647L184.975 52.7059M184.031 53.647L184.975 54.5882L184.031 55.5294M183.087 54.5882L182.144 55.5294M183.087 54.5882L184.031 55.5294M182.144 55.5294L183.087 56.4706L184.031 55.5294M182.144 55.5294L181.2 56.4706M184.031 55.5294L184.975 56.4706"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask927_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="196"
        y="52"
      >
        <path d="M200.075 52.7059H196.3V56.4706H200.075V52.7059Z" fill="white" />
      </mask>
      <g mask="url(#mask927_2057_43870)">
        <mask
          height="5"
          id="mask928_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="196"
          y="52"
        >
          <path d="M200.075 52.7059H196.3V56.4706H200.075V52.7059Z" fill="white" />
        </mask>
        <g mask="url(#mask928_2057_43870)">
          <mask
            height="5"
            id="mask929_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="196"
            y="52"
          >
            <path d="M200.075 52.7059H196.3V56.4706H200.075V52.7059Z" fill="white" />
          </mask>
          <g mask="url(#mask929_2057_43870)">
            <path
              d="M196.3 52.7059L197.244 53.647M197.244 53.647L198.188 52.7059L199.131 53.647M197.244 53.647L198.188 54.5882M197.244 53.647L196.3 54.5882L197.244 55.5294M199.131 53.647L198.188 54.5882M199.131 53.647L200.075 52.7059M199.131 53.647L200.075 54.5882L199.131 55.5294M198.188 54.5882L197.244 55.5294M198.188 54.5882L199.131 55.5294M197.244 55.5294L198.188 56.4706L199.131 55.5294M197.244 55.5294L196.3 56.4706M199.131 55.5294L200.075 56.4706"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask930_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="200"
        y="52"
      >
        <path d="M203.85 52.7059H200.075V56.4706H203.85V52.7059Z" fill="white" />
      </mask>
      <g mask="url(#mask930_2057_43870)">
        <mask
          height="5"
          id="mask931_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="200"
          y="52"
        >
          <path d="M203.85 52.7059H200.075V56.4706H203.85V52.7059Z" fill="white" />
        </mask>
        <g mask="url(#mask931_2057_43870)">
          <mask
            height="5"
            id="mask932_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="200"
            y="52"
          >
            <path d="M203.85 52.7059H200.075V56.4706H203.85V52.7059Z" fill="white" />
          </mask>
          <g mask="url(#mask932_2057_43870)">
            <path
              d="M200.075 52.7059L201.019 53.647M201.019 53.647L201.962 52.7059L202.906 53.647M201.019 53.647L201.962 54.5882M201.019 53.647L200.075 54.5882L201.019 55.5294M202.906 53.647L201.962 54.5882M202.906 53.647L203.85 52.7059M202.906 53.647L203.85 54.5882L202.906 55.5294M201.962 54.5882L201.019 55.5294M201.962 54.5882L202.906 55.5294M201.019 55.5294L201.962 56.4706L202.906 55.5294M201.019 55.5294L200.075 56.4706M202.906 55.5294L203.85 56.4706"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask933_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="203"
        y="52"
      >
        <path d="M207.625 52.7059H203.85V56.4706H207.625V52.7059Z" fill="white" />
      </mask>
      <g mask="url(#mask933_2057_43870)">
        <mask
          height="5"
          id="mask934_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="203"
          y="52"
        >
          <path d="M207.625 52.7059H203.85V56.4706H207.625V52.7059Z" fill="white" />
        </mask>
        <g mask="url(#mask934_2057_43870)">
          <mask
            height="5"
            id="mask935_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="203"
            y="52"
          >
            <path d="M207.625 52.7059H203.85V56.4706H207.625V52.7059Z" fill="white" />
          </mask>
          <g mask="url(#mask935_2057_43870)">
            <path
              d="M203.85 52.7059L204.794 53.647M204.794 53.647L205.737 52.7059L206.681 53.647M204.794 53.647L205.737 54.5882M204.794 53.647L203.85 54.5882L204.794 55.5294M206.681 53.647L205.737 54.5882M206.681 53.647L207.625 52.7059M206.681 53.647L207.625 54.5882L206.681 55.5294M205.737 54.5882L204.794 55.5294M205.737 54.5882L206.681 55.5294M204.794 55.5294L205.737 56.4706L206.681 55.5294M204.794 55.5294L203.85 56.4706M206.681 55.5294L207.625 56.4706"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask936_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="237"
        y="52"
      >
        <path d="M241.6 52.7059H237.825V56.4706H241.6V52.7059Z" fill="white" />
      </mask>
      <g mask="url(#mask936_2057_43870)">
        <mask
          height="5"
          id="mask937_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="237"
          y="52"
        >
          <path d="M241.6 52.7059H237.825V56.4706H241.6V52.7059Z" fill="white" />
        </mask>
        <g mask="url(#mask937_2057_43870)">
          <mask
            height="5"
            id="mask938_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="237"
            y="52"
          >
            <path d="M241.6 52.7059H237.825V56.4706H241.6V52.7059Z" fill="white" />
          </mask>
          <g mask="url(#mask938_2057_43870)">
            <path
              d="M237.825 52.7059L238.769 53.647M238.769 53.647L239.712 52.7059L240.656 53.647M238.769 53.647L239.712 54.5882M238.769 53.647L237.825 54.5882L238.769 55.5294M240.656 53.647L239.712 54.5882M240.656 53.647L241.6 52.7059M240.656 53.647L241.6 54.5882L240.656 55.5294M239.712 54.5882L238.769 55.5294M239.712 54.5882L240.656 55.5294M238.769 55.5294L239.712 56.4706L240.656 55.5294M238.769 55.5294L237.825 56.4706M240.656 55.5294L241.6 56.4706"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask939_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="241"
        y="52"
      >
        <path d="M245.375 52.7059H241.6V56.4706H245.375V52.7059Z" fill="white" />
      </mask>
      <g mask="url(#mask939_2057_43870)">
        <mask
          height="5"
          id="mask940_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="241"
          y="52"
        >
          <path d="M245.375 52.7059H241.6V56.4706H245.375V52.7059Z" fill="white" />
        </mask>
        <g mask="url(#mask940_2057_43870)">
          <mask
            height="5"
            id="mask941_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="241"
            y="52"
          >
            <path d="M245.375 52.7059H241.6V56.4706H245.375V52.7059Z" fill="white" />
          </mask>
          <g mask="url(#mask941_2057_43870)">
            <path
              d="M241.6 52.7059L242.544 53.647M242.544 53.647L243.487 52.7059L244.431 53.647M242.544 53.647L243.487 54.5882M242.544 53.647L241.6 54.5882L242.544 55.5294M244.431 53.647L243.487 54.5882M244.431 53.647L245.375 52.7059M244.431 53.647L245.375 54.5882L244.431 55.5294M243.487 54.5882L242.544 55.5294M243.487 54.5882L244.431 55.5294M242.544 55.5294L243.487 56.4706L244.431 55.5294M242.544 55.5294L241.6 56.4706M244.431 55.5294L245.375 56.4706"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask942_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="245"
        y="52"
      >
        <path d="M249.15 52.7059H245.375V56.4706H249.15V52.7059Z" fill="white" />
      </mask>
      <g mask="url(#mask942_2057_43870)">
        <mask
          height="5"
          id="mask943_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="245"
          y="52"
        >
          <path d="M249.15 52.7059H245.375V56.4706H249.15V52.7059Z" fill="white" />
        </mask>
        <g mask="url(#mask943_2057_43870)">
          <mask
            height="5"
            id="mask944_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="245"
            y="52"
          >
            <path d="M249.15 52.7059H245.375V56.4706H249.15V52.7059Z" fill="white" />
          </mask>
          <g mask="url(#mask944_2057_43870)">
            <path
              d="M245.375 52.7059L246.319 53.647M246.319 53.647L247.262 52.7059L248.206 53.647M246.319 53.647L247.262 54.5882M246.319 53.647L245.375 54.5882L246.319 55.5294M248.206 53.647L247.262 54.5882M248.206 53.647L249.15 52.7059M248.206 53.647L249.15 54.5882L248.206 55.5294M247.262 54.5882L246.319 55.5294M247.262 54.5882L248.206 55.5294M246.319 55.5294L247.262 56.4706L248.206 55.5294M246.319 55.5294L245.375 56.4706M248.206 55.5294L249.15 56.4706"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask945_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="283"
        y="52"
      >
        <path d="M286.9 52.7059H283.125V56.4706H286.9V52.7059Z" fill="white" />
      </mask>
      <g mask="url(#mask945_2057_43870)">
        <mask
          height="5"
          id="mask946_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="283"
          y="52"
        >
          <path d="M286.9 52.7059H283.125V56.4706H286.9V52.7059Z" fill="white" />
        </mask>
        <g mask="url(#mask946_2057_43870)">
          <mask
            height="5"
            id="mask947_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="283"
            y="52"
          >
            <path d="M286.9 52.7059H283.125V56.4706H286.9V52.7059Z" fill="white" />
          </mask>
          <g mask="url(#mask947_2057_43870)">
            <path
              d="M283.125 52.7059L284.069 53.647M284.069 53.647L285.012 52.7059L285.956 53.647M284.069 53.647L285.012 54.5882M284.069 53.647L283.125 54.5882L284.069 55.5294M285.956 53.647L285.012 54.5882M285.956 53.647L286.9 52.7059M285.956 53.647L286.9 54.5882L285.956 55.5294M285.012 54.5882L284.069 55.5294M285.012 54.5882L285.956 55.5294M284.069 55.5294L285.012 56.4706L285.956 55.5294M284.069 55.5294L283.125 56.4706M285.956 55.5294L286.9 56.4706"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask948_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="286"
        y="52"
      >
        <path d="M290.675 52.7059H286.9V56.4706H290.675V52.7059Z" fill="white" />
      </mask>
      <g mask="url(#mask948_2057_43870)">
        <mask
          height="5"
          id="mask949_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="286"
          y="52"
        >
          <path d="M290.675 52.7059H286.9V56.4706H290.675V52.7059Z" fill="white" />
        </mask>
        <g mask="url(#mask949_2057_43870)">
          <mask
            height="5"
            id="mask950_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="286"
            y="52"
          >
            <path d="M290.675 52.7059H286.9V56.4706H290.675V52.7059Z" fill="white" />
          </mask>
          <g mask="url(#mask950_2057_43870)">
            <path
              d="M286.9 52.7059L287.844 53.647M287.844 53.647L288.788 52.7059L289.731 53.647M287.844 53.647L288.788 54.5882M287.844 53.647L286.9 54.5882L287.844 55.5294M289.731 53.647L288.788 54.5882M289.731 53.647L290.675 52.7059M289.731 53.647L290.675 54.5882L289.731 55.5294M288.788 54.5882L287.844 55.5294M288.788 54.5882L289.731 55.5294M287.844 55.5294L288.788 56.4706L289.731 55.5294M287.844 55.5294L286.9 56.4706M289.731 55.5294L290.675 56.4706"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask951_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="290"
        y="52"
      >
        <path d="M294.45 52.7059H290.675V56.4706H294.45V52.7059Z" fill="white" />
      </mask>
      <g mask="url(#mask951_2057_43870)">
        <mask
          height="5"
          id="mask952_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="290"
          y="52"
        >
          <path d="M294.45 52.7059H290.675V56.4706H294.45V52.7059Z" fill="white" />
        </mask>
        <g mask="url(#mask952_2057_43870)">
          <mask
            height="5"
            id="mask953_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="290"
            y="52"
          >
            <path d="M294.45 52.7059H290.675V56.4706H294.45V52.7059Z" fill="white" />
          </mask>
          <g mask="url(#mask953_2057_43870)">
            <path
              d="M290.675 52.7059L291.619 53.647M291.619 53.647L292.563 52.7059L293.506 53.647M291.619 53.647L292.563 54.5882M291.619 53.647L290.675 54.5882L291.619 55.5294M293.506 53.647L292.563 54.5882M293.506 53.647L294.45 52.7059M293.506 53.647L294.45 54.5882L293.506 55.5294M292.563 54.5882L291.619 55.5294M292.563 54.5882L293.506 55.5294M291.619 55.5294L292.563 56.4706L293.506 55.5294M291.619 55.5294L290.675 56.4706M293.506 55.5294L294.45 56.4706"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="3"
        id="mask954_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="0"
        y="57"
      >
        <path d="M2.98143 57.1851H0.716431V59.4439H2.98143V57.1851Z" fill="white" />
      </mask>
      <g mask="url(#mask954_2057_43870)">
        <mask
          height="3"
          id="mask955_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="0"
          y="57"
        >
          <path d="M2.98143 57.1851H0.716431V59.4439H2.98143V57.1851Z" fill="white" />
        </mask>
        <g mask="url(#mask955_2057_43870)">
          <path
            d="M0.716431 57.1851L1.84893 58.3145M1.84893 58.3145L2.98143 57.1851M1.84893 58.3145L2.98143 59.4439M1.84893 58.3145L0.716431 59.4439"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask956_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="4"
        y="57"
      >
        <path d="M6.75646 57.1851H4.49146V59.4439H6.75646V57.1851Z" fill="white" />
      </mask>
      <g mask="url(#mask956_2057_43870)">
        <mask
          height="3"
          id="mask957_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="4"
          y="57"
        >
          <path d="M6.75646 57.1851H4.49146V59.4439H6.75646V57.1851Z" fill="white" />
        </mask>
        <g mask="url(#mask957_2057_43870)">
          <path
            d="M4.49146 57.1851L5.62396 58.3145M5.62396 58.3145L6.75646 57.1851M5.62396 58.3145L6.75646 59.4439M5.62396 58.3145L4.49146 59.4439"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask958_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="8"
        y="57"
      >
        <path d="M10.5315 57.1851H8.26648V59.4439H10.5315V57.1851Z" fill="white" />
      </mask>
      <g mask="url(#mask958_2057_43870)">
        <mask
          height="3"
          id="mask959_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="8"
          y="57"
        >
          <path d="M10.5315 57.1851H8.26648V59.4439H10.5315V57.1851Z" fill="white" />
        </mask>
        <g mask="url(#mask959_2057_43870)">
          <path
            d="M8.26648 57.1851L9.39898 58.3145M9.39898 58.3145L10.5315 57.1851M9.39898 58.3145L10.5315 59.4439M9.39898 58.3145L8.26648 59.4439"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask960_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="46"
        y="57"
      >
        <path d="M48.2815 57.1851H46.0165V59.4439H48.2815V57.1851Z" fill="white" />
      </mask>
      <g mask="url(#mask960_2057_43870)">
        <mask
          height="3"
          id="mask961_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="46"
          y="57"
        >
          <path d="M48.2815 57.1851H46.0165V59.4439H48.2815V57.1851Z" fill="white" />
        </mask>
        <g mask="url(#mask961_2057_43870)">
          <path
            d="M46.0165 57.1851L47.149 58.3145M47.149 58.3145L48.2815 57.1851M47.149 58.3145L48.2815 59.4439M47.149 58.3145L46.0165 59.4439"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask962_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="49"
        y="57"
      >
        <path d="M52.0565 57.1851H49.7915V59.4439H52.0565V57.1851Z" fill="white" />
      </mask>
      <g mask="url(#mask962_2057_43870)">
        <mask
          height="3"
          id="mask963_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="49"
          y="57"
        >
          <path d="M52.0565 57.1851H49.7915V59.4439H52.0565V57.1851Z" fill="white" />
        </mask>
        <g mask="url(#mask963_2057_43870)">
          <path
            d="M49.7915 57.1851L50.924 58.3145M50.924 58.3145L52.0565 57.1851M50.924 58.3145L52.0565 59.4439M50.924 58.3145L49.7915 59.4439"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="3"
        id="mask964_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="53"
        y="57"
      >
        <path d="M55.8315 57.1851H53.5665V59.4439H55.8315V57.1851Z" fill="white" />
      </mask>
      <g mask="url(#mask964_2057_43870)">
        <mask
          height="3"
          id="mask965_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="53"
          y="57"
        >
          <path d="M55.8315 57.1851H53.5665V59.4439H55.8315V57.1851Z" fill="white" />
        </mask>
        <g mask="url(#mask965_2057_43870)">
          <path
            d="M53.5665 57.1851L54.699 58.3145M54.699 58.3145L55.8315 57.1851M54.699 58.3145L55.8315 59.4439M54.699 58.3145L53.5665 59.4439"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="5"
        id="mask966_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="75"
        y="56"
      >
        <path d="M79.275 56.4706H75.5V60.2353H79.275V56.4706Z" fill="white" />
      </mask>
      <g mask="url(#mask966_2057_43870)">
        <mask
          height="5"
          id="mask967_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="75"
          y="56"
        >
          <path d="M79.275 56.4706H75.5V60.2353H79.275V56.4706Z" fill="white" />
        </mask>
        <g mask="url(#mask967_2057_43870)">
          <mask
            height="5"
            id="mask968_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="75"
            y="56"
          >
            <path d="M79.275 56.4706H75.5V60.2353H79.275V56.4706Z" fill="white" />
          </mask>
          <g mask="url(#mask968_2057_43870)">
            <path
              d="M75.5 56.4706L76.4437 57.4118M76.4437 57.4118L77.3875 56.4706L78.3312 57.4118M76.4437 57.4118L77.3875 58.3529M76.4437 57.4118L75.5 58.3529L76.4437 59.2941M78.3312 57.4118L77.3875 58.3529M78.3312 57.4118L79.275 56.4706M78.3312 57.4118L79.275 58.3529L78.3312 59.2941M77.3875 58.3529L76.4437 59.2941M77.3875 58.3529L78.3312 59.2941M76.4437 59.2941L77.3875 60.2353L78.3312 59.2941M76.4437 59.2941L75.5 60.2353M78.3312 59.2941L79.275 60.2353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask969_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="79"
        y="56"
      >
        <path d="M83.05 56.4706H79.275V60.2353H83.05V56.4706Z" fill="white" />
      </mask>
      <g mask="url(#mask969_2057_43870)">
        <mask
          height="5"
          id="mask970_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="79"
          y="56"
        >
          <path d="M83.05 56.4706H79.275V60.2353H83.05V56.4706Z" fill="white" />
        </mask>
        <g mask="url(#mask970_2057_43870)">
          <mask
            height="5"
            id="mask971_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="79"
            y="56"
          >
            <path d="M83.05 56.4706H79.275V60.2353H83.05V56.4706Z" fill="white" />
          </mask>
          <g mask="url(#mask971_2057_43870)">
            <path
              d="M79.275 56.4706L80.2188 57.4118M80.2188 57.4118L81.1625 56.4706L82.1063 57.4118M80.2188 57.4118L81.1625 58.3529M80.2188 57.4118L79.275 58.3529L80.2188 59.2941M82.1063 57.4118L81.1625 58.3529M82.1063 57.4118L83.05 56.4706M82.1063 57.4118L83.05 58.3529L82.1063 59.2941M81.1625 58.3529L80.2188 59.2941M81.1625 58.3529L82.1063 59.2941M80.2188 59.2941L81.1625 60.2353L82.1063 59.2941M80.2188 59.2941L79.275 60.2353M82.1063 59.2941L83.05 60.2353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask972_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="83"
        y="56"
      >
        <path d="M86.825 56.4706H83.05V60.2353H86.825V56.4706Z" fill="white" />
      </mask>
      <g mask="url(#mask972_2057_43870)">
        <mask
          height="5"
          id="mask973_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="83"
          y="56"
        >
          <path d="M86.825 56.4706H83.05V60.2353H86.825V56.4706Z" fill="white" />
        </mask>
        <g mask="url(#mask973_2057_43870)">
          <mask
            height="5"
            id="mask974_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="83"
            y="56"
          >
            <path d="M86.825 56.4706H83.05V60.2353H86.825V56.4706Z" fill="white" />
          </mask>
          <g mask="url(#mask974_2057_43870)">
            <path
              d="M83.05 56.4706L83.9938 57.4118M83.9938 57.4118L84.9375 56.4706L85.8813 57.4118M83.9938 57.4118L84.9375 58.3529M83.9938 57.4118L83.05 58.3529L83.9938 59.2941M85.8813 57.4118L84.9375 58.3529M85.8813 57.4118L86.825 56.4706M85.8813 57.4118L86.825 58.3529L85.8813 59.2941M84.9375 58.3529L83.9938 59.2941M84.9375 58.3529L85.8813 59.2941M83.9938 59.2941L84.9375 60.2353L85.8813 59.2941M83.9938 59.2941L83.05 60.2353M85.8813 59.2941L86.825 60.2353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask975_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="98"
        y="56"
      >
        <path d="M101.925 56.4706H98.15V60.2353H101.925V56.4706Z" fill="white" />
      </mask>
      <g mask="url(#mask975_2057_43870)">
        <mask
          height="5"
          id="mask976_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="98"
          y="56"
        >
          <path d="M101.925 56.4706H98.15V60.2353H101.925V56.4706Z" fill="white" />
        </mask>
        <g mask="url(#mask976_2057_43870)">
          <mask
            height="5"
            id="mask977_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="98"
            y="56"
          >
            <path d="M101.925 56.4706H98.15V60.2353H101.925V56.4706Z" fill="white" />
          </mask>
          <g mask="url(#mask977_2057_43870)">
            <path
              d="M98.15 56.4706L99.0938 57.4118M99.0938 57.4118L100.038 56.4706L100.981 57.4118M99.0938 57.4118L100.038 58.3529M99.0938 57.4118L98.15 58.3529L99.0938 59.2941M100.981 57.4118L100.038 58.3529M100.981 57.4118L101.925 56.4706M100.981 57.4118L101.925 58.3529L100.981 59.2941M100.038 58.3529L99.0938 59.2941M100.038 58.3529L100.981 59.2941M99.0938 59.2941L100.038 60.2353L100.981 59.2941M99.0938 59.2941L98.15 60.2353M100.981 59.2941L101.925 60.2353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask978_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="101"
        y="56"
      >
        <path d="M105.7 56.4706H101.925V60.2353H105.7V56.4706Z" fill="white" />
      </mask>
      <g mask="url(#mask978_2057_43870)">
        <mask
          height="5"
          id="mask979_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="101"
          y="56"
        >
          <path d="M105.7 56.4706H101.925V60.2353H105.7V56.4706Z" fill="white" />
        </mask>
        <g mask="url(#mask979_2057_43870)">
          <mask
            height="5"
            id="mask980_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="101"
            y="56"
          >
            <path d="M105.7 56.4706H101.925V60.2353H105.7V56.4706Z" fill="white" />
          </mask>
          <g mask="url(#mask980_2057_43870)">
            <path
              d="M101.925 56.4706L102.869 57.4118M102.869 57.4118L103.813 56.4706L104.756 57.4118M102.869 57.4118L103.813 58.3529M102.869 57.4118L101.925 58.3529L102.869 59.2941M104.756 57.4118L103.813 58.3529M104.756 57.4118L105.7 56.4706M104.756 57.4118L105.7 58.3529L104.756 59.2941M103.813 58.3529L102.869 59.2941M103.813 58.3529L104.756 59.2941M102.869 59.2941L103.813 60.2353L104.756 59.2941M102.869 59.2941L101.925 60.2353M104.756 59.2941L105.7 60.2353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask981_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="105"
        y="56"
      >
        <path d="M109.475 56.4706H105.7V60.2353H109.475V56.4706Z" fill="white" />
      </mask>
      <g mask="url(#mask981_2057_43870)">
        <mask
          height="5"
          id="mask982_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="105"
          y="56"
        >
          <path d="M109.475 56.4706H105.7V60.2353H109.475V56.4706Z" fill="white" />
        </mask>
        <g mask="url(#mask982_2057_43870)">
          <mask
            height="5"
            id="mask983_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="105"
            y="56"
          >
            <path d="M109.475 56.4706H105.7V60.2353H109.475V56.4706Z" fill="white" />
          </mask>
          <g mask="url(#mask983_2057_43870)">
            <path
              d="M105.7 56.4706L106.644 57.4118M106.644 57.4118L107.587 56.4706L108.531 57.4118M106.644 57.4118L107.587 58.3529M106.644 57.4118L105.7 58.3529L106.644 59.2941M108.531 57.4118L107.587 58.3529M108.531 57.4118L109.475 56.4706M108.531 57.4118L109.475 58.3529L108.531 59.2941M107.587 58.3529L106.644 59.2941M107.587 58.3529L108.531 59.2941M106.644 59.2941L107.587 60.2353L108.531 59.2941M106.644 59.2941L105.7 60.2353M108.531 59.2941L109.475 60.2353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask984_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="132"
        y="56"
      >
        <path d="M135.9 56.4706H132.125V60.2353H135.9V56.4706Z" fill="white" />
      </mask>
      <g mask="url(#mask984_2057_43870)">
        <mask
          height="5"
          id="mask985_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="132"
          y="56"
        >
          <path d="M135.9 56.4706H132.125V60.2353H135.9V56.4706Z" fill="white" />
        </mask>
        <g mask="url(#mask985_2057_43870)">
          <mask
            height="5"
            id="mask986_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="132"
            y="56"
          >
            <path d="M135.9 56.4706H132.125V60.2353H135.9V56.4706Z" fill="white" />
          </mask>
          <g mask="url(#mask986_2057_43870)">
            <path
              d="M132.125 56.4706L133.069 57.4118M133.069 57.4118L134.012 56.4706L134.956 57.4118M133.069 57.4118L134.012 58.3529M133.069 57.4118L132.125 58.3529L133.069 59.2941M134.956 57.4118L134.012 58.3529M134.956 57.4118L135.9 56.4706M134.956 57.4118L135.9 58.3529L134.956 59.2941M134.012 58.3529L133.069 59.2941M134.012 58.3529L134.956 59.2941M133.069 59.2941L134.012 60.2353L134.956 59.2941M133.069 59.2941L132.125 60.2353M134.956 59.2941L135.9 60.2353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask987_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="135"
        y="56"
      >
        <path d="M139.675 56.4706H135.9V60.2353H139.675V56.4706Z" fill="white" />
      </mask>
      <g mask="url(#mask987_2057_43870)">
        <mask
          height="5"
          id="mask988_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="135"
          y="56"
        >
          <path d="M139.675 56.4706H135.9V60.2353H139.675V56.4706Z" fill="white" />
        </mask>
        <g mask="url(#mask988_2057_43870)">
          <mask
            height="5"
            id="mask989_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="135"
            y="56"
          >
            <path d="M139.675 56.4706H135.9V60.2353H139.675V56.4706Z" fill="white" />
          </mask>
          <g mask="url(#mask989_2057_43870)">
            <path
              d="M135.9 56.4706L136.844 57.4118M136.844 57.4118L137.788 56.4706L138.731 57.4118M136.844 57.4118L137.788 58.3529M136.844 57.4118L135.9 58.3529L136.844 59.2941M138.731 57.4118L137.788 58.3529M138.731 57.4118L139.675 56.4706M138.731 57.4118L139.675 58.3529L138.731 59.2941M137.788 58.3529L136.844 59.2941M137.788 58.3529L138.731 59.2941M136.844 59.2941L137.788 60.2353L138.731 59.2941M136.844 59.2941L135.9 60.2353M138.731 59.2941L139.675 60.2353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask990_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="139"
        y="56"
      >
        <path d="M143.45 56.4706H139.675V60.2353H143.45V56.4706Z" fill="white" />
      </mask>
      <g mask="url(#mask990_2057_43870)">
        <mask
          height="5"
          id="mask991_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="139"
          y="56"
        >
          <path d="M143.45 56.4706H139.675V60.2353H143.45V56.4706Z" fill="white" />
        </mask>
        <g mask="url(#mask991_2057_43870)">
          <mask
            height="5"
            id="mask992_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="139"
            y="56"
          >
            <path d="M143.45 56.4706H139.675V60.2353H143.45V56.4706Z" fill="white" />
          </mask>
          <g mask="url(#mask992_2057_43870)">
            <path
              d="M139.675 56.4706L140.619 57.4118M140.619 57.4118L141.563 56.4706L142.506 57.4118M140.619 57.4118L141.563 58.3529M140.619 57.4118L139.675 58.3529L140.619 59.2941M142.506 57.4118L141.563 58.3529M142.506 57.4118L143.45 56.4706M142.506 57.4118L143.45 58.3529L142.506 59.2941M141.563 58.3529L140.619 59.2941M141.563 58.3529L142.506 59.2941M140.619 59.2941L141.563 60.2353L142.506 59.2941M140.619 59.2941L139.675 60.2353M142.506 59.2941L143.45 60.2353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask993_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="173"
        y="56"
      >
        <path d="M177.425 56.4706H173.65V60.2353H177.425V56.4706Z" fill="white" />
      </mask>
      <g mask="url(#mask993_2057_43870)">
        <mask
          height="5"
          id="mask994_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="173"
          y="56"
        >
          <path d="M177.425 56.4706H173.65V60.2353H177.425V56.4706Z" fill="white" />
        </mask>
        <g mask="url(#mask994_2057_43870)">
          <mask
            height="5"
            id="mask995_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="173"
            y="56"
          >
            <path d="M177.425 56.4706H173.65V60.2353H177.425V56.4706Z" fill="white" />
          </mask>
          <g mask="url(#mask995_2057_43870)">
            <path
              d="M173.65 56.4706L174.594 57.4118M174.594 57.4118L175.538 56.4706L176.481 57.4118M174.594 57.4118L175.538 58.3529M174.594 57.4118L173.65 58.3529L174.594 59.2941M176.481 57.4118L175.538 58.3529M176.481 57.4118L177.425 56.4706M176.481 57.4118L177.425 58.3529L176.481 59.2941M175.538 58.3529L174.594 59.2941M175.538 58.3529L176.481 59.2941M174.594 59.2941L175.538 60.2353L176.481 59.2941M174.594 59.2941L173.65 60.2353M176.481 59.2941L177.425 60.2353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask996_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="177"
        y="56"
      >
        <path d="M181.2 56.4706H177.425V60.2353H181.2V56.4706Z" fill="white" />
      </mask>
      <g mask="url(#mask996_2057_43870)">
        <mask
          height="5"
          id="mask997_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="177"
          y="56"
        >
          <path d="M181.2 56.4706H177.425V60.2353H181.2V56.4706Z" fill="white" />
        </mask>
        <g mask="url(#mask997_2057_43870)">
          <mask
            height="5"
            id="mask998_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="177"
            y="56"
          >
            <path d="M181.2 56.4706H177.425V60.2353H181.2V56.4706Z" fill="white" />
          </mask>
          <g mask="url(#mask998_2057_43870)">
            <path
              d="M177.425 56.4706L178.369 57.4118M178.369 57.4118L179.313 56.4706L180.256 57.4118M178.369 57.4118L179.313 58.3529M178.369 57.4118L177.425 58.3529L178.369 59.2941M180.256 57.4118L179.313 58.3529M180.256 57.4118L181.2 56.4706M180.256 57.4118L181.2 58.3529L180.256 59.2941M179.313 58.3529L178.369 59.2941M179.313 58.3529L180.256 59.2941M178.369 59.2941L179.313 60.2353L180.256 59.2941M178.369 59.2941L177.425 60.2353M180.256 59.2941L181.2 60.2353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask999_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="181"
        y="56"
      >
        <path d="M184.975 56.4706H181.2V60.2353H184.975V56.4706Z" fill="white" />
      </mask>
      <g mask="url(#mask999_2057_43870)">
        <mask
          height="5"
          id="mask1000_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="181"
          y="56"
        >
          <path d="M184.975 56.4706H181.2V60.2353H184.975V56.4706Z" fill="white" />
        </mask>
        <g mask="url(#mask1000_2057_43870)">
          <mask
            height="5"
            id="mask1001_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="181"
            y="56"
          >
            <path d="M184.975 56.4706H181.2V60.2353H184.975V56.4706Z" fill="white" />
          </mask>
          <g mask="url(#mask1001_2057_43870)">
            <path
              d="M181.2 56.4706L182.144 57.4118M182.144 57.4118L183.087 56.4706L184.031 57.4118M182.144 57.4118L183.087 58.3529M182.144 57.4118L181.2 58.3529L182.144 59.2941M184.031 57.4118L183.087 58.3529M184.031 57.4118L184.975 56.4706M184.031 57.4118L184.975 58.3529L184.031 59.2941M183.087 58.3529L182.144 59.2941M183.087 58.3529L184.031 59.2941M182.144 59.2941L183.087 60.2353L184.031 59.2941M182.144 59.2941L181.2 60.2353M184.031 59.2941L184.975 60.2353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask1002_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="196"
        y="56"
      >
        <path d="M200.075 56.4706H196.3V60.2353H200.075V56.4706Z" fill="white" />
      </mask>
      <g mask="url(#mask1002_2057_43870)">
        <mask
          height="5"
          id="mask1003_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="196"
          y="56"
        >
          <path d="M200.075 56.4706H196.3V60.2353H200.075V56.4706Z" fill="white" />
        </mask>
        <g mask="url(#mask1003_2057_43870)">
          <mask
            height="5"
            id="mask1004_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="196"
            y="56"
          >
            <path d="M200.075 56.4706H196.3V60.2353H200.075V56.4706Z" fill="white" />
          </mask>
          <g mask="url(#mask1004_2057_43870)">
            <path
              d="M196.3 56.4706L197.244 57.4118M197.244 57.4118L198.188 56.4706L199.131 57.4118M197.244 57.4118L198.188 58.3529M197.244 57.4118L196.3 58.3529L197.244 59.2941M199.131 57.4118L198.188 58.3529M199.131 57.4118L200.075 56.4706M199.131 57.4118L200.075 58.3529L199.131 59.2941M198.188 58.3529L197.244 59.2941M198.188 58.3529L199.131 59.2941M197.244 59.2941L198.188 60.2353L199.131 59.2941M197.244 59.2941L196.3 60.2353M199.131 59.2941L200.075 60.2353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask1005_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="200"
        y="56"
      >
        <path d="M203.85 56.4706H200.075V60.2353H203.85V56.4706Z" fill="white" />
      </mask>
      <g mask="url(#mask1005_2057_43870)">
        <mask
          height="5"
          id="mask1006_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="200"
          y="56"
        >
          <path d="M203.85 56.4706H200.075V60.2353H203.85V56.4706Z" fill="white" />
        </mask>
        <g mask="url(#mask1006_2057_43870)">
          <mask
            height="5"
            id="mask1007_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="200"
            y="56"
          >
            <path d="M203.85 56.4706H200.075V60.2353H203.85V56.4706Z" fill="white" />
          </mask>
          <g mask="url(#mask1007_2057_43870)">
            <path
              d="M200.075 56.4706L201.019 57.4118M201.019 57.4118L201.962 56.4706L202.906 57.4118M201.019 57.4118L201.962 58.3529M201.019 57.4118L200.075 58.3529L201.019 59.2941M202.906 57.4118L201.962 58.3529M202.906 57.4118L203.85 56.4706M202.906 57.4118L203.85 58.3529L202.906 59.2941M201.962 58.3529L201.019 59.2941M201.962 58.3529L202.906 59.2941M201.019 59.2941L201.962 60.2353L202.906 59.2941M201.019 59.2941L200.075 60.2353M202.906 59.2941L203.85 60.2353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask1008_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="203"
        y="56"
      >
        <path d="M207.625 56.4706H203.85V60.2353H207.625V56.4706Z" fill="white" />
      </mask>
      <g mask="url(#mask1008_2057_43870)">
        <mask
          height="5"
          id="mask1009_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="203"
          y="56"
        >
          <path d="M207.625 56.4706H203.85V60.2353H207.625V56.4706Z" fill="white" />
        </mask>
        <g mask="url(#mask1009_2057_43870)">
          <mask
            height="5"
            id="mask1010_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="203"
            y="56"
          >
            <path d="M207.625 56.4706H203.85V60.2353H207.625V56.4706Z" fill="white" />
          </mask>
          <g mask="url(#mask1010_2057_43870)">
            <path
              d="M203.85 56.4706L204.794 57.4118M204.794 57.4118L205.737 56.4706L206.681 57.4118M204.794 57.4118L205.737 58.3529M204.794 57.4118L203.85 58.3529L204.794 59.2941M206.681 57.4118L205.737 58.3529M206.681 57.4118L207.625 56.4706M206.681 57.4118L207.625 58.3529L206.681 59.2941M205.737 58.3529L204.794 59.2941M205.737 58.3529L206.681 59.2941M204.794 59.2941L205.737 60.2353L206.681 59.2941M204.794 59.2941L203.85 60.2353M206.681 59.2941L207.625 60.2353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask1011_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="237"
        y="56"
      >
        <path d="M241.6 56.4706H237.825V60.2353H241.6V56.4706Z" fill="white" />
      </mask>
      <g mask="url(#mask1011_2057_43870)">
        <mask
          height="5"
          id="mask1012_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="237"
          y="56"
        >
          <path d="M241.6 56.4706H237.825V60.2353H241.6V56.4706Z" fill="white" />
        </mask>
        <g mask="url(#mask1012_2057_43870)">
          <mask
            height="5"
            id="mask1013_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="237"
            y="56"
          >
            <path d="M241.6 56.4706H237.825V60.2353H241.6V56.4706Z" fill="white" />
          </mask>
          <g mask="url(#mask1013_2057_43870)">
            <path
              d="M237.825 56.4706L238.769 57.4118M238.769 57.4118L239.712 56.4706L240.656 57.4118M238.769 57.4118L239.712 58.3529M238.769 57.4118L237.825 58.3529L238.769 59.2941M240.656 57.4118L239.712 58.3529M240.656 57.4118L241.6 56.4706M240.656 57.4118L241.6 58.3529L240.656 59.2941M239.712 58.3529L238.769 59.2941M239.712 58.3529L240.656 59.2941M238.769 59.2941L239.712 60.2353L240.656 59.2941M238.769 59.2941L237.825 60.2353M240.656 59.2941L241.6 60.2353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask1014_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="241"
        y="56"
      >
        <path d="M245.375 56.4706H241.6V60.2353H245.375V56.4706Z" fill="white" />
      </mask>
      <g mask="url(#mask1014_2057_43870)">
        <mask
          height="5"
          id="mask1015_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="241"
          y="56"
        >
          <path d="M245.375 56.4706H241.6V60.2353H245.375V56.4706Z" fill="white" />
        </mask>
        <g mask="url(#mask1015_2057_43870)">
          <mask
            height="5"
            id="mask1016_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="241"
            y="56"
          >
            <path d="M245.375 56.4706H241.6V60.2353H245.375V56.4706Z" fill="white" />
          </mask>
          <g mask="url(#mask1016_2057_43870)">
            <path
              d="M241.6 56.4706L242.544 57.4118M242.544 57.4118L243.487 56.4706L244.431 57.4118M242.544 57.4118L243.487 58.3529M242.544 57.4118L241.6 58.3529L242.544 59.2941M244.431 57.4118L243.487 58.3529M244.431 57.4118L245.375 56.4706M244.431 57.4118L245.375 58.3529L244.431 59.2941M243.487 58.3529L242.544 59.2941M243.487 58.3529L244.431 59.2941M242.544 59.2941L243.487 60.2353L244.431 59.2941M242.544 59.2941L241.6 60.2353M244.431 59.2941L245.375 60.2353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask1017_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="245"
        y="56"
      >
        <path d="M249.15 56.4706H245.375V60.2353H249.15V56.4706Z" fill="white" />
      </mask>
      <g mask="url(#mask1017_2057_43870)">
        <mask
          height="5"
          id="mask1018_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="245"
          y="56"
        >
          <path d="M249.15 56.4706H245.375V60.2353H249.15V56.4706Z" fill="white" />
        </mask>
        <g mask="url(#mask1018_2057_43870)">
          <mask
            height="5"
            id="mask1019_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="245"
            y="56"
          >
            <path d="M249.15 56.4706H245.375V60.2353H249.15V56.4706Z" fill="white" />
          </mask>
          <g mask="url(#mask1019_2057_43870)">
            <path
              d="M245.375 56.4706L246.319 57.4118M246.319 57.4118L247.262 56.4706L248.206 57.4118M246.319 57.4118L247.262 58.3529M246.319 57.4118L245.375 58.3529L246.319 59.2941M248.206 57.4118L247.262 58.3529M248.206 57.4118L249.15 56.4706M248.206 57.4118L249.15 58.3529L248.206 59.2941M247.262 58.3529L246.319 59.2941M247.262 58.3529L248.206 59.2941M246.319 59.2941L247.262 60.2353L248.206 59.2941M246.319 59.2941L245.375 60.2353M248.206 59.2941L249.15 60.2353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask1020_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="283"
        y="56"
      >
        <path d="M286.9 56.4706H283.125V60.2353H286.9V56.4706Z" fill="white" />
      </mask>
      <g mask="url(#mask1020_2057_43870)">
        <mask
          height="5"
          id="mask1021_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="283"
          y="56"
        >
          <path d="M286.9 56.4706H283.125V60.2353H286.9V56.4706Z" fill="white" />
        </mask>
        <g mask="url(#mask1021_2057_43870)">
          <mask
            height="5"
            id="mask1022_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="283"
            y="56"
          >
            <path d="M286.9 56.4706H283.125V60.2353H286.9V56.4706Z" fill="white" />
          </mask>
          <g mask="url(#mask1022_2057_43870)">
            <path
              d="M283.125 56.4706L284.069 57.4118M284.069 57.4118L285.012 56.4706L285.956 57.4118M284.069 57.4118L285.012 58.3529M284.069 57.4118L283.125 58.3529L284.069 59.2941M285.956 57.4118L285.012 58.3529M285.956 57.4118L286.9 56.4706M285.956 57.4118L286.9 58.3529L285.956 59.2941M285.012 58.3529L284.069 59.2941M285.012 58.3529L285.956 59.2941M284.069 59.2941L285.012 60.2353L285.956 59.2941M284.069 59.2941L283.125 60.2353M285.956 59.2941L286.9 60.2353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask1023_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="286"
        y="56"
      >
        <path d="M290.675 56.4706H286.9V60.2353H290.675V56.4706Z" fill="white" />
      </mask>
      <g mask="url(#mask1023_2057_43870)">
        <mask
          height="5"
          id="mask1024_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="286"
          y="56"
        >
          <path d="M290.675 56.4706H286.9V60.2353H290.675V56.4706Z" fill="white" />
        </mask>
        <g mask="url(#mask1024_2057_43870)">
          <mask
            height="5"
            id="mask1025_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="286"
            y="56"
          >
            <path d="M290.675 56.4706H286.9V60.2353H290.675V56.4706Z" fill="white" />
          </mask>
          <g mask="url(#mask1025_2057_43870)">
            <path
              d="M286.9 56.4706L287.844 57.4118M287.844 57.4118L288.788 56.4706L289.731 57.4118M287.844 57.4118L288.788 58.3529M287.844 57.4118L286.9 58.3529L287.844 59.2941M289.731 57.4118L288.788 58.3529M289.731 57.4118L290.675 56.4706M289.731 57.4118L290.675 58.3529L289.731 59.2941M288.788 58.3529L287.844 59.2941M288.788 58.3529L289.731 59.2941M287.844 59.2941L288.788 60.2353L289.731 59.2941M287.844 59.2941L286.9 60.2353M289.731 59.2941L290.675 60.2353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="5"
        id="mask1026_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="290"
        y="56"
      >
        <path d="M294.45 56.4706H290.675V60.2353H294.45V56.4706Z" fill="white" />
      </mask>
      <g mask="url(#mask1026_2057_43870)">
        <mask
          height="5"
          id="mask1027_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="290"
          y="56"
        >
          <path d="M294.45 56.4706H290.675V60.2353H294.45V56.4706Z" fill="white" />
        </mask>
        <g mask="url(#mask1027_2057_43870)">
          <mask
            height="5"
            id="mask1028_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="290"
            y="56"
          >
            <path d="M294.45 56.4706H290.675V60.2353H294.45V56.4706Z" fill="white" />
          </mask>
          <g mask="url(#mask1028_2057_43870)">
            <path
              d="M290.675 56.4706L291.619 57.4118M291.619 57.4118L292.563 56.4706L293.506 57.4118M291.619 57.4118L292.563 58.3529M291.619 57.4118L290.675 58.3529L291.619 59.2941M293.506 57.4118L292.563 58.3529M293.506 57.4118L294.45 56.4706M293.506 57.4118L294.45 58.3529L293.506 59.2941M292.563 58.3529L291.619 59.2941M292.563 58.3529L293.506 59.2941M291.619 59.2941L292.563 60.2353L293.506 59.2941M291.619 59.2941L290.675 60.2353M293.506 59.2941L294.45 60.2353"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask1029_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="0"
        y="60"
      >
        <path d="M2.98143 60.9498H0.716431V63.2087H2.98143V60.9498Z" fill="white" />
      </mask>
      <g mask="url(#mask1029_2057_43870)">
        <mask
          height="4"
          id="mask1030_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="0"
          y="60"
        >
          <path d="M2.98143 60.9498H0.716431V63.2087H2.98143V60.9498Z" fill="white" />
        </mask>
        <g mask="url(#mask1030_2057_43870)">
          <path
            d="M0.716431 60.9498L1.84893 62.0792M1.84893 62.0792L2.98143 60.9498M1.84893 62.0792L2.98143 63.2087M1.84893 62.0792L0.716431 63.2087"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="4"
        id="mask1031_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="4"
        y="60"
      >
        <path d="M6.75646 60.9498H4.49146V63.2087H6.75646V60.9498Z" fill="white" />
      </mask>
      <g mask="url(#mask1031_2057_43870)">
        <mask
          height="4"
          id="mask1032_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="4"
          y="60"
        >
          <path d="M6.75646 60.9498H4.49146V63.2087H6.75646V60.9498Z" fill="white" />
        </mask>
        <g mask="url(#mask1032_2057_43870)">
          <path
            d="M4.49146 60.9498L5.62396 62.0792M5.62396 62.0792L6.75646 60.9498M5.62396 62.0792L6.75646 63.2087M5.62396 62.0792L4.49146 63.2087"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="4"
        id="mask1033_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="8"
        y="60"
      >
        <path d="M10.5315 60.9498H8.26648V63.2087H10.5315V60.9498Z" fill="white" />
      </mask>
      <g mask="url(#mask1033_2057_43870)">
        <mask
          height="4"
          id="mask1034_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="8"
          y="60"
        >
          <path d="M10.5315 60.9498H8.26648V63.2087H10.5315V60.9498Z" fill="white" />
        </mask>
        <g mask="url(#mask1034_2057_43870)">
          <path
            d="M8.26648 60.9498L9.39898 62.0792M9.39898 62.0792L10.5315 60.9498M9.39898 62.0792L10.5315 63.2087M9.39898 62.0792L8.26648 63.2087"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="4"
        id="mask1035_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="46"
        y="60"
      >
        <path d="M48.2815 60.9498H46.0165V63.2087H48.2815V60.9498Z" fill="white" />
      </mask>
      <g mask="url(#mask1035_2057_43870)">
        <mask
          height="4"
          id="mask1036_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="46"
          y="60"
        >
          <path d="M48.2815 60.9498H46.0165V63.2087H48.2815V60.9498Z" fill="white" />
        </mask>
        <g mask="url(#mask1036_2057_43870)">
          <path
            d="M46.0165 60.9498L47.149 62.0792M47.149 62.0792L48.2815 60.9498M47.149 62.0792L48.2815 63.2087M47.149 62.0792L46.0165 63.2087"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="4"
        id="mask1037_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="49"
        y="60"
      >
        <path d="M52.0565 60.9498H49.7915V63.2087H52.0565V60.9498Z" fill="white" />
      </mask>
      <g mask="url(#mask1037_2057_43870)">
        <mask
          height="4"
          id="mask1038_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="49"
          y="60"
        >
          <path d="M52.0565 60.9498H49.7915V63.2087H52.0565V60.9498Z" fill="white" />
        </mask>
        <g mask="url(#mask1038_2057_43870)">
          <path
            d="M49.7915 60.9498L50.924 62.0792M50.924 62.0792L52.0565 60.9498M50.924 62.0792L52.0565 63.2087M50.924 62.0792L49.7915 63.2087"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="4"
        id="mask1039_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="3"
        x="53"
        y="60"
      >
        <path d="M55.8315 60.9498H53.5665V63.2087H55.8315V60.9498Z" fill="white" />
      </mask>
      <g mask="url(#mask1039_2057_43870)">
        <mask
          height="4"
          id="mask1040_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="3"
          x="53"
          y="60"
        >
          <path d="M55.8315 60.9498H53.5665V63.2087H55.8315V60.9498Z" fill="white" />
        </mask>
        <g mask="url(#mask1040_2057_43870)">
          <path
            d="M53.5665 60.9498L54.699 62.0792M54.699 62.0792L55.8315 60.9498M54.699 62.0792L55.8315 63.2087M54.699 62.0792L53.5665 63.2087"
            stroke="#863DFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
      <mask
        height="4"
        id="mask1041_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="75"
        y="60"
      >
        <path d="M79.275 60.2353H75.5V64H79.275V60.2353Z" fill="white" />
      </mask>
      <g mask="url(#mask1041_2057_43870)">
        <mask
          height="4"
          id="mask1042_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="75"
          y="60"
        >
          <path d="M79.275 60.2353H75.5V64H79.275V60.2353Z" fill="white" />
        </mask>
        <g mask="url(#mask1042_2057_43870)">
          <mask
            height="4"
            id="mask1043_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="75"
            y="60"
          >
            <path d="M79.275 60.2353H75.5V64H79.275V60.2353Z" fill="white" />
          </mask>
          <g mask="url(#mask1043_2057_43870)">
            <path
              d="M75.5 60.2353L76.4437 61.1765M76.4437 61.1765L77.3875 60.2353L78.3312 61.1765M76.4437 61.1765L77.3875 62.1176M76.4437 61.1765L75.5 62.1176L76.4437 63.0588M78.3312 61.1765L77.3875 62.1176M78.3312 61.1765L79.275 60.2353M78.3312 61.1765L79.275 62.1176L78.3312 63.0588M77.3875 62.1176L76.4437 63.0588M77.3875 62.1176L78.3312 63.0588M76.4437 63.0588L77.3875 64L78.3312 63.0588M76.4437 63.0588L75.5 64M78.3312 63.0588L79.275 64"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask1044_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="79"
        y="60"
      >
        <path d="M83.05 60.2353H79.275V64H83.05V60.2353Z" fill="white" />
      </mask>
      <g mask="url(#mask1044_2057_43870)">
        <mask
          height="4"
          id="mask1045_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="79"
          y="60"
        >
          <path d="M83.05 60.2353H79.275V64H83.05V60.2353Z" fill="white" />
        </mask>
        <g mask="url(#mask1045_2057_43870)">
          <mask
            height="4"
            id="mask1046_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="79"
            y="60"
          >
            <path d="M83.05 60.2353H79.275V64H83.05V60.2353Z" fill="white" />
          </mask>
          <g mask="url(#mask1046_2057_43870)">
            <path
              d="M79.275 60.2353L80.2188 61.1765M80.2188 61.1765L81.1625 60.2353L82.1063 61.1765M80.2188 61.1765L81.1625 62.1176M80.2188 61.1765L79.275 62.1176L80.2188 63.0588M82.1063 61.1765L81.1625 62.1176M82.1063 61.1765L83.05 60.2353M82.1063 61.1765L83.05 62.1176L82.1063 63.0588M81.1625 62.1176L80.2188 63.0588M81.1625 62.1176L82.1063 63.0588M80.2188 63.0588L81.1625 64L82.1063 63.0588M80.2188 63.0588L79.275 64M82.1063 63.0588L83.05 64"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask1047_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="83"
        y="60"
      >
        <path d="M86.825 60.2353H83.05V64H86.825V60.2353Z" fill="white" />
      </mask>
      <g mask="url(#mask1047_2057_43870)">
        <mask
          height="4"
          id="mask1048_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="83"
          y="60"
        >
          <path d="M86.825 60.2353H83.05V64H86.825V60.2353Z" fill="white" />
        </mask>
        <g mask="url(#mask1048_2057_43870)">
          <mask
            height="4"
            id="mask1049_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="83"
            y="60"
          >
            <path d="M86.825 60.2353H83.05V64H86.825V60.2353Z" fill="white" />
          </mask>
          <g mask="url(#mask1049_2057_43870)">
            <path
              d="M83.05 60.2353L83.9938 61.1765M83.9938 61.1765L84.9375 60.2353L85.8813 61.1765M83.9938 61.1765L84.9375 62.1176M83.9938 61.1765L83.05 62.1176L83.9938 63.0588M85.8813 61.1765L84.9375 62.1176M85.8813 61.1765L86.825 60.2353M85.8813 61.1765L86.825 62.1176L85.8813 63.0588M84.9375 62.1176L83.9938 63.0588M84.9375 62.1176L85.8813 63.0588M83.9938 63.0588L84.9375 64L85.8813 63.0588M83.9938 63.0588L83.05 64M85.8813 63.0588L86.825 64"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask1050_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="98"
        y="60"
      >
        <path d="M101.925 60.2353H98.15V64H101.925V60.2353Z" fill="white" />
      </mask>
      <g mask="url(#mask1050_2057_43870)">
        <mask
          height="4"
          id="mask1051_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="98"
          y="60"
        >
          <path d="M101.925 60.2353H98.15V64H101.925V60.2353Z" fill="white" />
        </mask>
        <g mask="url(#mask1051_2057_43870)">
          <mask
            height="4"
            id="mask1052_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="98"
            y="60"
          >
            <path d="M101.925 60.2353H98.15V64H101.925V60.2353Z" fill="white" />
          </mask>
          <g mask="url(#mask1052_2057_43870)">
            <path
              d="M98.15 60.2353L99.0938 61.1765M99.0938 61.1765L100.038 60.2353L100.981 61.1765M99.0938 61.1765L100.038 62.1176M99.0938 61.1765L98.15 62.1176L99.0938 63.0588M100.981 61.1765L100.038 62.1176M100.981 61.1765L101.925 60.2353M100.981 61.1765L101.925 62.1176L100.981 63.0588M100.038 62.1176L99.0938 63.0588M100.038 62.1176L100.981 63.0588M99.0938 63.0588L100.038 64L100.981 63.0588M99.0938 63.0588L98.15 64M100.981 63.0588L101.925 64"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask1053_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="101"
        y="60"
      >
        <path d="M105.7 60.2353H101.925V64H105.7V60.2353Z" fill="white" />
      </mask>
      <g mask="url(#mask1053_2057_43870)">
        <mask
          height="4"
          id="mask1054_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="101"
          y="60"
        >
          <path d="M105.7 60.2353H101.925V64H105.7V60.2353Z" fill="white" />
        </mask>
        <g mask="url(#mask1054_2057_43870)">
          <mask
            height="4"
            id="mask1055_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="101"
            y="60"
          >
            <path d="M105.7 60.2353H101.925V64H105.7V60.2353Z" fill="white" />
          </mask>
          <g mask="url(#mask1055_2057_43870)">
            <path
              d="M101.925 60.2353L102.869 61.1765M102.869 61.1765L103.813 60.2353L104.756 61.1765M102.869 61.1765L103.813 62.1176M102.869 61.1765L101.925 62.1176L102.869 63.0588M104.756 61.1765L103.813 62.1176M104.756 61.1765L105.7 60.2353M104.756 61.1765L105.7 62.1176L104.756 63.0588M103.813 62.1176L102.869 63.0588M103.813 62.1176L104.756 63.0588M102.869 63.0588L103.813 64L104.756 63.0588M102.869 63.0588L101.925 64M104.756 63.0588L105.7 64"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask1056_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="105"
        y="60"
      >
        <path d="M109.475 60.2353H105.7V64H109.475V60.2353Z" fill="white" />
      </mask>
      <g mask="url(#mask1056_2057_43870)">
        <mask
          height="4"
          id="mask1057_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="105"
          y="60"
        >
          <path d="M109.475 60.2353H105.7V64H109.475V60.2353Z" fill="white" />
        </mask>
        <g mask="url(#mask1057_2057_43870)">
          <mask
            height="4"
            id="mask1058_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="105"
            y="60"
          >
            <path d="M109.475 60.2353H105.7V64H109.475V60.2353Z" fill="white" />
          </mask>
          <g mask="url(#mask1058_2057_43870)">
            <path
              d="M105.7 60.2353L106.644 61.1765M106.644 61.1765L107.587 60.2353L108.531 61.1765M106.644 61.1765L107.587 62.1176M106.644 61.1765L105.7 62.1176L106.644 63.0588M108.531 61.1765L107.587 62.1176M108.531 61.1765L109.475 60.2353M108.531 61.1765L109.475 62.1176L108.531 63.0588M107.587 62.1176L106.644 63.0588M107.587 62.1176L108.531 63.0588M106.644 63.0588L107.587 64L108.531 63.0588M106.644 63.0588L105.7 64M108.531 63.0588L109.475 64"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask1059_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="132"
        y="60"
      >
        <path d="M135.9 60.2353H132.125V64H135.9V60.2353Z" fill="white" />
      </mask>
      <g mask="url(#mask1059_2057_43870)">
        <mask
          height="4"
          id="mask1060_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="132"
          y="60"
        >
          <path d="M135.9 60.2353H132.125V64H135.9V60.2353Z" fill="white" />
        </mask>
        <g mask="url(#mask1060_2057_43870)">
          <mask
            height="4"
            id="mask1061_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="132"
            y="60"
          >
            <path d="M135.9 60.2353H132.125V64H135.9V60.2353Z" fill="white" />
          </mask>
          <g mask="url(#mask1061_2057_43870)">
            <path
              d="M132.125 60.2353L133.069 61.1765M133.069 61.1765L134.012 60.2353L134.956 61.1765M133.069 61.1765L134.012 62.1176M133.069 61.1765L132.125 62.1176L133.069 63.0588M134.956 61.1765L134.012 62.1176M134.956 61.1765L135.9 60.2353M134.956 61.1765L135.9 62.1176L134.956 63.0588M134.012 62.1176L133.069 63.0588M134.012 62.1176L134.956 63.0588M133.069 63.0588L134.012 64L134.956 63.0588M133.069 63.0588L132.125 64M134.956 63.0588L135.9 64"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask1062_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="135"
        y="60"
      >
        <path d="M139.675 60.2353H135.9V64H139.675V60.2353Z" fill="white" />
      </mask>
      <g mask="url(#mask1062_2057_43870)">
        <mask
          height="4"
          id="mask1063_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="135"
          y="60"
        >
          <path d="M139.675 60.2353H135.9V64H139.675V60.2353Z" fill="white" />
        </mask>
        <g mask="url(#mask1063_2057_43870)">
          <mask
            height="4"
            id="mask1064_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="135"
            y="60"
          >
            <path d="M139.675 60.2353H135.9V64H139.675V60.2353Z" fill="white" />
          </mask>
          <g mask="url(#mask1064_2057_43870)">
            <path
              d="M135.9 60.2353L136.844 61.1765M136.844 61.1765L137.788 60.2353L138.731 61.1765M136.844 61.1765L137.788 62.1176M136.844 61.1765L135.9 62.1176L136.844 63.0588M138.731 61.1765L137.788 62.1176M138.731 61.1765L139.675 60.2353M138.731 61.1765L139.675 62.1176L138.731 63.0588M137.788 62.1176L136.844 63.0588M137.788 62.1176L138.731 63.0588M136.844 63.0588L137.788 64L138.731 63.0588M136.844 63.0588L135.9 64M138.731 63.0588L139.675 64"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask1065_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="139"
        y="60"
      >
        <path d="M143.45 60.2353H139.675V64H143.45V60.2353Z" fill="white" />
      </mask>
      <g mask="url(#mask1065_2057_43870)">
        <mask
          height="4"
          id="mask1066_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="139"
          y="60"
        >
          <path d="M143.45 60.2353H139.675V64H143.45V60.2353Z" fill="white" />
        </mask>
        <g mask="url(#mask1066_2057_43870)">
          <mask
            height="4"
            id="mask1067_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="139"
            y="60"
          >
            <path d="M143.45 60.2353H139.675V64H143.45V60.2353Z" fill="white" />
          </mask>
          <g mask="url(#mask1067_2057_43870)">
            <path
              d="M139.675 60.2353L140.619 61.1765M140.619 61.1765L141.563 60.2353L142.506 61.1765M140.619 61.1765L141.563 62.1176M140.619 61.1765L139.675 62.1176L140.619 63.0588M142.506 61.1765L141.563 62.1176M142.506 61.1765L143.45 60.2353M142.506 61.1765L143.45 62.1176L142.506 63.0588M141.563 62.1176L140.619 63.0588M141.563 62.1176L142.506 63.0588M140.619 63.0588L141.563 64L142.506 63.0588M140.619 63.0588L139.675 64M142.506 63.0588L143.45 64"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask1068_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="173"
        y="60"
      >
        <path d="M177.425 60.2353H173.65V64H177.425V60.2353Z" fill="white" />
      </mask>
      <g mask="url(#mask1068_2057_43870)">
        <mask
          height="4"
          id="mask1069_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="173"
          y="60"
        >
          <path d="M177.425 60.2353H173.65V64H177.425V60.2353Z" fill="white" />
        </mask>
        <g mask="url(#mask1069_2057_43870)">
          <mask
            height="4"
            id="mask1070_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="173"
            y="60"
          >
            <path d="M177.425 60.2353H173.65V64H177.425V60.2353Z" fill="white" />
          </mask>
          <g mask="url(#mask1070_2057_43870)">
            <path
              d="M173.65 60.2353L174.594 61.1765M174.594 61.1765L175.538 60.2353L176.481 61.1765M174.594 61.1765L175.538 62.1176M174.594 61.1765L173.65 62.1176L174.594 63.0588M176.481 61.1765L175.538 62.1176M176.481 61.1765L177.425 60.2353M176.481 61.1765L177.425 62.1176L176.481 63.0588M175.538 62.1176L174.594 63.0588M175.538 62.1176L176.481 63.0588M174.594 63.0588L175.538 64L176.481 63.0588M174.594 63.0588L173.65 64M176.481 63.0588L177.425 64"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask1071_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="177"
        y="60"
      >
        <path d="M181.2 60.2353H177.425V64H181.2V60.2353Z" fill="white" />
      </mask>
      <g mask="url(#mask1071_2057_43870)">
        <mask
          height="4"
          id="mask1072_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="177"
          y="60"
        >
          <path d="M181.2 60.2353H177.425V64H181.2V60.2353Z" fill="white" />
        </mask>
        <g mask="url(#mask1072_2057_43870)">
          <mask
            height="4"
            id="mask1073_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="177"
            y="60"
          >
            <path d="M181.2 60.2353H177.425V64H181.2V60.2353Z" fill="white" />
          </mask>
          <g mask="url(#mask1073_2057_43870)">
            <path
              d="M177.425 60.2353L178.369 61.1765M178.369 61.1765L179.313 60.2353L180.256 61.1765M178.369 61.1765L179.313 62.1176M178.369 61.1765L177.425 62.1176L178.369 63.0588M180.256 61.1765L179.313 62.1176M180.256 61.1765L181.2 60.2353M180.256 61.1765L181.2 62.1176L180.256 63.0588M179.313 62.1176L178.369 63.0588M179.313 62.1176L180.256 63.0588M178.369 63.0588L179.313 64L180.256 63.0588M178.369 63.0588L177.425 64M180.256 63.0588L181.2 64"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask1074_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="181"
        y="60"
      >
        <path d="M184.975 60.2353H181.2V64H184.975V60.2353Z" fill="white" />
      </mask>
      <g mask="url(#mask1074_2057_43870)">
        <mask
          height="4"
          id="mask1075_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="181"
          y="60"
        >
          <path d="M184.975 60.2353H181.2V64H184.975V60.2353Z" fill="white" />
        </mask>
        <g mask="url(#mask1075_2057_43870)">
          <mask
            height="4"
            id="mask1076_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="181"
            y="60"
          >
            <path d="M184.975 60.2353H181.2V64H184.975V60.2353Z" fill="white" />
          </mask>
          <g mask="url(#mask1076_2057_43870)">
            <path
              d="M181.2 60.2353L182.144 61.1765M182.144 61.1765L183.087 60.2353L184.031 61.1765M182.144 61.1765L183.087 62.1176M182.144 61.1765L181.2 62.1176L182.144 63.0588M184.031 61.1765L183.087 62.1176M184.031 61.1765L184.975 60.2353M184.031 61.1765L184.975 62.1176L184.031 63.0588M183.087 62.1176L182.144 63.0588M183.087 62.1176L184.031 63.0588M182.144 63.0588L183.087 64L184.031 63.0588M182.144 63.0588L181.2 64M184.031 63.0588L184.975 64"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask1077_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="196"
        y="60"
      >
        <path d="M200.075 60.2353H196.3V64H200.075V60.2353Z" fill="white" />
      </mask>
      <g mask="url(#mask1077_2057_43870)">
        <mask
          height="4"
          id="mask1078_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="196"
          y="60"
        >
          <path d="M200.075 60.2353H196.3V64H200.075V60.2353Z" fill="white" />
        </mask>
        <g mask="url(#mask1078_2057_43870)">
          <mask
            height="4"
            id="mask1079_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="196"
            y="60"
          >
            <path d="M200.075 60.2353H196.3V64H200.075V60.2353Z" fill="white" />
          </mask>
          <g mask="url(#mask1079_2057_43870)">
            <path
              d="M196.3 60.2353L197.244 61.1765M197.244 61.1765L198.188 60.2353L199.131 61.1765M197.244 61.1765L198.188 62.1176M197.244 61.1765L196.3 62.1176L197.244 63.0588M199.131 61.1765L198.188 62.1176M199.131 61.1765L200.075 60.2353M199.131 61.1765L200.075 62.1176L199.131 63.0588M198.188 62.1176L197.244 63.0588M198.188 62.1176L199.131 63.0588M197.244 63.0588L198.188 64L199.131 63.0588M197.244 63.0588L196.3 64M199.131 63.0588L200.075 64"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask1080_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="200"
        y="60"
      >
        <path d="M203.85 60.2353H200.075V64H203.85V60.2353Z" fill="white" />
      </mask>
      <g mask="url(#mask1080_2057_43870)">
        <mask
          height="4"
          id="mask1081_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="200"
          y="60"
        >
          <path d="M203.85 60.2353H200.075V64H203.85V60.2353Z" fill="white" />
        </mask>
        <g mask="url(#mask1081_2057_43870)">
          <mask
            height="4"
            id="mask1082_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="200"
            y="60"
          >
            <path d="M203.85 60.2353H200.075V64H203.85V60.2353Z" fill="white" />
          </mask>
          <g mask="url(#mask1082_2057_43870)">
            <path
              d="M200.075 60.2353L201.019 61.1765M201.019 61.1765L201.962 60.2353L202.906 61.1765M201.019 61.1765L201.962 62.1176M201.019 61.1765L200.075 62.1176L201.019 63.0588M202.906 61.1765L201.962 62.1176M202.906 61.1765L203.85 60.2353M202.906 61.1765L203.85 62.1176L202.906 63.0588M201.962 62.1176L201.019 63.0588M201.962 62.1176L202.906 63.0588M201.019 63.0588L201.962 64L202.906 63.0588M201.019 63.0588L200.075 64M202.906 63.0588L203.85 64"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask1083_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="203"
        y="60"
      >
        <path d="M207.625 60.2353H203.85V64H207.625V60.2353Z" fill="white" />
      </mask>
      <g mask="url(#mask1083_2057_43870)">
        <mask
          height="4"
          id="mask1084_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="203"
          y="60"
        >
          <path d="M207.625 60.2353H203.85V64H207.625V60.2353Z" fill="white" />
        </mask>
        <g mask="url(#mask1084_2057_43870)">
          <mask
            height="4"
            id="mask1085_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="203"
            y="60"
          >
            <path d="M207.625 60.2353H203.85V64H207.625V60.2353Z" fill="white" />
          </mask>
          <g mask="url(#mask1085_2057_43870)">
            <path
              d="M203.85 60.2353L204.794 61.1765M204.794 61.1765L205.737 60.2353L206.681 61.1765M204.794 61.1765L205.737 62.1176M204.794 61.1765L203.85 62.1176L204.794 63.0588M206.681 61.1765L205.737 62.1176M206.681 61.1765L207.625 60.2353M206.681 61.1765L207.625 62.1176L206.681 63.0588M205.737 62.1176L204.794 63.0588M205.737 62.1176L206.681 63.0588M204.794 63.0588L205.737 64L206.681 63.0588M204.794 63.0588L203.85 64M206.681 63.0588L207.625 64"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask1086_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="237"
        y="60"
      >
        <path d="M241.6 60.2353H237.825V64H241.6V60.2353Z" fill="white" />
      </mask>
      <g mask="url(#mask1086_2057_43870)">
        <mask
          height="4"
          id="mask1087_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="237"
          y="60"
        >
          <path d="M241.6 60.2353H237.825V64H241.6V60.2353Z" fill="white" />
        </mask>
        <g mask="url(#mask1087_2057_43870)">
          <mask
            height="4"
            id="mask1088_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="237"
            y="60"
          >
            <path d="M241.6 60.2353H237.825V64H241.6V60.2353Z" fill="white" />
          </mask>
          <g mask="url(#mask1088_2057_43870)">
            <path
              d="M237.825 60.2353L238.769 61.1765M238.769 61.1765L239.712 60.2353L240.656 61.1765M238.769 61.1765L239.712 62.1176M238.769 61.1765L237.825 62.1176L238.769 63.0588M240.656 61.1765L239.712 62.1176M240.656 61.1765L241.6 60.2353M240.656 61.1765L241.6 62.1176L240.656 63.0588M239.712 62.1176L238.769 63.0588M239.712 62.1176L240.656 63.0588M238.769 63.0588L239.712 64L240.656 63.0588M238.769 63.0588L237.825 64M240.656 63.0588L241.6 64"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask1089_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="241"
        y="60"
      >
        <path d="M245.375 60.2353H241.6V64H245.375V60.2353Z" fill="white" />
      </mask>
      <g mask="url(#mask1089_2057_43870)">
        <mask
          height="4"
          id="mask1090_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="241"
          y="60"
        >
          <path d="M245.375 60.2353H241.6V64H245.375V60.2353Z" fill="white" />
        </mask>
        <g mask="url(#mask1090_2057_43870)">
          <mask
            height="4"
            id="mask1091_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="241"
            y="60"
          >
            <path d="M245.375 60.2353H241.6V64H245.375V60.2353Z" fill="white" />
          </mask>
          <g mask="url(#mask1091_2057_43870)">
            <path
              d="M241.6 60.2353L242.544 61.1765M242.544 61.1765L243.487 60.2353L244.431 61.1765M242.544 61.1765L243.487 62.1176M242.544 61.1765L241.6 62.1176L242.544 63.0588M244.431 61.1765L243.487 62.1176M244.431 61.1765L245.375 60.2353M244.431 61.1765L245.375 62.1176L244.431 63.0588M243.487 62.1176L242.544 63.0588M243.487 62.1176L244.431 63.0588M242.544 63.0588L243.487 64L244.431 63.0588M242.544 63.0588L241.6 64M244.431 63.0588L245.375 64"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask1092_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="245"
        y="60"
      >
        <path d="M249.15 60.2353H245.375V64H249.15V60.2353Z" fill="white" />
      </mask>
      <g mask="url(#mask1092_2057_43870)">
        <mask
          height="4"
          id="mask1093_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="245"
          y="60"
        >
          <path d="M249.15 60.2353H245.375V64H249.15V60.2353Z" fill="white" />
        </mask>
        <g mask="url(#mask1093_2057_43870)">
          <mask
            height="4"
            id="mask1094_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="245"
            y="60"
          >
            <path d="M249.15 60.2353H245.375V64H249.15V60.2353Z" fill="white" />
          </mask>
          <g mask="url(#mask1094_2057_43870)">
            <path
              d="M245.375 60.2353L246.319 61.1765M246.319 61.1765L247.262 60.2353L248.206 61.1765M246.319 61.1765L247.262 62.1176M246.319 61.1765L245.375 62.1176L246.319 63.0588M248.206 61.1765L247.262 62.1176M248.206 61.1765L249.15 60.2353M248.206 61.1765L249.15 62.1176L248.206 63.0588M247.262 62.1176L246.319 63.0588M247.262 62.1176L248.206 63.0588M246.319 63.0588L247.262 64L248.206 63.0588M246.319 63.0588L245.375 64M248.206 63.0588L249.15 64"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask1095_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="4"
        x="283"
        y="60"
      >
        <path d="M286.9 60.2353H283.125V64H286.9V60.2353Z" fill="white" />
      </mask>
      <g mask="url(#mask1095_2057_43870)">
        <mask
          height="4"
          id="mask1096_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="4"
          x="283"
          y="60"
        >
          <path d="M286.9 60.2353H283.125V64H286.9V60.2353Z" fill="white" />
        </mask>
        <g mask="url(#mask1096_2057_43870)">
          <mask
            height="4"
            id="mask1097_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="4"
            x="283"
            y="60"
          >
            <path d="M286.9 60.2353H283.125V64H286.9V60.2353Z" fill="white" />
          </mask>
          <g mask="url(#mask1097_2057_43870)">
            <path
              d="M283.125 60.2353L284.069 61.1765M284.069 61.1765L285.012 60.2353L285.956 61.1765M284.069 61.1765L285.012 62.1176M284.069 61.1765L283.125 62.1176L284.069 63.0588M285.956 61.1765L285.012 62.1176M285.956 61.1765L286.9 60.2353M285.956 61.1765L286.9 62.1176L285.956 63.0588M285.012 62.1176L284.069 63.0588M285.012 62.1176L285.956 63.0588M284.069 63.0588L285.012 64L285.956 63.0588M284.069 63.0588L283.125 64M285.956 63.0588L286.9 64"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask1098_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="286"
        y="60"
      >
        <path d="M290.675 60.2353H286.9V64H290.675V60.2353Z" fill="white" />
      </mask>
      <g mask="url(#mask1098_2057_43870)">
        <mask
          height="4"
          id="mask1099_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="286"
          y="60"
        >
          <path d="M290.675 60.2353H286.9V64H290.675V60.2353Z" fill="white" />
        </mask>
        <g mask="url(#mask1099_2057_43870)">
          <mask
            height="4"
            id="mask1100_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="286"
            y="60"
          >
            <path d="M290.675 60.2353H286.9V64H290.675V60.2353Z" fill="white" />
          </mask>
          <g mask="url(#mask1100_2057_43870)">
            <path
              d="M286.9 60.2353L287.844 61.1765M287.844 61.1765L288.788 60.2353L289.731 61.1765M287.844 61.1765L288.788 62.1176M287.844 61.1765L286.9 62.1176L287.844 63.0588M289.731 61.1765L288.788 62.1176M289.731 61.1765L290.675 60.2353M289.731 61.1765L290.675 62.1176L289.731 63.0588M288.788 62.1176L287.844 63.0588M288.788 62.1176L289.731 63.0588M287.844 63.0588L288.788 64L289.731 63.0588M287.844 63.0588L286.9 64M289.731 63.0588L290.675 64"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
      <mask
        height="4"
        id="mask1101_2057_43870"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="5"
        x="290"
        y="60"
      >
        <path d="M294.45 60.2353H290.675V64H294.45V60.2353Z" fill="white" />
      </mask>
      <g mask="url(#mask1101_2057_43870)">
        <mask
          height="4"
          id="mask1102_2057_43870"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="5"
          x="290"
          y="60"
        >
          <path d="M294.45 60.2353H290.675V64H294.45V60.2353Z" fill="white" />
        </mask>
        <g mask="url(#mask1102_2057_43870)">
          <mask
            height="4"
            id="mask1103_2057_43870"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="5"
            x="290"
            y="60"
          >
            <path d="M294.45 60.2353H290.675V64H294.45V60.2353Z" fill="white" />
          </mask>
          <g mask="url(#mask1103_2057_43870)">
            <path
              d="M290.675 60.2353L291.619 61.1765M291.619 61.1765L292.563 60.2353L293.506 61.1765M291.619 61.1765L292.563 62.1176M291.619 61.1765L290.675 62.1176L291.619 63.0588M293.506 61.1765L292.563 62.1176M293.506 61.1765L294.45 60.2353M293.506 61.1765L294.45 62.1176L293.506 63.0588M292.563 62.1176L291.619 63.0588M292.563 62.1176L293.506 63.0588M291.619 63.0588L292.563 64L293.506 63.0588M291.619 63.0588L290.675 64M293.506 63.0588L294.45 64"
              stroke="#C4C4C4"
              strokeWidth="0.833333"
            />
          </g>
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2057_43870">
        <rect fill="white" height="64" width="302" />
      </clipPath>
    </defs>
  </svg>
);

export const AnalyticsIcon: React.FC<IconSvgProps> = ({ ...props }) => {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M10 11H11V21H10V22H8V21H7V11H8V10H10V11Z" fill="#808080" fillOpacity="0.55" />
      <path d="M12 5H11V6H12V5Z" fill="#808080" fillOpacity="0.55" />
      <path d="M13 6H12V7H13V6Z" fill="#808080" fillOpacity="0.55" />
      <path d="M16 8H17V10H16V11H14V10H13V8H14V7H16V8Z" fill="#808080" fillOpacity="0.55" />
      <path d="M16 15H17V21H16V22H14V21H13V15H14V14H16V15Z" fill="#808080" fillOpacity="0.55" />
      <path d="M18 6H17V7H18V6Z" fill="#808080" fillOpacity="0.55" />
      <path d="M19 5H18V6H19V5Z" fill="#808080" fillOpacity="0.55" />
      <path d="M23 2V4H22V5H20V4H19V2H20V1H22V2H23Z" fill="#808080" fillOpacity="0.55" />
      <path d="M22 11H23V21H22V22H20V21H19V11H20V10H22V11Z" fill="#808080" fillOpacity="0.55" />
      <path d="M6 7H5V8H6V7Z" fill="#808080" fillOpacity="0.55" />
      <path d="M4 9H5V11H4V12H2V11H1V9H2V8H4V9Z" fill="#808080" fillOpacity="0.55" />
      <path d="M4 16H5V21H4V22H2V21H1V16H2V15H4V16Z" fill="#808080" fillOpacity="0.55" />
      <path d="M7 6H6V7H7V6Z" fill="#808080" fillOpacity="0.55" />
      <path d="M8 4H7V2H8V1H10V2H11V4H10V5H8V4Z" fill="#808080" fillOpacity="0.55" />
    </svg>
  );
};

export const BoxUSDIcon: React.FC<IconSvgProps> = ({ ...props }) => {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 9V22H2V23H22V22H23V9H1ZM13 20V22H11V20H9V18H13V17H10V16H9V12H11V10H13V12H15V14H11V15H14V16H15V20H13Z"
        fill="#808080"
        fillOpacity="0.55"
      />
      <path d="M11 1V7H1V6H2V4H3V3H4V2H5V1H11Z" fill="#808080" fillOpacity="0.55" />
      <path d="M23 6V7H13V1H19V2H20V3H21V4H22V6H23Z" fill="#808080" fillOpacity="0.55" />
    </svg>
  );
};

export const TrendingIcon: React.FC<IconSvgProps> = ({ ...props }) => {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23 5V15H22V14H21V13H20V12H18V13H17V14H16V15H15V16H14V17H13V18H12V19H10V18H9V17H8V16H7V15H5V16H4V17H1V14H2V13H3V12H4V11H5V10H7V11H8V12H9V13H10V14H12V13H13V12H14V11H15V10H16V8H15V7H14V6H13V5H23Z"
        fill="#808080"
        fillOpacity="0.55"
      />
    </svg>
  );
};

export const QuestionMarkCircledIcon: React.FC<IconSvgProps> = ({ ...props }) => {
  return (
    <svg
      fill="none"
      height="14"
      viewBox="0 0 14 14"
      width="14"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M14 5.33301H13.335V8.66676H14V5.33301Z" fill="currentColor" />
      <path d="M13.335 8.66699H12.6656V10.0014H13.335V8.66699Z" fill="currentColor" />
      <path d="M13.335 3.99854H12.6656V5.33291H13.335V3.99854Z" fill="currentColor" />
      <path d="M12.6656 10.0015H12.0006V11.3315H12.6656V10.0015Z" fill="currentColor" />
      <path d="M12.6656 2.66431H12.0006V3.99868H12.6656V2.66431Z" fill="currentColor" />
      <path d="M12.0007 11.3315H11.3313V12.0009H12.0007V11.3315Z" fill="currentColor" />
      <path d="M12.0007 1.99951H11.3313V2.66451H12.0007V1.99951Z" fill="currentColor" />
      <path d="M11.3312 12.0005H10.0012V12.6655H11.3312V12.0005Z" fill="currentColor" />
      <path d="M11.3312 1.33423H10.0012V1.99923H11.3312V1.33423Z" fill="currentColor" />
      <path d="M10.0012 12.6658H8.66687V13.3351H10.0012V12.6658Z" fill="currentColor" />
      <path
        d="M9.3319 2.66451H8.6669V1.99951H5.33315V2.66451H4.66815V3.33389H3.99878V5.33326H5.33315V3.99889H5.99815V3.33389H7.33253V3.99889H8.0019V5.33326H7.33253V5.99826H6.66753V6.66764H5.99815V8.00201H8.0019V7.33264H8.6669V6.66764H9.3319V5.99826H10.0013V3.33389H9.3319V2.66451Z"
        fill="currentColor"
      />
      <path d="M10.0012 0.664795H8.66687V1.33417H10.0012V0.664795Z" fill="currentColor" />
      <path d="M8.66688 13.3352H5.33313V14.0002H8.66688V13.3352Z" fill="currentColor" />
      <path
        d="M8.00188 8.66699H5.99813V9.33199H5.33313V11.3314H5.99813V12.0007H8.00188V11.3314H8.66688V9.33199H8.00188V8.66699Z"
        fill="currentColor"
      />
      <path d="M8.66688 0H5.33313V0.665H8.66688V0Z" fill="currentColor" />
      <path d="M5.33315 12.6658H3.99878V13.3351H5.33315V12.6658Z" fill="currentColor" />
      <path d="M5.33315 0.664795H3.99878V1.33417H5.33315V0.664795Z" fill="currentColor" />
      <path d="M3.99868 12.0005H2.66431V12.6655H3.99868V12.0005Z" fill="currentColor" />
      <path d="M3.99868 1.33423H2.66431V1.99923H3.99868V1.33423Z" fill="currentColor" />
      <path d="M2.66439 11.3315H1.99939V12.0009H2.66439V11.3315Z" fill="currentColor" />
      <path d="M2.66439 1.99951H1.99939V2.66451H2.66439V1.99951Z" fill="currentColor" />
      <path d="M1.99935 10.0015H1.33435V11.3315H1.99935V10.0015Z" fill="currentColor" />
      <path d="M1.99935 2.66431H1.33435V3.99868H1.99935V2.66431Z" fill="currentColor" />
      <path d="M1.33441 8.66699H0.665039V10.0014H1.33441V8.66699Z" fill="currentColor" />
      <path d="M1.33441 3.99854H0.665039V5.33291H1.33441V3.99854Z" fill="currentColor" />
      <path d="M0.665 5.33301H0V8.66676H0.665V5.33301Z" fill="currentColor" />
    </svg>
  );
};

export const FingerprintIcon: React.FC<IconSvgProps> = ({ ...props }) => {
  return (
    <svg
      fill="none"
      height="40"
      viewBox="0 0 34 40"
      width="34"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M33.1875 13.3374H31.2875V30.4749H33.1875V13.3374Z" fill="#71717A" />
      <path d="M33.1875 9.5249H31.2875V11.4249H33.1875V9.5249Z" fill="#71717A" />
      <path d="M31.2875 30.4751H29.3875V34.2876H31.2875V30.4751Z" fill="#71717A" />
      <path d="M31.2875 5.7124H29.3875V9.5249H31.2875V5.7124Z" fill="#71717A" />
      <path d="M29.3875 22.8625H27.475V28.575H29.3875V22.8625Z" fill="#71717A" />
      <path d="M29.3875 11.425H27.475V17.1375H29.3875V11.425Z" fill="#71717A" />
      <path d="M27.4749 28.575H25.575V32.3875H27.4749V28.575Z" fill="#71717A" />
      <path d="M27.4749 7.625H25.575V11.425H27.4749V7.625Z" fill="#71717A" />
      <path d="M25.575 36.1875H23.6625V38.1H25.575V36.1875Z" fill="#71717A" />
      <path d="M25.575 13.3374H23.6625V26.6624H25.575V13.3374Z" fill="#71717A" />
      <path d="M25.575 5.7124H21.7625V7.6249H25.575V5.7124Z" fill="#71717A" />
      <path d="M25.575 1.8999H23.6625V3.8124H25.575V1.8999Z" fill="#71717A" />
      <path d="M25.575 32.3875H21.7625V34.2875H25.575V32.3875Z" fill="#71717A" />
      <path d="M23.6625 11.425H21.7625V13.3375H23.6625V11.425Z" fill="#71717A" />
      <path d="M23.6625 38.1001H19.8625V40.0001H23.6625V38.1001Z" fill="#71717A" />
      <path d="M21.7625 28.575H19.8625V30.4749H21.7625V28.575Z" fill="#71717A" />
      <path d="M21.7625 20.95H19.8625V24.7625H21.7625V20.95Z" fill="#71717A" />
      <path d="M21.7625 15.2375H19.8625V19.05H21.7625V15.2375Z" fill="#71717A" />
      <path d="M21.7625 3.8125H17.95V5.7125H21.7625V3.8125Z" fill="#71717A" />
      <path d="M21.7625 34.2876H12.2375V36.1876H21.7625V34.2876Z" fill="#71717A" />
      <path d="M19.8626 13.3374H16.05V15.2374H19.8626V13.3374Z" fill="#71717A" />
      <path d="M19.8625 24.7625H14.1375V26.6625H19.8625V24.7625Z" fill="#71717A" />
      <path d="M17.95 17.1375H16.05V22.8625H17.95V17.1375Z" fill="#71717A" />
      <path d="M19.8625 7.625H14.1375V9.525H19.8625V7.625Z" fill="#71717A" />
      <path d="M19.8625 30.4751H14.1375V32.3876H19.8625V30.4751Z" fill="#71717A" />
      <path d="M16.05 3.8125H12.2375V5.7125H16.05V3.8125Z" fill="#71717A" />
      <path d="M16.05 38.1001H10.3375V40.0001H16.05V38.1001Z" fill="#71717A" />
      <path d="M14.1375 28.575H12.2375V30.4749H14.1375V28.575Z" fill="#71717A" />
      <path d="M14.1375 17.1375H12.2375V24.7625H14.1375V17.1375Z" fill="#71717A" />
      <path d="M23.6625 0H10.3375V1.9H23.6625V0Z" fill="#71717A" />
      <path d="M12.2375 11.425H10.3375V13.3375H12.2375V11.425Z" fill="#71717A" />
      <path d="M12.2375 5.7124H8.42505V7.6249H12.2375V5.7124Z" fill="#71717A" />
      <path d="M10.3375 36.1875H6.52502V38.1H10.3375V36.1875Z" fill="#71717A" />
      <path d="M10.3375 24.7625H8.42505V26.6625H10.3375V24.7625Z" fill="#71717A" />
      <path d="M10.3375 19.05H8.42505V22.8626H10.3375V19.05Z" fill="#71717A" />
      <path d="M10.3375 13.3374H8.42505V17.1374H10.3375V13.3374Z" fill="#71717A" />
      <path d="M8.42502 28.575H6.52502V32.3875H8.42502V28.575Z" fill="#71717A" />
      <path d="M8.42502 7.625H6.52502V11.425H8.42502V7.625Z" fill="#71717A" />
      <path d="M6.525 34.2876H4.625V36.1876H6.525V34.2876Z" fill="#71717A" />
      <path d="M6.525 13.3374H4.625V28.5749H6.525V13.3374Z" fill="#71717A" />
      <path d="M6.525 3.8125H4.625V5.7125H6.525V3.8125Z" fill="#71717A" />
      <path d="M4.62502 30.4751H2.71252V34.2876H4.62502V30.4751Z" fill="#71717A" />
      <path d="M4.62502 5.7124H2.71252V9.5249H4.62502V5.7124Z" fill="#71717A" />
      <path d="M2.7125 24.7625H0.8125V30.475H2.7125V24.7625Z" fill="#71717A" />
      <path d="M2.7125 9.5249H0.8125V22.8624H2.7125V9.5249Z" fill="#71717A" />
    </svg>
  );
};

export const ReferralsIcon: React.FC<IconSvgProps> = ({ ...props }) => {
  return (
    <svg
      fill="none"
      height="26"
      viewBox="0 0 26 26"
      width="26"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.2869 13.6176H23.5219V24.7569H24.7569V13.6176H26V12.3826H22.2869V13.6176Z"
        fill="#CEA100"
      />
      <path d="M24.7568 1.23511H23.5219V4.94823H24.7568V1.23511Z" fill="#CEA100" />
      <path d="M24.7568 7.42627H23.5219V11.1394H24.7568V7.42627Z" fill="#CEA100" />
      <path d="M23.5219 24.7568H2.47815V26H23.5219V24.7568Z" fill="#CEA100" />
      <path d="M23.5218 0H19.8087V1.235H23.5218V0Z" fill="#CEA100" />
      <path d="M21.0438 12.3826H18.5657V13.6176H21.0438V12.3826Z" fill="#CEA100" />
      <path
        d="M17.3306 16.0956V7.42627H8.66125V8.66127H9.90438V9.90439H11.1394V11.1394H9.90438V12.3825H8.66125V16.0956H9.90438V18.5656H11.1394V19.8088H16.0956V18.5656H13.6175V17.3306H12.3825V14.8525H13.6175V13.6175H14.8525V14.8525H16.0956V16.0956H17.3306Z"
        fill="#CEA100"
      />
      <path d="M17.3307 0H13.6176V1.235H17.3307V0Z" fill="#CEA100" />
      <path d="M12.3825 0H8.66125V1.235H12.3825V0Z" fill="#CEA100" />
      <path d="M7.42625 12.3826H4.94812V13.6176H7.42625V12.3826Z" fill="#CEA100" />
      <path d="M6.19127 0H2.47815V1.235H6.19127V0Z" fill="#CEA100" />
      <path d="M2.47811 1.23511H1.23499V4.94823H2.47811V1.23511Z" fill="#CEA100" />
      <path d="M2.47811 7.42627H1.23499V11.1394H2.47811V7.42627Z" fill="#CEA100" />
      <path
        d="M3.71313 13.6176V12.3826H0V13.6176H1.235V24.7569H2.47812V13.6176H3.71313Z"
        fill="#CEA100"
      />
    </svg>
  );
};

export const CheckIcon: React.FC<IconSvgProps> = ({ ...props }) => {
  return (
    <svg
      fill="none"
      height="21"
      viewBox="0 0 20 21"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect fill="#00CE7D" height="20" transform="translate(0 0.5)" width="20" />
      <path
        d="M18.3333 2.16659V1.33325H1.66659V2.16659H0.833252V18.8333H1.66659V19.6666H18.3333V18.8333H19.1666V2.16659H18.3333ZM4.16658 9.66658H4.99992V8.83325H5.83325V7.99992H6.66658V8.83325H7.49992V9.66658H8.33325V10.4999H9.99992V9.66658H10.8333V8.83325H11.6666V7.99992H12.4999V7.16658H13.3333V6.33325H14.1666V7.16658H14.9999V7.99992H15.8333V8.83325H14.9999V9.66658H14.1666V10.4999H13.3333V11.3333H12.4999V12.1666H11.6666V12.9999H10.8333V13.8333H9.99992V14.6666H8.33325V13.8333H7.49992V12.9999H6.66658V12.1666H5.83325V11.3333H4.99992V10.4999H4.16658V9.66658Z"
        fill="black"
      />
    </svg>
  );
};

export const CrossIcon: React.FC<IconSvgProps> = ({ ...props }) => {
  return (
    <svg
      version="1.1"
      viewBox="0 0 78 97.5"
      x="0px"
      xmlns="http://www.w3.org/2000/svg"
      y="0px"
      {...props}
    >
      <g>
        <rect height="6" width="6" x="54" y="54" />
        <rect height="6" width="6" x="36" y="36" />
        <rect height="6" width="6" x="30" y="42" />
        <rect height="6" width="6" x="24" y="48" />
        <rect height="6" width="6" x="18" y="54" />
        <rect height="6" width="6" x="42" y="30" />
        <rect height="6" width="6" x="48" y="24" />
        <rect height="6" width="6" x="54" y="18" />
        <rect height="6" width="6" x="42" y="42" />
        <rect height="6" width="6" x="48" y="48" />
        <rect height="6" width="6" x="30" y="30" />
        <rect height="6" width="6" x="18" y="18" />
        <rect height="6" width="6" x="24" y="24" />
      </g>
    </svg>
  );
};
